/* tslint:disable */
/* eslint-disable */
/**
 * Arteco Extranet API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBasicAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
export const AccountingAccountAccountTypeEnum = {
    ACTIVO: 'ACTIVO',
    PASIVO: 'PASIVO',
    NETO: 'NETO',
    INGRESO: 'INGRESO',
    GASTO: 'GASTO'
};
export const AccountingAccountNatureEnum = {
    DEUDORA: 'DEUDORA',
    ACREEDORA: 'ACREEDORA'
};
export const AccountingAccountListAccountTypeEnum = {
    ACTIVO: 'ACTIVO',
    PASIVO: 'PASIVO',
    NETO: 'NETO',
    INGRESO: 'INGRESO',
    GASTO: 'GASTO'
};
export const AccountingAccountListNatureEnum = {
    DEUDORA: 'DEUDORA',
    ACREEDORA: 'ACREEDORA'
};
export const AccountingPeriodOfficialSourceEnum = {
    CONTASOL: 'CONTASOL',
    EXTRANET: 'EXTRANET'
};
export const AccountingPeriodStatusEnum = {
    ABIERTO: 'ABIERTO',
    CERRADO: 'CERRADO',
    BLOQUEADO: 'BLOQUEADO'
};
export const AccountingPeriodListOfficialSourceEnum = {
    CONTASOL: 'CONTASOL',
    EXTRANET: 'EXTRANET'
};
export const AccountingPeriodListStatusEnum = {
    ABIERTO: 'ABIERTO',
    CERRADO: 'CERRADO',
    BLOQUEADO: 'BLOQUEADO'
};
export const AccountingRuleEventEnum = {
    VENTA: 'VENTA',
    COMPRA: 'COMPRA',
    NOMINA: 'NOMINA',
    COBRO: 'COBRO',
    PAGO: 'PAGO',
    AMORTIZACION: 'AMORTIZACION'
};
export const AccountingRuleListEventEnum = {
    VENTA: 'VENTA',
    COMPRA: 'COMPRA',
    NOMINA: 'NOMINA',
    COBRO: 'COBRO',
    PAGO: 'PAGO',
    AMORTIZACION: 'AMORTIZACION'
};
export const BankMovementMovementTypeEnum = {
    COBRO: 'COBRO',
    PAGO: 'PAGO'
};
export const BankMovementListMovementTypeEnum = {
    COBRO: 'COBRO',
    PAGO: 'PAGO'
};
export const BillInvoiceTypeEnum = {
    F1: 'F1',
    F2: 'F2',
    F3: 'F3',
    R1: 'R1',
    R2: 'R2',
    R3: 'R3',
    R4: 'R4',
    R5: 'R5'
};
export const BillPaymentMethodEnum = {
    TRANSFERENCIA: 'TRANSFERENCIA',
    ADEUDO_SEPA: 'ADEUDO_SEPA',
    CONFIRMING: 'CONFIRMING'
};
export const BillListInvoiceTypeEnum = {
    F1: 'F1',
    F2: 'F2',
    F3: 'F3',
    R1: 'R1',
    R2: 'R2',
    R3: 'R3',
    R4: 'R4',
    R5: 'R5'
};
export const BillListPaymentMethodEnum = {
    TRANSFERENCIA: 'TRANSFERENCIA',
    ADEUDO_SEPA: 'ADEUDO_SEPA',
    CONFIRMING: 'CONFIRMING'
};
export const BudgetBillingPeriodEnum = {
    MENSUAL: 'MENSUAL',
    TRIMESTRAL: 'TRIMESTRAL',
    ANUAL: 'ANUAL'
};
export const BudgetDeliveryAcceptanceEnum = {
    PENDIENTE: 'PENDIENTE',
    CONFORME: 'CONFORME',
    CON_RESERVAS: 'CON_RESERVAS',
    RECHAZADA: 'RECHAZADA',
    CONFORME_TACITA: 'CONFORME_TACITA'
};
export const BudgetKindEnum = {
    PROYECTO: 'PROYECTO',
    BOLSA: 'BOLSA',
    TM: 'TM',
    CUOTA: 'CUOTA'
};
export const BudgetListBillingPeriodEnum = {
    MENSUAL: 'MENSUAL',
    TRIMESTRAL: 'TRIMESTRAL',
    ANUAL: 'ANUAL'
};
export const BudgetListDeliveryAcceptanceEnum = {
    PENDIENTE: 'PENDIENTE',
    CONFORME: 'CONFORME',
    CON_RESERVAS: 'CON_RESERVAS',
    RECHAZADA: 'RECHAZADA',
    CONFORME_TACITA: 'CONFORME_TACITA'
};
export const BudgetListKindEnum = {
    PROYECTO: 'PROYECTO',
    BOLSA: 'BOLSA',
    TM: 'TM',
    CUOTA: 'CUOTA'
};
export const BudgetPendingBillingDtoKindEnum = {
    PROYECTO: 'PROYECTO',
    BOLSA: 'BOLSA',
    TM: 'TM',
    CUOTA: 'CUOTA'
};
export const ByTypeTypeEnum = {
    NO_CONFORMIDAD: 'NO_CONFORMIDAD',
    INCIDENTE_SEGURIDAD: 'INCIDENTE_SEGURIDAD',
    RECLAMACION: 'RECLAMACION',
    OPORTUNIDAD_MEJORA: 'OPORTUNIDAD_MEJORA'
};
export const CandidateCountryEnum = {
    AD: 'AD',
    AE: 'AE',
    AF: 'AF',
    AG: 'AG',
    AI: 'AI',
    AL: 'AL',
    AM: 'AM',
    AN: 'AN',
    AO: 'AO',
    AQ: 'AQ',
    AR: 'AR',
    AS: 'AS',
    AT: 'AT',
    AU: 'AU',
    AW: 'AW',
    AZ: 'AZ',
    BA: 'BA',
    BB: 'BB',
    BD: 'BD',
    BE: 'BE',
    BF: 'BF',
    BG: 'BG',
    BH: 'BH',
    BI: 'BI',
    BJ: 'BJ',
    BM: 'BM',
    BN: 'BN',
    BO: 'BO',
    BR: 'BR',
    BS: 'BS',
    BT: 'BT',
    BV: 'BV',
    BW: 'BW',
    BY: 'BY',
    BZ: 'BZ',
    CA: 'CA',
    CC: 'CC',
    CD: 'CD',
    CF: 'CF',
    CG: 'CG',
    CH: 'CH',
    CI: 'CI',
    CK: 'CK',
    CL: 'CL',
    CM: 'CM',
    CN: 'CN',
    CO: 'CO',
    CR: 'CR',
    CU: 'CU',
    CV: 'CV',
    CX: 'CX',
    CY: 'CY',
    CZ: 'CZ',
    DE: 'DE',
    DJ: 'DJ',
    DK: 'DK',
    DM: 'DM',
    DO: 'DO',
    DZ: 'DZ',
    EC: 'EC',
    EE: 'EE',
    EG: 'EG',
    EH: 'EH',
    ER: 'ER',
    ES: 'ES',
    ET: 'ET',
    FI: 'FI',
    FJ: 'FJ',
    FK: 'FK',
    FM: 'FM',
    FO: 'FO',
    FR: 'FR',
    GA: 'GA',
    GB: 'GB',
    GD: 'GD',
    GE: 'GE',
    GF: 'GF',
    GG: 'GG',
    GH: 'GH',
    GI: 'GI',
    GL: 'GL',
    GM: 'GM',
    GN: 'GN',
    GP: 'GP',
    GQ: 'GQ',
    GR: 'GR',
    GS: 'GS',
    GT: 'GT',
    GU: 'GU',
    GW: 'GW',
    GY: 'GY',
    GZ: 'GZ',
    HK: 'HK',
    HM: 'HM',
    HN: 'HN',
    HR: 'HR',
    HT: 'HT',
    HU: 'HU',
    ID: 'ID',
    IE: 'IE',
    IL: 'IL',
    IM: 'IM',
    IN: 'IN',
    IO: 'IO',
    IQ: 'IQ',
    IR: 'IR',
    IS: 'IS',
    IT: 'IT',
    JE: 'JE',
    JM: 'JM',
    JO: 'JO',
    JP: 'JP',
    KE: 'KE',
    KG: 'KG',
    KH: 'KH',
    KI: 'KI',
    KM: 'KM',
    KN: 'KN',
    KP: 'KP',
    KR: 'KR',
    KW: 'KW',
    KY: 'KY',
    KZ: 'KZ',
    LA: 'LA',
    LB: 'LB',
    LC: 'LC',
    LI: 'LI',
    LK: 'LK',
    LR: 'LR',
    LS: 'LS',
    LT: 'LT',
    LU: 'LU',
    LV: 'LV',
    LY: 'LY',
    MA: 'MA',
    MC: 'MC',
    MD: 'MD',
    ME: 'ME',
    MG: 'MG',
    MH: 'MH',
    MK: 'MK',
    ML: 'ML',
    MM: 'MM',
    MN: 'MN',
    MO: 'MO',
    MP: 'MP',
    MQ: 'MQ',
    MR: 'MR',
    MS: 'MS',
    MT: 'MT',
    MU: 'MU',
    MV: 'MV',
    MW: 'MW',
    MX: 'MX',
    MY: 'MY',
    MZ: 'MZ',
    NA: 'NA',
    NC: 'NC',
    NE: 'NE',
    NF: 'NF',
    NG: 'NG',
    NI: 'NI',
    NL: 'NL',
    NO: 'NO',
    NP: 'NP',
    NR: 'NR',
    NU: 'NU',
    NZ: 'NZ',
    OM: 'OM',
    PA: 'PA',
    PE: 'PE',
    PF: 'PF',
    PG: 'PG',
    PH: 'PH',
    PK: 'PK',
    PL: 'PL',
    PM: 'PM',
    PN: 'PN',
    PR: 'PR',
    PS: 'PS',
    PT: 'PT',
    PW: 'PW',
    PY: 'PY',
    QA: 'QA',
    RE: 'RE',
    RO: 'RO',
    RS: 'RS',
    RU: 'RU',
    RW: 'RW',
    SA: 'SA',
    SB: 'SB',
    SC: 'SC',
    SD: 'SD',
    SE: 'SE',
    SG: 'SG',
    SH: 'SH',
    SI: 'SI',
    SJ: 'SJ',
    SK: 'SK',
    SL: 'SL',
    SM: 'SM',
    SN: 'SN',
    SO: 'SO',
    SR: 'SR',
    ST: 'ST',
    SV: 'SV',
    SY: 'SY',
    SZ: 'SZ',
    TC: 'TC',
    TD: 'TD',
    TF: 'TF',
    TG: 'TG',
    TH: 'TH',
    TJ: 'TJ',
    TK: 'TK',
    TL: 'TL',
    TM: 'TM',
    TN: 'TN',
    TO: 'TO',
    TR: 'TR',
    TT: 'TT',
    TV: 'TV',
    TW: 'TW',
    TZ: 'TZ',
    UA: 'UA',
    UG: 'UG',
    UM: 'UM',
    US: 'US',
    UY: 'UY',
    UZ: 'UZ',
    VA: 'VA',
    VC: 'VC',
    VE: 'VE',
    VG: 'VG',
    VI: 'VI',
    VN: 'VN',
    VU: 'VU',
    WF: 'WF',
    WS: 'WS',
    XK: 'XK',
    YE: 'YE',
    YT: 'YT',
    ZA: 'ZA',
    ZM: 'ZM',
    ZW: 'ZW'
};
export const CandidateWorkTypeEnum = {
    FULL_DAY: 'FULL_DAY',
    PART_DAY: 'PART_DAY',
    PRACTICE: 'PRACTICE'
};
export const CandidateEventTypeEnum = {
    NOTE: 'NOTE',
    EMAIL: 'EMAIL',
    CALL: 'CALL',
    INTERVIEW: 'INTERVIEW',
    LEVEL_TEST: 'LEVEL_TEST',
    PROFILE_UPDATE: 'PROFILE_UPDATE'
};
export const CandidateEventListTypeEnum = {
    NOTE: 'NOTE',
    EMAIL: 'EMAIL',
    CALL: 'CALL',
    INTERVIEW: 'INTERVIEW',
    LEVEL_TEST: 'LEVEL_TEST',
    PROFILE_UPDATE: 'PROFILE_UPDATE'
};
export const CandidateFormCountryEnum = {
    AD: 'AD',
    AE: 'AE',
    AF: 'AF',
    AG: 'AG',
    AI: 'AI',
    AL: 'AL',
    AM: 'AM',
    AN: 'AN',
    AO: 'AO',
    AQ: 'AQ',
    AR: 'AR',
    AS: 'AS',
    AT: 'AT',
    AU: 'AU',
    AW: 'AW',
    AZ: 'AZ',
    BA: 'BA',
    BB: 'BB',
    BD: 'BD',
    BE: 'BE',
    BF: 'BF',
    BG: 'BG',
    BH: 'BH',
    BI: 'BI',
    BJ: 'BJ',
    BM: 'BM',
    BN: 'BN',
    BO: 'BO',
    BR: 'BR',
    BS: 'BS',
    BT: 'BT',
    BV: 'BV',
    BW: 'BW',
    BY: 'BY',
    BZ: 'BZ',
    CA: 'CA',
    CC: 'CC',
    CD: 'CD',
    CF: 'CF',
    CG: 'CG',
    CH: 'CH',
    CI: 'CI',
    CK: 'CK',
    CL: 'CL',
    CM: 'CM',
    CN: 'CN',
    CO: 'CO',
    CR: 'CR',
    CU: 'CU',
    CV: 'CV',
    CX: 'CX',
    CY: 'CY',
    CZ: 'CZ',
    DE: 'DE',
    DJ: 'DJ',
    DK: 'DK',
    DM: 'DM',
    DO: 'DO',
    DZ: 'DZ',
    EC: 'EC',
    EE: 'EE',
    EG: 'EG',
    EH: 'EH',
    ER: 'ER',
    ES: 'ES',
    ET: 'ET',
    FI: 'FI',
    FJ: 'FJ',
    FK: 'FK',
    FM: 'FM',
    FO: 'FO',
    FR: 'FR',
    GA: 'GA',
    GB: 'GB',
    GD: 'GD',
    GE: 'GE',
    GF: 'GF',
    GG: 'GG',
    GH: 'GH',
    GI: 'GI',
    GL: 'GL',
    GM: 'GM',
    GN: 'GN',
    GP: 'GP',
    GQ: 'GQ',
    GR: 'GR',
    GS: 'GS',
    GT: 'GT',
    GU: 'GU',
    GW: 'GW',
    GY: 'GY',
    GZ: 'GZ',
    HK: 'HK',
    HM: 'HM',
    HN: 'HN',
    HR: 'HR',
    HT: 'HT',
    HU: 'HU',
    ID: 'ID',
    IE: 'IE',
    IL: 'IL',
    IM: 'IM',
    IN: 'IN',
    IO: 'IO',
    IQ: 'IQ',
    IR: 'IR',
    IS: 'IS',
    IT: 'IT',
    JE: 'JE',
    JM: 'JM',
    JO: 'JO',
    JP: 'JP',
    KE: 'KE',
    KG: 'KG',
    KH: 'KH',
    KI: 'KI',
    KM: 'KM',
    KN: 'KN',
    KP: 'KP',
    KR: 'KR',
    KW: 'KW',
    KY: 'KY',
    KZ: 'KZ',
    LA: 'LA',
    LB: 'LB',
    LC: 'LC',
    LI: 'LI',
    LK: 'LK',
    LR: 'LR',
    LS: 'LS',
    LT: 'LT',
    LU: 'LU',
    LV: 'LV',
    LY: 'LY',
    MA: 'MA',
    MC: 'MC',
    MD: 'MD',
    ME: 'ME',
    MG: 'MG',
    MH: 'MH',
    MK: 'MK',
    ML: 'ML',
    MM: 'MM',
    MN: 'MN',
    MO: 'MO',
    MP: 'MP',
    MQ: 'MQ',
    MR: 'MR',
    MS: 'MS',
    MT: 'MT',
    MU: 'MU',
    MV: 'MV',
    MW: 'MW',
    MX: 'MX',
    MY: 'MY',
    MZ: 'MZ',
    NA: 'NA',
    NC: 'NC',
    NE: 'NE',
    NF: 'NF',
    NG: 'NG',
    NI: 'NI',
    NL: 'NL',
    NO: 'NO',
    NP: 'NP',
    NR: 'NR',
    NU: 'NU',
    NZ: 'NZ',
    OM: 'OM',
    PA: 'PA',
    PE: 'PE',
    PF: 'PF',
    PG: 'PG',
    PH: 'PH',
    PK: 'PK',
    PL: 'PL',
    PM: 'PM',
    PN: 'PN',
    PR: 'PR',
    PS: 'PS',
    PT: 'PT',
    PW: 'PW',
    PY: 'PY',
    QA: 'QA',
    RE: 'RE',
    RO: 'RO',
    RS: 'RS',
    RU: 'RU',
    RW: 'RW',
    SA: 'SA',
    SB: 'SB',
    SC: 'SC',
    SD: 'SD',
    SE: 'SE',
    SG: 'SG',
    SH: 'SH',
    SI: 'SI',
    SJ: 'SJ',
    SK: 'SK',
    SL: 'SL',
    SM: 'SM',
    SN: 'SN',
    SO: 'SO',
    SR: 'SR',
    ST: 'ST',
    SV: 'SV',
    SY: 'SY',
    SZ: 'SZ',
    TC: 'TC',
    TD: 'TD',
    TF: 'TF',
    TG: 'TG',
    TH: 'TH',
    TJ: 'TJ',
    TK: 'TK',
    TL: 'TL',
    TM: 'TM',
    TN: 'TN',
    TO: 'TO',
    TR: 'TR',
    TT: 'TT',
    TV: 'TV',
    TW: 'TW',
    TZ: 'TZ',
    UA: 'UA',
    UG: 'UG',
    UM: 'UM',
    US: 'US',
    UY: 'UY',
    UZ: 'UZ',
    VA: 'VA',
    VC: 'VC',
    VE: 'VE',
    VG: 'VG',
    VI: 'VI',
    VN: 'VN',
    VU: 'VU',
    WF: 'WF',
    WS: 'WS',
    XK: 'XK',
    YE: 'YE',
    YT: 'YT',
    ZA: 'ZA',
    ZM: 'ZM',
    ZW: 'ZW'
};
export const CandidateFormWorkTypeEnum = {
    FULL_DAY: 'FULL_DAY',
    PART_DAY: 'PART_DAY',
    PRACTICE: 'PRACTICE'
};
export const CandidateListCountryEnum = {
    AD: 'AD',
    AE: 'AE',
    AF: 'AF',
    AG: 'AG',
    AI: 'AI',
    AL: 'AL',
    AM: 'AM',
    AN: 'AN',
    AO: 'AO',
    AQ: 'AQ',
    AR: 'AR',
    AS: 'AS',
    AT: 'AT',
    AU: 'AU',
    AW: 'AW',
    AZ: 'AZ',
    BA: 'BA',
    BB: 'BB',
    BD: 'BD',
    BE: 'BE',
    BF: 'BF',
    BG: 'BG',
    BH: 'BH',
    BI: 'BI',
    BJ: 'BJ',
    BM: 'BM',
    BN: 'BN',
    BO: 'BO',
    BR: 'BR',
    BS: 'BS',
    BT: 'BT',
    BV: 'BV',
    BW: 'BW',
    BY: 'BY',
    BZ: 'BZ',
    CA: 'CA',
    CC: 'CC',
    CD: 'CD',
    CF: 'CF',
    CG: 'CG',
    CH: 'CH',
    CI: 'CI',
    CK: 'CK',
    CL: 'CL',
    CM: 'CM',
    CN: 'CN',
    CO: 'CO',
    CR: 'CR',
    CU: 'CU',
    CV: 'CV',
    CX: 'CX',
    CY: 'CY',
    CZ: 'CZ',
    DE: 'DE',
    DJ: 'DJ',
    DK: 'DK',
    DM: 'DM',
    DO: 'DO',
    DZ: 'DZ',
    EC: 'EC',
    EE: 'EE',
    EG: 'EG',
    EH: 'EH',
    ER: 'ER',
    ES: 'ES',
    ET: 'ET',
    FI: 'FI',
    FJ: 'FJ',
    FK: 'FK',
    FM: 'FM',
    FO: 'FO',
    FR: 'FR',
    GA: 'GA',
    GB: 'GB',
    GD: 'GD',
    GE: 'GE',
    GF: 'GF',
    GG: 'GG',
    GH: 'GH',
    GI: 'GI',
    GL: 'GL',
    GM: 'GM',
    GN: 'GN',
    GP: 'GP',
    GQ: 'GQ',
    GR: 'GR',
    GS: 'GS',
    GT: 'GT',
    GU: 'GU',
    GW: 'GW',
    GY: 'GY',
    GZ: 'GZ',
    HK: 'HK',
    HM: 'HM',
    HN: 'HN',
    HR: 'HR',
    HT: 'HT',
    HU: 'HU',
    ID: 'ID',
    IE: 'IE',
    IL: 'IL',
    IM: 'IM',
    IN: 'IN',
    IO: 'IO',
    IQ: 'IQ',
    IR: 'IR',
    IS: 'IS',
    IT: 'IT',
    JE: 'JE',
    JM: 'JM',
    JO: 'JO',
    JP: 'JP',
    KE: 'KE',
    KG: 'KG',
    KH: 'KH',
    KI: 'KI',
    KM: 'KM',
    KN: 'KN',
    KP: 'KP',
    KR: 'KR',
    KW: 'KW',
    KY: 'KY',
    KZ: 'KZ',
    LA: 'LA',
    LB: 'LB',
    LC: 'LC',
    LI: 'LI',
    LK: 'LK',
    LR: 'LR',
    LS: 'LS',
    LT: 'LT',
    LU: 'LU',
    LV: 'LV',
    LY: 'LY',
    MA: 'MA',
    MC: 'MC',
    MD: 'MD',
    ME: 'ME',
    MG: 'MG',
    MH: 'MH',
    MK: 'MK',
    ML: 'ML',
    MM: 'MM',
    MN: 'MN',
    MO: 'MO',
    MP: 'MP',
    MQ: 'MQ',
    MR: 'MR',
    MS: 'MS',
    MT: 'MT',
    MU: 'MU',
    MV: 'MV',
    MW: 'MW',
    MX: 'MX',
    MY: 'MY',
    MZ: 'MZ',
    NA: 'NA',
    NC: 'NC',
    NE: 'NE',
    NF: 'NF',
    NG: 'NG',
    NI: 'NI',
    NL: 'NL',
    NO: 'NO',
    NP: 'NP',
    NR: 'NR',
    NU: 'NU',
    NZ: 'NZ',
    OM: 'OM',
    PA: 'PA',
    PE: 'PE',
    PF: 'PF',
    PG: 'PG',
    PH: 'PH',
    PK: 'PK',
    PL: 'PL',
    PM: 'PM',
    PN: 'PN',
    PR: 'PR',
    PS: 'PS',
    PT: 'PT',
    PW: 'PW',
    PY: 'PY',
    QA: 'QA',
    RE: 'RE',
    RO: 'RO',
    RS: 'RS',
    RU: 'RU',
    RW: 'RW',
    SA: 'SA',
    SB: 'SB',
    SC: 'SC',
    SD: 'SD',
    SE: 'SE',
    SG: 'SG',
    SH: 'SH',
    SI: 'SI',
    SJ: 'SJ',
    SK: 'SK',
    SL: 'SL',
    SM: 'SM',
    SN: 'SN',
    SO: 'SO',
    SR: 'SR',
    ST: 'ST',
    SV: 'SV',
    SY: 'SY',
    SZ: 'SZ',
    TC: 'TC',
    TD: 'TD',
    TF: 'TF',
    TG: 'TG',
    TH: 'TH',
    TJ: 'TJ',
    TK: 'TK',
    TL: 'TL',
    TM: 'TM',
    TN: 'TN',
    TO: 'TO',
    TR: 'TR',
    TT: 'TT',
    TV: 'TV',
    TW: 'TW',
    TZ: 'TZ',
    UA: 'UA',
    UG: 'UG',
    UM: 'UM',
    US: 'US',
    UY: 'UY',
    UZ: 'UZ',
    VA: 'VA',
    VC: 'VC',
    VE: 'VE',
    VG: 'VG',
    VI: 'VI',
    VN: 'VN',
    VU: 'VU',
    WF: 'WF',
    WS: 'WS',
    XK: 'XK',
    YE: 'YE',
    YT: 'YT',
    ZA: 'ZA',
    ZM: 'ZM',
    ZW: 'ZW'
};
export const CandidateListWorkTypeEnum = {
    FULL_DAY: 'FULL_DAY',
    PART_DAY: 'PART_DAY',
    PRACTICE: 'PRACTICE'
};
export const CompanyExpiryCategoryEnum = {
    CERTIFICATE: 'CERTIFICATE',
    DOMAIN: 'DOMAIN',
    SUPPLIER: 'SUPPLIER',
    OTHER: 'OTHER'
};
export const CompanyExpiryListCategoryEnum = {
    CERTIFICATE: 'CERTIFICATE',
    DOMAIN: 'DOMAIN',
    SUPPLIER: 'SUPPLIER',
    OTHER: 'OTHER'
};
export const ContactEventTypeEnum = {
    CALL: 'CALL',
    EMAIL: 'EMAIL',
    MEETING: 'MEETING',
    NOTE: 'NOTE',
    TASK: 'TASK',
    OTHER: 'OTHER'
};
export const ContactEventListTypeEnum = {
    CALL: 'CALL',
    EMAIL: 'EMAIL',
    MEETING: 'MEETING',
    NOTE: 'NOTE',
    TASK: 'TASK',
    OTHER: 'OTHER'
};
export const CrmContactCommercialEmailBasisEnum = {
    CLIENT: 'CLIENT',
    CONSENT: 'CONSENT',
    B2B_TO_REVIEW: 'B2B_TO_REVIEW',
    NONE: 'NONE',
    OPTED_OUT: 'OPTED_OUT'
};
export const CrmContactTypeEnum = {
    LEAD: 'LEAD',
    PROSPECT: 'PROSPECT',
    CLIENT: 'CLIENT',
    PARTNER: 'PARTNER',
    PROVIDER: 'PROVIDER',
    OTHER: 'OTHER'
};
export const CrmContactListCommercialEmailBasisEnum = {
    CLIENT: 'CLIENT',
    CONSENT: 'CONSENT',
    B2B_TO_REVIEW: 'B2B_TO_REVIEW',
    NONE: 'NONE',
    OPTED_OUT: 'OPTED_OUT'
};
export const CrmContactListTypeEnum = {
    LEAD: 'LEAD',
    PROSPECT: 'PROSPECT',
    CLIENT: 'CLIENT',
    PARTNER: 'PARTNER',
    PROVIDER: 'PROVIDER',
    OTHER: 'OTHER'
};
export const CustomerDefaultPaymentMethodEnum = {
    TRANSFERENCIA: 'TRANSFERENCIA',
    ADEUDO_SEPA: 'ADEUDO_SEPA',
    CONFIRMING: 'CONFIRMING'
};
export const CustomerListDefaultPaymentMethodEnum = {
    TRANSFERENCIA: 'TRANSFERENCIA',
    ADEUDO_SEPA: 'ADEUDO_SEPA',
    CONFIRMING: 'CONFIRMING'
};
export const DedicationCreateResultDtoStatusEnum = {
    OK: 'OK',
    WARNING: 'WARNING',
    ERROR: 'ERROR'
};
export const DedicationImportResultDtoStatusEnum = {
    OK: 'OK',
    WARNING: 'WARNING',
    ERROR: 'ERROR'
};
export const DocumentAccessesEnum = {
    ADMIN: 'ADMIN',
    ADMIN_BILLING: 'ADMIN_BILLING',
    ADMIN_CONTROLLING: 'ADMIN_CONTROLLING',
    ADMIN_EMPLOYEE: 'ADMIN_EMPLOYEE',
    ADMIN_RECRUITMENT: 'ADMIN_RECRUITMENT',
    ADMIN_PROJECT: 'ADMIN_PROJECT',
    ADMIN_MARKETING: 'ADMIN_MARKETING',
    ADMIN_ACCOUNTING: 'ADMIN_ACCOUNTING',
    ADMIN_COMPLIANCE: 'ADMIN_COMPLIANCE',
    EMPLOYEE: 'EMPLOYEE',
    PUBLIC: 'PUBLIC'
};
export const DocumentReviewStatusEnum = {
    SIN_REVISION: 'SIN_REVISION',
    VIGENTE: 'VIGENTE',
    POR_REVISAR: 'POR_REVISAR',
    CADUCADO: 'CADUCADO'
};
export const DocumentRolesEnum = {
    MANAGEMENT: 'MANAGEMENT',
    INFORMATION_OWNER: 'INFORMATION_OWNER',
    SERVICE_OWNER: 'SERVICE_OWNER',
    SYSTEM_OWNER: 'SYSTEM_OWNER',
    SECURITY_OFFICER: 'SECURITY_OFFICER',
    QUALITY_COORDINATOR: 'QUALITY_COORDINATOR',
    INTERNAL_AUDITOR: 'INTERNAL_AUDITOR',
    SECURITY_CONTACT: 'SECURITY_CONTACT'
};
export const DocumentListAccessesEnum = {
    ADMIN: 'ADMIN',
    ADMIN_BILLING: 'ADMIN_BILLING',
    ADMIN_CONTROLLING: 'ADMIN_CONTROLLING',
    ADMIN_EMPLOYEE: 'ADMIN_EMPLOYEE',
    ADMIN_RECRUITMENT: 'ADMIN_RECRUITMENT',
    ADMIN_PROJECT: 'ADMIN_PROJECT',
    ADMIN_MARKETING: 'ADMIN_MARKETING',
    ADMIN_ACCOUNTING: 'ADMIN_ACCOUNTING',
    ADMIN_COMPLIANCE: 'ADMIN_COMPLIANCE',
    EMPLOYEE: 'EMPLOYEE',
    PUBLIC: 'PUBLIC'
};
export const DocumentListReviewStatusEnum = {
    SIN_REVISION: 'SIN_REVISION',
    VIGENTE: 'VIGENTE',
    POR_REVISAR: 'POR_REVISAR',
    CADUCADO: 'CADUCADO'
};
export const DocumentListRolesEnum = {
    MANAGEMENT: 'MANAGEMENT',
    INFORMATION_OWNER: 'INFORMATION_OWNER',
    SERVICE_OWNER: 'SERVICE_OWNER',
    SYSTEM_OWNER: 'SYSTEM_OWNER',
    SECURITY_OFFICER: 'SECURITY_OFFICER',
    QUALITY_COORDINATOR: 'QUALITY_COORDINATOR',
    INTERNAL_AUDITOR: 'INTERNAL_AUDITOR',
    SECURITY_CONTACT: 'SECURITY_CONTACT'
};
export const DocumentReviewDtoStatusEnum = {
    SIN_REVISION: 'SIN_REVISION',
    VIGENTE: 'VIGENTE',
    POR_REVISAR: 'POR_REVISAR',
    CADUCADO: 'CADUCADO'
};
export const FixedAssetAmortizationMethodEnum = {
    LINEAL: 'LINEAL',
    DEGRESIVO: 'DEGRESIVO'
};
export const FixedAssetStatusEnum = {
    ACTIVO: 'ACTIVO',
    AMORTIZADO: 'AMORTIZADO',
    DADO_DE_BAJA: 'DADO_DE_BAJA'
};
export const FixedAssetListAmortizationMethodEnum = {
    LINEAL: 'LINEAL',
    DEGRESIVO: 'DEGRESIVO'
};
export const FixedAssetListStatusEnum = {
    ACTIVO: 'ACTIVO',
    AMORTIZADO: 'AMORTIZADO',
    DADO_DE_BAJA: 'DADO_DE_BAJA'
};
export const HolidayCalendarEnum = {
    PALMA: 'PALMA',
    MADRID: 'MADRID'
};
export const HolidayListCalendarEnum = {
    PALMA: 'PALMA',
    MADRID: 'MADRID'
};
export const IndicatorToneEnum = {
    GOOD: 'GOOD',
    WARNING: 'WARNING',
    BAD: 'BAD',
    EMPTY: 'EMPTY',
    NO_SOURCE: 'NO_SOURCE'
};
export const InterviewExitRiskEnum = {
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH'
};
export const InterviewHealthEnum = {
    GREEN: 'GREEN',
    AMBER: 'AMBER',
    RED: 'RED'
};
export const InterviewBoardRowLastExitRiskEnum = {
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH'
};
export const InterviewBoardRowLastHealthEnum = {
    GREEN: 'GREEN',
    AMBER: 'AMBER',
    RED: 'RED'
};
export const InterviewBoardRowNextDueBasisEnum = {
    PLANNED: 'PLANNED',
    FOLLOW_UP: 'FOLLOW_UP',
    ONBOARDING: 'ONBOARDING',
    REGULAR: 'REGULAR'
};
export const InterviewBoardRowStatusEnum = {
    UP_TO_DATE: 'UP_TO_DATE',
    DUE_SOON: 'DUE_SOON',
    OVERDUE: 'OVERDUE',
    NO_CADENCE: 'NO_CADENCE'
};
export const InterviewListExitRiskEnum = {
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH'
};
export const InterviewListHealthEnum = {
    GREEN: 'GREEN',
    AMBER: 'AMBER',
    RED: 'RED'
};
export const JournalEntryOriginEnum = {
    MANUAL: 'MANUAL',
    AUTO_FACTURA: 'AUTO_FACTURA',
    AUTO_NOMINA: 'AUTO_NOMINA',
    AUTO_COBRO: 'AUTO_COBRO',
    AUTO_AMORTIZACION: 'AUTO_AMORTIZACION',
    CONTASOL: 'CONTASOL',
    APERTURA: 'APERTURA',
    CIERRE: 'CIERRE',
    REGULARIZACION: 'REGULARIZACION'
};
export const JournalEntryStatusEnum = {
    BORRADOR: 'BORRADOR',
    CONFIRMADO: 'CONFIRMADO',
    ANULADO: 'ANULADO'
};
export const JournalEntryListOriginEnum = {
    MANUAL: 'MANUAL',
    AUTO_FACTURA: 'AUTO_FACTURA',
    AUTO_NOMINA: 'AUTO_NOMINA',
    AUTO_COBRO: 'AUTO_COBRO',
    AUTO_AMORTIZACION: 'AUTO_AMORTIZACION',
    CONTASOL: 'CONTASOL',
    APERTURA: 'APERTURA',
    CIERRE: 'CIERRE',
    REGULARIZACION: 'REGULARIZACION'
};
export const JournalEntryListStatusEnum = {
    BORRADOR: 'BORRADOR',
    CONFIRMADO: 'CONFIRMADO',
    ANULADO: 'ANULADO'
};
export const LeadCommercialEmailBasisEnum = {
    CLIENT: 'CLIENT',
    CONSENT: 'CONSENT',
    B2B_TO_REVIEW: 'B2B_TO_REVIEW',
    NONE: 'NONE',
    OPTED_OUT: 'OPTED_OUT'
};
export const LeadInOperationEnum = {
    EN_OPERACION: 'EN_OPERACION',
    NO_ARRANCADO: 'NO_ARRANCADO'
};
export const LeadMaintainedByEnum = {
    INTERNO: 'INTERNO',
    AGENCIA: 'AGENCIA',
    NADIE: 'NADIE'
};
export const LeadSourceEnum = {
    WEB_FORM: 'WEB_FORM',
    NEWSLETTER: 'NEWSLETTER',
    EMAIL_INBOUND: 'EMAIL_INBOUND',
    REFERRAL: 'REFERRAL',
    IMPORT: 'IMPORT',
    EVENT: 'EVENT',
    MANUAL: 'MANUAL',
    OUTBOUND: 'OUTBOUND',
    SOCIAL: 'SOCIAL',
    OTHER: 'OTHER'
};
export const LeadStatusEnum = {
    NEW: 'NEW',
    CONTACTED: 'CONTACTED',
    QUALIFIED: 'QUALIFIED',
    CONVERTED: 'CONVERTED',
    DISCARDED: 'DISCARDED'
};
export const LeadListCommercialEmailBasisEnum = {
    CLIENT: 'CLIENT',
    CONSENT: 'CONSENT',
    B2B_TO_REVIEW: 'B2B_TO_REVIEW',
    NONE: 'NONE',
    OPTED_OUT: 'OPTED_OUT'
};
export const LeadListInOperationEnum = {
    EN_OPERACION: 'EN_OPERACION',
    NO_ARRANCADO: 'NO_ARRANCADO'
};
export const LeadListMaintainedByEnum = {
    INTERNO: 'INTERNO',
    AGENCIA: 'AGENCIA',
    NADIE: 'NADIE'
};
export const LeadListSourceEnum = {
    WEB_FORM: 'WEB_FORM',
    NEWSLETTER: 'NEWSLETTER',
    EMAIL_INBOUND: 'EMAIL_INBOUND',
    REFERRAL: 'REFERRAL',
    IMPORT: 'IMPORT',
    EVENT: 'EVENT',
    MANUAL: 'MANUAL',
    OUTBOUND: 'OUTBOUND',
    SOCIAL: 'SOCIAL',
    OTHER: 'OTHER'
};
export const LeadListStatusEnum = {
    NEW: 'NEW',
    CONTACTED: 'CONTACTED',
    QUALIFIED: 'QUALIFIED',
    CONVERTED: 'CONVERTED',
    DISCARDED: 'DISCARDED'
};
export const LeadSummaryCommercialEmailBasisEnum = {
    CLIENT: 'CLIENT',
    CONSENT: 'CONSENT',
    B2B_TO_REVIEW: 'B2B_TO_REVIEW',
    NONE: 'NONE',
    OPTED_OUT: 'OPTED_OUT'
};
export const LeadSummaryInOperationEnum = {
    EN_OPERACION: 'EN_OPERACION',
    NO_ARRANCADO: 'NO_ARRANCADO'
};
export const LeadSummaryMaintainedByEnum = {
    INTERNO: 'INTERNO',
    AGENCIA: 'AGENCIA',
    NADIE: 'NADIE'
};
export const LeadSummarySourceEnum = {
    WEB_FORM: 'WEB_FORM',
    NEWSLETTER: 'NEWSLETTER',
    EMAIL_INBOUND: 'EMAIL_INBOUND',
    REFERRAL: 'REFERRAL',
    IMPORT: 'IMPORT',
    EVENT: 'EVENT',
    MANUAL: 'MANUAL',
    OUTBOUND: 'OUTBOUND',
    SOCIAL: 'SOCIAL',
    OTHER: 'OTHER'
};
export const LeadSummaryStatusEnum = {
    NEW: 'NEW',
    CONTACTED: 'CONTACTED',
    QUALIFIED: 'QUALIFIED',
    CONVERTED: 'CONVERTED',
    DISCARDED: 'DISCARDED'
};
export const ManagementRoleAssignmentRoleEnum = {
    MANAGEMENT: 'MANAGEMENT',
    INFORMATION_OWNER: 'INFORMATION_OWNER',
    SERVICE_OWNER: 'SERVICE_OWNER',
    SYSTEM_OWNER: 'SYSTEM_OWNER',
    SECURITY_OFFICER: 'SECURITY_OFFICER',
    QUALITY_COORDINATOR: 'QUALITY_COORDINATOR',
    INTERNAL_AUDITOR: 'INTERNAL_AUDITOR',
    SECURITY_CONTACT: 'SECURITY_CONTACT'
};
export const ManagementRoleAssignmentListRoleEnum = {
    MANAGEMENT: 'MANAGEMENT',
    INFORMATION_OWNER: 'INFORMATION_OWNER',
    SERVICE_OWNER: 'SERVICE_OWNER',
    SYSTEM_OWNER: 'SYSTEM_OWNER',
    SECURITY_OFFICER: 'SECURITY_OFFICER',
    QUALITY_COORDINATOR: 'QUALITY_COORDINATOR',
    INTERNAL_AUDITOR: 'INTERNAL_AUDITOR',
    SECURITY_CONTACT: 'SECURITY_CONTACT'
};
export const ManagementRoleViewRoleEnum = {
    MANAGEMENT: 'MANAGEMENT',
    INFORMATION_OWNER: 'INFORMATION_OWNER',
    SERVICE_OWNER: 'SERVICE_OWNER',
    SYSTEM_OWNER: 'SYSTEM_OWNER',
    SECURITY_OFFICER: 'SECURITY_OFFICER',
    QUALITY_COORDINATOR: 'QUALITY_COORDINATOR',
    INTERNAL_AUDITOR: 'INTERNAL_AUDITOR',
    SECURITY_CONTACT: 'SECURITY_CONTACT'
};
export const Modelo200DataRegimeEnum = {
    GENERAL: 'GENERAL',
    REDUCED_SIZE: 'REDUCED_SIZE',
    MICRO: 'MICRO'
};
export const Modelo200RequestRegimeEnum = {
    GENERAL: 'GENERAL',
    REDUCED_SIZE: 'REDUCED_SIZE',
    MICRO: 'MICRO'
};
export const Modelo202DataModeEnum = {
    ART_40_2: 'ART_40_2',
    ART_40_3: 'ART_40_3'
};
export const Modelo202RequestModeEnum = {
    ART_40_2: 'ART_40_2',
    ART_40_3: 'ART_40_3'
};
export const Modelo202RequestRegimeEnum = {
    GENERAL: 'GENERAL',
    REDUCED_SIZE: 'REDUCED_SIZE',
    MICRO: 'MICRO'
};
export const OrgRequestStatusEnum = {
    DETECTED: 'DETECTED',
    PROPOSED: 'PROPOSED',
    WON: 'WON',
    LOST: 'LOST',
    LOST_ON_PRICE: 'LOST_ON_PRICE'
};
export const OrgRequestListStatusEnum = {
    DETECTED: 'DETECTED',
    PROPOSED: 'PROPOSED',
    WON: 'WON',
    LOST: 'LOST',
    LOST_ON_PRICE: 'LOST_ON_PRICE'
};
export const OrganizationStatusEnum = {
    ACTIVO: 'ACTIVO',
    EX_CLIENTE: 'EX_CLIENTE',
    NO_REACTIVAR: 'NO_REACTIVAR'
};
export const OrganizationListStatusEnum = {
    ACTIVO: 'ACTIVO',
    EX_CLIENTE: 'EX_CLIENTE',
    NO_REACTIVAR: 'NO_REACTIVAR'
};
export const PayrollPackTypeEnum = {
    PLA: 'PLA',
    OTHER: 'OTHER'
};
export const PayrollPackListTypeEnum = {
    PLA: 'PLA',
    OTHER: 'OTHER'
};
export const PendingActionKindEnum = {
    DONE: 'DONE',
    POSTPONED: 'POSTPONED',
    EXCEPTION: 'EXCEPTION'
};
export const PendingActionRequestKindEnum = {
    DONE: 'DONE',
    POSTPONED: 'POSTPONED',
    EXCEPTION: 'EXCEPTION'
};
export const PendingItemAlsoForEnum = {
    MANAGEMENT: 'MANAGEMENT',
    HR: 'HR',
    QUALITY: 'QUALITY',
    SECURITY: 'SECURITY',
    SYSTEM: 'SYSTEM',
    ACCOUNTING: 'ACCOUNTING'
};
export const PendingItemAudienceEnum = {
    MANAGEMENT: 'MANAGEMENT',
    HR: 'HR',
    QUALITY: 'QUALITY',
    SECURITY: 'SECURITY',
    SYSTEM: 'SYSTEM',
    ACCOUNTING: 'ACCOUNTING'
};
export const PendingItemSeverityEnum = {
    OVERDUE: 'OVERDUE',
    SOON: 'SOON',
    INFO: 'INFO'
};
export const PermissionRolEnum = {
    ADMIN: 'ADMIN',
    ADMIN_BILLING: 'ADMIN_BILLING',
    ADMIN_CONTROLLING: 'ADMIN_CONTROLLING',
    ADMIN_EMPLOYEE: 'ADMIN_EMPLOYEE',
    ADMIN_RECRUITMENT: 'ADMIN_RECRUITMENT',
    ADMIN_PROJECT: 'ADMIN_PROJECT',
    ADMIN_MARKETING: 'ADMIN_MARKETING',
    ADMIN_ACCOUNTING: 'ADMIN_ACCOUNTING',
    ADMIN_COMPLIANCE: 'ADMIN_COMPLIANCE',
    EMPLOYEE: 'EMPLOYEE',
    PUBLIC: 'PUBLIC'
};
export const PermissionListRolEnum = {
    ADMIN: 'ADMIN',
    ADMIN_BILLING: 'ADMIN_BILLING',
    ADMIN_CONTROLLING: 'ADMIN_CONTROLLING',
    ADMIN_EMPLOYEE: 'ADMIN_EMPLOYEE',
    ADMIN_RECRUITMENT: 'ADMIN_RECRUITMENT',
    ADMIN_PROJECT: 'ADMIN_PROJECT',
    ADMIN_MARKETING: 'ADMIN_MARKETING',
    ADMIN_ACCOUNTING: 'ADMIN_ACCOUNTING',
    ADMIN_COMPLIANCE: 'ADMIN_COMPLIANCE',
    EMPLOYEE: 'EMPLOYEE',
    PUBLIC: 'PUBLIC'
};
export const PersonCalendarEnum = {
    PALMA: 'PALMA',
    MADRID: 'MADRID'
};
export const PersonWorkModeEnum = {
    ON_SITE: 'ON_SITE',
    REMOTE: 'REMOTE',
    HYBRID: 'HYBRID'
};
export const PersonDocumentRetentionBasisEnum = {
    FORMER_STAFF: 'FORMER_STAFF',
    DOCUMENT_AGE: 'DOCUMENT_AGE',
    SUPERSEDED: 'SUPERSEDED',
    CANDIDATE_CONTACT: 'CANDIDATE_CONTACT'
};
export const PersonDocumentRetentionListBasisEnum = {
    FORMER_STAFF: 'FORMER_STAFF',
    DOCUMENT_AGE: 'DOCUMENT_AGE',
    SUPERSEDED: 'SUPERSEDED',
    CANDIDATE_CONTACT: 'CANDIDATE_CONTACT'
};
export const PersonDocumentTypeExpirationModeEnum = {
    NONE: 'NONE',
    MANUAL: 'MANUAL',
    AUTO: 'AUTO'
};
export const PersonDocumentTypeRequiredPeriodEnum = {
    ONCE: 'ONCE',
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
export const PersonDocumentTypeListExpirationModeEnum = {
    NONE: 'NONE',
    MANUAL: 'MANUAL',
    AUTO: 'AUTO'
};
export const PersonDocumentTypeListRequiredPeriodEnum = {
    ONCE: 'ONCE',
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
export const PersonListCalendarEnum = {
    PALMA: 'PALMA',
    MADRID: 'MADRID'
};
export const PersonListWorkModeEnum = {
    ON_SITE: 'ON_SITE',
    REMOTE: 'REMOTE',
    HYBRID: 'HYBRID'
};
export const PresalesRowDtoBallEnum = {
    OURS: 'OURS',
    THEIRS: 'THEIRS',
    NOBODY: 'NOBODY'
};
export const PresalesRowDtoStatusEnum = {
    DETECTED: 'DETECTED',
    PROPOSED: 'PROPOSED',
    WON: 'WON',
    LOST: 'LOST',
    LOST_ON_PRICE: 'LOST_ON_PRICE'
};
export const QualityActionStatusEnum = {
    PENDIENTE: 'PENDIENTE',
    EN_CURSO: 'EN_CURSO',
    HECHA: 'HECHA',
    DESCARTADA: 'DESCARTADA'
};
export const QualityActionTypeEnum = {
    CORRECCION: 'CORRECCION',
    CORRECTIVA: 'CORRECTIVA',
    MEJORA: 'MEJORA'
};
export const QualityActionListStatusEnum = {
    PENDIENTE: 'PENDIENTE',
    EN_CURSO: 'EN_CURSO',
    HECHA: 'HECHA',
    DESCARTADA: 'DESCARTADA'
};
export const QualityActionListTypeEnum = {
    CORRECCION: 'CORRECCION',
    CORRECTIVA: 'CORRECTIVA',
    MEJORA: 'MEJORA'
};
export const QualityFindingOriginEnum = {
    AUDITORIA_INTERNA: 'AUDITORIA_INTERNA',
    AUDITORIA_EXTERNA: 'AUDITORIA_EXTERNA',
    CLIENTE: 'CLIENTE',
    OPERACION: 'OPERACION',
    REVISION_DIRECCION: 'REVISION_DIRECCION',
    PROVEEDOR: 'PROVEEDOR'
};
export const QualityFindingSeverityEnum = {
    BAJA: 'BAJA',
    MEDIA: 'MEDIA',
    ALTA: 'ALTA'
};
export const QualityFindingStatusEnum = {
    ABIERTA: 'ABIERTA',
    EN_ANALISIS: 'EN_ANALISIS',
    EN_TRATAMIENTO: 'EN_TRATAMIENTO',
    PENDIENTE_EFICACIA: 'PENDIENTE_EFICACIA',
    CERRADA: 'CERRADA'
};
export const QualityFindingTypeEnum = {
    NO_CONFORMIDAD: 'NO_CONFORMIDAD',
    INCIDENTE_SEGURIDAD: 'INCIDENTE_SEGURIDAD',
    RECLAMACION: 'RECLAMACION',
    OPORTUNIDAD_MEJORA: 'OPORTUNIDAD_MEJORA'
};
export const QualityFindingListOriginEnum = {
    AUDITORIA_INTERNA: 'AUDITORIA_INTERNA',
    AUDITORIA_EXTERNA: 'AUDITORIA_EXTERNA',
    CLIENTE: 'CLIENTE',
    OPERACION: 'OPERACION',
    REVISION_DIRECCION: 'REVISION_DIRECCION',
    PROVEEDOR: 'PROVEEDOR'
};
export const QualityFindingListSeverityEnum = {
    BAJA: 'BAJA',
    MEDIA: 'MEDIA',
    ALTA: 'ALTA'
};
export const QualityFindingListStatusEnum = {
    ABIERTA: 'ABIERTA',
    EN_ANALISIS: 'EN_ANALISIS',
    EN_TRATAMIENTO: 'EN_TRATAMIENTO',
    PENDIENTE_EFICACIA: 'PENDIENTE_EFICACIA',
    CERRADA: 'CERRADA'
};
export const QualityFindingListTypeEnum = {
    NO_CONFORMIDAD: 'NO_CONFORMIDAD',
    INCIDENTE_SEGURIDAD: 'INCIDENTE_SEGURIDAD',
    RECLAMACION: 'RECLAMACION',
    OPORTUNIDAD_MEJORA: 'OPORTUNIDAD_MEJORA'
};
export const RecordAttachmentKindEnum = {
    SENT: 'SENT',
    SIGNED: 'SIGNED',
    RECEIVED: 'RECEIVED',
    OTHER: 'OTHER'
};
export const RecordAttachmentRecordTypeEnum = {
    BUDGET: 'BUDGET',
    BILL: 'BILL',
    CUSTOMER: 'CUSTOMER',
    SUPPLIER: 'SUPPLIER',
    ORGANIZATION: 'ORGANIZATION',
    ORG_REQUEST: 'ORG_REQUEST'
};
export const RecordAttachmentListKindEnum = {
    SENT: 'SENT',
    SIGNED: 'SIGNED',
    RECEIVED: 'RECEIVED',
    OTHER: 'OTHER'
};
export const RecordAttachmentListRecordTypeEnum = {
    BUDGET: 'BUDGET',
    BILL: 'BILL',
    CUSTOMER: 'CUSTOMER',
    SUPPLIER: 'SUPPLIER',
    ORGANIZATION: 'ORGANIZATION',
    ORG_REQUEST: 'ORG_REQUEST'
};
export const RecruitmentStatusEnum = {
    STARTED: 'STARTED',
    FINISHED: 'FINISHED',
    DESISTED: 'DESISTED'
};
export const RecruitmentListStatusEnum = {
    STARTED: 'STARTED',
    FINISHED: 'FINISHED',
    DESISTED: 'DESISTED'
};
export const RecurrentProposalDtoMonthMonthEnum = {
    JANUARY: 'JANUARY',
    FEBRUARY: 'FEBRUARY',
    MARCH: 'MARCH',
    APRIL: 'APRIL',
    MAY: 'MAY',
    JUNE: 'JUNE',
    JULY: 'JULY',
    AUGUST: 'AUGUST',
    SEPTEMBER: 'SEPTEMBER',
    OCTOBER: 'OCTOBER',
    NOVEMBER: 'NOVEMBER',
    DECEMBER: 'DECEMBER'
};
export const RecurrentProposalLineBillingPeriodEnum = {
    MENSUAL: 'MENSUAL',
    TRIMESTRAL: 'TRIMESTRAL',
    ANUAL: 'ANUAL'
};
export const RequiredDocumentCellStatusEnum = {
    OK: 'OK',
    EXPIRED: 'EXPIRED',
    MISSING: 'MISSING',
    NOT_DUE: 'NOT_DUE'
};
export const RequiredDocumentTypePeriodEnum = {
    ONCE: 'ONCE',
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
export const SalaryRoleEnum = {
    DEVELOPER: 'DEVELOPER',
    TEAM_LEAD: 'TEAM_LEAD',
    TECH_LEAD: 'TECH_LEAD',
    ARCHITECT: 'ARCHITECT',
    PROJECT_MANAGER: 'PROJECT_MANAGER',
    SUPPORT: 'SUPPORT'
};
export const SalaryRoleLevelEnum = {
    PRACTICE: 'PRACTICE',
    JUNIOR: 'JUNIOR',
    MID: 'MID',
    SENIOR: 'SENIOR'
};
export const SalaryIssueTypeEnum = {
    DUPLICATE_START_DATE: 'DUPLICATE_START_DATE',
    NO_SALARY_FOR_PERIOD: 'NO_SALARY_FOR_PERIOD'
};
export const SalaryListRoleEnum = {
    DEVELOPER: 'DEVELOPER',
    TEAM_LEAD: 'TEAM_LEAD',
    TECH_LEAD: 'TECH_LEAD',
    ARCHITECT: 'ARCHITECT',
    PROJECT_MANAGER: 'PROJECT_MANAGER',
    SUPPORT: 'SUPPORT'
};
export const SalaryListRoleLevelEnum = {
    PRACTICE: 'PRACTICE',
    JUNIOR: 'JUNIOR',
    MID: 'MID',
    SENIOR: 'SENIOR'
};
export const SearchResultDtoTargetTypeEnum = {
    PERSON: 'PERSON',
    PERSON_DOCUMENT: 'PERSON_DOCUMENT',
    TRAINING_RECORD: 'TRAINING_RECORD',
    CANDIDATE: 'CANDIDATE',
    CANDIDATE_DOCUMENT: 'CANDIDATE_DOCUMENT',
    LEVEL_TEST: 'LEVEL_TEST',
    LEVEL_SOLUTION: 'LEVEL_SOLUTION',
    RECRUITMENT: 'RECRUITMENT',
    RECRUITMENT_DOCUMENT: 'RECRUITMENT_DOCUMENT',
    CUSTOMER: 'CUSTOMER',
    BILL: 'BILL',
    BUDGET: 'BUDGET',
    SUPPLIER: 'SUPPLIER',
    SUPPLIER_BILL: 'SUPPLIER_BILL',
    ORGANIZATION: 'ORGANIZATION',
    CONTACT: 'CONTACT',
    LEAD: 'LEAD',
    ORG_REQUEST: 'ORG_REQUEST',
    QUALITY_FINDING: 'QUALITY_FINDING',
    ACCESS_REVIEW: 'ACCESS_REVIEW',
    COMPANY_DOCUMENT: 'COMPANY_DOCUMENT',
    WIKI_PAGE: 'WIKI_PAGE',
    RECORD_ATTACHMENT: 'RECORD_ATTACHMENT'
};
export const SearchResultDtoTypeEnum = {
    PERSON: 'PERSON',
    PERSON_DOCUMENT: 'PERSON_DOCUMENT',
    TRAINING_RECORD: 'TRAINING_RECORD',
    CANDIDATE: 'CANDIDATE',
    CANDIDATE_DOCUMENT: 'CANDIDATE_DOCUMENT',
    LEVEL_TEST: 'LEVEL_TEST',
    LEVEL_SOLUTION: 'LEVEL_SOLUTION',
    RECRUITMENT: 'RECRUITMENT',
    RECRUITMENT_DOCUMENT: 'RECRUITMENT_DOCUMENT',
    CUSTOMER: 'CUSTOMER',
    BILL: 'BILL',
    BUDGET: 'BUDGET',
    SUPPLIER: 'SUPPLIER',
    SUPPLIER_BILL: 'SUPPLIER_BILL',
    ORGANIZATION: 'ORGANIZATION',
    CONTACT: 'CONTACT',
    LEAD: 'LEAD',
    ORG_REQUEST: 'ORG_REQUEST',
    QUALITY_FINDING: 'QUALITY_FINDING',
    ACCESS_REVIEW: 'ACCESS_REVIEW',
    COMPANY_DOCUMENT: 'COMPANY_DOCUMENT',
    WIKI_PAGE: 'WIKI_PAGE',
    RECORD_ATTACHMENT: 'RECORD_ATTACHMENT'
};
export const SepaMandateSchemeEnum = {
    CORE: 'CORE',
    B2B: 'B2B'
};
export const SepaMandateStatusEnum = {
    ACTIVO: 'ACTIVO',
    REVOCADO: 'REVOCADO',
    CADUCADO: 'CADUCADO'
};
export const SepaMandateListSchemeEnum = {
    CORE: 'CORE',
    B2B: 'B2B'
};
export const SepaMandateListStatusEnum = {
    ACTIVO: 'ACTIVO',
    REVOCADO: 'REVOCADO',
    CADUCADO: 'CADUCADO'
};
export const SepaRemittanceStatusEnum = {
    BORRADOR: 'BORRADOR',
    PRESENTADA: 'PRESENTADA'
};
export const SepaRemittanceListStatusEnum = {
    BORRADOR: 'BORRADOR',
    PRESENTADA: 'PRESENTADA'
};
export const SocialAccountProviderEnum = {
    FACEBOOK: 'FACEBOOK',
    INSTAGRAM: 'INSTAGRAM',
    LINKEDIN: 'LINKEDIN'
};
export const SocialAccountStatusEnum = {
    CONNECTED: 'CONNECTED',
    EXPIRED: 'EXPIRED',
    DISCONNECTED: 'DISCONNECTED',
    ERROR: 'ERROR'
};
export const SocialAccountListProviderEnum = {
    FACEBOOK: 'FACEBOOK',
    INSTAGRAM: 'INSTAGRAM',
    LINKEDIN: 'LINKEDIN'
};
export const SocialAccountListStatusEnum = {
    CONNECTED: 'CONNECTED',
    EXPIRED: 'EXPIRED',
    DISCONNECTED: 'DISCONNECTED',
    ERROR: 'ERROR'
};
export const SocialPostStatusEnum = {
    DRAFT: 'DRAFT',
    SCHEDULED: 'SCHEDULED',
    PUBLISHED: 'PUBLISHED',
    PARTIAL: 'PARTIAL',
    FAILED: 'FAILED'
};
export const SocialPostListStatusEnum = {
    DRAFT: 'DRAFT',
    SCHEDULED: 'SCHEDULED',
    PUBLISHED: 'PUBLISHED',
    PARTIAL: 'PARTIAL',
    FAILED: 'FAILED'
};
export const SocialPublicationProviderEnum = {
    FACEBOOK: 'FACEBOOK',
    INSTAGRAM: 'INSTAGRAM',
    LINKEDIN: 'LINKEDIN'
};
export const SocialPublicationStatusEnum = {
    PENDING: 'PENDING',
    PUBLISHED: 'PUBLISHED',
    FAILED: 'FAILED'
};
export const SocialPublicationListProviderEnum = {
    FACEBOOK: 'FACEBOOK',
    INSTAGRAM: 'INSTAGRAM',
    LINKEDIN: 'LINKEDIN'
};
export const SocialPublicationListStatusEnum = {
    PENDING: 'PENDING',
    PUBLISHED: 'PUBLISHED',
    FAILED: 'FAILED'
};
export const TaxSubmissionModelTypeEnum = {
    M303_IVA: 'M303_IVA',
    M111_IRPF: 'M111_IRPF',
    M190_IRPF_ANUAL: 'M190_IRPF_ANUAL',
    M202_IS: 'M202_IS',
    M200_IS_ANUAL: 'M200_IS_ANUAL',
    M390_IVA_ANUAL: 'M390_IVA_ANUAL',
    M347_TERCEROS: 'M347_TERCEROS',
    M115_ALQUILER: 'M115_ALQUILER',
    M180_ALQUILER_ANUAL: 'M180_ALQUILER_ANUAL',
    M349_INTRACOMUNITARIO: 'M349_INTRACOMUNITARIO',
    M130_IRPF_AUTONOMO: 'M130_IRPF_AUTONOMO',
    LEGALIZACION_LIBROS: 'LEGALIZACION_LIBROS',
    APROBACION_CUENTAS: 'APROBACION_CUENTAS',
    DOCUMENTACION_DEPOSITO: 'DOCUMENTACION_DEPOSITO',
    DEPOSITO_CUENTAS: 'DEPOSITO_CUENTAS',
    SEGUROS_SOCIALES: 'SEGUROS_SOCIALES',
    PAGO_NOMINAS: 'PAGO_NOMINAS'
};
export const TaxSubmissionStatusEnum = {
    PENDIENTE: 'PENDIENTE',
    PRESENTADO: 'PRESENTADO',
    ACEPTADO: 'ACEPTADO',
    RECHAZADO: 'RECHAZADO'
};
export const TaxSubmissionTaxRegimeEnum = {
    GENERAL: 'GENERAL',
    REDUCED_SIZE: 'REDUCED_SIZE',
    MICRO: 'MICRO'
};
export const TaxSubmissionListModelTypeEnum = {
    M303_IVA: 'M303_IVA',
    M111_IRPF: 'M111_IRPF',
    M190_IRPF_ANUAL: 'M190_IRPF_ANUAL',
    M202_IS: 'M202_IS',
    M200_IS_ANUAL: 'M200_IS_ANUAL',
    M390_IVA_ANUAL: 'M390_IVA_ANUAL',
    M347_TERCEROS: 'M347_TERCEROS',
    M115_ALQUILER: 'M115_ALQUILER',
    M180_ALQUILER_ANUAL: 'M180_ALQUILER_ANUAL',
    M349_INTRACOMUNITARIO: 'M349_INTRACOMUNITARIO',
    M130_IRPF_AUTONOMO: 'M130_IRPF_AUTONOMO',
    LEGALIZACION_LIBROS: 'LEGALIZACION_LIBROS',
    APROBACION_CUENTAS: 'APROBACION_CUENTAS',
    DOCUMENTACION_DEPOSITO: 'DOCUMENTACION_DEPOSITO',
    DEPOSITO_CUENTAS: 'DEPOSITO_CUENTAS',
    SEGUROS_SOCIALES: 'SEGUROS_SOCIALES',
    PAGO_NOMINAS: 'PAGO_NOMINAS'
};
export const TaxSubmissionListStatusEnum = {
    PENDIENTE: 'PENDIENTE',
    PRESENTADO: 'PRESENTADO',
    ACEPTADO: 'ACEPTADO',
    RECHAZADO: 'RECHAZADO'
};
export const TaxSubmissionListTaxRegimeEnum = {
    GENERAL: 'GENERAL',
    REDUCED_SIZE: 'REDUCED_SIZE',
    MICRO: 'MICRO'
};
export const TimeClockCorrectionDtoStatusEnum = {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED'
};
export const TimeClockCrossCheckRowKindEnum = {
    NO_TIME_CLOCK: 'NO_TIME_CLOCK',
    INCOMPLETE_TIME_CLOCK: 'INCOMPLETE_TIME_CLOCK',
    MISMATCH: 'MISMATCH'
};
export const TimeClockEntryDtoOriginEnum = {
    WEB: 'WEB',
    CORRECTION: 'CORRECTION'
};
export const TimeClockEntryDtoStatusEnum = {
    OPEN: 'OPEN',
    COMPLETE: 'COMPLETE',
    INCOMPLETE: 'INCOMPLETE'
};
export const TokenCheckProviderEnum = {
    FACEBOOK: 'FACEBOOK',
    INSTAGRAM: 'INSTAGRAM',
    LINKEDIN: 'LINKEDIN'
};
export const TrainingRecordAreaEnum = {
    SEGURIDAD: 'SEGURIDAD',
    PROTECCION_DATOS: 'PROTECCION_DATOS',
    CALIDAD: 'CALIDAD',
    TECNICA: 'TECNICA',
    PRL: 'PRL',
    OTRA: 'OTRA'
};
export const TrainingRecordKindEnum = {
    FORMACION: 'FORMACION',
    CONCIENCIACION: 'CONCIENCIACION'
};
export const TrainingRecordStatusEnum = {
    PLANIFICADA: 'PLANIFICADA',
    REALIZADA: 'REALIZADA',
    CANCELADA: 'CANCELADA'
};
export const TrainingRecordListAreaEnum = {
    SEGURIDAD: 'SEGURIDAD',
    PROTECCION_DATOS: 'PROTECCION_DATOS',
    CALIDAD: 'CALIDAD',
    TECNICA: 'TECNICA',
    PRL: 'PRL',
    OTRA: 'OTRA'
};
export const TrainingRecordListKindEnum = {
    FORMACION: 'FORMACION',
    CONCIENCIACION: 'CONCIENCIACION'
};
export const TrainingRecordListStatusEnum = {
    PLANIFICADA: 'PLANIFICADA',
    REALIZADA: 'REALIZADA',
    CANCELADA: 'CANCELADA'
};
export const TrainingSessionDtoAreaEnum = {
    SEGURIDAD: 'SEGURIDAD',
    PROTECCION_DATOS: 'PROTECCION_DATOS',
    CALIDAD: 'CALIDAD',
    TECNICA: 'TECNICA',
    PRL: 'PRL',
    OTRA: 'OTRA'
};
export const TrainingSessionDtoKindEnum = {
    FORMACION: 'FORMACION',
    CONCIENCIACION: 'CONCIENCIACION'
};
export const TrainingSessionDtoStatusEnum = {
    PLANIFICADA: 'PLANIFICADA',
    REALIZADA: 'REALIZADA',
    CANCELADA: 'CANCELADA'
};
export const UserAuthItemTypeEnum = {
    ADMIN: 'ADMIN',
    ADMIN_BILLING: 'ADMIN_BILLING',
    ADMIN_CONTROLLING: 'ADMIN_CONTROLLING',
    ADMIN_EMPLOYEE: 'ADMIN_EMPLOYEE',
    ADMIN_RECRUITMENT: 'ADMIN_RECRUITMENT',
    ADMIN_PROJECT: 'ADMIN_PROJECT',
    ADMIN_MARKETING: 'ADMIN_MARKETING',
    ADMIN_ACCOUNTING: 'ADMIN_ACCOUNTING',
    ADMIN_COMPLIANCE: 'ADMIN_COMPLIANCE',
    EMPLOYEE: 'EMPLOYEE',
    PUBLIC: 'PUBLIC'
};
export const VacationCalendarEnum = {
    PALMA: 'PALMA',
    MADRID: 'MADRID'
};
export const VacationStateEnum = {
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    PENDING: 'PENDING'
};
export const VacationTypeEnum = {
    HOLIDAY: 'HOLIDAY',
    SICK_LEAVE: 'SICK_LEAVE',
    PATERNITY_LEAVE: 'PATERNITY_LEAVE',
    ERTE: 'ERTE',
    ERTE_50: 'ERTE_50',
    GIFT: 'GIFT',
    MOVING: 'MOVING',
    WEDDING: 'WEDDING',
    UNPAID_LEAVE: 'UNPAID_LEAVE',
    FAMILIAR_HOSPITALIZATION: 'FAMILIAR_HOSPITALIZATION'
};
export const VacationListCalendarEnum = {
    PALMA: 'PALMA',
    MADRID: 'MADRID'
};
export const VacationListStateEnum = {
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    PENDING: 'PENDING'
};
export const VacationListTypeEnum = {
    HOLIDAY: 'HOLIDAY',
    SICK_LEAVE: 'SICK_LEAVE',
    PATERNITY_LEAVE: 'PATERNITY_LEAVE',
    ERTE: 'ERTE',
    ERTE_50: 'ERTE_50',
    GIFT: 'GIFT',
    MOVING: 'MOVING',
    WEDDING: 'WEDDING',
    UNPAID_LEAVE: 'UNPAID_LEAVE',
    FAMILIAR_HOSPITALIZATION: 'FAMILIAR_HOSPITALIZATION'
};
export const VacationRequestStateEnum = {
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    PENDING: 'PENDING'
};
export const VacationRequestTypeEnum = {
    HOLIDAY: 'HOLIDAY',
    SICK_LEAVE: 'SICK_LEAVE',
    PATERNITY_LEAVE: 'PATERNITY_LEAVE',
    ERTE: 'ERTE',
    ERTE_50: 'ERTE_50',
    GIFT: 'GIFT',
    MOVING: 'MOVING',
    WEDDING: 'WEDDING',
    UNPAID_LEAVE: 'UNPAID_LEAVE',
    FAMILIAR_HOSPITALIZATION: 'FAMILIAR_HOSPITALIZATION'
};
export const VatBookBookTypeEnum = {
    EMITIDAS: 'EMITIDAS',
    RECIBIDAS: 'RECIBIDAS'
};
export const VatBookStatusEnum = {
    PENDIENTE: 'PENDIENTE',
    PRESENTADO: 'PRESENTADO',
    ACEPTADO: 'ACEPTADO',
    RECHAZADO: 'RECHAZADO'
};
export const VatBookListBookTypeEnum = {
    EMITIDAS: 'EMITIDAS',
    RECIBIDAS: 'RECIBIDAS'
};
export const VatBookListStatusEnum = {
    PENDIENTE: 'PENDIENTE',
    PRESENTADO: 'PRESENTADO',
    ACEPTADO: 'ACEPTADO',
    RECHAZADO: 'RECHAZADO'
};
export const VerifactuRecordInvoiceTypeEnum = {
    F1: 'F1',
    F2: 'F2',
    F3: 'F3',
    R1: 'R1',
    R2: 'R2',
    R3: 'R3',
    R4: 'R4',
    R5: 'R5'
};
export const VerifactuRecordRecordTypeEnum = {
    ALTA: 'ALTA',
    ANULACION: 'ANULACION'
};
export const VerifactuRecordSubmissionStatusEnum = {
    PENDIENTE: 'PENDIENTE',
    ACEPTADO: 'ACEPTADO',
    ACEPTADO_CON_ERRORES: 'ACEPTADO_CON_ERRORES',
    RECHAZADO: 'RECHAZADO'
};
export const VerifactuRecordListInvoiceTypeEnum = {
    F1: 'F1',
    F2: 'F2',
    F3: 'F3',
    R1: 'R1',
    R2: 'R2',
    R3: 'R3',
    R4: 'R4',
    R5: 'R5'
};
export const VerifactuRecordListRecordTypeEnum = {
    ALTA: 'ALTA',
    ANULACION: 'ANULACION'
};
export const VerifactuRecordListSubmissionStatusEnum = {
    PENDIENTE: 'PENDIENTE',
    ACEPTADO: 'ACEPTADO',
    ACEPTADO_CON_ERRORES: 'ACEPTADO_CON_ERRORES',
    RECHAZADO: 'RECHAZADO'
};
export const WorkCenterCalendarEnum = {
    PALMA: 'PALMA',
    MADRID: 'MADRID'
};
export const WorkCenterListCalendarEnum = {
    PALMA: 'PALMA',
    MADRID: 'MADRID'
};
/**
 * AccessReviewRestControllerApi - axios parameter creator
 * @export
 */
export const AccessReviewRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAccessReview: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/quality/access-review/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissAccessReview: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissAccessReview', 'id', id);
            const localVarPath = `/api/admin/quality/access-review/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchAccessReview: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchAccessReview', 'ids', ids);
            const localVarPath = `/api/admin/quality/access-review/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessReview: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAccessReview', 'id', id);
            const localVarPath = `/api/admin/quality/access-review/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessReview: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/quality/access-review/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageAccessReview: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/quality/access-review/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {AccessReview} accessReview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAccessReview: async (accessReview, options = {}) => {
            // verify required parameter 'accessReview' is not null or undefined
            assertParamExists('saveAccessReview', 'accessReview', accessReview);
            const localVarPath = `/api/admin/quality/access-review/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(accessReview, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {UsersAccessReviewSystemEnum} [system]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersAccessReview: async (system, options = {}) => {
            const localVarPath = `/api/admin/quality/access-review/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (system !== undefined) {
                localVarQueryParameter['system'] = system;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {UsersCsvAccessReviewSystemEnum} [system]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCsvAccessReview: async (system, options = {}) => {
            const localVarPath = `/api/admin/quality/access-review/users.csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (system !== undefined) {
                localVarQueryParameter['system'] = system;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewAccessReview: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('viewAccessReview', 'id', id);
            const localVarPath = `/api/admin/quality/access-review/view/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccessReviewRestControllerApi - functional programming interface
 * @export
 */
export const AccessReviewRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccessReviewRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countAccessReview(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countAccessReview(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessReviewRestControllerApi.countAccessReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissAccessReview(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissAccessReview(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessReviewRestControllerApi.deleteOrDismissAccessReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchAccessReview(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchAccessReview(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessReviewRestControllerApi.deleteOrDismissInBatchAccessReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessReview(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessReview(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessReviewRestControllerApi.getAccessReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccessReview(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccessReview(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessReviewRestControllerApi.listAccessReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageAccessReview(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageAccessReview(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessReviewRestControllerApi.pageAccessReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {AccessReview} accessReview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAccessReview(accessReview, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAccessReview(accessReview, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessReviewRestControllerApi.saveAccessReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {UsersAccessReviewSystemEnum} [system]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersAccessReview(system, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersAccessReview(system, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessReviewRestControllerApi.usersAccessReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {UsersCsvAccessReviewSystemEnum} [system]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersCsvAccessReview(system, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersCsvAccessReview(system, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessReviewRestControllerApi.usersCsvAccessReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewAccessReview(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewAccessReview(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessReviewRestControllerApi.viewAccessReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AccessReviewRestControllerApi - factory interface
 * @export
 */
export const AccessReviewRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccessReviewRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAccessReview(term, showDismissed, options) {
            return localVarFp.countAccessReview(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissAccessReview(id, options) {
            return localVarFp.deleteOrDismissAccessReview(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchAccessReview(ids, options) {
            return localVarFp.deleteOrDismissInBatchAccessReview(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessReview(id, options) {
            return localVarFp.getAccessReview(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessReview(term, showDismissed, options) {
            return localVarFp.listAccessReview(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageAccessReview(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageAccessReview(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AccessReview} accessReview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAccessReview(accessReview, options) {
            return localVarFp.saveAccessReview(accessReview, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UsersAccessReviewSystemEnum} [system]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersAccessReview(system, options) {
            return localVarFp.usersAccessReview(system, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UsersCsvAccessReviewSystemEnum} [system]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCsvAccessReview(system, options) {
            return localVarFp.usersCsvAccessReview(system, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewAccessReview(id, options) {
            return localVarFp.viewAccessReview(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccessReviewRestControllerApi - object-oriented interface
 * @export
 * @class AccessReviewRestControllerApi
 * @extends {BaseAPI}
 */
export class AccessReviewRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessReviewRestControllerApi
     */
    countAccessReview(term, showDismissed, options) {
        return AccessReviewRestControllerApiFp(this.configuration).countAccessReview(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessReviewRestControllerApi
     */
    deleteOrDismissAccessReview(id, options) {
        return AccessReviewRestControllerApiFp(this.configuration).deleteOrDismissAccessReview(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessReviewRestControllerApi
     */
    deleteOrDismissInBatchAccessReview(ids, options) {
        return AccessReviewRestControllerApiFp(this.configuration).deleteOrDismissInBatchAccessReview(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessReviewRestControllerApi
     */
    getAccessReview(id, options) {
        return AccessReviewRestControllerApiFp(this.configuration).getAccessReview(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessReviewRestControllerApi
     */
    listAccessReview(term, showDismissed, options) {
        return AccessReviewRestControllerApiFp(this.configuration).listAccessReview(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessReviewRestControllerApi
     */
    pageAccessReview(page, size, sort, term, showDismissed, options) {
        return AccessReviewRestControllerApiFp(this.configuration).pageAccessReview(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AccessReview} accessReview
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessReviewRestControllerApi
     */
    saveAccessReview(accessReview, options) {
        return AccessReviewRestControllerApiFp(this.configuration).saveAccessReview(accessReview, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UsersAccessReviewSystemEnum} [system]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessReviewRestControllerApi
     */
    usersAccessReview(system, options) {
        return AccessReviewRestControllerApiFp(this.configuration).usersAccessReview(system, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UsersCsvAccessReviewSystemEnum} [system]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessReviewRestControllerApi
     */
    usersCsvAccessReview(system, options) {
        return AccessReviewRestControllerApiFp(this.configuration).usersCsvAccessReview(system, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessReviewRestControllerApi
     */
    viewAccessReview(id, options) {
        return AccessReviewRestControllerApiFp(this.configuration).viewAccessReview(id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const UsersAccessReviewSystemEnum = {
    EXTRANET: 'EXTRANET',
    GITEA: 'GITEA',
    REDMINE: 'REDMINE'
};
/**
 * @export
 */
export const UsersCsvAccessReviewSystemEnum = {
    EXTRANET: 'EXTRANET',
    GITEA: 'GITEA',
    REDMINE: 'REDMINE'
};
/**
 * AccountingAccountRestControllerApi - axios parameter creator
 * @export
 */
export const AccountingAccountRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        childrenAccountingAccount: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('childrenAccountingAccount', 'id', id);
            const localVarPath = `/api/admin/accounting/account/{id}/children`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CountAccountingAccountAccountTypeEnum} [accountType]
         * @param {number} [accountGroup]
         * @param {number} [parentId]
         * @param {boolean} [rootsOnly]
         * @param {boolean} [isPymes]
         * @param {boolean} [recentFirst]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAccountingAccount: async (accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/account/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (accountType !== undefined) {
                localVarQueryParameter['accountType'] = accountType;
            }
            if (accountGroup !== undefined) {
                localVarQueryParameter['accountGroup'] = accountGroup;
            }
            if (parentId !== undefined) {
                localVarQueryParameter['parentId'] = parentId;
            }
            if (rootsOnly !== undefined) {
                localVarQueryParameter['rootsOnly'] = rootsOnly;
            }
            if (isPymes !== undefined) {
                localVarQueryParameter['isPymes'] = isPymes;
            }
            if (recentFirst !== undefined) {
                localVarQueryParameter['recentFirst'] = recentFirst;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissAccountingAccount: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissAccountingAccount', 'id', id);
            const localVarPath = `/api/admin/accounting/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchAccountingAccount: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchAccountingAccount', 'ids', ids);
            const localVarPath = `/api/admin/accounting/account/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingAccount: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAccountingAccount', 'id', id);
            const localVarPath = `/api/admin/accounting/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ListAccountingAccountAccountTypeEnum} [accountType]
         * @param {number} [accountGroup]
         * @param {number} [parentId]
         * @param {boolean} [rootsOnly]
         * @param {boolean} [isPymes]
         * @param {boolean} [recentFirst]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountingAccount: async (accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/account/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (accountType !== undefined) {
                localVarQueryParameter['accountType'] = accountType;
            }
            if (accountGroup !== undefined) {
                localVarQueryParameter['accountGroup'] = accountGroup;
            }
            if (parentId !== undefined) {
                localVarQueryParameter['parentId'] = parentId;
            }
            if (rootsOnly !== undefined) {
                localVarQueryParameter['rootsOnly'] = rootsOnly;
            }
            if (isPymes !== undefined) {
                localVarQueryParameter['isPymes'] = isPymes;
            }
            if (recentFirst !== undefined) {
                localVarQueryParameter['recentFirst'] = recentFirst;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageAccountingAccountAccountTypeEnum} [accountType]
         * @param {number} [accountGroup]
         * @param {number} [parentId]
         * @param {boolean} [rootsOnly]
         * @param {boolean} [isPymes]
         * @param {boolean} [recentFirst]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageAccountingAccount: async (page, size, sort, accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/account/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (accountType !== undefined) {
                localVarQueryParameter['accountType'] = accountType;
            }
            if (accountGroup !== undefined) {
                localVarQueryParameter['accountGroup'] = accountGroup;
            }
            if (parentId !== undefined) {
                localVarQueryParameter['parentId'] = parentId;
            }
            if (rootsOnly !== undefined) {
                localVarQueryParameter['rootsOnly'] = rootsOnly;
            }
            if (isPymes !== undefined) {
                localVarQueryParameter['isPymes'] = isPymes;
            }
            if (recentFirst !== undefined) {
                localVarQueryParameter['recentFirst'] = recentFirst;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootsAccountingAccount: async (options = {}) => {
            const localVarPath = `/api/admin/accounting/account/roots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {AccountingAccount} accountingAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAccountingAccount: async (accountingAccount, options = {}) => {
            // verify required parameter 'accountingAccount' is not null or undefined
            assertParamExists('saveAccountingAccount', 'accountingAccount', accountingAccount);
            const localVarPath = `/api/admin/accounting/account/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(accountingAccount, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountingAccountRestControllerApi - functional programming interface
 * @export
 */
export const AccountingAccountRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountingAccountRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async childrenAccountingAccount(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.childrenAccountingAccount(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingAccountRestControllerApi.childrenAccountingAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CountAccountingAccountAccountTypeEnum} [accountType]
         * @param {number} [accountGroup]
         * @param {number} [parentId]
         * @param {boolean} [rootsOnly]
         * @param {boolean} [isPymes]
         * @param {boolean} [recentFirst]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countAccountingAccount(accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countAccountingAccount(accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingAccountRestControllerApi.countAccountingAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissAccountingAccount(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissAccountingAccount(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingAccountRestControllerApi.deleteOrDismissAccountingAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchAccountingAccount(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchAccountingAccount(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingAccountRestControllerApi.deleteOrDismissInBatchAccountingAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountingAccount(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountingAccount(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingAccountRestControllerApi.getAccountingAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ListAccountingAccountAccountTypeEnum} [accountType]
         * @param {number} [accountGroup]
         * @param {number} [parentId]
         * @param {boolean} [rootsOnly]
         * @param {boolean} [isPymes]
         * @param {boolean} [recentFirst]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccountingAccount(accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccountingAccount(accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingAccountRestControllerApi.listAccountingAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageAccountingAccountAccountTypeEnum} [accountType]
         * @param {number} [accountGroup]
         * @param {number} [parentId]
         * @param {boolean} [rootsOnly]
         * @param {boolean} [isPymes]
         * @param {boolean} [recentFirst]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageAccountingAccount(page, size, sort, accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageAccountingAccount(page, size, sort, accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingAccountRestControllerApi.pageAccountingAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootsAccountingAccount(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootsAccountingAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingAccountRestControllerApi.rootsAccountingAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {AccountingAccount} accountingAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAccountingAccount(accountingAccount, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAccountingAccount(accountingAccount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingAccountRestControllerApi.saveAccountingAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AccountingAccountRestControllerApi - factory interface
 * @export
 */
export const AccountingAccountRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountingAccountRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        childrenAccountingAccount(id, options) {
            return localVarFp.childrenAccountingAccount(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CountAccountingAccountAccountTypeEnum} [accountType]
         * @param {number} [accountGroup]
         * @param {number} [parentId]
         * @param {boolean} [rootsOnly]
         * @param {boolean} [isPymes]
         * @param {boolean} [recentFirst]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAccountingAccount(accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options) {
            return localVarFp.countAccountingAccount(accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissAccountingAccount(id, options) {
            return localVarFp.deleteOrDismissAccountingAccount(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchAccountingAccount(ids, options) {
            return localVarFp.deleteOrDismissInBatchAccountingAccount(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingAccount(id, options) {
            return localVarFp.getAccountingAccount(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ListAccountingAccountAccountTypeEnum} [accountType]
         * @param {number} [accountGroup]
         * @param {number} [parentId]
         * @param {boolean} [rootsOnly]
         * @param {boolean} [isPymes]
         * @param {boolean} [recentFirst]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountingAccount(accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options) {
            return localVarFp.listAccountingAccount(accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageAccountingAccountAccountTypeEnum} [accountType]
         * @param {number} [accountGroup]
         * @param {number} [parentId]
         * @param {boolean} [rootsOnly]
         * @param {boolean} [isPymes]
         * @param {boolean} [recentFirst]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageAccountingAccount(page, size, sort, accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options) {
            return localVarFp.pageAccountingAccount(page, size, sort, accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootsAccountingAccount(options) {
            return localVarFp.rootsAccountingAccount(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AccountingAccount} accountingAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAccountingAccount(accountingAccount, options) {
            return localVarFp.saveAccountingAccount(accountingAccount, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountingAccountRestControllerApi - object-oriented interface
 * @export
 * @class AccountingAccountRestControllerApi
 * @extends {BaseAPI}
 */
export class AccountingAccountRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingAccountRestControllerApi
     */
    childrenAccountingAccount(id, options) {
        return AccountingAccountRestControllerApiFp(this.configuration).childrenAccountingAccount(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CountAccountingAccountAccountTypeEnum} [accountType]
     * @param {number} [accountGroup]
     * @param {number} [parentId]
     * @param {boolean} [rootsOnly]
     * @param {boolean} [isPymes]
     * @param {boolean} [recentFirst]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingAccountRestControllerApi
     */
    countAccountingAccount(accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options) {
        return AccountingAccountRestControllerApiFp(this.configuration).countAccountingAccount(accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingAccountRestControllerApi
     */
    deleteOrDismissAccountingAccount(id, options) {
        return AccountingAccountRestControllerApiFp(this.configuration).deleteOrDismissAccountingAccount(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingAccountRestControllerApi
     */
    deleteOrDismissInBatchAccountingAccount(ids, options) {
        return AccountingAccountRestControllerApiFp(this.configuration).deleteOrDismissInBatchAccountingAccount(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingAccountRestControllerApi
     */
    getAccountingAccount(id, options) {
        return AccountingAccountRestControllerApiFp(this.configuration).getAccountingAccount(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ListAccountingAccountAccountTypeEnum} [accountType]
     * @param {number} [accountGroup]
     * @param {number} [parentId]
     * @param {boolean} [rootsOnly]
     * @param {boolean} [isPymes]
     * @param {boolean} [recentFirst]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingAccountRestControllerApi
     */
    listAccountingAccount(accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options) {
        return AccountingAccountRestControllerApiFp(this.configuration).listAccountingAccount(accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {PageAccountingAccountAccountTypeEnum} [accountType]
     * @param {number} [accountGroup]
     * @param {number} [parentId]
     * @param {boolean} [rootsOnly]
     * @param {boolean} [isPymes]
     * @param {boolean} [recentFirst]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingAccountRestControllerApi
     */
    pageAccountingAccount(page, size, sort, accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options) {
        return AccountingAccountRestControllerApiFp(this.configuration).pageAccountingAccount(page, size, sort, accountType, accountGroup, parentId, rootsOnly, isPymes, recentFirst, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingAccountRestControllerApi
     */
    rootsAccountingAccount(options) {
        return AccountingAccountRestControllerApiFp(this.configuration).rootsAccountingAccount(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AccountingAccount} accountingAccount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingAccountRestControllerApi
     */
    saveAccountingAccount(accountingAccount, options) {
        return AccountingAccountRestControllerApiFp(this.configuration).saveAccountingAccount(accountingAccount, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountAccountingAccountAccountTypeEnum = {
    ACTIVO: 'ACTIVO',
    PASIVO: 'PASIVO',
    NETO: 'NETO',
    INGRESO: 'INGRESO',
    GASTO: 'GASTO'
};
/**
 * @export
 */
export const ListAccountingAccountAccountTypeEnum = {
    ACTIVO: 'ACTIVO',
    PASIVO: 'PASIVO',
    NETO: 'NETO',
    INGRESO: 'INGRESO',
    GASTO: 'GASTO'
};
/**
 * @export
 */
export const PageAccountingAccountAccountTypeEnum = {
    ACTIVO: 'ACTIVO',
    PASIVO: 'PASIVO',
    NETO: 'NETO',
    INGRESO: 'INGRESO',
    GASTO: 'GASTO'
};
/**
 * AccountingDashboardRestControllerApi - axios parameter creator
 * @export
 */
export const AccountingDashboardRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard: async (options = {}) => {
            const localVarPath = `/api/admin/accounting/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountingDashboardRestControllerApi - functional programming interface
 * @export
 */
export const AccountingDashboardRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountingDashboardRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboard(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboard(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingDashboardRestControllerApi.getDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AccountingDashboardRestControllerApi - factory interface
 * @export
 */
export const AccountingDashboardRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountingDashboardRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard(options) {
            return localVarFp.getDashboard(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountingDashboardRestControllerApi - object-oriented interface
 * @export
 * @class AccountingDashboardRestControllerApi
 * @extends {BaseAPI}
 */
export class AccountingDashboardRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingDashboardRestControllerApi
     */
    getDashboard(options) {
        return AccountingDashboardRestControllerApiFp(this.configuration).getDashboard(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AccountingForecastRestControllerApi - axios parameter creator
 * @export
 */
export const AccountingForecastRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forecast: async (options = {}) => {
            const localVarPath = `/api/admin/accounting/forecast`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forecastSettings: async (options = {}) => {
            const localVarPath = `/api/admin/accounting/forecast/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {AccountingForecastSettings} accountingForecastSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveForecastSettings: async (accountingForecastSettings, options = {}) => {
            // verify required parameter 'accountingForecastSettings' is not null or undefined
            assertParamExists('saveForecastSettings', 'accountingForecastSettings', accountingForecastSettings);
            const localVarPath = `/api/admin/accounting/forecast/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(accountingForecastSettings, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountingForecastRestControllerApi - functional programming interface
 * @export
 */
export const AccountingForecastRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountingForecastRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forecast(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forecast(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingForecastRestControllerApi.forecast']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forecastSettings(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forecastSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingForecastRestControllerApi.forecastSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {AccountingForecastSettings} accountingForecastSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveForecastSettings(accountingForecastSettings, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveForecastSettings(accountingForecastSettings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingForecastRestControllerApi.saveForecastSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AccountingForecastRestControllerApi - factory interface
 * @export
 */
export const AccountingForecastRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountingForecastRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forecast(options) {
            return localVarFp.forecast(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forecastSettings(options) {
            return localVarFp.forecastSettings(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AccountingForecastSettings} accountingForecastSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveForecastSettings(accountingForecastSettings, options) {
            return localVarFp.saveForecastSettings(accountingForecastSettings, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountingForecastRestControllerApi - object-oriented interface
 * @export
 * @class AccountingForecastRestControllerApi
 * @extends {BaseAPI}
 */
export class AccountingForecastRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingForecastRestControllerApi
     */
    forecast(options) {
        return AccountingForecastRestControllerApiFp(this.configuration).forecast(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingForecastRestControllerApi
     */
    forecastSettings(options) {
        return AccountingForecastRestControllerApiFp(this.configuration).forecastSettings(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AccountingForecastSettings} accountingForecastSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingForecastRestControllerApi
     */
    saveForecastSettings(accountingForecastSettings, options) {
        return AccountingForecastRestControllerApiFp(this.configuration).saveForecastSettings(accountingForecastSettings, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AccountingGenerationRestControllerApi - axios parameter creator
 * @export
 */
export const AccountingGenerationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} movementId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fromBankMovement: async (movementId, options = {}) => {
            // verify required parameter 'movementId' is not null or undefined
            assertParamExists('fromBankMovement', 'movementId', movementId);
            const localVarPath = `/api/admin/accounting/generate/bank-movement/{movementId}`
                .replace(`{${"movementId"}}`, encodeURIComponent(String(movementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fromBill: async (billId, options = {}) => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('fromBill', 'billId', billId);
            const localVarPath = `/api/admin/accounting/generate/bill/{billId}`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} packId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fromPayrollPack: async (packId, options = {}) => {
            // verify required parameter 'packId' is not null or undefined
            assertParamExists('fromPayrollPack', 'packId', packId);
            const localVarPath = `/api/admin/accounting/generate/payroll-pack/{packId}`
                .replace(`{${"packId"}}`, encodeURIComponent(String(packId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountingGenerationRestControllerApi - functional programming interface
 * @export
 */
export const AccountingGenerationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountingGenerationRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} movementId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fromBankMovement(movementId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fromBankMovement(movementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingGenerationRestControllerApi.fromBankMovement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fromBill(billId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fromBill(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingGenerationRestControllerApi.fromBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} packId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fromPayrollPack(packId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fromPayrollPack(packId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingGenerationRestControllerApi.fromPayrollPack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AccountingGenerationRestControllerApi - factory interface
 * @export
 */
export const AccountingGenerationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountingGenerationRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} movementId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fromBankMovement(movementId, options) {
            return localVarFp.fromBankMovement(movementId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fromBill(billId, options) {
            return localVarFp.fromBill(billId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} packId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fromPayrollPack(packId, options) {
            return localVarFp.fromPayrollPack(packId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountingGenerationRestControllerApi - object-oriented interface
 * @export
 * @class AccountingGenerationRestControllerApi
 * @extends {BaseAPI}
 */
export class AccountingGenerationRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} movementId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingGenerationRestControllerApi
     */
    fromBankMovement(movementId, options) {
        return AccountingGenerationRestControllerApiFp(this.configuration).fromBankMovement(movementId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} billId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingGenerationRestControllerApi
     */
    fromBill(billId, options) {
        return AccountingGenerationRestControllerApiFp(this.configuration).fromBill(billId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} packId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingGenerationRestControllerApi
     */
    fromPayrollPack(packId, options) {
        return AccountingGenerationRestControllerApiFp(this.configuration).fromPayrollPack(packId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AccountingPeriodRestControllerApi - axios parameter creator
 * @export
 */
export const AccountingPeriodRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeAccountingPeriod: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('closeAccountingPeriod', 'id', id);
            const localVarPath = `/api/admin/accounting/period/{id}/close`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [yearValue]
         * @param {CountAccountingPeriodStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAccountingPeriod: async (yearValue, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/period/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (yearValue !== undefined) {
                localVarQueryParameter['yearValue'] = yearValue;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentAccountingPeriod: async (options = {}) => {
            const localVarPath = `/api/admin/accounting/period/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissAccountingPeriod: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissAccountingPeriod', 'id', id);
            const localVarPath = `/api/admin/accounting/period/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchAccountingPeriod: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchAccountingPeriod', 'ids', ids);
            const localVarPath = `/api/admin/accounting/period/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingPeriod: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAccountingPeriod', 'id', id);
            const localVarPath = `/api/admin/accounting/period/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [yearValue]
         * @param {ListAccountingPeriodStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountingPeriod: async (yearValue, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/period/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (yearValue !== undefined) {
                localVarQueryParameter['yearValue'] = yearValue;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockAccountingPeriod: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('lockAccountingPeriod', 'id', id);
            const localVarPath = `/api/admin/accounting/period/{id}/lock`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [yearValue]
         * @param {PageAccountingPeriodStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageAccountingPeriod: async (page, size, sort, yearValue, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/period/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (yearValue !== undefined) {
                localVarQueryParameter['yearValue'] = yearValue;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {AccountingPeriod} accountingPeriod
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAccountingPeriod: async (accountingPeriod, options = {}) => {
            // verify required parameter 'accountingPeriod' is not null or undefined
            assertParamExists('saveAccountingPeriod', 'accountingPeriod', accountingPeriod);
            const localVarPath = `/api/admin/accounting/period/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(accountingPeriod, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountingPeriodRestControllerApi - functional programming interface
 * @export
 */
export const AccountingPeriodRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountingPeriodRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeAccountingPeriod(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeAccountingPeriod(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingPeriodRestControllerApi.closeAccountingPeriod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [yearValue]
         * @param {CountAccountingPeriodStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countAccountingPeriod(yearValue, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countAccountingPeriod(yearValue, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingPeriodRestControllerApi.countAccountingPeriod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currentAccountingPeriod(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currentAccountingPeriod(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingPeriodRestControllerApi.currentAccountingPeriod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissAccountingPeriod(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissAccountingPeriod(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingPeriodRestControllerApi.deleteOrDismissAccountingPeriod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchAccountingPeriod(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchAccountingPeriod(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingPeriodRestControllerApi.deleteOrDismissInBatchAccountingPeriod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountingPeriod(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountingPeriod(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingPeriodRestControllerApi.getAccountingPeriod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [yearValue]
         * @param {ListAccountingPeriodStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccountingPeriod(yearValue, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccountingPeriod(yearValue, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingPeriodRestControllerApi.listAccountingPeriod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockAccountingPeriod(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lockAccountingPeriod(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingPeriodRestControllerApi.lockAccountingPeriod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [yearValue]
         * @param {PageAccountingPeriodStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageAccountingPeriod(page, size, sort, yearValue, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageAccountingPeriod(page, size, sort, yearValue, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingPeriodRestControllerApi.pageAccountingPeriod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {AccountingPeriod} accountingPeriod
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAccountingPeriod(accountingPeriod, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAccountingPeriod(accountingPeriod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingPeriodRestControllerApi.saveAccountingPeriod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AccountingPeriodRestControllerApi - factory interface
 * @export
 */
export const AccountingPeriodRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountingPeriodRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeAccountingPeriod(id, options) {
            return localVarFp.closeAccountingPeriod(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [yearValue]
         * @param {CountAccountingPeriodStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAccountingPeriod(yearValue, status, term, showDismissed, options) {
            return localVarFp.countAccountingPeriod(yearValue, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentAccountingPeriod(options) {
            return localVarFp.currentAccountingPeriod(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissAccountingPeriod(id, options) {
            return localVarFp.deleteOrDismissAccountingPeriod(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchAccountingPeriod(ids, options) {
            return localVarFp.deleteOrDismissInBatchAccountingPeriod(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingPeriod(id, options) {
            return localVarFp.getAccountingPeriod(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [yearValue]
         * @param {ListAccountingPeriodStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountingPeriod(yearValue, status, term, showDismissed, options) {
            return localVarFp.listAccountingPeriod(yearValue, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockAccountingPeriod(id, options) {
            return localVarFp.lockAccountingPeriod(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [yearValue]
         * @param {PageAccountingPeriodStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageAccountingPeriod(page, size, sort, yearValue, status, term, showDismissed, options) {
            return localVarFp.pageAccountingPeriod(page, size, sort, yearValue, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AccountingPeriod} accountingPeriod
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAccountingPeriod(accountingPeriod, options) {
            return localVarFp.saveAccountingPeriod(accountingPeriod, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountingPeriodRestControllerApi - object-oriented interface
 * @export
 * @class AccountingPeriodRestControllerApi
 * @extends {BaseAPI}
 */
export class AccountingPeriodRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingPeriodRestControllerApi
     */
    closeAccountingPeriod(id, options) {
        return AccountingPeriodRestControllerApiFp(this.configuration).closeAccountingPeriod(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [yearValue]
     * @param {CountAccountingPeriodStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingPeriodRestControllerApi
     */
    countAccountingPeriod(yearValue, status, term, showDismissed, options) {
        return AccountingPeriodRestControllerApiFp(this.configuration).countAccountingPeriod(yearValue, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingPeriodRestControllerApi
     */
    currentAccountingPeriod(options) {
        return AccountingPeriodRestControllerApiFp(this.configuration).currentAccountingPeriod(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingPeriodRestControllerApi
     */
    deleteOrDismissAccountingPeriod(id, options) {
        return AccountingPeriodRestControllerApiFp(this.configuration).deleteOrDismissAccountingPeriod(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingPeriodRestControllerApi
     */
    deleteOrDismissInBatchAccountingPeriod(ids, options) {
        return AccountingPeriodRestControllerApiFp(this.configuration).deleteOrDismissInBatchAccountingPeriod(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingPeriodRestControllerApi
     */
    getAccountingPeriod(id, options) {
        return AccountingPeriodRestControllerApiFp(this.configuration).getAccountingPeriod(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [yearValue]
     * @param {ListAccountingPeriodStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingPeriodRestControllerApi
     */
    listAccountingPeriod(yearValue, status, term, showDismissed, options) {
        return AccountingPeriodRestControllerApiFp(this.configuration).listAccountingPeriod(yearValue, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingPeriodRestControllerApi
     */
    lockAccountingPeriod(id, options) {
        return AccountingPeriodRestControllerApiFp(this.configuration).lockAccountingPeriod(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [yearValue]
     * @param {PageAccountingPeriodStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingPeriodRestControllerApi
     */
    pageAccountingPeriod(page, size, sort, yearValue, status, term, showDismissed, options) {
        return AccountingPeriodRestControllerApiFp(this.configuration).pageAccountingPeriod(page, size, sort, yearValue, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AccountingPeriod} accountingPeriod
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingPeriodRestControllerApi
     */
    saveAccountingPeriod(accountingPeriod, options) {
        return AccountingPeriodRestControllerApiFp(this.configuration).saveAccountingPeriod(accountingPeriod, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountAccountingPeriodStatusEnum = {
    ABIERTO: 'ABIERTO',
    CERRADO: 'CERRADO',
    BLOQUEADO: 'BLOQUEADO'
};
/**
 * @export
 */
export const ListAccountingPeriodStatusEnum = {
    ABIERTO: 'ABIERTO',
    CERRADO: 'CERRADO',
    BLOQUEADO: 'BLOQUEADO'
};
/**
 * @export
 */
export const PageAccountingPeriodStatusEnum = {
    ABIERTO: 'ABIERTO',
    CERRADO: 'CERRADO',
    BLOQUEADO: 'BLOQUEADO'
};
/**
 * AccountingReportRestControllerApi - axios parameter creator
 * @export
 */
export const AccountingReportRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditExport: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('auditExport', 'year', year);
            const localVarPath = `/api/admin/accounting/reports/audit-export/{year}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {string} [dateTo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceSheet: async (year, dateTo, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('balanceSheet', 'year', year);
            const localVarPath = `/api/admin/accounting/reports/balance-sheet/{year}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString().substring(0, 10) :
                    dateTo;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {string} prefixes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drilldown: async (year, prefixes, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('drilldown', 'year', year);
            // verify required parameter 'prefixes' is not null or undefined
            assertParamExists('drilldown', 'prefixes', prefixes);
            const localVarPath = `/api/admin/accounting/reports/drilldown/{year}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (prefixes !== undefined) {
                localVarQueryParameter['prefixes'] = prefixes;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalLedger: async (dateFrom, dateTo, options = {}) => {
            // verify required parameter 'dateFrom' is not null or undefined
            assertParamExists('generalLedger', 'dateFrom', dateFrom);
            // verify required parameter 'dateTo' is not null or undefined
            assertParamExists('generalLedger', 'dateTo', dateTo);
            const localVarPath = `/api/admin/accounting/reports/general-ledger`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString().substring(0, 10) :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString().substring(0, 10) :
                    dateTo;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateClosingEntry: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('generateClosingEntry', 'year', year);
            const localVarPath = `/api/admin/accounting/reports/close/{year}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOpeningEntry: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('generateOpeningEntry', 'year', year);
            const localVarPath = `/api/admin/accounting/reports/open/{year}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfficialBooks: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getOfficialBooks', 'year', year);
            const localVarPath = `/api/admin/accounting/reports/official-books/{year}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        journalBook: async (dateFrom, dateTo, options = {}) => {
            // verify required parameter 'dateFrom' is not null or undefined
            assertParamExists('journalBook', 'dateFrom', dateFrom);
            // verify required parameter 'dateTo' is not null or undefined
            assertParamExists('journalBook', 'dateTo', dateTo);
            const localVarPath = `/api/admin/accounting/reports/journal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString().substring(0, 10) :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString().substring(0, 10) :
                    dateTo;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} [month]
         * @param {number} [digits]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        layerBalance: async (year, month, digits, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('layerBalance', 'year', year);
            const localVarPath = `/api/admin/accounting/reports/layer-balance/{year}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (digits !== undefined) {
                localVarQueryParameter['digits'] = digits;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        layerOverlap: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('layerOverlap', 'year', year);
            const localVarPath = `/api/admin/accounting/reports/layer-balance/{year}/overlap`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {string} accountCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ledger: async (year, accountCode, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('ledger', 'year', year);
            // verify required parameter 'accountCode' is not null or undefined
            assertParamExists('ledger', 'accountCode', accountCode);
            const localVarPath = `/api/admin/accounting/reports/ledger/{year}/{accountCode}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"accountCode"}}`, encodeURIComponent(String(accountCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        officialInventoryPdf: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('officialInventoryPdf', 'year', year);
            const localVarPath = `/api/admin/accounting/reports/official-books/{year}/inventarios.pdf`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        officialJournalPdf: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('officialJournalPdf', 'year', year);
            const localVarPath = `/api/admin/accounting/reports/official-books/{year}/diario.pdf`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profitLoss: async (year, dateFrom, dateTo, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('profitLoss', 'year', year);
            const localVarPath = `/api/admin/accounting/reports/profit-loss/{year}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString().substring(0, 10) :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString().substring(0, 10) :
                    dateTo;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} accountCode
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statement: async (accountCode, dateFrom, dateTo, options = {}) => {
            // verify required parameter 'accountCode' is not null or undefined
            assertParamExists('statement', 'accountCode', accountCode);
            // verify required parameter 'dateFrom' is not null or undefined
            assertParamExists('statement', 'dateFrom', dateFrom);
            // verify required parameter 'dateTo' is not null or undefined
            assertParamExists('statement', 'dateTo', dateTo);
            const localVarPath = `/api/admin/accounting/reports/statement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (accountCode !== undefined) {
                localVarQueryParameter['accountCode'] = accountCode;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString().substring(0, 10) :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString().substring(0, 10) :
                    dateTo;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trialBalance: async (year, dateFrom, dateTo, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('trialBalance', 'year', year);
            const localVarPath = `/api/admin/accounting/reports/trial-balance/{year}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString().substring(0, 10) :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString().substring(0, 10) :
                    dateTo;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withholdingsReceived: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('withholdingsReceived', 'year', year);
            const localVarPath = `/api/admin/accounting/reports/withholdings-received/{year}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountingReportRestControllerApi - functional programming interface
 * @export
 */
export const AccountingReportRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountingReportRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditExport(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditExport(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingReportRestControllerApi.auditExport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {string} [dateTo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceSheet(year, dateTo, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceSheet(year, dateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingReportRestControllerApi.balanceSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {string} prefixes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async drilldown(year, prefixes, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.drilldown(year, prefixes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingReportRestControllerApi.drilldown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalLedger(dateFrom, dateTo, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalLedger(dateFrom, dateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingReportRestControllerApi.generalLedger']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateClosingEntry(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateClosingEntry(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingReportRestControllerApi.generateClosingEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateOpeningEntry(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateOpeningEntry(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingReportRestControllerApi.generateOpeningEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfficialBooks(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfficialBooks(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingReportRestControllerApi.getOfficialBooks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async journalBook(dateFrom, dateTo, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.journalBook(dateFrom, dateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingReportRestControllerApi.journalBook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} [month]
         * @param {number} [digits]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async layerBalance(year, month, digits, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.layerBalance(year, month, digits, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingReportRestControllerApi.layerBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async layerOverlap(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.layerOverlap(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingReportRestControllerApi.layerOverlap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {string} accountCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ledger(year, accountCode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ledger(year, accountCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingReportRestControllerApi.ledger']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async officialInventoryPdf(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.officialInventoryPdf(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingReportRestControllerApi.officialInventoryPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async officialJournalPdf(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.officialJournalPdf(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingReportRestControllerApi.officialJournalPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profitLoss(year, dateFrom, dateTo, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profitLoss(year, dateFrom, dateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingReportRestControllerApi.profitLoss']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} accountCode
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statement(accountCode, dateFrom, dateTo, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statement(accountCode, dateFrom, dateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingReportRestControllerApi.statement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trialBalance(year, dateFrom, dateTo, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trialBalance(year, dateFrom, dateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingReportRestControllerApi.trialBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async withholdingsReceived(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.withholdingsReceived(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingReportRestControllerApi.withholdingsReceived']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AccountingReportRestControllerApi - factory interface
 * @export
 */
export const AccountingReportRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountingReportRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditExport(year, options) {
            return localVarFp.auditExport(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {string} [dateTo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceSheet(year, dateTo, options) {
            return localVarFp.balanceSheet(year, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {string} prefixes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drilldown(year, prefixes, options) {
            return localVarFp.drilldown(year, prefixes, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalLedger(dateFrom, dateTo, options) {
            return localVarFp.generalLedger(dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateClosingEntry(year, options) {
            return localVarFp.generateClosingEntry(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOpeningEntry(year, options) {
            return localVarFp.generateOpeningEntry(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfficialBooks(year, options) {
            return localVarFp.getOfficialBooks(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        journalBook(dateFrom, dateTo, options) {
            return localVarFp.journalBook(dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} [month]
         * @param {number} [digits]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        layerBalance(year, month, digits, options) {
            return localVarFp.layerBalance(year, month, digits, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        layerOverlap(year, options) {
            return localVarFp.layerOverlap(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {string} accountCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ledger(year, accountCode, options) {
            return localVarFp.ledger(year, accountCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        officialInventoryPdf(year, options) {
            return localVarFp.officialInventoryPdf(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        officialJournalPdf(year, options) {
            return localVarFp.officialJournalPdf(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profitLoss(year, dateFrom, dateTo, options) {
            return localVarFp.profitLoss(year, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} accountCode
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statement(accountCode, dateFrom, dateTo, options) {
            return localVarFp.statement(accountCode, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trialBalance(year, dateFrom, dateTo, options) {
            return localVarFp.trialBalance(year, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withholdingsReceived(year, options) {
            return localVarFp.withholdingsReceived(year, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountingReportRestControllerApi - object-oriented interface
 * @export
 * @class AccountingReportRestControllerApi
 * @extends {BaseAPI}
 */
export class AccountingReportRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingReportRestControllerApi
     */
    auditExport(year, options) {
        return AccountingReportRestControllerApiFp(this.configuration).auditExport(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {string} [dateTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingReportRestControllerApi
     */
    balanceSheet(year, dateTo, options) {
        return AccountingReportRestControllerApiFp(this.configuration).balanceSheet(year, dateTo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {string} prefixes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingReportRestControllerApi
     */
    drilldown(year, prefixes, options) {
        return AccountingReportRestControllerApiFp(this.configuration).drilldown(year, prefixes, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} dateFrom
     * @param {string} dateTo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingReportRestControllerApi
     */
    generalLedger(dateFrom, dateTo, options) {
        return AccountingReportRestControllerApiFp(this.configuration).generalLedger(dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingReportRestControllerApi
     */
    generateClosingEntry(year, options) {
        return AccountingReportRestControllerApiFp(this.configuration).generateClosingEntry(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingReportRestControllerApi
     */
    generateOpeningEntry(year, options) {
        return AccountingReportRestControllerApiFp(this.configuration).generateOpeningEntry(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingReportRestControllerApi
     */
    getOfficialBooks(year, options) {
        return AccountingReportRestControllerApiFp(this.configuration).getOfficialBooks(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} dateFrom
     * @param {string} dateTo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingReportRestControllerApi
     */
    journalBook(dateFrom, dateTo, options) {
        return AccountingReportRestControllerApiFp(this.configuration).journalBook(dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} [month]
     * @param {number} [digits]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingReportRestControllerApi
     */
    layerBalance(year, month, digits, options) {
        return AccountingReportRestControllerApiFp(this.configuration).layerBalance(year, month, digits, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingReportRestControllerApi
     */
    layerOverlap(year, options) {
        return AccountingReportRestControllerApiFp(this.configuration).layerOverlap(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {string} accountCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingReportRestControllerApi
     */
    ledger(year, accountCode, options) {
        return AccountingReportRestControllerApiFp(this.configuration).ledger(year, accountCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingReportRestControllerApi
     */
    officialInventoryPdf(year, options) {
        return AccountingReportRestControllerApiFp(this.configuration).officialInventoryPdf(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingReportRestControllerApi
     */
    officialJournalPdf(year, options) {
        return AccountingReportRestControllerApiFp(this.configuration).officialJournalPdf(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingReportRestControllerApi
     */
    profitLoss(year, dateFrom, dateTo, options) {
        return AccountingReportRestControllerApiFp(this.configuration).profitLoss(year, dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} accountCode
     * @param {string} dateFrom
     * @param {string} dateTo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingReportRestControllerApi
     */
    statement(accountCode, dateFrom, dateTo, options) {
        return AccountingReportRestControllerApiFp(this.configuration).statement(accountCode, dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingReportRestControllerApi
     */
    trialBalance(year, dateFrom, dateTo, options) {
        return AccountingReportRestControllerApiFp(this.configuration).trialBalance(year, dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingReportRestControllerApi
     */
    withholdingsReceived(year, options) {
        return AccountingReportRestControllerApiFp(this.configuration).withholdingsReceived(year, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AccountingRuleRestControllerApi - axios parameter creator
 * @export
 */
export const AccountingRuleRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CountAccountingRuleEventEnum} [event]
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAccountingRule: async (event, active, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/rule/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (event !== undefined) {
                localVarQueryParameter['event'] = event;
            }
            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissAccountingRule: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissAccountingRule', 'id', id);
            const localVarPath = `/api/admin/accounting/rule/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchAccountingRule: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchAccountingRule', 'ids', ids);
            const localVarPath = `/api/admin/accounting/rule/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingRule: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAccountingRule', 'id', id);
            const localVarPath = `/api/admin/accounting/rule/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ListAccountingRuleEventEnum} [event]
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountingRule: async (event, active, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/rule/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (event !== undefined) {
                localVarQueryParameter['event'] = event;
            }
            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageAccountingRuleEventEnum} [event]
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageAccountingRule: async (page, size, sort, event, active, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/rule/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (event !== undefined) {
                localVarQueryParameter['event'] = event;
            }
            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {AccountingRule} accountingRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAccountingRule: async (accountingRule, options = {}) => {
            // verify required parameter 'accountingRule' is not null or undefined
            assertParamExists('saveAccountingRule', 'accountingRule', accountingRule);
            const localVarPath = `/api/admin/accounting/rule/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(accountingRule, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountingRuleRestControllerApi - functional programming interface
 * @export
 */
export const AccountingRuleRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountingRuleRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CountAccountingRuleEventEnum} [event]
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countAccountingRule(event, active, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countAccountingRule(event, active, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingRuleRestControllerApi.countAccountingRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissAccountingRule(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissAccountingRule(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingRuleRestControllerApi.deleteOrDismissAccountingRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchAccountingRule(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchAccountingRule(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingRuleRestControllerApi.deleteOrDismissInBatchAccountingRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountingRule(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountingRule(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingRuleRestControllerApi.getAccountingRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ListAccountingRuleEventEnum} [event]
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccountingRule(event, active, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccountingRule(event, active, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingRuleRestControllerApi.listAccountingRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageAccountingRuleEventEnum} [event]
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageAccountingRule(page, size, sort, event, active, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageAccountingRule(page, size, sort, event, active, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingRuleRestControllerApi.pageAccountingRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {AccountingRule} accountingRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAccountingRule(accountingRule, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAccountingRule(accountingRule, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingRuleRestControllerApi.saveAccountingRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AccountingRuleRestControllerApi - factory interface
 * @export
 */
export const AccountingRuleRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountingRuleRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {CountAccountingRuleEventEnum} [event]
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAccountingRule(event, active, term, showDismissed, options) {
            return localVarFp.countAccountingRule(event, active, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissAccountingRule(id, options) {
            return localVarFp.deleteOrDismissAccountingRule(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchAccountingRule(ids, options) {
            return localVarFp.deleteOrDismissInBatchAccountingRule(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingRule(id, options) {
            return localVarFp.getAccountingRule(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ListAccountingRuleEventEnum} [event]
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountingRule(event, active, term, showDismissed, options) {
            return localVarFp.listAccountingRule(event, active, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageAccountingRuleEventEnum} [event]
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageAccountingRule(page, size, sort, event, active, term, showDismissed, options) {
            return localVarFp.pageAccountingRule(page, size, sort, event, active, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AccountingRule} accountingRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAccountingRule(accountingRule, options) {
            return localVarFp.saveAccountingRule(accountingRule, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountingRuleRestControllerApi - object-oriented interface
 * @export
 * @class AccountingRuleRestControllerApi
 * @extends {BaseAPI}
 */
export class AccountingRuleRestControllerApi extends BaseAPI {
    /**
     *
     * @param {CountAccountingRuleEventEnum} [event]
     * @param {boolean} [active]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingRuleRestControllerApi
     */
    countAccountingRule(event, active, term, showDismissed, options) {
        return AccountingRuleRestControllerApiFp(this.configuration).countAccountingRule(event, active, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingRuleRestControllerApi
     */
    deleteOrDismissAccountingRule(id, options) {
        return AccountingRuleRestControllerApiFp(this.configuration).deleteOrDismissAccountingRule(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingRuleRestControllerApi
     */
    deleteOrDismissInBatchAccountingRule(ids, options) {
        return AccountingRuleRestControllerApiFp(this.configuration).deleteOrDismissInBatchAccountingRule(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingRuleRestControllerApi
     */
    getAccountingRule(id, options) {
        return AccountingRuleRestControllerApiFp(this.configuration).getAccountingRule(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ListAccountingRuleEventEnum} [event]
     * @param {boolean} [active]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingRuleRestControllerApi
     */
    listAccountingRule(event, active, term, showDismissed, options) {
        return AccountingRuleRestControllerApiFp(this.configuration).listAccountingRule(event, active, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {PageAccountingRuleEventEnum} [event]
     * @param {boolean} [active]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingRuleRestControllerApi
     */
    pageAccountingRule(page, size, sort, event, active, term, showDismissed, options) {
        return AccountingRuleRestControllerApiFp(this.configuration).pageAccountingRule(page, size, sort, event, active, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AccountingRule} accountingRule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingRuleRestControllerApi
     */
    saveAccountingRule(accountingRule, options) {
        return AccountingRuleRestControllerApiFp(this.configuration).saveAccountingRule(accountingRule, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountAccountingRuleEventEnum = {
    VENTA: 'VENTA',
    COMPRA: 'COMPRA',
    NOMINA: 'NOMINA',
    COBRO: 'COBRO',
    PAGO: 'PAGO',
    AMORTIZACION: 'AMORTIZACION'
};
/**
 * @export
 */
export const ListAccountingRuleEventEnum = {
    VENTA: 'VENTA',
    COMPRA: 'COMPRA',
    NOMINA: 'NOMINA',
    COBRO: 'COBRO',
    PAGO: 'PAGO',
    AMORTIZACION: 'AMORTIZACION'
};
/**
 * @export
 */
export const PageAccountingRuleEventEnum = {
    VENTA: 'VENTA',
    COMPRA: 'COMPRA',
    NOMINA: 'NOMINA',
    COBRO: 'COBRO',
    PAGO: 'PAGO',
    AMORTIZACION: 'AMORTIZACION'
};
/**
 * AdminSharedRestControllerApi - axios parameter creator
 * @export
 */
export const AdminSharedRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCustomers: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/shared/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePeople: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/shared/people`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AdminSharedRestControllerApi - functional programming interface
 * @export
 */
export const AdminSharedRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminSharedRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveCustomers(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveCustomers(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSharedRestControllerApi.retrieveCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrievePeople(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrievePeople(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSharedRestControllerApi.retrievePeople']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AdminSharedRestControllerApi - factory interface
 * @export
 */
export const AdminSharedRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminSharedRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCustomers(term, showDismissed, options) {
            return localVarFp.retrieveCustomers(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePeople(term, showDismissed, options) {
            return localVarFp.retrievePeople(term, showDismissed, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminSharedRestControllerApi - object-oriented interface
 * @export
 * @class AdminSharedRestControllerApi
 * @extends {BaseAPI}
 */
export class AdminSharedRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSharedRestControllerApi
     */
    retrieveCustomers(term, showDismissed, options) {
        return AdminSharedRestControllerApiFp(this.configuration).retrieveCustomers(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSharedRestControllerApi
     */
    retrievePeople(term, showDismissed, options) {
        return AdminSharedRestControllerApiFp(this.configuration).retrievePeople(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AmortizationEntryRestControllerApi - axios parameter creator
 * @export
 */
export const AmortizationEntryRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [fixedAssetId]
         * @param {number} [year]
         * @param {number} [periodId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAmortizationEntry: async (fixedAssetId, year, periodId, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/amortization-entry/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (fixedAssetId !== undefined) {
                localVarQueryParameter['fixedAssetId'] = fixedAssetId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (periodId !== undefined) {
                localVarQueryParameter['periodId'] = periodId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissAmortizationEntry: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissAmortizationEntry', 'id', id);
            const localVarPath = `/api/admin/accounting/amortization-entry/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchAmortizationEntry: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchAmortizationEntry', 'ids', ids);
            const localVarPath = `/api/admin/accounting/amortization-entry/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAmortizationEntry: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAmortizationEntry', 'id', id);
            const localVarPath = `/api/admin/accounting/amortization-entry/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [fixedAssetId]
         * @param {number} [year]
         * @param {number} [periodId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAmortizationEntry: async (fixedAssetId, year, periodId, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/amortization-entry/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (fixedAssetId !== undefined) {
                localVarQueryParameter['fixedAssetId'] = fixedAssetId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (periodId !== undefined) {
                localVarQueryParameter['periodId'] = periodId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [fixedAssetId]
         * @param {number} [year]
         * @param {number} [periodId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageAmortizationEntry: async (page, size, sort, fixedAssetId, year, periodId, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/amortization-entry/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (fixedAssetId !== undefined) {
                localVarQueryParameter['fixedAssetId'] = fixedAssetId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (periodId !== undefined) {
                localVarQueryParameter['periodId'] = periodId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {AmortizationEntry} amortizationEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAmortizationEntry: async (amortizationEntry, options = {}) => {
            // verify required parameter 'amortizationEntry' is not null or undefined
            assertParamExists('saveAmortizationEntry', 'amortizationEntry', amortizationEntry);
            const localVarPath = `/api/admin/accounting/amortization-entry/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(amortizationEntry, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AmortizationEntryRestControllerApi - functional programming interface
 * @export
 */
export const AmortizationEntryRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AmortizationEntryRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [fixedAssetId]
         * @param {number} [year]
         * @param {number} [periodId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countAmortizationEntry(fixedAssetId, year, periodId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countAmortizationEntry(fixedAssetId, year, periodId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AmortizationEntryRestControllerApi.countAmortizationEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissAmortizationEntry(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissAmortizationEntry(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AmortizationEntryRestControllerApi.deleteOrDismissAmortizationEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchAmortizationEntry(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchAmortizationEntry(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AmortizationEntryRestControllerApi.deleteOrDismissInBatchAmortizationEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAmortizationEntry(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAmortizationEntry(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AmortizationEntryRestControllerApi.getAmortizationEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [fixedAssetId]
         * @param {number} [year]
         * @param {number} [periodId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAmortizationEntry(fixedAssetId, year, periodId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAmortizationEntry(fixedAssetId, year, periodId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AmortizationEntryRestControllerApi.listAmortizationEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [fixedAssetId]
         * @param {number} [year]
         * @param {number} [periodId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageAmortizationEntry(page, size, sort, fixedAssetId, year, periodId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageAmortizationEntry(page, size, sort, fixedAssetId, year, periodId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AmortizationEntryRestControllerApi.pageAmortizationEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {AmortizationEntry} amortizationEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAmortizationEntry(amortizationEntry, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAmortizationEntry(amortizationEntry, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AmortizationEntryRestControllerApi.saveAmortizationEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AmortizationEntryRestControllerApi - factory interface
 * @export
 */
export const AmortizationEntryRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AmortizationEntryRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [fixedAssetId]
         * @param {number} [year]
         * @param {number} [periodId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAmortizationEntry(fixedAssetId, year, periodId, term, showDismissed, options) {
            return localVarFp.countAmortizationEntry(fixedAssetId, year, periodId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissAmortizationEntry(id, options) {
            return localVarFp.deleteOrDismissAmortizationEntry(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchAmortizationEntry(ids, options) {
            return localVarFp.deleteOrDismissInBatchAmortizationEntry(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAmortizationEntry(id, options) {
            return localVarFp.getAmortizationEntry(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [fixedAssetId]
         * @param {number} [year]
         * @param {number} [periodId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAmortizationEntry(fixedAssetId, year, periodId, term, showDismissed, options) {
            return localVarFp.listAmortizationEntry(fixedAssetId, year, periodId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [fixedAssetId]
         * @param {number} [year]
         * @param {number} [periodId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageAmortizationEntry(page, size, sort, fixedAssetId, year, periodId, term, showDismissed, options) {
            return localVarFp.pageAmortizationEntry(page, size, sort, fixedAssetId, year, periodId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AmortizationEntry} amortizationEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAmortizationEntry(amortizationEntry, options) {
            return localVarFp.saveAmortizationEntry(amortizationEntry, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AmortizationEntryRestControllerApi - object-oriented interface
 * @export
 * @class AmortizationEntryRestControllerApi
 * @extends {BaseAPI}
 */
export class AmortizationEntryRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [fixedAssetId]
     * @param {number} [year]
     * @param {number} [periodId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmortizationEntryRestControllerApi
     */
    countAmortizationEntry(fixedAssetId, year, periodId, term, showDismissed, options) {
        return AmortizationEntryRestControllerApiFp(this.configuration).countAmortizationEntry(fixedAssetId, year, periodId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmortizationEntryRestControllerApi
     */
    deleteOrDismissAmortizationEntry(id, options) {
        return AmortizationEntryRestControllerApiFp(this.configuration).deleteOrDismissAmortizationEntry(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmortizationEntryRestControllerApi
     */
    deleteOrDismissInBatchAmortizationEntry(ids, options) {
        return AmortizationEntryRestControllerApiFp(this.configuration).deleteOrDismissInBatchAmortizationEntry(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmortizationEntryRestControllerApi
     */
    getAmortizationEntry(id, options) {
        return AmortizationEntryRestControllerApiFp(this.configuration).getAmortizationEntry(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [fixedAssetId]
     * @param {number} [year]
     * @param {number} [periodId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmortizationEntryRestControllerApi
     */
    listAmortizationEntry(fixedAssetId, year, periodId, term, showDismissed, options) {
        return AmortizationEntryRestControllerApiFp(this.configuration).listAmortizationEntry(fixedAssetId, year, periodId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [fixedAssetId]
     * @param {number} [year]
     * @param {number} [periodId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmortizationEntryRestControllerApi
     */
    pageAmortizationEntry(page, size, sort, fixedAssetId, year, periodId, term, showDismissed, options) {
        return AmortizationEntryRestControllerApiFp(this.configuration).pageAmortizationEntry(page, size, sort, fixedAssetId, year, periodId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AmortizationEntry} amortizationEntry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmortizationEntryRestControllerApi
     */
    saveAmortizationEntry(amortizationEntry, options) {
        return AmortizationEntryRestControllerApiFp(this.configuration).saveAmortizationEntry(amortizationEntry, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AmortizationRestControllerApi - axios parameter creator
 * @export
 */
export const AmortizationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generate: async (year, month, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('generate', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('generate', 'month', month);
            const localVarPath = `/api/admin/accounting/amortization/generate/{year}/{month}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"month"}}`, encodeURIComponent(String(month)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AmortizationRestControllerApi - functional programming interface
 * @export
 */
export const AmortizationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AmortizationRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generate(year, month, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generate(year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AmortizationRestControllerApi.generate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AmortizationRestControllerApi - factory interface
 * @export
 */
export const AmortizationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AmortizationRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generate(year, month, options) {
            return localVarFp.generate(year, month, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AmortizationRestControllerApi - object-oriented interface
 * @export
 * @class AmortizationRestControllerApi
 * @extends {BaseAPI}
 */
export class AmortizationRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmortizationRestControllerApi
     */
    generate(year, month, options) {
        return AmortizationRestControllerApiFp(this.configuration).generate(year, month, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ApplicantRestControllerApi - axios parameter creator
 * @export
 */
export const ApplicantRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} applicationId
         * @param {number} targetRecruitmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyApplicant: async (applicationId, targetRecruitmentId, options = {}) => {
            // verify required parameter 'applicationId' is not null or undefined
            assertParamExists('copyApplicant', 'applicationId', applicationId);
            // verify required parameter 'targetRecruitmentId' is not null or undefined
            assertParamExists('copyApplicant', 'targetRecruitmentId', targetRecruitmentId);
            const localVarPath = `/api/admin/recruitment/applicant/copy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (applicationId !== undefined) {
                localVarQueryParameter['applicationId'] = applicationId;
            }
            if (targetRecruitmentId !== undefined) {
                localVarQueryParameter['targetRecruitmentId'] = targetRecruitmentId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [candidateId]
         * @param {number} [recruitmentId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countApplicant: async (candidateId, recruitmentId, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/applicant/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (recruitmentId !== undefined) {
                localVarQueryParameter['recruitmentId'] = recruitmentId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissApplicant: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissApplicant', 'id', id);
            const localVarPath = `/api/admin/recruitment/applicant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchApplicant: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchApplicant', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/applicant/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicant: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApplicant', 'id', id);
            const localVarPath = `/api/admin/recruitment/applicant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [candidateId]
         * @param {number} [recruitmentId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplicant: async (candidateId, recruitmentId, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/applicant/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (recruitmentId !== undefined) {
                localVarQueryParameter['recruitmentId'] = recruitmentId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [candidateId]
         * @param {number} [recruitmentId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageApplicant: async (page, size, sort, candidateId, recruitmentId, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/applicant/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (recruitmentId !== undefined) {
                localVarQueryParameter['recruitmentId'] = recruitmentId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Applicant} applicant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveApplicant: async (applicant, options = {}) => {
            // verify required parameter 'applicant' is not null or undefined
            assertParamExists('saveApplicant', 'applicant', applicant);
            const localVarPath = `/api/admin/recruitment/applicant/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(applicant, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ApplicantRestControllerApi - functional programming interface
 * @export
 */
export const ApplicantRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ApplicantRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} applicationId
         * @param {number} targetRecruitmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyApplicant(applicationId, targetRecruitmentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyApplicant(applicationId, targetRecruitmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantRestControllerApi.copyApplicant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [candidateId]
         * @param {number} [recruitmentId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countApplicant(candidateId, recruitmentId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countApplicant(candidateId, recruitmentId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantRestControllerApi.countApplicant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissApplicant(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissApplicant(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantRestControllerApi.deleteOrDismissApplicant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchApplicant(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchApplicant(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantRestControllerApi.deleteOrDismissInBatchApplicant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApplicant(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApplicant(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantRestControllerApi.getApplicant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [candidateId]
         * @param {number} [recruitmentId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listApplicant(candidateId, recruitmentId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listApplicant(candidateId, recruitmentId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantRestControllerApi.listApplicant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [candidateId]
         * @param {number} [recruitmentId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageApplicant(page, size, sort, candidateId, recruitmentId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageApplicant(page, size, sort, candidateId, recruitmentId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantRestControllerApi.pageApplicant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Applicant} applicant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveApplicant(applicant, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveApplicant(applicant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantRestControllerApi.saveApplicant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ApplicantRestControllerApi - factory interface
 * @export
 */
export const ApplicantRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ApplicantRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} applicationId
         * @param {number} targetRecruitmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyApplicant(applicationId, targetRecruitmentId, options) {
            return localVarFp.copyApplicant(applicationId, targetRecruitmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [candidateId]
         * @param {number} [recruitmentId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countApplicant(candidateId, recruitmentId, term, showDismissed, options) {
            return localVarFp.countApplicant(candidateId, recruitmentId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissApplicant(id, options) {
            return localVarFp.deleteOrDismissApplicant(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchApplicant(ids, options) {
            return localVarFp.deleteOrDismissInBatchApplicant(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicant(id, options) {
            return localVarFp.getApplicant(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [candidateId]
         * @param {number} [recruitmentId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplicant(candidateId, recruitmentId, term, showDismissed, options) {
            return localVarFp.listApplicant(candidateId, recruitmentId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [candidateId]
         * @param {number} [recruitmentId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageApplicant(page, size, sort, candidateId, recruitmentId, term, showDismissed, options) {
            return localVarFp.pageApplicant(page, size, sort, candidateId, recruitmentId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Applicant} applicant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveApplicant(applicant, options) {
            return localVarFp.saveApplicant(applicant, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ApplicantRestControllerApi - object-oriented interface
 * @export
 * @class ApplicantRestControllerApi
 * @extends {BaseAPI}
 */
export class ApplicantRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} applicationId
     * @param {number} targetRecruitmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantRestControllerApi
     */
    copyApplicant(applicationId, targetRecruitmentId, options) {
        return ApplicantRestControllerApiFp(this.configuration).copyApplicant(applicationId, targetRecruitmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [candidateId]
     * @param {number} [recruitmentId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantRestControllerApi
     */
    countApplicant(candidateId, recruitmentId, term, showDismissed, options) {
        return ApplicantRestControllerApiFp(this.configuration).countApplicant(candidateId, recruitmentId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantRestControllerApi
     */
    deleteOrDismissApplicant(id, options) {
        return ApplicantRestControllerApiFp(this.configuration).deleteOrDismissApplicant(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantRestControllerApi
     */
    deleteOrDismissInBatchApplicant(ids, options) {
        return ApplicantRestControllerApiFp(this.configuration).deleteOrDismissInBatchApplicant(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantRestControllerApi
     */
    getApplicant(id, options) {
        return ApplicantRestControllerApiFp(this.configuration).getApplicant(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [candidateId]
     * @param {number} [recruitmentId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantRestControllerApi
     */
    listApplicant(candidateId, recruitmentId, term, showDismissed, options) {
        return ApplicantRestControllerApiFp(this.configuration).listApplicant(candidateId, recruitmentId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [candidateId]
     * @param {number} [recruitmentId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantRestControllerApi
     */
    pageApplicant(page, size, sort, candidateId, recruitmentId, term, showDismissed, options) {
        return ApplicantRestControllerApiFp(this.configuration).pageApplicant(page, size, sort, candidateId, recruitmentId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Applicant} applicant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantRestControllerApi
     */
    saveApplicant(applicant, options) {
        return ApplicantRestControllerApiFp(this.configuration).saveApplicant(applicant, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ApplicantStateRestControllerApi - axios parameter creator
 * @export
 */
export const ApplicantStateRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countApplicantState: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/state/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissApplicantState: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissApplicantState', 'id', id);
            const localVarPath = `/api/admin/recruitment/state/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchApplicantState: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchApplicantState', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/state/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicantState: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getApplicantState', 'id', id);
            const localVarPath = `/api/admin/recruitment/state/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplicantState: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/state/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageApplicantState: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/state/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApplicantState} applicantState
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveApplicantState: async (applicantState, options = {}) => {
            // verify required parameter 'applicantState' is not null or undefined
            assertParamExists('saveApplicantState', 'applicantState', applicantState);
            const localVarPath = `/api/admin/recruitment/state/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(applicantState, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ApplicantStateRestControllerApi - functional programming interface
 * @export
 */
export const ApplicantStateRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ApplicantStateRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countApplicantState(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countApplicantState(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantStateRestControllerApi.countApplicantState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissApplicantState(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissApplicantState(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantStateRestControllerApi.deleteOrDismissApplicantState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchApplicantState(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchApplicantState(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantStateRestControllerApi.deleteOrDismissInBatchApplicantState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApplicantState(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApplicantState(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantStateRestControllerApi.getApplicantState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listApplicantState(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listApplicantState(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantStateRestControllerApi.listApplicantState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageApplicantState(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageApplicantState(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantStateRestControllerApi.pageApplicantState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ApplicantState} applicantState
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveApplicantState(applicantState, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveApplicantState(applicantState, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantStateRestControllerApi.saveApplicantState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ApplicantStateRestControllerApi - factory interface
 * @export
 */
export const ApplicantStateRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ApplicantStateRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countApplicantState(term, showDismissed, options) {
            return localVarFp.countApplicantState(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissApplicantState(id, options) {
            return localVarFp.deleteOrDismissApplicantState(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchApplicantState(ids, options) {
            return localVarFp.deleteOrDismissInBatchApplicantState(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicantState(id, options) {
            return localVarFp.getApplicantState(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplicantState(term, showDismissed, options) {
            return localVarFp.listApplicantState(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageApplicantState(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageApplicantState(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApplicantState} applicantState
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveApplicantState(applicantState, options) {
            return localVarFp.saveApplicantState(applicantState, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ApplicantStateRestControllerApi - object-oriented interface
 * @export
 * @class ApplicantStateRestControllerApi
 * @extends {BaseAPI}
 */
export class ApplicantStateRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantStateRestControllerApi
     */
    countApplicantState(term, showDismissed, options) {
        return ApplicantStateRestControllerApiFp(this.configuration).countApplicantState(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantStateRestControllerApi
     */
    deleteOrDismissApplicantState(id, options) {
        return ApplicantStateRestControllerApiFp(this.configuration).deleteOrDismissApplicantState(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantStateRestControllerApi
     */
    deleteOrDismissInBatchApplicantState(ids, options) {
        return ApplicantStateRestControllerApiFp(this.configuration).deleteOrDismissInBatchApplicantState(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantStateRestControllerApi
     */
    getApplicantState(id, options) {
        return ApplicantStateRestControllerApiFp(this.configuration).getApplicantState(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantStateRestControllerApi
     */
    listApplicantState(term, showDismissed, options) {
        return ApplicantStateRestControllerApiFp(this.configuration).listApplicantState(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantStateRestControllerApi
     */
    pageApplicantState(page, size, sort, term, showDismissed, options) {
        return ApplicantStateRestControllerApiFp(this.configuration).pageApplicantState(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApplicantState} applicantState
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantStateRestControllerApi
     */
    saveApplicantState(applicantState, options) {
        return ApplicantStateRestControllerApiFp(this.configuration).saveApplicantState(applicantState, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BankAccountRestControllerApi - axios parameter creator
 * @export
 */
export const BankAccountRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBankAccount: async (active, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/bank-account/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBankAccount: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissBankAccount', 'id', id);
            const localVarPath = `/api/admin/accounting/bank-account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBankAccount: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchBankAccount', 'ids', ids);
            const localVarPath = `/api/admin/accounting/bank-account/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccount: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBankAccount', 'id', id);
            const localVarPath = `/api/admin/accounting/bank-account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBankAccount: async (active, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/bank-account/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBankAccount: async (page, size, sort, active, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/bank-account/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {BankAccount} bankAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBankAccount: async (bankAccount, options = {}) => {
            // verify required parameter 'bankAccount' is not null or undefined
            assertParamExists('saveBankAccount', 'bankAccount', bankAccount);
            const localVarPath = `/api/admin/accounting/bank-account/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(bankAccount, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BankAccountRestControllerApi - functional programming interface
 * @export
 */
export const BankAccountRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = BankAccountRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countBankAccount(active, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countBankAccount(active, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankAccountRestControllerApi.countBankAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissBankAccount(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissBankAccount(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankAccountRestControllerApi.deleteOrDismissBankAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchBankAccount(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchBankAccount(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankAccountRestControllerApi.deleteOrDismissInBatchBankAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankAccount(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankAccount(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankAccountRestControllerApi.getBankAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBankAccount(active, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBankAccount(active, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankAccountRestControllerApi.listBankAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageBankAccount(page, size, sort, active, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageBankAccount(page, size, sort, active, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankAccountRestControllerApi.pageBankAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {BankAccount} bankAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveBankAccount(bankAccount, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveBankAccount(bankAccount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankAccountRestControllerApi.saveBankAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * BankAccountRestControllerApi - factory interface
 * @export
 */
export const BankAccountRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BankAccountRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBankAccount(active, term, showDismissed, options) {
            return localVarFp.countBankAccount(active, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBankAccount(id, options) {
            return localVarFp.deleteOrDismissBankAccount(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBankAccount(ids, options) {
            return localVarFp.deleteOrDismissInBatchBankAccount(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccount(id, options) {
            return localVarFp.getBankAccount(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBankAccount(active, term, showDismissed, options) {
            return localVarFp.listBankAccount(active, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBankAccount(page, size, sort, active, term, showDismissed, options) {
            return localVarFp.pageBankAccount(page, size, sort, active, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BankAccount} bankAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBankAccount(bankAccount, options) {
            return localVarFp.saveBankAccount(bankAccount, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BankAccountRestControllerApi - object-oriented interface
 * @export
 * @class BankAccountRestControllerApi
 * @extends {BaseAPI}
 */
export class BankAccountRestControllerApi extends BaseAPI {
    /**
     *
     * @param {boolean} [active]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountRestControllerApi
     */
    countBankAccount(active, term, showDismissed, options) {
        return BankAccountRestControllerApiFp(this.configuration).countBankAccount(active, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountRestControllerApi
     */
    deleteOrDismissBankAccount(id, options) {
        return BankAccountRestControllerApiFp(this.configuration).deleteOrDismissBankAccount(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountRestControllerApi
     */
    deleteOrDismissInBatchBankAccount(ids, options) {
        return BankAccountRestControllerApiFp(this.configuration).deleteOrDismissInBatchBankAccount(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountRestControllerApi
     */
    getBankAccount(id, options) {
        return BankAccountRestControllerApiFp(this.configuration).getBankAccount(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [active]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountRestControllerApi
     */
    listBankAccount(active, term, showDismissed, options) {
        return BankAccountRestControllerApiFp(this.configuration).listBankAccount(active, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {boolean} [active]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountRestControllerApi
     */
    pageBankAccount(page, size, sort, active, term, showDismissed, options) {
        return BankAccountRestControllerApiFp(this.configuration).pageBankAccount(page, size, sort, active, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BankAccount} bankAccount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountRestControllerApi
     */
    saveBankAccount(bankAccount, options) {
        return BankAccountRestControllerApiFp(this.configuration).saveBankAccount(bankAccount, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BankMovementRestControllerApi - axios parameter creator
 * @export
 */
export const BankMovementRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CountBankMovementMovementTypeEnum} [movementType]
         * @param {number} [billId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {number} [bankAccountId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBankMovement: async (movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/bank-movement/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (movementType !== undefined) {
                localVarQueryParameter['movementType'] = movementType;
            }
            if (billId !== undefined) {
                localVarQueryParameter['billId'] = billId;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString().substring(0, 10) :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString().substring(0, 10) :
                    dateTo;
            }
            if (bankAccountId !== undefined) {
                localVarQueryParameter['bankAccountId'] = bankAccountId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBankMovement: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissBankMovement', 'id', id);
            const localVarPath = `/api/admin/accounting/bank-movement/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBankMovement: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchBankMovement', 'ids', ids);
            const localVarPath = `/api/admin/accounting/bank-movement/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankMovement: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBankMovement', 'id', id);
            const localVarPath = `/api/admin/accounting/bank-movement/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkBillBankMovement: async (id, billId, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('linkBillBankMovement', 'id', id);
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('linkBillBankMovement', 'billId', billId);
            const localVarPath = `/api/admin/accounting/bank-movement/{id}/link-bill`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (billId !== undefined) {
                localVarQueryParameter['billId'] = billId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ListBankMovementMovementTypeEnum} [movementType]
         * @param {number} [billId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {number} [bankAccountId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBankMovement: async (movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/bank-movement/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (movementType !== undefined) {
                localVarQueryParameter['movementType'] = movementType;
            }
            if (billId !== undefined) {
                localVarQueryParameter['billId'] = billId;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString().substring(0, 10) :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString().substring(0, 10) :
                    dateTo;
            }
            if (bankAccountId !== undefined) {
                localVarQueryParameter['bankAccountId'] = bankAccountId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageBankMovementMovementTypeEnum} [movementType]
         * @param {number} [billId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {number} [bankAccountId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBankMovement: async (page, size, sort, movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/bank-movement/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (movementType !== undefined) {
                localVarQueryParameter['movementType'] = movementType;
            }
            if (billId !== undefined) {
                localVarQueryParameter['billId'] = billId;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString().substring(0, 10) :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString().substring(0, 10) :
                    dateTo;
            }
            if (bankAccountId !== undefined) {
                localVarQueryParameter['bankAccountId'] = bankAccountId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proposalsBankMovement: async (options = {}) => {
            const localVarPath = `/api/admin/accounting/bank-movement/proposals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {BankMovement} bankMovement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBankMovement: async (bankMovement, options = {}) => {
            // verify required parameter 'bankMovement' is not null or undefined
            assertParamExists('saveBankMovement', 'bankMovement', bankMovement);
            const localVarPath = `/api/admin/accounting/bank-movement/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(bankMovement, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BankMovementRestControllerApi - functional programming interface
 * @export
 */
export const BankMovementRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = BankMovementRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CountBankMovementMovementTypeEnum} [movementType]
         * @param {number} [billId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {number} [bankAccountId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countBankMovement(movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countBankMovement(movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankMovementRestControllerApi.countBankMovement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissBankMovement(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissBankMovement(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankMovementRestControllerApi.deleteOrDismissBankMovement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchBankMovement(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchBankMovement(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankMovementRestControllerApi.deleteOrDismissInBatchBankMovement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankMovement(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankMovement(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankMovementRestControllerApi.getBankMovement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkBillBankMovement(id, billId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkBillBankMovement(id, billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankMovementRestControllerApi.linkBillBankMovement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ListBankMovementMovementTypeEnum} [movementType]
         * @param {number} [billId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {number} [bankAccountId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBankMovement(movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBankMovement(movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankMovementRestControllerApi.listBankMovement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageBankMovementMovementTypeEnum} [movementType]
         * @param {number} [billId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {number} [bankAccountId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageBankMovement(page, size, sort, movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageBankMovement(page, size, sort, movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankMovementRestControllerApi.pageBankMovement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proposalsBankMovement(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proposalsBankMovement(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankMovementRestControllerApi.proposalsBankMovement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {BankMovement} bankMovement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveBankMovement(bankMovement, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveBankMovement(bankMovement, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankMovementRestControllerApi.saveBankMovement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * BankMovementRestControllerApi - factory interface
 * @export
 */
export const BankMovementRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BankMovementRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {CountBankMovementMovementTypeEnum} [movementType]
         * @param {number} [billId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {number} [bankAccountId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBankMovement(movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options) {
            return localVarFp.countBankMovement(movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBankMovement(id, options) {
            return localVarFp.deleteOrDismissBankMovement(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBankMovement(ids, options) {
            return localVarFp.deleteOrDismissInBatchBankMovement(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankMovement(id, options) {
            return localVarFp.getBankMovement(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkBillBankMovement(id, billId, options) {
            return localVarFp.linkBillBankMovement(id, billId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ListBankMovementMovementTypeEnum} [movementType]
         * @param {number} [billId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {number} [bankAccountId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBankMovement(movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options) {
            return localVarFp.listBankMovement(movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageBankMovementMovementTypeEnum} [movementType]
         * @param {number} [billId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {number} [bankAccountId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBankMovement(page, size, sort, movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options) {
            return localVarFp.pageBankMovement(page, size, sort, movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proposalsBankMovement(options) {
            return localVarFp.proposalsBankMovement(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BankMovement} bankMovement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBankMovement(bankMovement, options) {
            return localVarFp.saveBankMovement(bankMovement, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BankMovementRestControllerApi - object-oriented interface
 * @export
 * @class BankMovementRestControllerApi
 * @extends {BaseAPI}
 */
export class BankMovementRestControllerApi extends BaseAPI {
    /**
     *
     * @param {CountBankMovementMovementTypeEnum} [movementType]
     * @param {number} [billId]
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {number} [bankAccountId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankMovementRestControllerApi
     */
    countBankMovement(movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options) {
        return BankMovementRestControllerApiFp(this.configuration).countBankMovement(movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankMovementRestControllerApi
     */
    deleteOrDismissBankMovement(id, options) {
        return BankMovementRestControllerApiFp(this.configuration).deleteOrDismissBankMovement(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankMovementRestControllerApi
     */
    deleteOrDismissInBatchBankMovement(ids, options) {
        return BankMovementRestControllerApiFp(this.configuration).deleteOrDismissInBatchBankMovement(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankMovementRestControllerApi
     */
    getBankMovement(id, options) {
        return BankMovementRestControllerApiFp(this.configuration).getBankMovement(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} billId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankMovementRestControllerApi
     */
    linkBillBankMovement(id, billId, options) {
        return BankMovementRestControllerApiFp(this.configuration).linkBillBankMovement(id, billId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ListBankMovementMovementTypeEnum} [movementType]
     * @param {number} [billId]
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {number} [bankAccountId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankMovementRestControllerApi
     */
    listBankMovement(movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options) {
        return BankMovementRestControllerApiFp(this.configuration).listBankMovement(movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {PageBankMovementMovementTypeEnum} [movementType]
     * @param {number} [billId]
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {number} [bankAccountId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankMovementRestControllerApi
     */
    pageBankMovement(page, size, sort, movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options) {
        return BankMovementRestControllerApiFp(this.configuration).pageBankMovement(page, size, sort, movementType, billId, dateFrom, dateTo, bankAccountId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankMovementRestControllerApi
     */
    proposalsBankMovement(options) {
        return BankMovementRestControllerApiFp(this.configuration).proposalsBankMovement(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BankMovement} bankMovement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankMovementRestControllerApi
     */
    saveBankMovement(bankMovement, options) {
        return BankMovementRestControllerApiFp(this.configuration).saveBankMovement(bankMovement, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountBankMovementMovementTypeEnum = {
    COBRO: 'COBRO',
    PAGO: 'PAGO'
};
/**
 * @export
 */
export const ListBankMovementMovementTypeEnum = {
    COBRO: 'COBRO',
    PAGO: 'PAGO'
};
/**
 * @export
 */
export const PageBankMovementMovementTypeEnum = {
    COBRO: 'COBRO',
    PAGO: 'PAGO'
};
/**
 * BankStatementRestControllerApi - axios parameter creator
 * @export
 */
export const BankStatementRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} bankAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoReconcileWithJournalBankStatementLine: async (bankAccountId, options = {}) => {
            // verify required parameter 'bankAccountId' is not null or undefined
            assertParamExists('autoReconcileWithJournalBankStatementLine', 'bankAccountId', bankAccountId);
            const localVarPath = `/api/admin/accounting/bank-statement/journal-auto/{bankAccountId}`
                .replace(`{${"bankAccountId"}}`, encodeURIComponent(String(bankAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [bankAccountId]
         * @param {boolean} [reconciled]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBankStatementLine: async (bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/bank-statement/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (bankAccountId !== undefined) {
                localVarQueryParameter['bankAccountId'] = bankAccountId;
            }
            if (reconciled !== undefined) {
                localVarQueryParameter['reconciled'] = reconciled;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString().substring(0, 10) :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString().substring(0, 10) :
                    dateTo;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBankStatementLine: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissBankStatementLine', 'id', id);
            const localVarPath = `/api/admin/accounting/bank-statement/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBankStatementLine: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchBankStatementLine', 'ids', ids);
            const localVarPath = `/api/admin/accounting/bank-statement/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankStatementLine: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBankStatementLine', 'id', id);
            const localVarPath = `/api/admin/accounting/bank-statement/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [bankAccountId]
         * @param {boolean} [reconciled]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBankStatementLine: async (bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/bank-statement/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (bankAccountId !== undefined) {
                localVarQueryParameter['bankAccountId'] = bankAccountId;
            }
            if (reconciled !== undefined) {
                localVarQueryParameter['reconciled'] = reconciled;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString().substring(0, 10) :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString().substring(0, 10) :
                    dateTo;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJournalCandidatesBankStatementLine: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listJournalCandidatesBankStatementLine', 'id', id);
            const localVarPath = `/api/admin/accounting/bank-statement/{id}/journal-candidates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [bankAccountId]
         * @param {boolean} [reconciled]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBankStatementLine: async (page, size, sort, bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/bank-statement/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (bankAccountId !== undefined) {
                localVarQueryParameter['bankAccountId'] = bankAccountId;
            }
            if (reconciled !== undefined) {
                localVarQueryParameter['reconciled'] = reconciled;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString().substring(0, 10) :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString().substring(0, 10) :
                    dateTo;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {BankStatementPostEntryRequestList} bankStatementPostEntryRequestList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postStatementLineEntryBankStatementLine: async (id, bankStatementPostEntryRequestList, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postStatementLineEntryBankStatementLine', 'id', id);
            // verify required parameter 'bankStatementPostEntryRequestList' is not null or undefined
            assertParamExists('postStatementLineEntryBankStatementLine', 'bankStatementPostEntryRequestList', bankStatementPostEntryRequestList);
            const localVarPath = `/api/admin/accounting/bank-statement/{id}/post-entry`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(bankStatementPostEntryRequestList, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {number} journalLineId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reconcileWithJournalBankStatementLine: async (id, journalLineId, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reconcileWithJournalBankStatementLine', 'id', id);
            // verify required parameter 'journalLineId' is not null or undefined
            assertParamExists('reconcileWithJournalBankStatementLine', 'journalLineId', journalLineId);
            const localVarPath = `/api/admin/accounting/bank-statement/{id}/journal-reconcile/{journalLineId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"journalLineId"}}`, encodeURIComponent(String(journalLineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {BankStatementLine} bankStatementLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBankStatementLine: async (bankStatementLine, options = {}) => {
            // verify required parameter 'bankStatementLine' is not null or undefined
            assertParamExists('saveBankStatementLine', 'bankStatementLine', bankStatementLine);
            const localVarPath = `/api/admin/accounting/bank-statement/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(bankStatementLine, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestCounterAccountBankStatementLine: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('suggestCounterAccountBankStatementLine', 'id', id);
            const localVarPath = `/api/admin/accounting/bank-statement/{id}/counter-account-suggestion`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unreconcileFromJournalBankStatementLine: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unreconcileFromJournalBankStatementLine', 'id', id);
            const localVarPath = `/api/admin/accounting/bank-statement/{id}/journal-unreconcile`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} bankAccountId
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBankStatementLine: async (bankAccountId, validateBalanceRequest, options = {}) => {
            // verify required parameter 'bankAccountId' is not null or undefined
            assertParamExists('uploadBankStatementLine', 'bankAccountId', bankAccountId);
            const localVarPath = `/api/admin/accounting/bank-statement/upload/{bankAccountId}`
                .replace(`{${"bankAccountId"}}`, encodeURIComponent(String(bankAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(validateBalanceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BankStatementRestControllerApi - functional programming interface
 * @export
 */
export const BankStatementRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = BankStatementRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} bankAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autoReconcileWithJournalBankStatementLine(bankAccountId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autoReconcileWithJournalBankStatementLine(bankAccountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankStatementRestControllerApi.autoReconcileWithJournalBankStatementLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [bankAccountId]
         * @param {boolean} [reconciled]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countBankStatementLine(bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countBankStatementLine(bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankStatementRestControllerApi.countBankStatementLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissBankStatementLine(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissBankStatementLine(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankStatementRestControllerApi.deleteOrDismissBankStatementLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchBankStatementLine(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchBankStatementLine(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankStatementRestControllerApi.deleteOrDismissInBatchBankStatementLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankStatementLine(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankStatementLine(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankStatementRestControllerApi.getBankStatementLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [bankAccountId]
         * @param {boolean} [reconciled]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBankStatementLine(bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBankStatementLine(bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankStatementRestControllerApi.listBankStatementLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listJournalCandidatesBankStatementLine(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listJournalCandidatesBankStatementLine(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankStatementRestControllerApi.listJournalCandidatesBankStatementLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [bankAccountId]
         * @param {boolean} [reconciled]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageBankStatementLine(page, size, sort, bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageBankStatementLine(page, size, sort, bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankStatementRestControllerApi.pageBankStatementLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {BankStatementPostEntryRequestList} bankStatementPostEntryRequestList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postStatementLineEntryBankStatementLine(id, bankStatementPostEntryRequestList, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postStatementLineEntryBankStatementLine(id, bankStatementPostEntryRequestList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankStatementRestControllerApi.postStatementLineEntryBankStatementLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {number} journalLineId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reconcileWithJournalBankStatementLine(id, journalLineId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reconcileWithJournalBankStatementLine(id, journalLineId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankStatementRestControllerApi.reconcileWithJournalBankStatementLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {BankStatementLine} bankStatementLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveBankStatementLine(bankStatementLine, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveBankStatementLine(bankStatementLine, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankStatementRestControllerApi.saveBankStatementLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestCounterAccountBankStatementLine(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestCounterAccountBankStatementLine(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankStatementRestControllerApi.suggestCounterAccountBankStatementLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unreconcileFromJournalBankStatementLine(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unreconcileFromJournalBankStatementLine(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankStatementRestControllerApi.unreconcileFromJournalBankStatementLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} bankAccountId
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadBankStatementLine(bankAccountId, validateBalanceRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadBankStatementLine(bankAccountId, validateBalanceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankStatementRestControllerApi.uploadBankStatementLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * BankStatementRestControllerApi - factory interface
 * @export
 */
export const BankStatementRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BankStatementRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} bankAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoReconcileWithJournalBankStatementLine(bankAccountId, options) {
            return localVarFp.autoReconcileWithJournalBankStatementLine(bankAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [bankAccountId]
         * @param {boolean} [reconciled]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBankStatementLine(bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options) {
            return localVarFp.countBankStatementLine(bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBankStatementLine(id, options) {
            return localVarFp.deleteOrDismissBankStatementLine(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBankStatementLine(ids, options) {
            return localVarFp.deleteOrDismissInBatchBankStatementLine(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankStatementLine(id, options) {
            return localVarFp.getBankStatementLine(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [bankAccountId]
         * @param {boolean} [reconciled]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBankStatementLine(bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options) {
            return localVarFp.listBankStatementLine(bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJournalCandidatesBankStatementLine(id, options) {
            return localVarFp.listJournalCandidatesBankStatementLine(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [bankAccountId]
         * @param {boolean} [reconciled]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBankStatementLine(page, size, sort, bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options) {
            return localVarFp.pageBankStatementLine(page, size, sort, bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {BankStatementPostEntryRequestList} bankStatementPostEntryRequestList
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postStatementLineEntryBankStatementLine(id, bankStatementPostEntryRequestList, options) {
            return localVarFp.postStatementLineEntryBankStatementLine(id, bankStatementPostEntryRequestList, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} journalLineId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reconcileWithJournalBankStatementLine(id, journalLineId, options) {
            return localVarFp.reconcileWithJournalBankStatementLine(id, journalLineId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BankStatementLine} bankStatementLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBankStatementLine(bankStatementLine, options) {
            return localVarFp.saveBankStatementLine(bankStatementLine, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestCounterAccountBankStatementLine(id, options) {
            return localVarFp.suggestCounterAccountBankStatementLine(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unreconcileFromJournalBankStatementLine(id, options) {
            return localVarFp.unreconcileFromJournalBankStatementLine(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} bankAccountId
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBankStatementLine(bankAccountId, validateBalanceRequest, options) {
            return localVarFp.uploadBankStatementLine(bankAccountId, validateBalanceRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BankStatementRestControllerApi - object-oriented interface
 * @export
 * @class BankStatementRestControllerApi
 * @extends {BaseAPI}
 */
export class BankStatementRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} bankAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankStatementRestControllerApi
     */
    autoReconcileWithJournalBankStatementLine(bankAccountId, options) {
        return BankStatementRestControllerApiFp(this.configuration).autoReconcileWithJournalBankStatementLine(bankAccountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [bankAccountId]
     * @param {boolean} [reconciled]
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankStatementRestControllerApi
     */
    countBankStatementLine(bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options) {
        return BankStatementRestControllerApiFp(this.configuration).countBankStatementLine(bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankStatementRestControllerApi
     */
    deleteOrDismissBankStatementLine(id, options) {
        return BankStatementRestControllerApiFp(this.configuration).deleteOrDismissBankStatementLine(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankStatementRestControllerApi
     */
    deleteOrDismissInBatchBankStatementLine(ids, options) {
        return BankStatementRestControllerApiFp(this.configuration).deleteOrDismissInBatchBankStatementLine(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankStatementRestControllerApi
     */
    getBankStatementLine(id, options) {
        return BankStatementRestControllerApiFp(this.configuration).getBankStatementLine(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [bankAccountId]
     * @param {boolean} [reconciled]
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankStatementRestControllerApi
     */
    listBankStatementLine(bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options) {
        return BankStatementRestControllerApiFp(this.configuration).listBankStatementLine(bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankStatementRestControllerApi
     */
    listJournalCandidatesBankStatementLine(id, options) {
        return BankStatementRestControllerApiFp(this.configuration).listJournalCandidatesBankStatementLine(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [bankAccountId]
     * @param {boolean} [reconciled]
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankStatementRestControllerApi
     */
    pageBankStatementLine(page, size, sort, bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options) {
        return BankStatementRestControllerApiFp(this.configuration).pageBankStatementLine(page, size, sort, bankAccountId, reconciled, dateFrom, dateTo, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {BankStatementPostEntryRequestList} bankStatementPostEntryRequestList
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankStatementRestControllerApi
     */
    postStatementLineEntryBankStatementLine(id, bankStatementPostEntryRequestList, options) {
        return BankStatementRestControllerApiFp(this.configuration).postStatementLineEntryBankStatementLine(id, bankStatementPostEntryRequestList, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} journalLineId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankStatementRestControllerApi
     */
    reconcileWithJournalBankStatementLine(id, journalLineId, options) {
        return BankStatementRestControllerApiFp(this.configuration).reconcileWithJournalBankStatementLine(id, journalLineId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BankStatementLine} bankStatementLine
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankStatementRestControllerApi
     */
    saveBankStatementLine(bankStatementLine, options) {
        return BankStatementRestControllerApiFp(this.configuration).saveBankStatementLine(bankStatementLine, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankStatementRestControllerApi
     */
    suggestCounterAccountBankStatementLine(id, options) {
        return BankStatementRestControllerApiFp(this.configuration).suggestCounterAccountBankStatementLine(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankStatementRestControllerApi
     */
    unreconcileFromJournalBankStatementLine(id, options) {
        return BankStatementRestControllerApiFp(this.configuration).unreconcileFromJournalBankStatementLine(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} bankAccountId
     * @param {ValidateBalanceRequest} [validateBalanceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankStatementRestControllerApi
     */
    uploadBankStatementLine(bankAccountId, validateBalanceRequest, options) {
        return BankStatementRestControllerApiFp(this.configuration).uploadBankStatementLine(bankAccountId, validateBalanceRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BillAlertRestControllerApi - axios parameter creator
 * @export
 */
export const BillAlertRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlerts: async (options = {}) => {
            const localVarPath = `/api/admin/accounting/bill-alert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BillAlertRestControllerApi - functional programming interface
 * @export
 */
export const BillAlertRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = BillAlertRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlerts(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlerts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillAlertRestControllerApi.getAlerts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * BillAlertRestControllerApi - factory interface
 * @export
 */
export const BillAlertRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BillAlertRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlerts(options) {
            return localVarFp.getAlerts(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BillAlertRestControllerApi - object-oriented interface
 * @export
 * @class BillAlertRestControllerApi
 * @extends {BaseAPI}
 */
export class BillAlertRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillAlertRestControllerApi
     */
    getAlerts(options) {
        return BillAlertRestControllerApiFp(this.configuration).getAlerts(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BillDiscountRestControllerApi - axios parameter creator
 * @export
 */
export const BillDiscountRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} discountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appendLineBillDiscount: async (discountId, options = {}) => {
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('appendLineBillDiscount', 'discountId', discountId);
            const localVarPath = `/api/admin/billing/discount/{discountId}/appendLine`
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBillDiscount: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/discount/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBillDiscount: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissBillDiscount', 'id', id);
            const localVarPath = `/api/admin/billing/discount/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBillDiscount: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchBillDiscount', 'ids', ids);
            const localVarPath = `/api/admin/billing/discount/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillDiscount: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBillDiscount', 'id', id);
            const localVarPath = `/api/admin/billing/discount/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryBillDiscount: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getSummaryBillDiscount', 'year', year);
            const localVarPath = `/api/admin/billing/discount/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBillDiscount: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/discount/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBillDiscount: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/discount/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} discountId
         * @param {Array<number>} lineIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLinesBillDiscount: async (discountId, lineIds, options = {}) => {
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('removeLinesBillDiscount', 'discountId', discountId);
            // verify required parameter 'lineIds' is not null or undefined
            assertParamExists('removeLinesBillDiscount', 'lineIds', lineIds);
            const localVarPath = `/api/admin/billing/discount/{discountId}/removeLines`
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (lineIds) {
                localVarQueryParameter['lineIds'] = lineIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {BillDiscount} billDiscount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBillDiscount: async (billDiscount, options = {}) => {
            // verify required parameter 'billDiscount' is not null or undefined
            assertParamExists('saveBillDiscount', 'billDiscount', billDiscount);
            const localVarPath = `/api/admin/billing/discount/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(billDiscount, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BillDiscountRestControllerApi - functional programming interface
 * @export
 */
export const BillDiscountRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = BillDiscountRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} discountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appendLineBillDiscount(discountId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appendLineBillDiscount(discountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillDiscountRestControllerApi.appendLineBillDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countBillDiscount(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countBillDiscount(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillDiscountRestControllerApi.countBillDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissBillDiscount(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissBillDiscount(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillDiscountRestControllerApi.deleteOrDismissBillDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchBillDiscount(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchBillDiscount(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillDiscountRestControllerApi.deleteOrDismissInBatchBillDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillDiscount(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillDiscount(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillDiscountRestControllerApi.getBillDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSummaryBillDiscount(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSummaryBillDiscount(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillDiscountRestControllerApi.getSummaryBillDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBillDiscount(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBillDiscount(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillDiscountRestControllerApi.listBillDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageBillDiscount(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageBillDiscount(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillDiscountRestControllerApi.pageBillDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} discountId
         * @param {Array<number>} lineIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeLinesBillDiscount(discountId, lineIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeLinesBillDiscount(discountId, lineIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillDiscountRestControllerApi.removeLinesBillDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {BillDiscount} billDiscount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveBillDiscount(billDiscount, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveBillDiscount(billDiscount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillDiscountRestControllerApi.saveBillDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * BillDiscountRestControllerApi - factory interface
 * @export
 */
export const BillDiscountRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BillDiscountRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} discountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appendLineBillDiscount(discountId, options) {
            return localVarFp.appendLineBillDiscount(discountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBillDiscount(term, showDismissed, options) {
            return localVarFp.countBillDiscount(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBillDiscount(id, options) {
            return localVarFp.deleteOrDismissBillDiscount(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBillDiscount(ids, options) {
            return localVarFp.deleteOrDismissInBatchBillDiscount(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillDiscount(id, options) {
            return localVarFp.getBillDiscount(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryBillDiscount(year, options) {
            return localVarFp.getSummaryBillDiscount(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBillDiscount(term, showDismissed, options) {
            return localVarFp.listBillDiscount(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBillDiscount(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageBillDiscount(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} discountId
         * @param {Array<number>} lineIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLinesBillDiscount(discountId, lineIds, options) {
            return localVarFp.removeLinesBillDiscount(discountId, lineIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BillDiscount} billDiscount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBillDiscount(billDiscount, options) {
            return localVarFp.saveBillDiscount(billDiscount, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BillDiscountRestControllerApi - object-oriented interface
 * @export
 * @class BillDiscountRestControllerApi
 * @extends {BaseAPI}
 */
export class BillDiscountRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} discountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    appendLineBillDiscount(discountId, options) {
        return BillDiscountRestControllerApiFp(this.configuration).appendLineBillDiscount(discountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    countBillDiscount(term, showDismissed, options) {
        return BillDiscountRestControllerApiFp(this.configuration).countBillDiscount(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    deleteOrDismissBillDiscount(id, options) {
        return BillDiscountRestControllerApiFp(this.configuration).deleteOrDismissBillDiscount(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    deleteOrDismissInBatchBillDiscount(ids, options) {
        return BillDiscountRestControllerApiFp(this.configuration).deleteOrDismissInBatchBillDiscount(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    getBillDiscount(id, options) {
        return BillDiscountRestControllerApiFp(this.configuration).getBillDiscount(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    getSummaryBillDiscount(year, options) {
        return BillDiscountRestControllerApiFp(this.configuration).getSummaryBillDiscount(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    listBillDiscount(term, showDismissed, options) {
        return BillDiscountRestControllerApiFp(this.configuration).listBillDiscount(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    pageBillDiscount(page, size, sort, term, showDismissed, options) {
        return BillDiscountRestControllerApiFp(this.configuration).pageBillDiscount(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} discountId
     * @param {Array<number>} lineIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    removeLinesBillDiscount(discountId, lineIds, options) {
        return BillDiscountRestControllerApiFp(this.configuration).removeLinesBillDiscount(discountId, lineIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BillDiscount} billDiscount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillDiscountRestControllerApi
     */
    saveBillDiscount(billDiscount, options) {
        return BillDiscountRestControllerApiFp(this.configuration).saveBillDiscount(billDiscount, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BillRestControllerApi - axios parameter creator
 * @export
 */
export const BillRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annualSummaryBill: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('annualSummaryBill', 'year', year);
            const localVarPath = `/api/admin/billing/bill/annual-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} bills
         * @param {boolean} sent
         * @param {string} [separator]
         * @param {boolean} [simulate]
         * @param {string} [operationMonth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchCreateBill: async (bills, sent, separator, simulate, operationMonth, options = {}) => {
            // verify required parameter 'bills' is not null or undefined
            assertParamExists('batchCreateBill', 'bills', bills);
            // verify required parameter 'sent' is not null or undefined
            assertParamExists('batchCreateBill', 'sent', sent);
            const localVarPath = `/api/admin/billing/bill/batch-create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (bills !== undefined) {
                localVarQueryParameter['bills'] = bills;
            }
            if (separator !== undefined) {
                localVarQueryParameter['separator'] = separator;
            }
            if (sent !== undefined) {
                localVarQueryParameter['sent'] = sent;
            }
            if (simulate !== undefined) {
                localVarQueryParameter['simulate'] = simulate;
            }
            if (operationMonth !== undefined) {
                localVarQueryParameter['operationMonth'] = operationMonth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} budgetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        budgetLinesBill: async (budgetId, options = {}) => {
            // verify required parameter 'budgetId' is not null or undefined
            assertParamExists('budgetLinesBill', 'budgetId', budgetId);
            const localVarPath = `/api/admin/billing/bill/budget-lines/{budgetId}`
                .replace(`{${"budgetId"}}`, encodeURIComponent(String(budgetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBill: async (billId, options = {}) => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('cancelBill', 'billId', billId);
            const localVarPath = `/api/admin/billing/bill/{billId}/cancel`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {boolean} [overdue]
         * @param {number} [budgetId]
         * @param {number} [customerId]
         * @param {string} [issueDateFrom]
         * @param {string} [issueDateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBill: async (advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/bill/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (advanced !== undefined) {
                localVarQueryParameter['advanced'] = advanced;
            }
            if (pending !== undefined) {
                localVarQueryParameter['pending'] = pending;
            }
            if (overdue !== undefined) {
                localVarQueryParameter['overdue'] = overdue;
            }
            if (budgetId !== undefined) {
                localVarQueryParameter['budgetId'] = budgetId;
            }
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            if (issueDateFrom !== undefined) {
                localVarQueryParameter['issueDateFrom'] = (issueDateFrom instanceof Date) ?
                    issueDateFrom.toISOString().substring(0, 10) :
                    issueDateFrom;
            }
            if (issueDateTo !== undefined) {
                localVarQueryParameter['issueDateTo'] = (issueDateTo instanceof Date) ?
                    issueDateTo.toISOString().substring(0, 10) :
                    issueDateTo;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBill: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissBill', 'id', id);
            const localVarPath = `/api/admin/billing/bill/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBill: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchBill', 'ids', ids);
            const localVarPath = `/api/admin/billing/bill/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateBill: async (billId, options = {}) => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('duplicateBill', 'billId', billId);
            const localVarPath = `/api/admin/billing/bill/{billId}/duplicate`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBill: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBill', 'id', id);
            const localVarPath = `/api/admin/billing/bill/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueBill: async (billId, options = {}) => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('issueBill', 'billId', billId);
            const localVarPath = `/api/admin/billing/bill/{billId}/issue`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kpisBill: async (year, options = {}) => {
            const localVarPath = `/api/admin/billing/bill/kpis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {boolean} [overdue]
         * @param {number} [budgetId]
         * @param {number} [customerId]
         * @param {string} [issueDateFrom]
         * @param {string} [issueDateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBill: async (advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/bill/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (advanced !== undefined) {
                localVarQueryParameter['advanced'] = advanced;
            }
            if (pending !== undefined) {
                localVarQueryParameter['pending'] = pending;
            }
            if (overdue !== undefined) {
                localVarQueryParameter['overdue'] = overdue;
            }
            if (budgetId !== undefined) {
                localVarQueryParameter['budgetId'] = budgetId;
            }
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            if (issueDateFrom !== undefined) {
                localVarQueryParameter['issueDateFrom'] = (issueDateFrom instanceof Date) ?
                    issueDateFrom.toISOString().substring(0, 10) :
                    issueDateFrom;
            }
            if (issueDateTo !== undefined) {
                localVarQueryParameter['issueDateTo'] = (issueDateTo instanceof Date) ?
                    issueDateTo.toISOString().substring(0, 10) :
                    issueDateTo;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overdueBill: async (options = {}) => {
            const localVarPath = `/api/admin/billing/bill/overdue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {boolean} [overdue]
         * @param {number} [budgetId]
         * @param {number} [customerId]
         * @param {string} [issueDateFrom]
         * @param {string} [issueDateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBill: async (page, size, sort, advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/bill/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (advanced !== undefined) {
                localVarQueryParameter['advanced'] = advanced;
            }
            if (pending !== undefined) {
                localVarQueryParameter['pending'] = pending;
            }
            if (overdue !== undefined) {
                localVarQueryParameter['overdue'] = overdue;
            }
            if (budgetId !== undefined) {
                localVarQueryParameter['budgetId'] = budgetId;
            }
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            if (issueDateFrom !== undefined) {
                localVarQueryParameter['issueDateFrom'] = (issueDateFrom instanceof Date) ?
                    issueDateFrom.toISOString().substring(0, 10) :
                    issueDateFrom;
            }
            if (issueDateTo !== undefined) {
                localVarQueryParameter['issueDateTo'] = (issueDateTo instanceof Date) ?
                    issueDateTo.toISOString().substring(0, 10) :
                    issueDateTo;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} billId
         * @param {Array<number>} lineIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLinesBill: async (billId, lineIds, options = {}) => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('removeLinesBill', 'billId', billId);
            // verify required parameter 'lineIds' is not null or undefined
            assertParamExists('removeLinesBill', 'lineIds', lineIds);
            const localVarPath = `/api/admin/billing/bill/{billId}/removeLines`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (lineIds) {
                localVarQueryParameter['lineIds'] = lineIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Bill} bill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBill: async (bill, options = {}) => {
            // verify required parameter 'bill' is not null or undefined
            assertParamExists('saveBill', 'bill', bill);
            const localVarPath = `/api/admin/billing/bill/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(bill, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} billId
         * @param {BillLine} billLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLineBill: async (billId, billLine, options = {}) => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('saveLineBill', 'billId', billId);
            // verify required parameter 'billLine' is not null or undefined
            assertParamExists('saveLineBill', 'billLine', billLine);
            const localVarPath = `/api/admin/billing/bill/{billId}/saveLine`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(billLine, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summaryBill: async (options = {}) => {
            const localVarPath = `/api/admin/billing/bill/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {boolean} [overdue]
         * @param {number} [budgetId]
         * @param {number} [customerId]
         * @param {string} [issueDateFrom]
         * @param {string} [issueDateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totalsBill: async (advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/bill/totals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (advanced !== undefined) {
                localVarQueryParameter['advanced'] = advanced;
            }
            if (pending !== undefined) {
                localVarQueryParameter['pending'] = pending;
            }
            if (overdue !== undefined) {
                localVarQueryParameter['overdue'] = overdue;
            }
            if (budgetId !== undefined) {
                localVarQueryParameter['budgetId'] = budgetId;
            }
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            if (issueDateFrom !== undefined) {
                localVarQueryParameter['issueDateFrom'] = (issueDateFrom instanceof Date) ?
                    issueDateFrom.toISOString().substring(0, 10) :
                    issueDateFrom;
            }
            if (issueDateTo !== undefined) {
                localVarQueryParameter['issueDateTo'] = (issueDateTo instanceof Date) ?
                    issueDateTo.toISOString().substring(0, 10) :
                    issueDateTo;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewFacturaEBill: async (billId, options = {}) => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('viewFacturaEBill', 'billId', billId);
            const localVarPath = `/api/admin/billing/bill/{billId}/facturae`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewPdfBill: async (billId, options = {}) => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('viewPdfBill', 'billId', billId);
            const localVarPath = `/api/admin/billing/bill/{billId}/pdf`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BillRestControllerApi - functional programming interface
 * @export
 */
export const BillRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = BillRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async annualSummaryBill(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.annualSummaryBill(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.annualSummaryBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} bills
         * @param {boolean} sent
         * @param {string} [separator]
         * @param {boolean} [simulate]
         * @param {string} [operationMonth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async batchCreateBill(bills, sent, separator, simulate, operationMonth, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.batchCreateBill(bills, sent, separator, simulate, operationMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.batchCreateBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} budgetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async budgetLinesBill(budgetId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.budgetLinesBill(budgetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.budgetLinesBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelBill(billId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelBill(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.cancelBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {boolean} [overdue]
         * @param {number} [budgetId]
         * @param {number} [customerId]
         * @param {string} [issueDateFrom]
         * @param {string} [issueDateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countBill(advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countBill(advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.countBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissBill(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissBill(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.deleteOrDismissBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchBill(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchBill(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.deleteOrDismissInBatchBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateBill(billId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateBill(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.duplicateBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBill(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBill(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.getBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async issueBill(billId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.issueBill(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.issueBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kpisBill(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kpisBill(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.kpisBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {boolean} [overdue]
         * @param {number} [budgetId]
         * @param {number} [customerId]
         * @param {string} [issueDateFrom]
         * @param {string} [issueDateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBill(advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBill(advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.listBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overdueBill(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overdueBill(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.overdueBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {boolean} [overdue]
         * @param {number} [budgetId]
         * @param {number} [customerId]
         * @param {string} [issueDateFrom]
         * @param {string} [issueDateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageBill(page, size, sort, advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageBill(page, size, sort, advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.pageBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} billId
         * @param {Array<number>} lineIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeLinesBill(billId, lineIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeLinesBill(billId, lineIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.removeLinesBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Bill} bill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveBill(bill, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveBill(bill, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.saveBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} billId
         * @param {BillLine} billLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveLineBill(billId, billLine, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveLineBill(billId, billLine, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.saveLineBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async summaryBill(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.summaryBill(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.summaryBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {boolean} [overdue]
         * @param {number} [budgetId]
         * @param {number} [customerId]
         * @param {string} [issueDateFrom]
         * @param {string} [issueDateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async totalsBill(advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.totalsBill(advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.totalsBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewFacturaEBill(billId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewFacturaEBill(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.viewFacturaEBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewPdfBill(billId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewPdfBill(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillRestControllerApi.viewPdfBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * BillRestControllerApi - factory interface
 * @export
 */
export const BillRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BillRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annualSummaryBill(year, options) {
            return localVarFp.annualSummaryBill(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} bills
         * @param {boolean} sent
         * @param {string} [separator]
         * @param {boolean} [simulate]
         * @param {string} [operationMonth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchCreateBill(bills, sent, separator, simulate, operationMonth, options) {
            return localVarFp.batchCreateBill(bills, sent, separator, simulate, operationMonth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} budgetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        budgetLinesBill(budgetId, options) {
            return localVarFp.budgetLinesBill(budgetId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBill(billId, options) {
            return localVarFp.cancelBill(billId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {boolean} [overdue]
         * @param {number} [budgetId]
         * @param {number} [customerId]
         * @param {string} [issueDateFrom]
         * @param {string} [issueDateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBill(advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options) {
            return localVarFp.countBill(advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBill(id, options) {
            return localVarFp.deleteOrDismissBill(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBill(ids, options) {
            return localVarFp.deleteOrDismissInBatchBill(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateBill(billId, options) {
            return localVarFp.duplicateBill(billId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBill(id, options) {
            return localVarFp.getBill(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueBill(billId, options) {
            return localVarFp.issueBill(billId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kpisBill(year, options) {
            return localVarFp.kpisBill(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {boolean} [overdue]
         * @param {number} [budgetId]
         * @param {number} [customerId]
         * @param {string} [issueDateFrom]
         * @param {string} [issueDateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBill(advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options) {
            return localVarFp.listBill(advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overdueBill(options) {
            return localVarFp.overdueBill(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {boolean} [overdue]
         * @param {number} [budgetId]
         * @param {number} [customerId]
         * @param {string} [issueDateFrom]
         * @param {string} [issueDateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBill(page, size, sort, advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options) {
            return localVarFp.pageBill(page, size, sort, advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} billId
         * @param {Array<number>} lineIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLinesBill(billId, lineIds, options) {
            return localVarFp.removeLinesBill(billId, lineIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Bill} bill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBill(bill, options) {
            return localVarFp.saveBill(bill, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} billId
         * @param {BillLine} billLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLineBill(billId, billLine, options) {
            return localVarFp.saveLineBill(billId, billLine, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summaryBill(options) {
            return localVarFp.summaryBill(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [advanced]
         * @param {boolean} [pending]
         * @param {boolean} [overdue]
         * @param {number} [budgetId]
         * @param {number} [customerId]
         * @param {string} [issueDateFrom]
         * @param {string} [issueDateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totalsBill(advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options) {
            return localVarFp.totalsBill(advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewFacturaEBill(billId, options) {
            return localVarFp.viewFacturaEBill(billId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewPdfBill(billId, options) {
            return localVarFp.viewPdfBill(billId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BillRestControllerApi - object-oriented interface
 * @export
 * @class BillRestControllerApi
 * @extends {BaseAPI}
 */
export class BillRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    annualSummaryBill(year, options) {
        return BillRestControllerApiFp(this.configuration).annualSummaryBill(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} bills
     * @param {boolean} sent
     * @param {string} [separator]
     * @param {boolean} [simulate]
     * @param {string} [operationMonth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    batchCreateBill(bills, sent, separator, simulate, operationMonth, options) {
        return BillRestControllerApiFp(this.configuration).batchCreateBill(bills, sent, separator, simulate, operationMonth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} budgetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    budgetLinesBill(budgetId, options) {
        return BillRestControllerApiFp(this.configuration).budgetLinesBill(budgetId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} billId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    cancelBill(billId, options) {
        return BillRestControllerApiFp(this.configuration).cancelBill(billId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [advanced]
     * @param {boolean} [pending]
     * @param {boolean} [overdue]
     * @param {number} [budgetId]
     * @param {number} [customerId]
     * @param {string} [issueDateFrom]
     * @param {string} [issueDateTo]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    countBill(advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options) {
        return BillRestControllerApiFp(this.configuration).countBill(advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    deleteOrDismissBill(id, options) {
        return BillRestControllerApiFp(this.configuration).deleteOrDismissBill(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    deleteOrDismissInBatchBill(ids, options) {
        return BillRestControllerApiFp(this.configuration).deleteOrDismissInBatchBill(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} billId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    duplicateBill(billId, options) {
        return BillRestControllerApiFp(this.configuration).duplicateBill(billId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    getBill(id, options) {
        return BillRestControllerApiFp(this.configuration).getBill(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} billId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    issueBill(billId, options) {
        return BillRestControllerApiFp(this.configuration).issueBill(billId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [year]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    kpisBill(year, options) {
        return BillRestControllerApiFp(this.configuration).kpisBill(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [advanced]
     * @param {boolean} [pending]
     * @param {boolean} [overdue]
     * @param {number} [budgetId]
     * @param {number} [customerId]
     * @param {string} [issueDateFrom]
     * @param {string} [issueDateTo]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    listBill(advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options) {
        return BillRestControllerApiFp(this.configuration).listBill(advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    overdueBill(options) {
        return BillRestControllerApiFp(this.configuration).overdueBill(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {boolean} [advanced]
     * @param {boolean} [pending]
     * @param {boolean} [overdue]
     * @param {number} [budgetId]
     * @param {number} [customerId]
     * @param {string} [issueDateFrom]
     * @param {string} [issueDateTo]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    pageBill(page, size, sort, advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options) {
        return BillRestControllerApiFp(this.configuration).pageBill(page, size, sort, advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} billId
     * @param {Array<number>} lineIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    removeLinesBill(billId, lineIds, options) {
        return BillRestControllerApiFp(this.configuration).removeLinesBill(billId, lineIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Bill} bill
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    saveBill(bill, options) {
        return BillRestControllerApiFp(this.configuration).saveBill(bill, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} billId
     * @param {BillLine} billLine
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    saveLineBill(billId, billLine, options) {
        return BillRestControllerApiFp(this.configuration).saveLineBill(billId, billLine, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    summaryBill(options) {
        return BillRestControllerApiFp(this.configuration).summaryBill(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [advanced]
     * @param {boolean} [pending]
     * @param {boolean} [overdue]
     * @param {number} [budgetId]
     * @param {number} [customerId]
     * @param {string} [issueDateFrom]
     * @param {string} [issueDateTo]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    totalsBill(advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options) {
        return BillRestControllerApiFp(this.configuration).totalsBill(advanced, pending, overdue, budgetId, customerId, issueDateFrom, issueDateTo, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} billId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    viewFacturaEBill(billId, options) {
        return BillRestControllerApiFp(this.configuration).viewFacturaEBill(billId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} billId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillRestControllerApi
     */
    viewPdfBill(billId, options) {
        return BillRestControllerApiFp(this.configuration).viewPdfBill(billId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BudgetPaymentRestControllerApi - axios parameter creator
 * @export
 */
export const BudgetPaymentRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [budgetId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [invoiced]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBudgetPayment: async (budgetId, year, month, invoiced, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/budget-payment/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (budgetId !== undefined) {
                localVarQueryParameter['budgetId'] = budgetId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (invoiced !== undefined) {
                localVarQueryParameter['invoiced'] = invoiced;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBudgetPayment: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissBudgetPayment', 'id', id);
            const localVarPath = `/api/admin/billing/budget-payment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBudgetPayment: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchBudgetPayment', 'ids', ids);
            const localVarPath = `/api/admin/billing/budget-payment/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPendingForMonthBudgetPayment: async (year, month, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('findPendingForMonthBudgetPayment', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('findPendingForMonthBudgetPayment', 'month', month);
            const localVarPath = `/api/admin/billing/budget-payment/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPendingWithoutDateBudgetPayment: async (options = {}) => {
            const localVarPath = `/api/admin/billing/budget-payment/pending-without-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBudgetPayment: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBudgetPayment', 'id', id);
            const localVarPath = `/api/admin/billing/budget-payment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [budgetId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [invoiced]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBudgetPayment: async (budgetId, year, month, invoiced, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/budget-payment/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (budgetId !== undefined) {
                localVarQueryParameter['budgetId'] = budgetId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (invoiced !== undefined) {
                localVarQueryParameter['invoiced'] = invoiced;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markInvoicedBudgetPayment: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markInvoicedBudgetPayment', 'id', id);
            const localVarPath = `/api/admin/billing/budget-payment/{id}/invoiced`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [budgetId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [invoiced]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBudgetPayment: async (page, size, sort, budgetId, year, month, invoiced, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/budget-payment/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (budgetId !== undefined) {
                localVarQueryParameter['budgetId'] = budgetId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (invoiced !== undefined) {
                localVarQueryParameter['invoiced'] = invoiced;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {BudgetPayment} budgetPayment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBudgetPayment: async (budgetPayment, options = {}) => {
            // verify required parameter 'budgetPayment' is not null or undefined
            assertParamExists('saveBudgetPayment', 'budgetPayment', budgetPayment);
            const localVarPath = `/api/admin/billing/budget-payment/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(budgetPayment, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BudgetPaymentRestControllerApi - functional programming interface
 * @export
 */
export const BudgetPaymentRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = BudgetPaymentRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [budgetId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [invoiced]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countBudgetPayment(budgetId, year, month, invoiced, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countBudgetPayment(budgetId, year, month, invoiced, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetPaymentRestControllerApi.countBudgetPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissBudgetPayment(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissBudgetPayment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetPaymentRestControllerApi.deleteOrDismissBudgetPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchBudgetPayment(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchBudgetPayment(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetPaymentRestControllerApi.deleteOrDismissInBatchBudgetPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPendingForMonthBudgetPayment(year, month, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findPendingForMonthBudgetPayment(year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetPaymentRestControllerApi.findPendingForMonthBudgetPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPendingWithoutDateBudgetPayment(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findPendingWithoutDateBudgetPayment(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetPaymentRestControllerApi.findPendingWithoutDateBudgetPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBudgetPayment(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBudgetPayment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetPaymentRestControllerApi.getBudgetPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [budgetId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [invoiced]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBudgetPayment(budgetId, year, month, invoiced, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBudgetPayment(budgetId, year, month, invoiced, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetPaymentRestControllerApi.listBudgetPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markInvoicedBudgetPayment(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markInvoicedBudgetPayment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetPaymentRestControllerApi.markInvoicedBudgetPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [budgetId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [invoiced]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageBudgetPayment(page, size, sort, budgetId, year, month, invoiced, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageBudgetPayment(page, size, sort, budgetId, year, month, invoiced, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetPaymentRestControllerApi.pageBudgetPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {BudgetPayment} budgetPayment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveBudgetPayment(budgetPayment, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveBudgetPayment(budgetPayment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetPaymentRestControllerApi.saveBudgetPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * BudgetPaymentRestControllerApi - factory interface
 * @export
 */
export const BudgetPaymentRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BudgetPaymentRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [budgetId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [invoiced]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBudgetPayment(budgetId, year, month, invoiced, term, showDismissed, options) {
            return localVarFp.countBudgetPayment(budgetId, year, month, invoiced, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBudgetPayment(id, options) {
            return localVarFp.deleteOrDismissBudgetPayment(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBudgetPayment(ids, options) {
            return localVarFp.deleteOrDismissInBatchBudgetPayment(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPendingForMonthBudgetPayment(year, month, options) {
            return localVarFp.findPendingForMonthBudgetPayment(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPendingWithoutDateBudgetPayment(options) {
            return localVarFp.findPendingWithoutDateBudgetPayment(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBudgetPayment(id, options) {
            return localVarFp.getBudgetPayment(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [budgetId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [invoiced]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBudgetPayment(budgetId, year, month, invoiced, term, showDismissed, options) {
            return localVarFp.listBudgetPayment(budgetId, year, month, invoiced, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markInvoicedBudgetPayment(id, options) {
            return localVarFp.markInvoicedBudgetPayment(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [budgetId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [invoiced]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBudgetPayment(page, size, sort, budgetId, year, month, invoiced, term, showDismissed, options) {
            return localVarFp.pageBudgetPayment(page, size, sort, budgetId, year, month, invoiced, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BudgetPayment} budgetPayment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBudgetPayment(budgetPayment, options) {
            return localVarFp.saveBudgetPayment(budgetPayment, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BudgetPaymentRestControllerApi - object-oriented interface
 * @export
 * @class BudgetPaymentRestControllerApi
 * @extends {BaseAPI}
 */
export class BudgetPaymentRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [budgetId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [invoiced]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetPaymentRestControllerApi
     */
    countBudgetPayment(budgetId, year, month, invoiced, term, showDismissed, options) {
        return BudgetPaymentRestControllerApiFp(this.configuration).countBudgetPayment(budgetId, year, month, invoiced, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetPaymentRestControllerApi
     */
    deleteOrDismissBudgetPayment(id, options) {
        return BudgetPaymentRestControllerApiFp(this.configuration).deleteOrDismissBudgetPayment(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetPaymentRestControllerApi
     */
    deleteOrDismissInBatchBudgetPayment(ids, options) {
        return BudgetPaymentRestControllerApiFp(this.configuration).deleteOrDismissInBatchBudgetPayment(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetPaymentRestControllerApi
     */
    findPendingForMonthBudgetPayment(year, month, options) {
        return BudgetPaymentRestControllerApiFp(this.configuration).findPendingForMonthBudgetPayment(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetPaymentRestControllerApi
     */
    findPendingWithoutDateBudgetPayment(options) {
        return BudgetPaymentRestControllerApiFp(this.configuration).findPendingWithoutDateBudgetPayment(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetPaymentRestControllerApi
     */
    getBudgetPayment(id, options) {
        return BudgetPaymentRestControllerApiFp(this.configuration).getBudgetPayment(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [budgetId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [invoiced]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetPaymentRestControllerApi
     */
    listBudgetPayment(budgetId, year, month, invoiced, term, showDismissed, options) {
        return BudgetPaymentRestControllerApiFp(this.configuration).listBudgetPayment(budgetId, year, month, invoiced, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetPaymentRestControllerApi
     */
    markInvoicedBudgetPayment(id, options) {
        return BudgetPaymentRestControllerApiFp(this.configuration).markInvoicedBudgetPayment(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [budgetId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [invoiced]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetPaymentRestControllerApi
     */
    pageBudgetPayment(page, size, sort, budgetId, year, month, invoiced, term, showDismissed, options) {
        return BudgetPaymentRestControllerApiFp(this.configuration).pageBudgetPayment(page, size, sort, budgetId, year, month, invoiced, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BudgetPayment} budgetPayment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetPaymentRestControllerApi
     */
    saveBudgetPayment(budgetPayment, options) {
        return BudgetPaymentRestControllerApiFp(this.configuration).saveBudgetPayment(budgetPayment, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BudgetRestControllerApi - axios parameter creator
 * @export
 */
export const BudgetRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changesBudget: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changesBudget', 'id', id);
            const localVarPath = `/api/admin/billing/budget/{id}/changes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBudget: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/budget/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBudget: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissBudget', 'id', id);
            const localVarPath = `/api/admin/billing/budget/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBudget: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchBudget', 'ids', ids);
            const localVarPath = `/api/admin/billing/budget/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [ownerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryStatsBudget: async (from, to, ownerId, options = {}) => {
            const localVarPath = `/api/admin/billing/budget/delivery-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString().substring(0, 10) :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString().substring(0, 10) :
                    to;
            }
            if (ownerId !== undefined) {
                localVarQueryParameter['ownerId'] = ownerId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findActiveRecurrentBudget: async (options = {}) => {
            const localVarPath = `/api/admin/billing/budget/recurrent/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSummariesBudget: async (options = {}) => {
            const localVarPath = `/api/admin/billing/budget/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBudget: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBudget', 'id', id);
            const localVarPath = `/api/admin/billing/budget/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitStatsBudget: async (year, options = {}) => {
            const localVarPath = `/api/admin/billing/budget/units-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBudget: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/budget/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerStatsBudget: async (year, options = {}) => {
            const localVarPath = `/api/admin/billing/budget/manager-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBudget: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/budget/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pendingBillingBudget: async (options = {}) => {
            const localVarPath = `/api/admin/billing/budget/pending-billing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recurrentProposalBudget: async (year, month, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('recurrentProposalBudget', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('recurrentProposalBudget', 'month', month);
            const localVarPath = `/api/admin/billing/budget/recurrent/proposal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Budget} budget
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBudget: async (budget, options = {}) => {
            // verify required parameter 'budget' is not null or undefined
            assertParamExists('saveBudget', 'budget', budget);
            const localVarPath = `/api/admin/billing/budget/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(budget, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BudgetRestControllerApi - functional programming interface
 * @export
 */
export const BudgetRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = BudgetRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changesBudget(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changesBudget(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetRestControllerApi.changesBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countBudget(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countBudget(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetRestControllerApi.countBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissBudget(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissBudget(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetRestControllerApi.deleteOrDismissBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchBudget(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchBudget(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetRestControllerApi.deleteOrDismissInBatchBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [ownerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryStatsBudget(from, to, ownerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryStatsBudget(from, to, ownerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetRestControllerApi.deliveryStatsBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findActiveRecurrentBudget(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findActiveRecurrentBudget(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetRestControllerApi.findActiveRecurrentBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveSummariesBudget(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveSummariesBudget(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetRestControllerApi.getActiveSummariesBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBudget(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBudget(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetRestControllerApi.getBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnitStatsBudget(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnitStatsBudget(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetRestControllerApi.getUnitStatsBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBudget(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBudget(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetRestControllerApi.listBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managerStatsBudget(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managerStatsBudget(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetRestControllerApi.managerStatsBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageBudget(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageBudget(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetRestControllerApi.pageBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pendingBillingBudget(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pendingBillingBudget(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetRestControllerApi.pendingBillingBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recurrentProposalBudget(year, month, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recurrentProposalBudget(year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetRestControllerApi.recurrentProposalBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Budget} budget
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveBudget(budget, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveBudget(budget, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetRestControllerApi.saveBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * BudgetRestControllerApi - factory interface
 * @export
 */
export const BudgetRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BudgetRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changesBudget(id, options) {
            return localVarFp.changesBudget(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countBudget(term, showDismissed, options) {
            return localVarFp.countBudget(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissBudget(id, options) {
            return localVarFp.deleteOrDismissBudget(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchBudget(ids, options) {
            return localVarFp.deleteOrDismissInBatchBudget(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [ownerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryStatsBudget(from, to, ownerId, options) {
            return localVarFp.deliveryStatsBudget(from, to, ownerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findActiveRecurrentBudget(options) {
            return localVarFp.findActiveRecurrentBudget(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSummariesBudget(options) {
            return localVarFp.getActiveSummariesBudget(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBudget(id, options) {
            return localVarFp.getBudget(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitStatsBudget(year, options) {
            return localVarFp.getUnitStatsBudget(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBudget(term, showDismissed, options) {
            return localVarFp.listBudget(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerStatsBudget(year, options) {
            return localVarFp.managerStatsBudget(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBudget(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageBudget(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pendingBillingBudget(options) {
            return localVarFp.pendingBillingBudget(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recurrentProposalBudget(year, month, options) {
            return localVarFp.recurrentProposalBudget(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Budget} budget
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBudget(budget, options) {
            return localVarFp.saveBudget(budget, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BudgetRestControllerApi - object-oriented interface
 * @export
 * @class BudgetRestControllerApi
 * @extends {BaseAPI}
 */
export class BudgetRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    changesBudget(id, options) {
        return BudgetRestControllerApiFp(this.configuration).changesBudget(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    countBudget(term, showDismissed, options) {
        return BudgetRestControllerApiFp(this.configuration).countBudget(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    deleteOrDismissBudget(id, options) {
        return BudgetRestControllerApiFp(this.configuration).deleteOrDismissBudget(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    deleteOrDismissInBatchBudget(ids, options) {
        return BudgetRestControllerApiFp(this.configuration).deleteOrDismissInBatchBudget(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [from]
     * @param {string} [to]
     * @param {number} [ownerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    deliveryStatsBudget(from, to, ownerId, options) {
        return BudgetRestControllerApiFp(this.configuration).deliveryStatsBudget(from, to, ownerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    findActiveRecurrentBudget(options) {
        return BudgetRestControllerApiFp(this.configuration).findActiveRecurrentBudget(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    getActiveSummariesBudget(options) {
        return BudgetRestControllerApiFp(this.configuration).getActiveSummariesBudget(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    getBudget(id, options) {
        return BudgetRestControllerApiFp(this.configuration).getBudget(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [year]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    getUnitStatsBudget(year, options) {
        return BudgetRestControllerApiFp(this.configuration).getUnitStatsBudget(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    listBudget(term, showDismissed, options) {
        return BudgetRestControllerApiFp(this.configuration).listBudget(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [year]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    managerStatsBudget(year, options) {
        return BudgetRestControllerApiFp(this.configuration).managerStatsBudget(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    pageBudget(page, size, sort, term, showDismissed, options) {
        return BudgetRestControllerApiFp(this.configuration).pageBudget(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    pendingBillingBudget(options) {
        return BudgetRestControllerApiFp(this.configuration).pendingBillingBudget(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    recurrentProposalBudget(year, month, options) {
        return BudgetRestControllerApiFp(this.configuration).recurrentProposalBudget(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Budget} budget
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetRestControllerApi
     */
    saveBudget(budget, options) {
        return BudgetRestControllerApiFp(this.configuration).saveBudget(budget, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CandidateDocumentRestControllerApi - axios parameter creator
 * @export
 */
export const CandidateDocumentRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateDocument: async (candidateId, term, showDismissed, options = {}) => {
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('countCandidateDocument', 'candidateId', candidateId);
            const localVarPath = `/api/admin/recruitment/candidate/document/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateDocument: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissCandidateDocument', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateDocument: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchCandidateDocument', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/candidate/document/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateDocument: async (documentId, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('downloadCandidateDocument', 'documentId', documentId);
            const localVarPath = `/api/admin/recruitment/candidate/document/{documentId}/attachment`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateDocument: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCandidateDocument', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateDocument: async (candidateId, term, showDismissed, options = {}) => {
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('listCandidateDocument', 'candidateId', candidateId);
            const localVarPath = `/api/admin/recruitment/candidate/document/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} candidateId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateDocument: async (candidateId, page, size, sort, term, showDismissed, options = {}) => {
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('pageCandidateDocument', 'candidateId', candidateId);
            const localVarPath = `/api/admin/recruitment/candidate/document/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CandidateDocument} candidateDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateDocument: async (candidateDocument, options = {}) => {
            // verify required parameter 'candidateDocument' is not null or undefined
            assertParamExists('saveCandidateDocument', 'candidateDocument', candidateDocument);
            const localVarPath = `/api/admin/recruitment/candidate/document/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(candidateDocument, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CandidateDocumentRestControllerApi - functional programming interface
 * @export
 */
export const CandidateDocumentRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = CandidateDocumentRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countCandidateDocument(candidateId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countCandidateDocument(candidateId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateDocumentRestControllerApi.countCandidateDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissCandidateDocument(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissCandidateDocument(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateDocumentRestControllerApi.deleteOrDismissCandidateDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchCandidateDocument(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchCandidateDocument(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateDocumentRestControllerApi.deleteOrDismissInBatchCandidateDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCandidateDocument(documentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCandidateDocument(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateDocumentRestControllerApi.downloadCandidateDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateDocument(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateDocument(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateDocumentRestControllerApi.getCandidateDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCandidateDocument(candidateId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCandidateDocument(candidateId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateDocumentRestControllerApi.listCandidateDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} candidateId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageCandidateDocument(candidateId, page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageCandidateDocument(candidateId, page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateDocumentRestControllerApi.pageCandidateDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CandidateDocument} candidateDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCandidateDocument(candidateDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCandidateDocument(candidateDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateDocumentRestControllerApi.saveCandidateDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CandidateDocumentRestControllerApi - factory interface
 * @export
 */
export const CandidateDocumentRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CandidateDocumentRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateDocument(candidateId, term, showDismissed, options) {
            return localVarFp.countCandidateDocument(candidateId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateDocument(id, options) {
            return localVarFp.deleteOrDismissCandidateDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateDocument(ids, options) {
            return localVarFp.deleteOrDismissInBatchCandidateDocument(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateDocument(documentId, options) {
            return localVarFp.downloadCandidateDocument(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateDocument(id, options) {
            return localVarFp.getCandidateDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateDocument(candidateId, term, showDismissed, options) {
            return localVarFp.listCandidateDocument(candidateId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} candidateId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateDocument(candidateId, page, size, sort, term, showDismissed, options) {
            return localVarFp.pageCandidateDocument(candidateId, page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CandidateDocument} candidateDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateDocument(candidateDocument, options) {
            return localVarFp.saveCandidateDocument(candidateDocument, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CandidateDocumentRestControllerApi - object-oriented interface
 * @export
 * @class CandidateDocumentRestControllerApi
 * @extends {BaseAPI}
 */
export class CandidateDocumentRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} candidateId
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateDocumentRestControllerApi
     */
    countCandidateDocument(candidateId, term, showDismissed, options) {
        return CandidateDocumentRestControllerApiFp(this.configuration).countCandidateDocument(candidateId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateDocumentRestControllerApi
     */
    deleteOrDismissCandidateDocument(id, options) {
        return CandidateDocumentRestControllerApiFp(this.configuration).deleteOrDismissCandidateDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateDocumentRestControllerApi
     */
    deleteOrDismissInBatchCandidateDocument(ids, options) {
        return CandidateDocumentRestControllerApiFp(this.configuration).deleteOrDismissInBatchCandidateDocument(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateDocumentRestControllerApi
     */
    downloadCandidateDocument(documentId, options) {
        return CandidateDocumentRestControllerApiFp(this.configuration).downloadCandidateDocument(documentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateDocumentRestControllerApi
     */
    getCandidateDocument(id, options) {
        return CandidateDocumentRestControllerApiFp(this.configuration).getCandidateDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} candidateId
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateDocumentRestControllerApi
     */
    listCandidateDocument(candidateId, term, showDismissed, options) {
        return CandidateDocumentRestControllerApiFp(this.configuration).listCandidateDocument(candidateId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} candidateId
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateDocumentRestControllerApi
     */
    pageCandidateDocument(candidateId, page, size, sort, term, showDismissed, options) {
        return CandidateDocumentRestControllerApiFp(this.configuration).pageCandidateDocument(candidateId, page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CandidateDocument} candidateDocument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateDocumentRestControllerApi
     */
    saveCandidateDocument(candidateDocument, options) {
        return CandidateDocumentRestControllerApiFp(this.configuration).saveCandidateDocument(candidateDocument, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CandidateEventRestControllerApi - axios parameter creator
 * @export
 */
export const CandidateEventRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateEvent: async (candidateId, term, showDismissed, options = {}) => {
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('countCandidateEvent', 'candidateId', candidateId);
            const localVarPath = `/api/admin/recruitment/candidate/event/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateEvent: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissCandidateEvent', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateEvent: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchCandidateEvent', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/candidate/event/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateEvent: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCandidateEvent', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateEvent: async (candidateId, term, showDismissed, options = {}) => {
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('listCandidateEvent', 'candidateId', candidateId);
            const localVarPath = `/api/admin/recruitment/candidate/event/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} candidateId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateEvent: async (candidateId, page, size, sort, term, showDismissed, options = {}) => {
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('pageCandidateEvent', 'candidateId', candidateId);
            const localVarPath = `/api/admin/recruitment/candidate/event/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CandidateEvent} candidateEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateEvent: async (candidateEvent, options = {}) => {
            // verify required parameter 'candidateEvent' is not null or undefined
            assertParamExists('saveCandidateEvent', 'candidateEvent', candidateEvent);
            const localVarPath = `/api/admin/recruitment/candidate/event/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(candidateEvent, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CandidateEventRestControllerApi - functional programming interface
 * @export
 */
export const CandidateEventRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = CandidateEventRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countCandidateEvent(candidateId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countCandidateEvent(candidateId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateEventRestControllerApi.countCandidateEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissCandidateEvent(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissCandidateEvent(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateEventRestControllerApi.deleteOrDismissCandidateEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchCandidateEvent(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchCandidateEvent(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateEventRestControllerApi.deleteOrDismissInBatchCandidateEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateEvent(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateEvent(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateEventRestControllerApi.getCandidateEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCandidateEvent(candidateId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCandidateEvent(candidateId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateEventRestControllerApi.listCandidateEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} candidateId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageCandidateEvent(candidateId, page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageCandidateEvent(candidateId, page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateEventRestControllerApi.pageCandidateEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CandidateEvent} candidateEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCandidateEvent(candidateEvent, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCandidateEvent(candidateEvent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateEventRestControllerApi.saveCandidateEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CandidateEventRestControllerApi - factory interface
 * @export
 */
export const CandidateEventRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CandidateEventRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateEvent(candidateId, term, showDismissed, options) {
            return localVarFp.countCandidateEvent(candidateId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateEvent(id, options) {
            return localVarFp.deleteOrDismissCandidateEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateEvent(ids, options) {
            return localVarFp.deleteOrDismissInBatchCandidateEvent(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateEvent(id, options) {
            return localVarFp.getCandidateEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} candidateId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateEvent(candidateId, term, showDismissed, options) {
            return localVarFp.listCandidateEvent(candidateId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} candidateId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateEvent(candidateId, page, size, sort, term, showDismissed, options) {
            return localVarFp.pageCandidateEvent(candidateId, page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CandidateEvent} candidateEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateEvent(candidateEvent, options) {
            return localVarFp.saveCandidateEvent(candidateEvent, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CandidateEventRestControllerApi - object-oriented interface
 * @export
 * @class CandidateEventRestControllerApi
 * @extends {BaseAPI}
 */
export class CandidateEventRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} candidateId
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateEventRestControllerApi
     */
    countCandidateEvent(candidateId, term, showDismissed, options) {
        return CandidateEventRestControllerApiFp(this.configuration).countCandidateEvent(candidateId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateEventRestControllerApi
     */
    deleteOrDismissCandidateEvent(id, options) {
        return CandidateEventRestControllerApiFp(this.configuration).deleteOrDismissCandidateEvent(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateEventRestControllerApi
     */
    deleteOrDismissInBatchCandidateEvent(ids, options) {
        return CandidateEventRestControllerApiFp(this.configuration).deleteOrDismissInBatchCandidateEvent(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateEventRestControllerApi
     */
    getCandidateEvent(id, options) {
        return CandidateEventRestControllerApiFp(this.configuration).getCandidateEvent(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} candidateId
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateEventRestControllerApi
     */
    listCandidateEvent(candidateId, term, showDismissed, options) {
        return CandidateEventRestControllerApiFp(this.configuration).listCandidateEvent(candidateId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} candidateId
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateEventRestControllerApi
     */
    pageCandidateEvent(candidateId, page, size, sort, term, showDismissed, options) {
        return CandidateEventRestControllerApiFp(this.configuration).pageCandidateEvent(candidateId, page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CandidateEvent} candidateEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateEventRestControllerApi
     */
    saveCandidateEvent(candidateEvent, options) {
        return CandidateEventRestControllerApiFp(this.configuration).saveCandidateEvent(candidateEvent, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CandidateLevelSolutionRestControllerApi - axios parameter creator
 * @export
 */
export const CandidateLevelSolutionRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [candidateId]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateLevelSolution: async (candidateId, pending, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/candidate/level/solution/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (pending !== undefined) {
                localVarQueryParameter['pending'] = pending;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateLevelSolution: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissCandidateLevelSolution', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/level/solution/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateLevelSolution: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchCandidateLevelSolution', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/candidate/level/solution/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} solutionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateLevelSolution: async (solutionId, options = {}) => {
            // verify required parameter 'solutionId' is not null or undefined
            assertParamExists('downloadCandidateLevelSolution', 'solutionId', solutionId);
            const localVarPath = `/api/admin/recruitment/candidate/level/solution/{solutionId}/attachment`
                .replace(`{${"solutionId"}}`, encodeURIComponent(String(solutionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateLevelSolution: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCandidateLevelSolution', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/level/solution/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [candidateId]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateLevelSolution: async (candidateId, pending, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/candidate/level/solution/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (pending !== undefined) {
                localVarQueryParameter['pending'] = pending;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [candidateId]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateLevelSolution: async (page, size, sort, candidateId, pending, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/candidate/level/solution/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (candidateId !== undefined) {
                localVarQueryParameter['candidateId'] = candidateId;
            }
            if (pending !== undefined) {
                localVarQueryParameter['pending'] = pending;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CandidateLevelSolution} candidateLevelSolution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateLevelSolution: async (candidateLevelSolution, options = {}) => {
            // verify required parameter 'candidateLevelSolution' is not null or undefined
            assertParamExists('saveCandidateLevelSolution', 'candidateLevelSolution', candidateLevelSolution);
            const localVarPath = `/api/admin/recruitment/candidate/level/solution/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(candidateLevelSolution, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CandidateLevelSolutionRestControllerApi - functional programming interface
 * @export
 */
export const CandidateLevelSolutionRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = CandidateLevelSolutionRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [candidateId]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countCandidateLevelSolution(candidateId, pending, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countCandidateLevelSolution(candidateId, pending, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateLevelSolutionRestControllerApi.countCandidateLevelSolution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissCandidateLevelSolution(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissCandidateLevelSolution(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateLevelSolutionRestControllerApi.deleteOrDismissCandidateLevelSolution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchCandidateLevelSolution(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchCandidateLevelSolution(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateLevelSolutionRestControllerApi.deleteOrDismissInBatchCandidateLevelSolution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} solutionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCandidateLevelSolution(solutionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCandidateLevelSolution(solutionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateLevelSolutionRestControllerApi.downloadCandidateLevelSolution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateLevelSolution(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateLevelSolution(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateLevelSolutionRestControllerApi.getCandidateLevelSolution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [candidateId]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCandidateLevelSolution(candidateId, pending, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCandidateLevelSolution(candidateId, pending, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateLevelSolutionRestControllerApi.listCandidateLevelSolution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [candidateId]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageCandidateLevelSolution(page, size, sort, candidateId, pending, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageCandidateLevelSolution(page, size, sort, candidateId, pending, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateLevelSolutionRestControllerApi.pageCandidateLevelSolution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CandidateLevelSolution} candidateLevelSolution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCandidateLevelSolution(candidateLevelSolution, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCandidateLevelSolution(candidateLevelSolution, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateLevelSolutionRestControllerApi.saveCandidateLevelSolution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CandidateLevelSolutionRestControllerApi - factory interface
 * @export
 */
export const CandidateLevelSolutionRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CandidateLevelSolutionRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [candidateId]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateLevelSolution(candidateId, pending, term, showDismissed, options) {
            return localVarFp.countCandidateLevelSolution(candidateId, pending, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateLevelSolution(id, options) {
            return localVarFp.deleteOrDismissCandidateLevelSolution(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateLevelSolution(ids, options) {
            return localVarFp.deleteOrDismissInBatchCandidateLevelSolution(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} solutionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateLevelSolution(solutionId, options) {
            return localVarFp.downloadCandidateLevelSolution(solutionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateLevelSolution(id, options) {
            return localVarFp.getCandidateLevelSolution(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [candidateId]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateLevelSolution(candidateId, pending, term, showDismissed, options) {
            return localVarFp.listCandidateLevelSolution(candidateId, pending, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [candidateId]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateLevelSolution(page, size, sort, candidateId, pending, term, showDismissed, options) {
            return localVarFp.pageCandidateLevelSolution(page, size, sort, candidateId, pending, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CandidateLevelSolution} candidateLevelSolution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateLevelSolution(candidateLevelSolution, options) {
            return localVarFp.saveCandidateLevelSolution(candidateLevelSolution, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CandidateLevelSolutionRestControllerApi - object-oriented interface
 * @export
 * @class CandidateLevelSolutionRestControllerApi
 * @extends {BaseAPI}
 */
export class CandidateLevelSolutionRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [candidateId]
     * @param {boolean} [pending]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelSolutionRestControllerApi
     */
    countCandidateLevelSolution(candidateId, pending, term, showDismissed, options) {
        return CandidateLevelSolutionRestControllerApiFp(this.configuration).countCandidateLevelSolution(candidateId, pending, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelSolutionRestControllerApi
     */
    deleteOrDismissCandidateLevelSolution(id, options) {
        return CandidateLevelSolutionRestControllerApiFp(this.configuration).deleteOrDismissCandidateLevelSolution(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelSolutionRestControllerApi
     */
    deleteOrDismissInBatchCandidateLevelSolution(ids, options) {
        return CandidateLevelSolutionRestControllerApiFp(this.configuration).deleteOrDismissInBatchCandidateLevelSolution(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} solutionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelSolutionRestControllerApi
     */
    downloadCandidateLevelSolution(solutionId, options) {
        return CandidateLevelSolutionRestControllerApiFp(this.configuration).downloadCandidateLevelSolution(solutionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelSolutionRestControllerApi
     */
    getCandidateLevelSolution(id, options) {
        return CandidateLevelSolutionRestControllerApiFp(this.configuration).getCandidateLevelSolution(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [candidateId]
     * @param {boolean} [pending]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelSolutionRestControllerApi
     */
    listCandidateLevelSolution(candidateId, pending, term, showDismissed, options) {
        return CandidateLevelSolutionRestControllerApiFp(this.configuration).listCandidateLevelSolution(candidateId, pending, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [candidateId]
     * @param {boolean} [pending]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelSolutionRestControllerApi
     */
    pageCandidateLevelSolution(page, size, sort, candidateId, pending, term, showDismissed, options) {
        return CandidateLevelSolutionRestControllerApiFp(this.configuration).pageCandidateLevelSolution(page, size, sort, candidateId, pending, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CandidateLevelSolution} candidateLevelSolution
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelSolutionRestControllerApi
     */
    saveCandidateLevelSolution(candidateLevelSolution, options) {
        return CandidateLevelSolutionRestControllerApiFp(this.configuration).saveCandidateLevelSolution(candidateLevelSolution, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CandidateLevelTestRestControllerApi - axios parameter creator
 * @export
 */
export const CandidateLevelTestRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateLevelTest: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/candidate/level/test/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateLevelTest: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissCandidateLevelTest', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/level/test/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateLevelTest: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchCandidateLevelTest', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/candidate/level/test/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} testId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateLevelTest: async (testId, options = {}) => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('downloadCandidateLevelTest', 'testId', testId);
            const localVarPath = `/api/admin/recruitment/candidate/level/test/{testId}/attachment`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateLevelTest: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCandidateLevelTest', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/level/test/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateLevelTest: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/candidate/level/test/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateLevelTest: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/candidate/level/test/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CandidateLevelTest} candidateLevelTest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateLevelTest: async (candidateLevelTest, options = {}) => {
            // verify required parameter 'candidateLevelTest' is not null or undefined
            assertParamExists('saveCandidateLevelTest', 'candidateLevelTest', candidateLevelTest);
            const localVarPath = `/api/admin/recruitment/candidate/level/test/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(candidateLevelTest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CandidateLevelTestRestControllerApi - functional programming interface
 * @export
 */
export const CandidateLevelTestRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = CandidateLevelTestRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countCandidateLevelTest(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countCandidateLevelTest(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateLevelTestRestControllerApi.countCandidateLevelTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissCandidateLevelTest(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissCandidateLevelTest(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateLevelTestRestControllerApi.deleteOrDismissCandidateLevelTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchCandidateLevelTest(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchCandidateLevelTest(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateLevelTestRestControllerApi.deleteOrDismissInBatchCandidateLevelTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} testId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCandidateLevelTest(testId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCandidateLevelTest(testId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateLevelTestRestControllerApi.downloadCandidateLevelTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateLevelTest(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateLevelTest(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateLevelTestRestControllerApi.getCandidateLevelTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCandidateLevelTest(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCandidateLevelTest(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateLevelTestRestControllerApi.listCandidateLevelTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageCandidateLevelTest(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageCandidateLevelTest(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateLevelTestRestControllerApi.pageCandidateLevelTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CandidateLevelTest} candidateLevelTest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCandidateLevelTest(candidateLevelTest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCandidateLevelTest(candidateLevelTest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateLevelTestRestControllerApi.saveCandidateLevelTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CandidateLevelTestRestControllerApi - factory interface
 * @export
 */
export const CandidateLevelTestRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CandidateLevelTestRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateLevelTest(term, showDismissed, options) {
            return localVarFp.countCandidateLevelTest(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateLevelTest(id, options) {
            return localVarFp.deleteOrDismissCandidateLevelTest(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateLevelTest(ids, options) {
            return localVarFp.deleteOrDismissInBatchCandidateLevelTest(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} testId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateLevelTest(testId, options) {
            return localVarFp.downloadCandidateLevelTest(testId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateLevelTest(id, options) {
            return localVarFp.getCandidateLevelTest(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateLevelTest(term, showDismissed, options) {
            return localVarFp.listCandidateLevelTest(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateLevelTest(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageCandidateLevelTest(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CandidateLevelTest} candidateLevelTest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateLevelTest(candidateLevelTest, options) {
            return localVarFp.saveCandidateLevelTest(candidateLevelTest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CandidateLevelTestRestControllerApi - object-oriented interface
 * @export
 * @class CandidateLevelTestRestControllerApi
 * @extends {BaseAPI}
 */
export class CandidateLevelTestRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelTestRestControllerApi
     */
    countCandidateLevelTest(term, showDismissed, options) {
        return CandidateLevelTestRestControllerApiFp(this.configuration).countCandidateLevelTest(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelTestRestControllerApi
     */
    deleteOrDismissCandidateLevelTest(id, options) {
        return CandidateLevelTestRestControllerApiFp(this.configuration).deleteOrDismissCandidateLevelTest(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelTestRestControllerApi
     */
    deleteOrDismissInBatchCandidateLevelTest(ids, options) {
        return CandidateLevelTestRestControllerApiFp(this.configuration).deleteOrDismissInBatchCandidateLevelTest(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} testId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelTestRestControllerApi
     */
    downloadCandidateLevelTest(testId, options) {
        return CandidateLevelTestRestControllerApiFp(this.configuration).downloadCandidateLevelTest(testId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelTestRestControllerApi
     */
    getCandidateLevelTest(id, options) {
        return CandidateLevelTestRestControllerApiFp(this.configuration).getCandidateLevelTest(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelTestRestControllerApi
     */
    listCandidateLevelTest(term, showDismissed, options) {
        return CandidateLevelTestRestControllerApiFp(this.configuration).listCandidateLevelTest(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelTestRestControllerApi
     */
    pageCandidateLevelTest(page, size, sort, term, showDismissed, options) {
        return CandidateLevelTestRestControllerApiFp(this.configuration).pageCandidateLevelTest(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CandidateLevelTest} candidateLevelTest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateLevelTestRestControllerApi
     */
    saveCandidateLevelTest(candidateLevelTest, options) {
        return CandidateLevelTestRestControllerApiFp(this.configuration).saveCandidateLevelTest(candidateLevelTest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CandidateRequestRestControllerApi - axios parameter creator
 * @export
 */
export const CandidateRequestRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CandidateDismissForm} candidateDismissForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissCandidateForm: async (candidateDismissForm, options = {}) => {
            // verify required parameter 'candidateDismissForm' is not null or undefined
            assertParamExists('dismissCandidateForm', 'candidateDismissForm', candidateDismissForm);
            const localVarPath = `/api/pub/candidate/dismiss`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(candidateDismissForm, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} email
         * @param {string} pass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateForm: async (email, pass, options = {}) => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getCandidateForm', 'email', email);
            // verify required parameter 'pass' is not null or undefined
            assertParamExists('getCandidateForm', 'pass', pass);
            const localVarPath = `/api/pub/candidate/recover`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (pass !== undefined) {
                localVarQueryParameter['pass'] = pass;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateSkills: async (options = {}) => {
            const localVarPath = `/api/pub/candidate/skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicRecruitments: async (options = {}) => {
            const localVarPath = `/api/pub/candidate/recruitments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentDetails: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRecruitmentDetails', 'id', id);
            const localVarPath = `/api/pub/candidate/recruitment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoverCandidateForm: async (email, options = {}) => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('recoverCandidateForm', 'email', email);
            const localVarPath = `/api/pub/candidate/recover`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} email
         * @param {string} pass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCandidateCV: async (email, pass, options = {}) => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('retrieveCandidateCV', 'email', email);
            // verify required parameter 'pass' is not null or undefined
            assertParamExists('retrieveCandidateCV', 'pass', pass);
            const localVarPath = `/api/pub/candidate/cv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (pass !== undefined) {
                localVarQueryParameter['pass'] = pass;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CandidateForm} candidateForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateForm: async (candidateForm, options = {}) => {
            // verify required parameter 'candidateForm' is not null or undefined
            assertParamExists('saveCandidateForm', 'candidateForm', candidateForm);
            const localVarPath = `/api/pub/candidate/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(candidateForm, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CandidateRequestRestControllerApi - functional programming interface
 * @export
 */
export const CandidateRequestRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = CandidateRequestRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CandidateDismissForm} candidateDismissForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dismissCandidateForm(candidateDismissForm, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dismissCandidateForm(candidateDismissForm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateRequestRestControllerApi.dismissCandidateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} email
         * @param {string} pass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateForm(email, pass, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateForm(email, pass, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateRequestRestControllerApi.getCandidateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateSkills(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateSkills(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateRequestRestControllerApi.getCandidateSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicRecruitments(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicRecruitments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateRequestRestControllerApi.getPublicRecruitments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecruitmentDetails(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecruitmentDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateRequestRestControllerApi.getRecruitmentDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recoverCandidateForm(email, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recoverCandidateForm(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateRequestRestControllerApi.recoverCandidateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} email
         * @param {string} pass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveCandidateCV(email, pass, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveCandidateCV(email, pass, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateRequestRestControllerApi.retrieveCandidateCV']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CandidateForm} candidateForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCandidateForm(candidateForm, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCandidateForm(candidateForm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateRequestRestControllerApi.saveCandidateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CandidateRequestRestControllerApi - factory interface
 * @export
 */
export const CandidateRequestRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CandidateRequestRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {CandidateDismissForm} candidateDismissForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissCandidateForm(candidateDismissForm, options) {
            return localVarFp.dismissCandidateForm(candidateDismissForm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} email
         * @param {string} pass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateForm(email, pass, options) {
            return localVarFp.getCandidateForm(email, pass, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateSkills(options) {
            return localVarFp.getCandidateSkills(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicRecruitments(options) {
            return localVarFp.getPublicRecruitments(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentDetails(id, options) {
            return localVarFp.getRecruitmentDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoverCandidateForm(email, options) {
            return localVarFp.recoverCandidateForm(email, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} email
         * @param {string} pass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCandidateCV(email, pass, options) {
            return localVarFp.retrieveCandidateCV(email, pass, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CandidateForm} candidateForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateForm(candidateForm, options) {
            return localVarFp.saveCandidateForm(candidateForm, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CandidateRequestRestControllerApi - object-oriented interface
 * @export
 * @class CandidateRequestRestControllerApi
 * @extends {BaseAPI}
 */
export class CandidateRequestRestControllerApi extends BaseAPI {
    /**
     *
     * @param {CandidateDismissForm} candidateDismissForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRequestRestControllerApi
     */
    dismissCandidateForm(candidateDismissForm, options) {
        return CandidateRequestRestControllerApiFp(this.configuration).dismissCandidateForm(candidateDismissForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} email
     * @param {string} pass
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRequestRestControllerApi
     */
    getCandidateForm(email, pass, options) {
        return CandidateRequestRestControllerApiFp(this.configuration).getCandidateForm(email, pass, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRequestRestControllerApi
     */
    getCandidateSkills(options) {
        return CandidateRequestRestControllerApiFp(this.configuration).getCandidateSkills(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRequestRestControllerApi
     */
    getPublicRecruitments(options) {
        return CandidateRequestRestControllerApiFp(this.configuration).getPublicRecruitments(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRequestRestControllerApi
     */
    getRecruitmentDetails(id, options) {
        return CandidateRequestRestControllerApiFp(this.configuration).getRecruitmentDetails(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRequestRestControllerApi
     */
    recoverCandidateForm(email, options) {
        return CandidateRequestRestControllerApiFp(this.configuration).recoverCandidateForm(email, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} email
     * @param {string} pass
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRequestRestControllerApi
     */
    retrieveCandidateCV(email, pass, options) {
        return CandidateRequestRestControllerApiFp(this.configuration).retrieveCandidateCV(email, pass, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CandidateForm} candidateForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRequestRestControllerApi
     */
    saveCandidateForm(candidateForm, options) {
        return CandidateRequestRestControllerApiFp(this.configuration).saveCandidateForm(candidateForm, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CandidateRestControllerApi - axios parameter creator
 * @export
 */
export const CandidateRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidate: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/candidate/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissCandidate', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidate: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchCandidate', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/candidate/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} candidateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCvCandidate: async (candidateId, options = {}) => {
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('downloadCvCandidate', 'candidateId', candidateId);
            const localVarPath = `/api/admin/recruitment/candidate/{candidateId}/cv`
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} candidateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPhotoCandidate: async (candidateId, options = {}) => {
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('downloadPhotoCandidate', 'candidateId', candidateId);
            const localVarPath = `/api/admin/recruitment/candidate/{candidateId}/photo`
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCandidate: async (options = {}) => {
            const localVarPath = `/api/admin/recruitment/candidate/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCandidate', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidate: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/candidate/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidate: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/candidate/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Candidate} candidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidate: async (candidate, options = {}) => {
            // verify required parameter 'candidate' is not null or undefined
            assertParamExists('saveCandidate', 'candidate', candidate);
            const localVarPath = `/api/admin/recruitment/candidate/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(candidate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CandidateRestControllerApi - functional programming interface
 * @export
 */
export const CandidateRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = CandidateRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countCandidate(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countCandidate(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateRestControllerApi.countCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissCandidate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissCandidate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateRestControllerApi.deleteOrDismissCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchCandidate(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchCandidate(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateRestControllerApi.deleteOrDismissInBatchCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} candidateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCvCandidate(candidateId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCvCandidate(candidateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateRestControllerApi.downloadCvCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} candidateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPhotoCandidate(candidateId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPhotoCandidate(candidateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateRestControllerApi.downloadPhotoCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportCandidate(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportCandidate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateRestControllerApi.exportCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateRestControllerApi.getCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCandidate(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCandidate(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateRestControllerApi.listCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageCandidate(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageCandidate(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateRestControllerApi.pageCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Candidate} candidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCandidate(candidate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCandidate(candidate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateRestControllerApi.saveCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CandidateRestControllerApi - factory interface
 * @export
 */
export const CandidateRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CandidateRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidate(term, showDismissed, options) {
            return localVarFp.countCandidate(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidate(id, options) {
            return localVarFp.deleteOrDismissCandidate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidate(ids, options) {
            return localVarFp.deleteOrDismissInBatchCandidate(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} candidateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCvCandidate(candidateId, options) {
            return localVarFp.downloadCvCandidate(candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} candidateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPhotoCandidate(candidateId, options) {
            return localVarFp.downloadPhotoCandidate(candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCandidate(options) {
            return localVarFp.exportCandidate(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidate(id, options) {
            return localVarFp.getCandidate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidate(term, showDismissed, options) {
            return localVarFp.listCandidate(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidate(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageCandidate(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Candidate} candidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidate(candidate, options) {
            return localVarFp.saveCandidate(candidate, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CandidateRestControllerApi - object-oriented interface
 * @export
 * @class CandidateRestControllerApi
 * @extends {BaseAPI}
 */
export class CandidateRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    countCandidate(term, showDismissed, options) {
        return CandidateRestControllerApiFp(this.configuration).countCandidate(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    deleteOrDismissCandidate(id, options) {
        return CandidateRestControllerApiFp(this.configuration).deleteOrDismissCandidate(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    deleteOrDismissInBatchCandidate(ids, options) {
        return CandidateRestControllerApiFp(this.configuration).deleteOrDismissInBatchCandidate(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    downloadCvCandidate(candidateId, options) {
        return CandidateRestControllerApiFp(this.configuration).downloadCvCandidate(candidateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    downloadPhotoCandidate(candidateId, options) {
        return CandidateRestControllerApiFp(this.configuration).downloadPhotoCandidate(candidateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    exportCandidate(options) {
        return CandidateRestControllerApiFp(this.configuration).exportCandidate(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    getCandidate(id, options) {
        return CandidateRestControllerApiFp(this.configuration).getCandidate(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    listCandidate(term, showDismissed, options) {
        return CandidateRestControllerApiFp(this.configuration).listCandidate(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    pageCandidate(page, size, sort, term, showDismissed, options) {
        return CandidateRestControllerApiFp(this.configuration).pageCandidate(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Candidate} candidate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateRestControllerApi
     */
    saveCandidate(candidate, options) {
        return CandidateRestControllerApiFp(this.configuration).saveCandidate(candidate, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CandidateSourceRestControllerApi - axios parameter creator
 * @export
 */
export const CandidateSourceRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateSource: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/source/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateSource: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissCandidateSource', 'id', id);
            const localVarPath = `/api/admin/recruitment/source/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateSource: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchCandidateSource', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/source/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateSource: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCandidateSource', 'id', id);
            const localVarPath = `/api/admin/recruitment/source/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateSource: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/source/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateSource: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/source/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CandidateSource} candidateSource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateSource: async (candidateSource, options = {}) => {
            // verify required parameter 'candidateSource' is not null or undefined
            assertParamExists('saveCandidateSource', 'candidateSource', candidateSource);
            const localVarPath = `/api/admin/recruitment/source/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(candidateSource, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CandidateSourceRestControllerApi - functional programming interface
 * @export
 */
export const CandidateSourceRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = CandidateSourceRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countCandidateSource(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countCandidateSource(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateSourceRestControllerApi.countCandidateSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissCandidateSource(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissCandidateSource(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateSourceRestControllerApi.deleteOrDismissCandidateSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchCandidateSource(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchCandidateSource(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateSourceRestControllerApi.deleteOrDismissInBatchCandidateSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateSource(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateSource(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateSourceRestControllerApi.getCandidateSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCandidateSource(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCandidateSource(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateSourceRestControllerApi.listCandidateSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageCandidateSource(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageCandidateSource(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateSourceRestControllerApi.pageCandidateSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CandidateSource} candidateSource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCandidateSource(candidateSource, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCandidateSource(candidateSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateSourceRestControllerApi.saveCandidateSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CandidateSourceRestControllerApi - factory interface
 * @export
 */
export const CandidateSourceRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CandidateSourceRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateSource(term, showDismissed, options) {
            return localVarFp.countCandidateSource(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateSource(id, options) {
            return localVarFp.deleteOrDismissCandidateSource(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateSource(ids, options) {
            return localVarFp.deleteOrDismissInBatchCandidateSource(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateSource(id, options) {
            return localVarFp.getCandidateSource(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateSource(term, showDismissed, options) {
            return localVarFp.listCandidateSource(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateSource(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageCandidateSource(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CandidateSource} candidateSource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateSource(candidateSource, options) {
            return localVarFp.saveCandidateSource(candidateSource, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CandidateSourceRestControllerApi - object-oriented interface
 * @export
 * @class CandidateSourceRestControllerApi
 * @extends {BaseAPI}
 */
export class CandidateSourceRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateSourceRestControllerApi
     */
    countCandidateSource(term, showDismissed, options) {
        return CandidateSourceRestControllerApiFp(this.configuration).countCandidateSource(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateSourceRestControllerApi
     */
    deleteOrDismissCandidateSource(id, options) {
        return CandidateSourceRestControllerApiFp(this.configuration).deleteOrDismissCandidateSource(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateSourceRestControllerApi
     */
    deleteOrDismissInBatchCandidateSource(ids, options) {
        return CandidateSourceRestControllerApiFp(this.configuration).deleteOrDismissInBatchCandidateSource(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateSourceRestControllerApi
     */
    getCandidateSource(id, options) {
        return CandidateSourceRestControllerApiFp(this.configuration).getCandidateSource(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateSourceRestControllerApi
     */
    listCandidateSource(term, showDismissed, options) {
        return CandidateSourceRestControllerApiFp(this.configuration).listCandidateSource(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateSourceRestControllerApi
     */
    pageCandidateSource(page, size, sort, term, showDismissed, options) {
        return CandidateSourceRestControllerApiFp(this.configuration).pageCandidateSource(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CandidateSource} candidateSource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateSourceRestControllerApi
     */
    saveCandidateSource(candidateSource, options) {
        return CandidateSourceRestControllerApiFp(this.configuration).saveCandidateSource(candidateSource, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CandidateStateRestControllerApi - axios parameter creator
 * @export
 */
export const CandidateStateRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateState: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/candidate/state/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateState: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissCandidateState', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/state/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateState: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchCandidateState', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/candidate/state/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateState: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCandidateState', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/state/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateState: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/candidate/state/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateState: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/candidate/state/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CandidateState} candidateState
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateState: async (candidateState, options = {}) => {
            // verify required parameter 'candidateState' is not null or undefined
            assertParamExists('saveCandidateState', 'candidateState', candidateState);
            const localVarPath = `/api/admin/recruitment/candidate/state/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(candidateState, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CandidateStateRestControllerApi - functional programming interface
 * @export
 */
export const CandidateStateRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = CandidateStateRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countCandidateState(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countCandidateState(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateStateRestControllerApi.countCandidateState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissCandidateState(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissCandidateState(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateStateRestControllerApi.deleteOrDismissCandidateState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchCandidateState(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchCandidateState(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateStateRestControllerApi.deleteOrDismissInBatchCandidateState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateState(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateState(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateStateRestControllerApi.getCandidateState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCandidateState(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCandidateState(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateStateRestControllerApi.listCandidateState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageCandidateState(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageCandidateState(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateStateRestControllerApi.pageCandidateState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CandidateState} candidateState
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCandidateState(candidateState, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCandidateState(candidateState, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateStateRestControllerApi.saveCandidateState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CandidateStateRestControllerApi - factory interface
 * @export
 */
export const CandidateStateRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CandidateStateRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateState(term, showDismissed, options) {
            return localVarFp.countCandidateState(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateState(id, options) {
            return localVarFp.deleteOrDismissCandidateState(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateState(ids, options) {
            return localVarFp.deleteOrDismissInBatchCandidateState(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateState(id, options) {
            return localVarFp.getCandidateState(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateState(term, showDismissed, options) {
            return localVarFp.listCandidateState(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateState(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageCandidateState(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CandidateState} candidateState
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateState(candidateState, options) {
            return localVarFp.saveCandidateState(candidateState, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CandidateStateRestControllerApi - object-oriented interface
 * @export
 * @class CandidateStateRestControllerApi
 * @extends {BaseAPI}
 */
export class CandidateStateRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateStateRestControllerApi
     */
    countCandidateState(term, showDismissed, options) {
        return CandidateStateRestControllerApiFp(this.configuration).countCandidateState(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateStateRestControllerApi
     */
    deleteOrDismissCandidateState(id, options) {
        return CandidateStateRestControllerApiFp(this.configuration).deleteOrDismissCandidateState(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateStateRestControllerApi
     */
    deleteOrDismissInBatchCandidateState(ids, options) {
        return CandidateStateRestControllerApiFp(this.configuration).deleteOrDismissInBatchCandidateState(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateStateRestControllerApi
     */
    getCandidateState(id, options) {
        return CandidateStateRestControllerApiFp(this.configuration).getCandidateState(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateStateRestControllerApi
     */
    listCandidateState(term, showDismissed, options) {
        return CandidateStateRestControllerApiFp(this.configuration).listCandidateState(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateStateRestControllerApi
     */
    pageCandidateState(page, size, sort, term, showDismissed, options) {
        return CandidateStateRestControllerApiFp(this.configuration).pageCandidateState(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CandidateState} candidateState
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateStateRestControllerApi
     */
    saveCandidateState(candidateState, options) {
        return CandidateStateRestControllerApiFp(this.configuration).saveCandidateState(candidateState, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CandidateTestRestControllerApi - axios parameter creator
 * @export
 */
export const CandidateTestRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} testId
         * @param {string} [t]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateTest: async (testId, t, options = {}) => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('downloadCandidateTest', 'testId', testId);
            const localVarPath = `/api/pub/candidate/test/{testId}/attachment`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (t !== undefined) {
                localVarQueryParameter['t'] = t;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} testId
         * @param {string} [t]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateTest: async (testId, t, options = {}) => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('getCandidateTest', 'testId', testId);
            const localVarPath = `/api/pub/candidate/test/{testId}`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (t !== undefined) {
                localVarQueryParameter['t'] = t;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CandidateTestForm} candidateTestForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateTest: async (candidateTestForm, options = {}) => {
            // verify required parameter 'candidateTestForm' is not null or undefined
            assertParamExists('saveCandidateTest', 'candidateTestForm', candidateTestForm);
            const localVarPath = `/api/pub/candidate/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(candidateTestForm, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CandidateTestRestControllerApi - functional programming interface
 * @export
 */
export const CandidateTestRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = CandidateTestRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} testId
         * @param {string} [t]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCandidateTest(testId, t, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCandidateTest(testId, t, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateTestRestControllerApi.downloadCandidateTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} testId
         * @param {string} [t]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateTest(testId, t, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateTest(testId, t, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateTestRestControllerApi.getCandidateTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CandidateTestForm} candidateTestForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCandidateTest(candidateTestForm, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCandidateTest(candidateTestForm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateTestRestControllerApi.saveCandidateTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CandidateTestRestControllerApi - factory interface
 * @export
 */
export const CandidateTestRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CandidateTestRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} testId
         * @param {string} [t]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateTest(testId, t, options) {
            return localVarFp.downloadCandidateTest(testId, t, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} testId
         * @param {string} [t]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateTest(testId, t, options) {
            return localVarFp.getCandidateTest(testId, t, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CandidateTestForm} candidateTestForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateTest(candidateTestForm, options) {
            return localVarFp.saveCandidateTest(candidateTestForm, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CandidateTestRestControllerApi - object-oriented interface
 * @export
 * @class CandidateTestRestControllerApi
 * @extends {BaseAPI}
 */
export class CandidateTestRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} testId
     * @param {string} [t]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTestRestControllerApi
     */
    downloadCandidateTest(testId, t, options) {
        return CandidateTestRestControllerApiFp(this.configuration).downloadCandidateTest(testId, t, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} testId
     * @param {string} [t]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTestRestControllerApi
     */
    getCandidateTest(testId, t, options) {
        return CandidateTestRestControllerApiFp(this.configuration).getCandidateTest(testId, t, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CandidateTestForm} candidateTestForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTestRestControllerApi
     */
    saveCandidateTest(candidateTestForm, options) {
        return CandidateTestRestControllerApiFp(this.configuration).saveCandidateTest(candidateTestForm, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CandidateTypeRestControllerApi - axios parameter creator
 * @export
 */
export const CandidateTypeRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateType: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/candidate/type/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateType: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissCandidateType', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/type/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateType: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchCandidateType', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/candidate/type/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateType: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCandidateType', 'id', id);
            const localVarPath = `/api/admin/recruitment/candidate/type/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateType: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/candidate/type/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateType: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/candidate/type/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CandidateType} candidateType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateType: async (candidateType, options = {}) => {
            // verify required parameter 'candidateType' is not null or undefined
            assertParamExists('saveCandidateType', 'candidateType', candidateType);
            const localVarPath = `/api/admin/recruitment/candidate/type/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(candidateType, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CandidateTypeRestControllerApi - functional programming interface
 * @export
 */
export const CandidateTypeRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = CandidateTypeRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countCandidateType(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countCandidateType(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateTypeRestControllerApi.countCandidateType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissCandidateType(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissCandidateType(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateTypeRestControllerApi.deleteOrDismissCandidateType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchCandidateType(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchCandidateType(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateTypeRestControllerApi.deleteOrDismissInBatchCandidateType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateType(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateType(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateTypeRestControllerApi.getCandidateType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCandidateType(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCandidateType(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateTypeRestControllerApi.listCandidateType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageCandidateType(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageCandidateType(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateTypeRestControllerApi.pageCandidateType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CandidateType} candidateType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCandidateType(candidateType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCandidateType(candidateType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CandidateTypeRestControllerApi.saveCandidateType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CandidateTypeRestControllerApi - factory interface
 * @export
 */
export const CandidateTypeRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CandidateTypeRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCandidateType(term, showDismissed, options) {
            return localVarFp.countCandidateType(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCandidateType(id, options) {
            return localVarFp.deleteOrDismissCandidateType(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCandidateType(ids, options) {
            return localVarFp.deleteOrDismissInBatchCandidateType(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateType(id, options) {
            return localVarFp.getCandidateType(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCandidateType(term, showDismissed, options) {
            return localVarFp.listCandidateType(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCandidateType(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageCandidateType(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CandidateType} candidateType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCandidateType(candidateType, options) {
            return localVarFp.saveCandidateType(candidateType, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CandidateTypeRestControllerApi - object-oriented interface
 * @export
 * @class CandidateTypeRestControllerApi
 * @extends {BaseAPI}
 */
export class CandidateTypeRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTypeRestControllerApi
     */
    countCandidateType(term, showDismissed, options) {
        return CandidateTypeRestControllerApiFp(this.configuration).countCandidateType(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTypeRestControllerApi
     */
    deleteOrDismissCandidateType(id, options) {
        return CandidateTypeRestControllerApiFp(this.configuration).deleteOrDismissCandidateType(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTypeRestControllerApi
     */
    deleteOrDismissInBatchCandidateType(ids, options) {
        return CandidateTypeRestControllerApiFp(this.configuration).deleteOrDismissInBatchCandidateType(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTypeRestControllerApi
     */
    getCandidateType(id, options) {
        return CandidateTypeRestControllerApiFp(this.configuration).getCandidateType(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTypeRestControllerApi
     */
    listCandidateType(term, showDismissed, options) {
        return CandidateTypeRestControllerApiFp(this.configuration).listCandidateType(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTypeRestControllerApi
     */
    pageCandidateType(page, size, sort, term, showDismissed, options) {
        return CandidateTypeRestControllerApiFp(this.configuration).pageCandidateType(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CandidateType} candidateType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateTypeRestControllerApi
     */
    saveCandidateType(candidateType, options) {
        return CandidateTypeRestControllerApiFp(this.configuration).saveCandidateType(candidateType, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CompanyExpiryRestControllerApi - axios parameter creator
 * @export
 */
export const CompanyExpiryRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCompanyExpiry: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/quality/expiry/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCompanyExpiry: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissCompanyExpiry', 'id', id);
            const localVarPath = `/api/admin/quality/expiry/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCompanyExpiry: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchCompanyExpiry', 'ids', ids);
            const localVarPath = `/api/admin/quality/expiry/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyExpiry: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompanyExpiry', 'id', id);
            const localVarPath = `/api/admin/quality/expiry/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyExpiry: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/quality/expiry/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCompanyExpiry: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/quality/expiry/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CompanyExpiry} companyExpiry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyExpiry: async (companyExpiry, options = {}) => {
            // verify required parameter 'companyExpiry' is not null or undefined
            assertParamExists('saveCompanyExpiry', 'companyExpiry', companyExpiry);
            const localVarPath = `/api/admin/quality/expiry/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(companyExpiry, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CompanyExpiryRestControllerApi - functional programming interface
 * @export
 */
export const CompanyExpiryRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = CompanyExpiryRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countCompanyExpiry(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countCompanyExpiry(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyExpiryRestControllerApi.countCompanyExpiry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissCompanyExpiry(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissCompanyExpiry(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyExpiryRestControllerApi.deleteOrDismissCompanyExpiry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchCompanyExpiry(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchCompanyExpiry(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyExpiryRestControllerApi.deleteOrDismissInBatchCompanyExpiry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyExpiry(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyExpiry(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyExpiryRestControllerApi.getCompanyExpiry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCompanyExpiry(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCompanyExpiry(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyExpiryRestControllerApi.listCompanyExpiry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageCompanyExpiry(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageCompanyExpiry(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyExpiryRestControllerApi.pageCompanyExpiry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CompanyExpiry} companyExpiry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCompanyExpiry(companyExpiry, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCompanyExpiry(companyExpiry, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyExpiryRestControllerApi.saveCompanyExpiry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CompanyExpiryRestControllerApi - factory interface
 * @export
 */
export const CompanyExpiryRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CompanyExpiryRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCompanyExpiry(term, showDismissed, options) {
            return localVarFp.countCompanyExpiry(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCompanyExpiry(id, options) {
            return localVarFp.deleteOrDismissCompanyExpiry(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCompanyExpiry(ids, options) {
            return localVarFp.deleteOrDismissInBatchCompanyExpiry(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyExpiry(id, options) {
            return localVarFp.getCompanyExpiry(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyExpiry(term, showDismissed, options) {
            return localVarFp.listCompanyExpiry(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCompanyExpiry(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageCompanyExpiry(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CompanyExpiry} companyExpiry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCompanyExpiry(companyExpiry, options) {
            return localVarFp.saveCompanyExpiry(companyExpiry, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CompanyExpiryRestControllerApi - object-oriented interface
 * @export
 * @class CompanyExpiryRestControllerApi
 * @extends {BaseAPI}
 */
export class CompanyExpiryRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyExpiryRestControllerApi
     */
    countCompanyExpiry(term, showDismissed, options) {
        return CompanyExpiryRestControllerApiFp(this.configuration).countCompanyExpiry(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyExpiryRestControllerApi
     */
    deleteOrDismissCompanyExpiry(id, options) {
        return CompanyExpiryRestControllerApiFp(this.configuration).deleteOrDismissCompanyExpiry(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyExpiryRestControllerApi
     */
    deleteOrDismissInBatchCompanyExpiry(ids, options) {
        return CompanyExpiryRestControllerApiFp(this.configuration).deleteOrDismissInBatchCompanyExpiry(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyExpiryRestControllerApi
     */
    getCompanyExpiry(id, options) {
        return CompanyExpiryRestControllerApiFp(this.configuration).getCompanyExpiry(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyExpiryRestControllerApi
     */
    listCompanyExpiry(term, showDismissed, options) {
        return CompanyExpiryRestControllerApiFp(this.configuration).listCompanyExpiry(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyExpiryRestControllerApi
     */
    pageCompanyExpiry(page, size, sort, term, showDismissed, options) {
        return CompanyExpiryRestControllerApiFp(this.configuration).pageCompanyExpiry(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyExpiry} companyExpiry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyExpiryRestControllerApi
     */
    saveCompanyExpiry(companyExpiry, options) {
        return CompanyExpiryRestControllerApiFp(this.configuration).saveCompanyExpiry(companyExpiry, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ComplianceCalendarRestControllerApi - axios parameter creator
 * @export
 */
export const ComplianceCalendarRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarCompliance: async (options = {}) => {
            const localVarPath = `/api/admin/quality/calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ComplianceCalendarRestControllerApi - functional programming interface
 * @export
 */
export const ComplianceCalendarRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ComplianceCalendarRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calendarCompliance(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calendarCompliance(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComplianceCalendarRestControllerApi.calendarCompliance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ComplianceCalendarRestControllerApi - factory interface
 * @export
 */
export const ComplianceCalendarRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ComplianceCalendarRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarCompliance(options) {
            return localVarFp.calendarCompliance(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ComplianceCalendarRestControllerApi - object-oriented interface
 * @export
 * @class ComplianceCalendarRestControllerApi
 * @extends {BaseAPI}
 */
export class ComplianceCalendarRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceCalendarRestControllerApi
     */
    calendarCompliance(options) {
        return ComplianceCalendarRestControllerApiFp(this.configuration).calendarCompliance(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ComplianceIndicatorsRestControllerApi - axios parameter creator
 * @export
 */
export const ComplianceIndicatorsRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indicatorsCompliance: async (options = {}) => {
            const localVarPath = `/api/admin/quality/indicators`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ComplianceIndicatorsRestControllerApi - functional programming interface
 * @export
 */
export const ComplianceIndicatorsRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ComplianceIndicatorsRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indicatorsCompliance(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indicatorsCompliance(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComplianceIndicatorsRestControllerApi.indicatorsCompliance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ComplianceIndicatorsRestControllerApi - factory interface
 * @export
 */
export const ComplianceIndicatorsRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ComplianceIndicatorsRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indicatorsCompliance(options) {
            return localVarFp.indicatorsCompliance(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ComplianceIndicatorsRestControllerApi - object-oriented interface
 * @export
 * @class ComplianceIndicatorsRestControllerApi
 * @extends {BaseAPI}
 */
export class ComplianceIndicatorsRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceIndicatorsRestControllerApi
     */
    indicatorsCompliance(options) {
        return ComplianceIndicatorsRestControllerApiFp(this.configuration).indicatorsCompliance(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ConfigAiConfigRestControllerApi - axios parameter creator
 * @export
 */
export const ConfigAiConfigRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig: async (options = {}) => {
            const localVarPath = `/api/admin/config/ai-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {AiConfigDto} aiConfigDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveConfig: async (aiConfigDto, options = {}) => {
            // verify required parameter 'aiConfigDto' is not null or undefined
            assertParamExists('saveConfig', 'aiConfigDto', aiConfigDto);
            const localVarPath = `/api/admin/config/ai-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(aiConfigDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ConfigAiConfigRestControllerApi - functional programming interface
 * @export
 */
export const ConfigAiConfigRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ConfigAiConfigRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfig(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigAiConfigRestControllerApi.getConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {AiConfigDto} aiConfigDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveConfig(aiConfigDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveConfig(aiConfigDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigAiConfigRestControllerApi.saveConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ConfigAiConfigRestControllerApi - factory interface
 * @export
 */
export const ConfigAiConfigRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ConfigAiConfigRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig(options) {
            return localVarFp.getConfig(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AiConfigDto} aiConfigDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveConfig(aiConfigDto, options) {
            return localVarFp.saveConfig(aiConfigDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConfigAiConfigRestControllerApi - object-oriented interface
 * @export
 * @class ConfigAiConfigRestControllerApi
 * @extends {BaseAPI}
 */
export class ConfigAiConfigRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigAiConfigRestControllerApi
     */
    getConfig(options) {
        return ConfigAiConfigRestControllerApiFp(this.configuration).getConfig(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AiConfigDto} aiConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigAiConfigRestControllerApi
     */
    saveConfig(aiConfigDto, options) {
        return ConfigAiConfigRestControllerApiFp(this.configuration).saveConfig(aiConfigDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ConfigParamRestControllerApi - axios parameter creator
 * @export
 */
export const ConfigParamRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countParameter: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/config/param/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchParameter: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchParameter', 'ids', ids);
            const localVarPath = `/api/admin/config/param/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissParameter: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissParameter', 'id', id);
            const localVarPath = `/api/admin/config/param/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameter: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getParameter', 'id', id);
            const localVarPath = `/api/admin/config/param/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParameter: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/config/param/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageParameter: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/config/param/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Parameter} parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveParameter: async (parameter, options = {}) => {
            // verify required parameter 'parameter' is not null or undefined
            assertParamExists('saveParameter', 'parameter', parameter);
            const localVarPath = `/api/admin/config/param/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(parameter, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ConfigParamRestControllerApi - functional programming interface
 * @export
 */
export const ConfigParamRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ConfigParamRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countParameter(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countParameter(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigParamRestControllerApi.countParameter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchParameter(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchParameter(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigParamRestControllerApi.deleteOrDismissInBatchParameter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissParameter(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissParameter(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigParamRestControllerApi.deleteOrDismissParameter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParameter(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParameter(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigParamRestControllerApi.getParameter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listParameter(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listParameter(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigParamRestControllerApi.listParameter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageParameter(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageParameter(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigParamRestControllerApi.pageParameter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Parameter} parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveParameter(parameter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveParameter(parameter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigParamRestControllerApi.saveParameter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ConfigParamRestControllerApi - factory interface
 * @export
 */
export const ConfigParamRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ConfigParamRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countParameter(term, showDismissed, options) {
            return localVarFp.countParameter(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchParameter(ids, options) {
            return localVarFp.deleteOrDismissInBatchParameter(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissParameter(id, options) {
            return localVarFp.deleteOrDismissParameter(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameter(id, options) {
            return localVarFp.getParameter(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParameter(term, showDismissed, options) {
            return localVarFp.listParameter(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageParameter(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageParameter(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Parameter} parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveParameter(parameter, options) {
            return localVarFp.saveParameter(parameter, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConfigParamRestControllerApi - object-oriented interface
 * @export
 * @class ConfigParamRestControllerApi
 * @extends {BaseAPI}
 */
export class ConfigParamRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigParamRestControllerApi
     */
    countParameter(term, showDismissed, options) {
        return ConfigParamRestControllerApiFp(this.configuration).countParameter(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigParamRestControllerApi
     */
    deleteOrDismissInBatchParameter(ids, options) {
        return ConfigParamRestControllerApiFp(this.configuration).deleteOrDismissInBatchParameter(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigParamRestControllerApi
     */
    deleteOrDismissParameter(id, options) {
        return ConfigParamRestControllerApiFp(this.configuration).deleteOrDismissParameter(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigParamRestControllerApi
     */
    getParameter(id, options) {
        return ConfigParamRestControllerApiFp(this.configuration).getParameter(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigParamRestControllerApi
     */
    listParameter(term, showDismissed, options) {
        return ConfigParamRestControllerApiFp(this.configuration).listParameter(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigParamRestControllerApi
     */
    pageParameter(page, size, sort, term, showDismissed, options) {
        return ConfigParamRestControllerApiFp(this.configuration).pageParameter(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Parameter} parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigParamRestControllerApi
     */
    saveParameter(parameter, options) {
        return ConfigParamRestControllerApiFp(this.configuration).saveParameter(parameter, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ConfigUserRestControllerApi - axios parameter creator
 * @export
 */
export const ConfigUserRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countUser: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/config/user/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchUser: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchUser', 'ids', ids);
            const localVarPath = `/api/admin/config/user/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissUser: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissUser', 'id', id);
            const localVarPath = `/api/admin/config/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} permissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePermissionUser: async (permissionId, options = {}) => {
            // verify required parameter 'permissionId' is not null or undefined
            assertParamExists('deletePermissionUser', 'permissionId', permissionId);
            const localVarPath = `/api/admin/config/user/permission/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (permissionId !== undefined) {
                localVarQueryParameter['permissionId'] = permissionId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUser', 'id', id);
            const localVarPath = `/api/admin/config/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUser: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/config/user/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUser: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/config/user/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUser: async (user, options = {}) => {
            // verify required parameter 'user' is not null or undefined
            assertParamExists('saveUser', 'user', user);
            const localVarPath = `/api/admin/config/user/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ConfigUserRestControllerApi - functional programming interface
 * @export
 */
export const ConfigUserRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ConfigUserRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countUser(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countUser(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigUserRestControllerApi.countUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchUser(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchUser(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigUserRestControllerApi.deleteOrDismissInBatchUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissUser(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigUserRestControllerApi.deleteOrDismissUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} permissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePermissionUser(permissionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePermissionUser(permissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigUserRestControllerApi.deletePermissionUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigUserRestControllerApi.getUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUser(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUser(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigUserRestControllerApi.listUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageUser(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageUser(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigUserRestControllerApi.pageUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveUser(user, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveUser(user, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigUserRestControllerApi.saveUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ConfigUserRestControllerApi - factory interface
 * @export
 */
export const ConfigUserRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ConfigUserRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countUser(term, showDismissed, options) {
            return localVarFp.countUser(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchUser(ids, options) {
            return localVarFp.deleteOrDismissInBatchUser(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissUser(id, options) {
            return localVarFp.deleteOrDismissUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} permissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePermissionUser(permissionId, options) {
            return localVarFp.deletePermissionUser(permissionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(id, options) {
            return localVarFp.getUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUser(term, showDismissed, options) {
            return localVarFp.listUser(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUser(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageUser(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUser(user, options) {
            return localVarFp.saveUser(user, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConfigUserRestControllerApi - object-oriented interface
 * @export
 * @class ConfigUserRestControllerApi
 * @extends {BaseAPI}
 */
export class ConfigUserRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigUserRestControllerApi
     */
    countUser(term, showDismissed, options) {
        return ConfigUserRestControllerApiFp(this.configuration).countUser(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigUserRestControllerApi
     */
    deleteOrDismissInBatchUser(ids, options) {
        return ConfigUserRestControllerApiFp(this.configuration).deleteOrDismissInBatchUser(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigUserRestControllerApi
     */
    deleteOrDismissUser(id, options) {
        return ConfigUserRestControllerApiFp(this.configuration).deleteOrDismissUser(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} permissionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigUserRestControllerApi
     */
    deletePermissionUser(permissionId, options) {
        return ConfigUserRestControllerApiFp(this.configuration).deletePermissionUser(permissionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigUserRestControllerApi
     */
    getUser(id, options) {
        return ConfigUserRestControllerApiFp(this.configuration).getUser(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigUserRestControllerApi
     */
    listUser(term, showDismissed, options) {
        return ConfigUserRestControllerApiFp(this.configuration).listUser(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigUserRestControllerApi
     */
    pageUser(page, size, sort, term, showDismissed, options) {
        return ConfigUserRestControllerApiFp(this.configuration).pageUser(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {User} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigUserRestControllerApi
     */
    saveUser(user, options) {
        return ConfigUserRestControllerApiFp(this.configuration).saveUser(user, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ContactEventRestControllerApi - axios parameter creator
 * @export
 */
export const ContactEventRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [contactId]
         * @param {CountContactEventTypeEnum} [type]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countContactEvent: async (contactId, type, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/contact-event/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (contactId !== undefined) {
                localVarQueryParameter['contactId'] = contactId;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissContactEvent: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissContactEvent', 'id', id);
            const localVarPath = `/api/admin/marketing/contact-event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchContactEvent: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchContactEvent', 'ids', ids);
            const localVarPath = `/api/admin/marketing/contact-event/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactEvent: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getContactEvent', 'id', id);
            const localVarPath = `/api/admin/marketing/contact-event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [contactId]
         * @param {ListContactEventTypeEnum} [type]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContactEvent: async (contactId, type, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/contact-event/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (contactId !== undefined) {
                localVarQueryParameter['contactId'] = contactId;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [contactId]
         * @param {PageContactEventTypeEnum} [type]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageContactEvent: async (page, size, sort, contactId, type, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/contact-event/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (contactId !== undefined) {
                localVarQueryParameter['contactId'] = contactId;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ContactEvent} contactEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveContactEvent: async (contactEvent, options = {}) => {
            // verify required parameter 'contactEvent' is not null or undefined
            assertParamExists('saveContactEvent', 'contactEvent', contactEvent);
            const localVarPath = `/api/admin/marketing/contact-event/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(contactEvent, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ContactEventRestControllerApi - functional programming interface
 * @export
 */
export const ContactEventRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ContactEventRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [contactId]
         * @param {CountContactEventTypeEnum} [type]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countContactEvent(contactId, type, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countContactEvent(contactId, type, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactEventRestControllerApi.countContactEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissContactEvent(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissContactEvent(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactEventRestControllerApi.deleteOrDismissContactEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchContactEvent(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchContactEvent(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactEventRestControllerApi.deleteOrDismissInBatchContactEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactEvent(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactEvent(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactEventRestControllerApi.getContactEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [contactId]
         * @param {ListContactEventTypeEnum} [type]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listContactEvent(contactId, type, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listContactEvent(contactId, type, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactEventRestControllerApi.listContactEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [contactId]
         * @param {PageContactEventTypeEnum} [type]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageContactEvent(page, size, sort, contactId, type, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageContactEvent(page, size, sort, contactId, type, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactEventRestControllerApi.pageContactEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ContactEvent} contactEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveContactEvent(contactEvent, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveContactEvent(contactEvent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactEventRestControllerApi.saveContactEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ContactEventRestControllerApi - factory interface
 * @export
 */
export const ContactEventRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ContactEventRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [contactId]
         * @param {CountContactEventTypeEnum} [type]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countContactEvent(contactId, type, term, showDismissed, options) {
            return localVarFp.countContactEvent(contactId, type, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissContactEvent(id, options) {
            return localVarFp.deleteOrDismissContactEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchContactEvent(ids, options) {
            return localVarFp.deleteOrDismissInBatchContactEvent(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactEvent(id, options) {
            return localVarFp.getContactEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [contactId]
         * @param {ListContactEventTypeEnum} [type]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContactEvent(contactId, type, term, showDismissed, options) {
            return localVarFp.listContactEvent(contactId, type, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [contactId]
         * @param {PageContactEventTypeEnum} [type]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageContactEvent(page, size, sort, contactId, type, term, showDismissed, options) {
            return localVarFp.pageContactEvent(page, size, sort, contactId, type, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ContactEvent} contactEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveContactEvent(contactEvent, options) {
            return localVarFp.saveContactEvent(contactEvent, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ContactEventRestControllerApi - object-oriented interface
 * @export
 * @class ContactEventRestControllerApi
 * @extends {BaseAPI}
 */
export class ContactEventRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [contactId]
     * @param {CountContactEventTypeEnum} [type]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactEventRestControllerApi
     */
    countContactEvent(contactId, type, term, showDismissed, options) {
        return ContactEventRestControllerApiFp(this.configuration).countContactEvent(contactId, type, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactEventRestControllerApi
     */
    deleteOrDismissContactEvent(id, options) {
        return ContactEventRestControllerApiFp(this.configuration).deleteOrDismissContactEvent(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactEventRestControllerApi
     */
    deleteOrDismissInBatchContactEvent(ids, options) {
        return ContactEventRestControllerApiFp(this.configuration).deleteOrDismissInBatchContactEvent(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactEventRestControllerApi
     */
    getContactEvent(id, options) {
        return ContactEventRestControllerApiFp(this.configuration).getContactEvent(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [contactId]
     * @param {ListContactEventTypeEnum} [type]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactEventRestControllerApi
     */
    listContactEvent(contactId, type, term, showDismissed, options) {
        return ContactEventRestControllerApiFp(this.configuration).listContactEvent(contactId, type, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [contactId]
     * @param {PageContactEventTypeEnum} [type]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactEventRestControllerApi
     */
    pageContactEvent(page, size, sort, contactId, type, term, showDismissed, options) {
        return ContactEventRestControllerApiFp(this.configuration).pageContactEvent(page, size, sort, contactId, type, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ContactEvent} contactEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactEventRestControllerApi
     */
    saveContactEvent(contactEvent, options) {
        return ContactEventRestControllerApiFp(this.configuration).saveContactEvent(contactEvent, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountContactEventTypeEnum = {
    CALL: 'CALL',
    EMAIL: 'EMAIL',
    MEETING: 'MEETING',
    NOTE: 'NOTE',
    TASK: 'TASK',
    OTHER: 'OTHER'
};
/**
 * @export
 */
export const ListContactEventTypeEnum = {
    CALL: 'CALL',
    EMAIL: 'EMAIL',
    MEETING: 'MEETING',
    NOTE: 'NOTE',
    TASK: 'TASK',
    OTHER: 'OTHER'
};
/**
 * @export
 */
export const PageContactEventTypeEnum = {
    CALL: 'CALL',
    EMAIL: 'EMAIL',
    MEETING: 'MEETING',
    NOTE: 'NOTE',
    TASK: 'TASK',
    OTHER: 'OTHER'
};
/**
 * ContactRestControllerApi - axios parameter creator
 * @export
 */
export const ContactRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [organizationId]
         * @param {CountContactTypeEnum} [type]
         * @param {boolean} [withoutEmail]
         * @param {boolean} [securityContact]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countContact: async (organizationId, type, withoutEmail, securityContact, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/contact/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (withoutEmail !== undefined) {
                localVarQueryParameter['withoutEmail'] = withoutEmail;
            }
            if (securityContact !== undefined) {
                localVarQueryParameter['securityContact'] = securityContact;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissContact: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissContact', 'id', id);
            const localVarPath = `/api/admin/marketing/contact/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchContact: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchContact', 'ids', ids);
            const localVarPath = `/api/admin/marketing/contact/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContact: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getContact', 'id', id);
            const localVarPath = `/api/admin/marketing/contact/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [organizationId]
         * @param {ListContactTypeEnum} [type]
         * @param {boolean} [withoutEmail]
         * @param {boolean} [securityContact]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContact: async (organizationId, type, withoutEmail, securityContact, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/contact/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (withoutEmail !== undefined) {
                localVarQueryParameter['withoutEmail'] = withoutEmail;
            }
            if (securityContact !== undefined) {
                localVarQueryParameter['securityContact'] = securityContact;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [organizationId]
         * @param {PageContactTypeEnum} [type]
         * @param {boolean} [withoutEmail]
         * @param {boolean} [securityContact]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageContact: async (page, size, sort, organizationId, type, withoutEmail, securityContact, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/contact/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (withoutEmail !== undefined) {
                localVarQueryParameter['withoutEmail'] = withoutEmail;
            }
            if (securityContact !== undefined) {
                localVarQueryParameter['securityContact'] = securityContact;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CrmContact} crmContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveContact: async (crmContact, options = {}) => {
            // verify required parameter 'crmContact' is not null or undefined
            assertParamExists('saveContact', 'crmContact', crmContact);
            const localVarPath = `/api/admin/marketing/contact/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(crmContact, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ContactRestControllerApi - functional programming interface
 * @export
 */
export const ContactRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ContactRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [organizationId]
         * @param {CountContactTypeEnum} [type]
         * @param {boolean} [withoutEmail]
         * @param {boolean} [securityContact]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countContact(organizationId, type, withoutEmail, securityContact, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countContact(organizationId, type, withoutEmail, securityContact, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactRestControllerApi.countContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissContact(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissContact(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactRestControllerApi.deleteOrDismissContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchContact(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchContact(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactRestControllerApi.deleteOrDismissInBatchContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContact(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContact(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactRestControllerApi.getContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [organizationId]
         * @param {ListContactTypeEnum} [type]
         * @param {boolean} [withoutEmail]
         * @param {boolean} [securityContact]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listContact(organizationId, type, withoutEmail, securityContact, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listContact(organizationId, type, withoutEmail, securityContact, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactRestControllerApi.listContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [organizationId]
         * @param {PageContactTypeEnum} [type]
         * @param {boolean} [withoutEmail]
         * @param {boolean} [securityContact]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageContact(page, size, sort, organizationId, type, withoutEmail, securityContact, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageContact(page, size, sort, organizationId, type, withoutEmail, securityContact, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactRestControllerApi.pageContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CrmContact} crmContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveContact(crmContact, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveContact(crmContact, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactRestControllerApi.saveContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ContactRestControllerApi - factory interface
 * @export
 */
export const ContactRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ContactRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [organizationId]
         * @param {CountContactTypeEnum} [type]
         * @param {boolean} [withoutEmail]
         * @param {boolean} [securityContact]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countContact(organizationId, type, withoutEmail, securityContact, term, showDismissed, options) {
            return localVarFp.countContact(organizationId, type, withoutEmail, securityContact, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissContact(id, options) {
            return localVarFp.deleteOrDismissContact(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchContact(ids, options) {
            return localVarFp.deleteOrDismissInBatchContact(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContact(id, options) {
            return localVarFp.getContact(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [organizationId]
         * @param {ListContactTypeEnum} [type]
         * @param {boolean} [withoutEmail]
         * @param {boolean} [securityContact]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContact(organizationId, type, withoutEmail, securityContact, term, showDismissed, options) {
            return localVarFp.listContact(organizationId, type, withoutEmail, securityContact, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [organizationId]
         * @param {PageContactTypeEnum} [type]
         * @param {boolean} [withoutEmail]
         * @param {boolean} [securityContact]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageContact(page, size, sort, organizationId, type, withoutEmail, securityContact, term, showDismissed, options) {
            return localVarFp.pageContact(page, size, sort, organizationId, type, withoutEmail, securityContact, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CrmContact} crmContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveContact(crmContact, options) {
            return localVarFp.saveContact(crmContact, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ContactRestControllerApi - object-oriented interface
 * @export
 * @class ContactRestControllerApi
 * @extends {BaseAPI}
 */
export class ContactRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [organizationId]
     * @param {CountContactTypeEnum} [type]
     * @param {boolean} [withoutEmail]
     * @param {boolean} [securityContact]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactRestControllerApi
     */
    countContact(organizationId, type, withoutEmail, securityContact, term, showDismissed, options) {
        return ContactRestControllerApiFp(this.configuration).countContact(organizationId, type, withoutEmail, securityContact, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactRestControllerApi
     */
    deleteOrDismissContact(id, options) {
        return ContactRestControllerApiFp(this.configuration).deleteOrDismissContact(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactRestControllerApi
     */
    deleteOrDismissInBatchContact(ids, options) {
        return ContactRestControllerApiFp(this.configuration).deleteOrDismissInBatchContact(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactRestControllerApi
     */
    getContact(id, options) {
        return ContactRestControllerApiFp(this.configuration).getContact(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [organizationId]
     * @param {ListContactTypeEnum} [type]
     * @param {boolean} [withoutEmail]
     * @param {boolean} [securityContact]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactRestControllerApi
     */
    listContact(organizationId, type, withoutEmail, securityContact, term, showDismissed, options) {
        return ContactRestControllerApiFp(this.configuration).listContact(organizationId, type, withoutEmail, securityContact, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [organizationId]
     * @param {PageContactTypeEnum} [type]
     * @param {boolean} [withoutEmail]
     * @param {boolean} [securityContact]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactRestControllerApi
     */
    pageContact(page, size, sort, organizationId, type, withoutEmail, securityContact, term, showDismissed, options) {
        return ContactRestControllerApiFp(this.configuration).pageContact(page, size, sort, organizationId, type, withoutEmail, securityContact, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CrmContact} crmContact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactRestControllerApi
     */
    saveContact(crmContact, options) {
        return ContactRestControllerApiFp(this.configuration).saveContact(crmContact, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountContactTypeEnum = {
    LEAD: 'LEAD',
    PROSPECT: 'PROSPECT',
    CLIENT: 'CLIENT',
    PARTNER: 'PARTNER',
    PROVIDER: 'PROVIDER',
    OTHER: 'OTHER'
};
/**
 * @export
 */
export const ListContactTypeEnum = {
    LEAD: 'LEAD',
    PROSPECT: 'PROSPECT',
    CLIENT: 'CLIENT',
    PARTNER: 'PARTNER',
    PROVIDER: 'PROVIDER',
    OTHER: 'OTHER'
};
/**
 * @export
 */
export const PageContactTypeEnum = {
    LEAD: 'LEAD',
    PROSPECT: 'PROSPECT',
    CLIENT: 'CLIENT',
    PARTNER: 'PARTNER',
    PROVIDER: 'PROVIDER',
    OTHER: 'OTHER'
};
/**
 * ContasolRestControllerApi - axios parameter creator
 * @export
 */
export const ContasolRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        divergences: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('divergences', 'year', year);
            const localVarPath = `/api/admin/accounting/contasol/divergences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceReimportJournal: async (year, validateBalanceRequest, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('forceReimportJournal', 'year', year);
            const localVarPath = `/api/admin/accounting/contasol/force-reimport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(validateBalanceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} bankAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBankMovements: async (year, bankAccountId, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('generateBankMovements', 'year', year);
            // verify required parameter 'bankAccountId' is not null or undefined
            assertParamExists('generateBankMovements', 'bankAccountId', bankAccountId);
            const localVarPath = `/api/admin/accounting/contasol/generate-bank-movements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (bankAccountId !== undefined) {
                localVarQueryParameter['bankAccountId'] = bankAccountId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCustomers: async (validateBalanceRequest, options = {}) => {
            const localVarPath = `/api/admin/accounting/contasol/import-customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(validateBalanceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importInvoices: async (validateBalanceRequest, options = {}) => {
            const localVarPath = `/api/admin/accounting/contasol/import-invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(validateBalanceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importJournal: async (year, validateBalanceRequest, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('importJournal', 'year', year);
            const localVarPath = `/api/admin/accounting/contasol/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(validateBalanceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importSuppliers: async (validateBalanceRequest, options = {}) => {
            const localVarPath = `/api/admin/accounting/contasol/import-suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(validateBalanceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchBills: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('matchBills', 'year', year);
            const localVarPath = `/api/admin/accounting/contasol/match-bills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchInvoices: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('matchInvoices', 'year', year);
            const localVarPath = `/api/admin/accounting/contasol/match-invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reconcile1: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('reconcile1', 'year', year);
            const localVarPath = `/api/admin/accounting/contasol/reconcile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBalance: async (year, validateBalanceRequest, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('validateBalance', 'year', year);
            const localVarPath = `/api/admin/accounting/contasol/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(validateBalanceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ContasolRestControllerApi - functional programming interface
 * @export
 */
export const ContasolRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ContasolRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async divergences(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.divergences(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContasolRestControllerApi.divergences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forceReimportJournal(year, validateBalanceRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forceReimportJournal(year, validateBalanceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContasolRestControllerApi.forceReimportJournal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} bankAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateBankMovements(year, bankAccountId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateBankMovements(year, bankAccountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContasolRestControllerApi.generateBankMovements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importCustomers(validateBalanceRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importCustomers(validateBalanceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContasolRestControllerApi.importCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importInvoices(validateBalanceRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importInvoices(validateBalanceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContasolRestControllerApi.importInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importJournal(year, validateBalanceRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importJournal(year, validateBalanceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContasolRestControllerApi.importJournal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importSuppliers(validateBalanceRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importSuppliers(validateBalanceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContasolRestControllerApi.importSuppliers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async matchBills(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.matchBills(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContasolRestControllerApi.matchBills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async matchInvoices(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.matchInvoices(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContasolRestControllerApi.matchInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reconcile1(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reconcile1(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContasolRestControllerApi.reconcile1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateBalance(year, validateBalanceRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateBalance(year, validateBalanceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContasolRestControllerApi.validateBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ContasolRestControllerApi - factory interface
 * @export
 */
export const ContasolRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ContasolRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        divergences(year, options) {
            return localVarFp.divergences(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceReimportJournal(year, validateBalanceRequest, options) {
            return localVarFp.forceReimportJournal(year, validateBalanceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} bankAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBankMovements(year, bankAccountId, options) {
            return localVarFp.generateBankMovements(year, bankAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCustomers(validateBalanceRequest, options) {
            return localVarFp.importCustomers(validateBalanceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importInvoices(validateBalanceRequest, options) {
            return localVarFp.importInvoices(validateBalanceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importJournal(year, validateBalanceRequest, options) {
            return localVarFp.importJournal(year, validateBalanceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importSuppliers(validateBalanceRequest, options) {
            return localVarFp.importSuppliers(validateBalanceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchBills(year, options) {
            return localVarFp.matchBills(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchInvoices(year, options) {
            return localVarFp.matchInvoices(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reconcile1(year, options) {
            return localVarFp.reconcile1(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {ValidateBalanceRequest} [validateBalanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBalance(year, validateBalanceRequest, options) {
            return localVarFp.validateBalance(year, validateBalanceRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ContasolRestControllerApi - object-oriented interface
 * @export
 * @class ContasolRestControllerApi
 * @extends {BaseAPI}
 */
export class ContasolRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContasolRestControllerApi
     */
    divergences(year, options) {
        return ContasolRestControllerApiFp(this.configuration).divergences(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {ValidateBalanceRequest} [validateBalanceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContasolRestControllerApi
     */
    forceReimportJournal(year, validateBalanceRequest, options) {
        return ContasolRestControllerApiFp(this.configuration).forceReimportJournal(year, validateBalanceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} bankAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContasolRestControllerApi
     */
    generateBankMovements(year, bankAccountId, options) {
        return ContasolRestControllerApiFp(this.configuration).generateBankMovements(year, bankAccountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ValidateBalanceRequest} [validateBalanceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContasolRestControllerApi
     */
    importCustomers(validateBalanceRequest, options) {
        return ContasolRestControllerApiFp(this.configuration).importCustomers(validateBalanceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ValidateBalanceRequest} [validateBalanceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContasolRestControllerApi
     */
    importInvoices(validateBalanceRequest, options) {
        return ContasolRestControllerApiFp(this.configuration).importInvoices(validateBalanceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {ValidateBalanceRequest} [validateBalanceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContasolRestControllerApi
     */
    importJournal(year, validateBalanceRequest, options) {
        return ContasolRestControllerApiFp(this.configuration).importJournal(year, validateBalanceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ValidateBalanceRequest} [validateBalanceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContasolRestControllerApi
     */
    importSuppliers(validateBalanceRequest, options) {
        return ContasolRestControllerApiFp(this.configuration).importSuppliers(validateBalanceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContasolRestControllerApi
     */
    matchBills(year, options) {
        return ContasolRestControllerApiFp(this.configuration).matchBills(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContasolRestControllerApi
     */
    matchInvoices(year, options) {
        return ContasolRestControllerApiFp(this.configuration).matchInvoices(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContasolRestControllerApi
     */
    reconcile1(year, options) {
        return ContasolRestControllerApiFp(this.configuration).reconcile1(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {ValidateBalanceRequest} [validateBalanceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContasolRestControllerApi
     */
    validateBalance(year, validateBalanceRequest, options) {
        return ContasolRestControllerApiFp(this.configuration).validateBalance(year, validateBalanceRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CustomerRestControllerApi - axios parameter creator
 * @export
 */
export const CustomerRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCustomer: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/customer/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCustomer: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissCustomer', 'id', id);
            const localVarPath = `/api/admin/billing/customer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCustomer: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchCustomer', 'ids', ids);
            const localVarPath = `/api/admin/billing/customer/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCustomer', 'id', id);
            const localVarPath = `/api/admin/billing/customer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomer: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/customer/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCustomer: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/customer/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Customer} customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCustomer: async (customer, options = {}) => {
            // verify required parameter 'customer' is not null or undefined
            assertParamExists('saveCustomer', 'customer', customer);
            const localVarPath = `/api/admin/billing/customer/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(customer, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CustomerRestControllerApi - functional programming interface
 * @export
 */
export const CustomerRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = CustomerRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countCustomer(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countCustomer(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerRestControllerApi.countCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissCustomer(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissCustomer(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerRestControllerApi.deleteOrDismissCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchCustomer(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchCustomer(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerRestControllerApi.deleteOrDismissInBatchCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomer(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomer(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerRestControllerApi.getCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCustomer(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCustomer(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerRestControllerApi.listCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageCustomer(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageCustomer(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerRestControllerApi.pageCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Customer} customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCustomer(customer, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCustomer(customer, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerRestControllerApi.saveCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CustomerRestControllerApi - factory interface
 * @export
 */
export const CustomerRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CustomerRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCustomer(term, showDismissed, options) {
            return localVarFp.countCustomer(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissCustomer(id, options) {
            return localVarFp.deleteOrDismissCustomer(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchCustomer(ids, options) {
            return localVarFp.deleteOrDismissInBatchCustomer(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer(id, options) {
            return localVarFp.getCustomer(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomer(term, showDismissed, options) {
            return localVarFp.listCustomer(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageCustomer(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageCustomer(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Customer} customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCustomer(customer, options) {
            return localVarFp.saveCustomer(customer, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CustomerRestControllerApi - object-oriented interface
 * @export
 * @class CustomerRestControllerApi
 * @extends {BaseAPI}
 */
export class CustomerRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRestControllerApi
     */
    countCustomer(term, showDismissed, options) {
        return CustomerRestControllerApiFp(this.configuration).countCustomer(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRestControllerApi
     */
    deleteOrDismissCustomer(id, options) {
        return CustomerRestControllerApiFp(this.configuration).deleteOrDismissCustomer(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRestControllerApi
     */
    deleteOrDismissInBatchCustomer(ids, options) {
        return CustomerRestControllerApiFp(this.configuration).deleteOrDismissInBatchCustomer(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRestControllerApi
     */
    getCustomer(id, options) {
        return CustomerRestControllerApiFp(this.configuration).getCustomer(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRestControllerApi
     */
    listCustomer(term, showDismissed, options) {
        return CustomerRestControllerApiFp(this.configuration).listCustomer(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRestControllerApi
     */
    pageCustomer(page, size, sort, term, showDismissed, options) {
        return CustomerRestControllerApiFp(this.configuration).pageCustomer(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Customer} customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRestControllerApi
     */
    saveCustomer(customer, options) {
        return CustomerRestControllerApiFp(this.configuration).saveCustomer(customer, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DedicationAuditRestControllerApi - axios parameter creator
 * @export
 */
export const DedicationAuditRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} from
         * @param {string} to
         * @param {boolean} [rebateOnly]
         * @param {boolean} [refresh]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationAudit: async (from, to, rebateOnly, refresh, options = {}) => {
            // verify required parameter 'from' is not null or undefined
            assertParamExists('dedicationAudit', 'from', from);
            // verify required parameter 'to' is not null or undefined
            assertParamExists('dedicationAudit', 'to', to);
            const localVarPath = `/api/admin/employee/dedication-audit/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (rebateOnly !== undefined) {
                localVarQueryParameter['rebateOnly'] = rebateOnly;
            }
            if (refresh !== undefined) {
                localVarQueryParameter['refresh'] = refresh;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} from
         * @param {string} to
         * @param {number} [personId]
         * @param {boolean} [refresh]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationAuditEntries: async (from, to, personId, refresh, options = {}) => {
            // verify required parameter 'from' is not null or undefined
            assertParamExists('dedicationAuditEntries', 'from', from);
            // verify required parameter 'to' is not null or undefined
            assertParamExists('dedicationAuditEntries', 'to', to);
            const localVarPath = `/api/admin/employee/dedication-audit/entries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (refresh !== undefined) {
                localVarQueryParameter['refresh'] = refresh;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DedicationAuditRestControllerApi - functional programming interface
 * @export
 */
export const DedicationAuditRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = DedicationAuditRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} from
         * @param {string} to
         * @param {boolean} [rebateOnly]
         * @param {boolean} [refresh]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dedicationAudit(from, to, rebateOnly, refresh, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dedicationAudit(from, to, rebateOnly, refresh, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationAuditRestControllerApi.dedicationAudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} from
         * @param {string} to
         * @param {number} [personId]
         * @param {boolean} [refresh]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dedicationAuditEntries(from, to, personId, refresh, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dedicationAuditEntries(from, to, personId, refresh, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationAuditRestControllerApi.dedicationAuditEntries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * DedicationAuditRestControllerApi - factory interface
 * @export
 */
export const DedicationAuditRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DedicationAuditRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} from
         * @param {string} to
         * @param {boolean} [rebateOnly]
         * @param {boolean} [refresh]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationAudit(from, to, rebateOnly, refresh, options) {
            return localVarFp.dedicationAudit(from, to, rebateOnly, refresh, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} from
         * @param {string} to
         * @param {number} [personId]
         * @param {boolean} [refresh]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationAuditEntries(from, to, personId, refresh, options) {
            return localVarFp.dedicationAuditEntries(from, to, personId, refresh, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DedicationAuditRestControllerApi - object-oriented interface
 * @export
 * @class DedicationAuditRestControllerApi
 * @extends {BaseAPI}
 */
export class DedicationAuditRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} from
     * @param {string} to
     * @param {boolean} [rebateOnly]
     * @param {boolean} [refresh]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationAuditRestControllerApi
     */
    dedicationAudit(from, to, rebateOnly, refresh, options) {
        return DedicationAuditRestControllerApiFp(this.configuration).dedicationAudit(from, to, rebateOnly, refresh, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} from
     * @param {string} to
     * @param {number} [personId]
     * @param {boolean} [refresh]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationAuditRestControllerApi
     */
    dedicationAuditEntries(from, to, personId, refresh, options) {
        return DedicationAuditRestControllerApiFp(this.configuration).dedicationAuditEntries(from, to, personId, refresh, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DedicationRestControllerApi - axios parameter creator
 * @export
 */
export const DedicationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkBillingPendingDedication: async (year, month, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('checkBillingPendingDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('checkBillingPendingDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/billed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDedication: async (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/dedication/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDedicationsDedication: async (year, month, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('createDedicationsDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('createDedicationsDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/create-dedications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} bills
         * @param {string} [separator]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationBatchCreateDedication: async (bills, separator, options = {}) => {
            // verify required parameter 'bills' is not null or undefined
            assertParamExists('dedicationBatchCreateDedication', 'bills', bills);
            const localVarPath = `/api/admin/billing/dedication/batch-create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (bills !== undefined) {
                localVarQueryParameter['bills'] = bills;
            }
            if (separator !== undefined) {
                localVarQueryParameter['separator'] = separator;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} dedications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationBatchDeleteDedication: async (dedications, options = {}) => {
            // verify required parameter 'dedications' is not null or undefined
            assertParamExists('dedicationBatchDeleteDedication', 'dedications', dedications);
            const localVarPath = `/api/admin/billing/dedication/batch-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (dedications) {
                localVarQueryParameter['dedications'] = dedications;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBillsDedication: async (year, month, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('deleteBillsDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('deleteBillsDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/billed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissDedication: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissDedication', 'id', id);
            const localVarPath = `/api/admin/billing/dedication/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchDedication: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchDedication', 'ids', ids);
            const localVarPath = `/api/admin/billing/dedication/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {Array<number>} [dedicationsIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateDedication: async (year, month, dedicationsIds, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('duplicateDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('duplicateDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/duplicate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (dedicationsIds) {
                localVarQueryParameter['dedicationsIds'] = dedicationsIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportXlsDedication: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('exportXlsDedication', 'ids', ids);
            const localVarPath = `/api/admin/billing/dedication/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDedication: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDedication', 'id', id);
            const localVarPath = `/api/admin/billing/dedication/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedmineDedication: async (year, month, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getRedmineDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('getRedmineDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/import-redmine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {DedicationImportDto} dedicationImportDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFileDedication: async (dedicationImportDto, options = {}) => {
            // verify required parameter 'dedicationImportDto' is not null or undefined
            assertParamExists('importFileDedication', 'dedicationImportDto', dedicationImportDto);
            const localVarPath = `/api/admin/billing/dedication/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(dedicationImportDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRedmineDedication: async (year, month, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('importRedmineDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('importRedmineDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/import-redmine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<DedicationLinkDto>} dedicationLinkDto
         * @param {boolean} [simulate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkDedication: async (dedicationLinkDto, simulate, options = {}) => {
            // verify required parameter 'dedicationLinkDto' is not null or undefined
            assertParamExists('linkDedication', 'dedicationLinkDto', dedicationLinkDto);
            const localVarPath = `/api/admin/billing/dedication/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (simulate !== undefined) {
                localVarQueryParameter['simulate'] = simulate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(dedicationLinkDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDedication: async (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/dedication/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {Array<number>} [dedicationsIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeBillsDedication: async (year, month, dedicationsIds, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('makeBillsDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('makeBillsDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/billed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (dedicationsIds) {
                localVarQueryParameter['dedicationsIds'] = dedicationsIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDedication: async (page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/dedication/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfsDedication: async (year, month, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('pdfsDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('pdfsDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/billed/pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRedmineDedication: async (year, month, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('removeRedmineDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('removeRedmineDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/import-redmine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairDedication: async (year, month, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('repairDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('repairDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/repair`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Dedication} dedication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDedication: async (dedication, options = {}) => {
            // verify required parameter 'dedication' is not null or undefined
            assertParamExists('saveDedication', 'dedication', dedication);
            const localVarPath = `/api/admin/billing/dedication/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(dedication, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {number} [customerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeEntriesDedication: async (year, month, customerId, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('timeEntriesDedication', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('timeEntriesDedication', 'month', month);
            const localVarPath = `/api/admin/billing/dedication/time-entries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {Dedication} dedication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInBatchDedication: async (ids, dedication, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('updateInBatchDedication', 'ids', ids);
            // verify required parameter 'dedication' is not null or undefined
            assertParamExists('updateInBatchDedication', 'dedication', dedication);
            const localVarPath = `/api/admin/billing/dedication/batch-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(dedication, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateInBatchDedication: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('validateInBatchDedication', 'ids', ids);
            const localVarPath = `/api/admin/billing/dedication/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DedicationRestControllerApi - functional programming interface
 * @export
 */
export const DedicationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = DedicationRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkBillingPendingDedication(year, month, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkBillingPendingDedication(year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.checkBillingPendingDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countDedication(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countDedication(personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.countDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDedicationsDedication(year, month, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDedicationsDedication(year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.createDedicationsDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} bills
         * @param {string} [separator]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dedicationBatchCreateDedication(bills, separator, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dedicationBatchCreateDedication(bills, separator, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.dedicationBatchCreateDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} dedications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dedicationBatchDeleteDedication(dedications, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dedicationBatchDeleteDedication(dedications, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.dedicationBatchDeleteDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBillsDedication(year, month, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBillsDedication(year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.deleteBillsDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissDedication(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissDedication(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.deleteOrDismissDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchDedication(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchDedication(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.deleteOrDismissInBatchDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {Array<number>} [dedicationsIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateDedication(year, month, dedicationsIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateDedication(year, month, dedicationsIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.duplicateDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportXlsDedication(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportXlsDedication(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.exportXlsDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDedication(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDedication(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.getDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRedmineDedication(year, month, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRedmineDedication(year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.getRedmineDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {DedicationImportDto} dedicationImportDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importFileDedication(dedicationImportDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importFileDedication(dedicationImportDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.importFileDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importRedmineDedication(year, month, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importRedmineDedication(year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.importRedmineDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<DedicationLinkDto>} dedicationLinkDto
         * @param {boolean} [simulate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkDedication(dedicationLinkDto, simulate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkDedication(dedicationLinkDto, simulate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.linkDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDedication(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDedication(personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.listDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {Array<number>} [dedicationsIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async makeBillsDedication(year, month, dedicationsIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.makeBillsDedication(year, month, dedicationsIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.makeBillsDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageDedication(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageDedication(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.pageDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfsDedication(year, month, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfsDedication(year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.pdfsDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeRedmineDedication(year, month, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeRedmineDedication(year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.removeRedmineDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairDedication(year, month, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairDedication(year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.repairDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Dedication} dedication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDedication(dedication, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDedication(dedication, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.saveDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {number} [customerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timeEntriesDedication(year, month, customerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.timeEntriesDedication(year, month, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.timeEntriesDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {Dedication} dedication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInBatchDedication(ids, dedication, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInBatchDedication(ids, dedication, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.updateInBatchDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateInBatchDedication(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateInBatchDedication(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DedicationRestControllerApi.validateInBatchDedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * DedicationRestControllerApi - factory interface
 * @export
 */
export const DedicationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DedicationRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkBillingPendingDedication(year, month, options) {
            return localVarFp.checkBillingPendingDedication(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDedication(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countDedication(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDedicationsDedication(year, month, options) {
            return localVarFp.createDedicationsDedication(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} bills
         * @param {string} [separator]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationBatchCreateDedication(bills, separator, options) {
            return localVarFp.dedicationBatchCreateDedication(bills, separator, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} dedications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationBatchDeleteDedication(dedications, options) {
            return localVarFp.dedicationBatchDeleteDedication(dedications, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBillsDedication(year, month, options) {
            return localVarFp.deleteBillsDedication(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissDedication(id, options) {
            return localVarFp.deleteOrDismissDedication(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchDedication(ids, options) {
            return localVarFp.deleteOrDismissInBatchDedication(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {Array<number>} [dedicationsIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateDedication(year, month, dedicationsIds, options) {
            return localVarFp.duplicateDedication(year, month, dedicationsIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportXlsDedication(ids, options) {
            return localVarFp.exportXlsDedication(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDedication(id, options) {
            return localVarFp.getDedication(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedmineDedication(year, month, options) {
            return localVarFp.getRedmineDedication(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DedicationImportDto} dedicationImportDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFileDedication(dedicationImportDto, options) {
            return localVarFp.importFileDedication(dedicationImportDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRedmineDedication(year, month, options) {
            return localVarFp.importRedmineDedication(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<DedicationLinkDto>} dedicationLinkDto
         * @param {boolean} [simulate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkDedication(dedicationLinkDto, simulate, options) {
            return localVarFp.linkDedication(dedicationLinkDto, simulate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDedication(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listDedication(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {Array<number>} [dedicationsIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeBillsDedication(year, month, dedicationsIds, options) {
            return localVarFp.makeBillsDedication(year, month, dedicationsIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDedication(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pageDedication(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfsDedication(year, month, options) {
            return localVarFp.pdfsDedication(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRedmineDedication(year, month, options) {
            return localVarFp.removeRedmineDedication(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairDedication(year, month, options) {
            return localVarFp.repairDedication(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Dedication} dedication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDedication(dedication, options) {
            return localVarFp.saveDedication(dedication, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {number} [customerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeEntriesDedication(year, month, customerId, options) {
            return localVarFp.timeEntriesDedication(year, month, customerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {Dedication} dedication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInBatchDedication(ids, dedication, options) {
            return localVarFp.updateInBatchDedication(ids, dedication, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateInBatchDedication(ids, options) {
            return localVarFp.validateInBatchDedication(ids, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DedicationRestControllerApi - object-oriented interface
 * @export
 * @class DedicationRestControllerApi
 * @extends {BaseAPI}
 */
export class DedicationRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    checkBillingPendingDedication(year, month, options) {
        return DedicationRestControllerApiFp(this.configuration).checkBillingPendingDedication(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    countDedication(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return DedicationRestControllerApiFp(this.configuration).countDedication(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    createDedicationsDedication(year, month, options) {
        return DedicationRestControllerApiFp(this.configuration).createDedicationsDedication(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} bills
     * @param {string} [separator]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    dedicationBatchCreateDedication(bills, separator, options) {
        return DedicationRestControllerApiFp(this.configuration).dedicationBatchCreateDedication(bills, separator, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} dedications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    dedicationBatchDeleteDedication(dedications, options) {
        return DedicationRestControllerApiFp(this.configuration).dedicationBatchDeleteDedication(dedications, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    deleteBillsDedication(year, month, options) {
        return DedicationRestControllerApiFp(this.configuration).deleteBillsDedication(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    deleteOrDismissDedication(id, options) {
        return DedicationRestControllerApiFp(this.configuration).deleteOrDismissDedication(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    deleteOrDismissInBatchDedication(ids, options) {
        return DedicationRestControllerApiFp(this.configuration).deleteOrDismissInBatchDedication(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {Array<number>} [dedicationsIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    duplicateDedication(year, month, dedicationsIds, options) {
        return DedicationRestControllerApiFp(this.configuration).duplicateDedication(year, month, dedicationsIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    exportXlsDedication(ids, options) {
        return DedicationRestControllerApiFp(this.configuration).exportXlsDedication(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    getDedication(id, options) {
        return DedicationRestControllerApiFp(this.configuration).getDedication(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    getRedmineDedication(year, month, options) {
        return DedicationRestControllerApiFp(this.configuration).getRedmineDedication(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DedicationImportDto} dedicationImportDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    importFileDedication(dedicationImportDto, options) {
        return DedicationRestControllerApiFp(this.configuration).importFileDedication(dedicationImportDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    importRedmineDedication(year, month, options) {
        return DedicationRestControllerApiFp(this.configuration).importRedmineDedication(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<DedicationLinkDto>} dedicationLinkDto
     * @param {boolean} [simulate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    linkDedication(dedicationLinkDto, simulate, options) {
        return DedicationRestControllerApiFp(this.configuration).linkDedication(dedicationLinkDto, simulate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    listDedication(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return DedicationRestControllerApiFp(this.configuration).listDedication(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {Array<number>} [dedicationsIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    makeBillsDedication(year, month, dedicationsIds, options) {
        return DedicationRestControllerApiFp(this.configuration).makeBillsDedication(year, month, dedicationsIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    pageDedication(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return DedicationRestControllerApiFp(this.configuration).pageDedication(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    pdfsDedication(year, month, options) {
        return DedicationRestControllerApiFp(this.configuration).pdfsDedication(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    removeRedmineDedication(year, month, options) {
        return DedicationRestControllerApiFp(this.configuration).removeRedmineDedication(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    repairDedication(year, month, options) {
        return DedicationRestControllerApiFp(this.configuration).repairDedication(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Dedication} dedication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    saveDedication(dedication, options) {
        return DedicationRestControllerApiFp(this.configuration).saveDedication(dedication, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {number} [customerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    timeEntriesDedication(year, month, customerId, options) {
        return DedicationRestControllerApiFp(this.configuration).timeEntriesDedication(year, month, customerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {Dedication} dedication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    updateInBatchDedication(ids, dedication, options) {
        return DedicationRestControllerApiFp(this.configuration).updateInBatchDedication(ids, dedication, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DedicationRestControllerApi
     */
    validateInBatchDedication(ids, options) {
        return DedicationRestControllerApiFp(this.configuration).validateInBatchDedication(ids, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DocumentRestControllerApi - axios parameter creator
 * @export
 */
export const DocumentRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDocument: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/document/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissDocument: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissDocument', 'id', id);
            const localVarPath = `/api/admin/employee/document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchDocument: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchDocument', 'ids', ids);
            const localVarPath = `/api/admin/employee/document/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocument', 'id', id);
            const localVarPath = `/api/admin/employee/document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocument: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/document/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDocument: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/document/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readsDocument: async (docId, options = {}) => {
            // verify required parameter 'docId' is not null or undefined
            assertParamExists('readsDocument', 'docId', docId);
            const localVarPath = `/api/admin/employee/document/{docId}/reads`
                .replace(`{${"docId"}}`, encodeURIComponent(String(docId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewBoardDocument: async (options = {}) => {
            const localVarPath = `/api/admin/employee/document/review-board`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewedDocument: async (docId, options = {}) => {
            // verify required parameter 'docId' is not null or undefined
            assertParamExists('reviewedDocument', 'docId', docId);
            const localVarPath = `/api/admin/employee/document/{docId}/reviewed`
                .replace(`{${"docId"}}`, encodeURIComponent(String(docId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Document} document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDocument: async (document, options = {}) => {
            // verify required parameter 'document' is not null or undefined
            assertParamExists('saveDocument', 'document', document);
            const localVarPath = `/api/admin/employee/document/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(document, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewDocument: async (docId, options = {}) => {
            // verify required parameter 'docId' is not null or undefined
            assertParamExists('viewDocument', 'docId', docId);
            const localVarPath = `/api/admin/employee/document/view/{docId}`
                .replace(`{${"docId"}}`, encodeURIComponent(String(docId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DocumentRestControllerApi - functional programming interface
 * @export
 */
export const DocumentRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = DocumentRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countDocument(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countDocument(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRestControllerApi.countDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissDocument(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissDocument(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRestControllerApi.deleteOrDismissDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchDocument(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchDocument(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRestControllerApi.deleteOrDismissInBatchDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocument(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocument(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRestControllerApi.getDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDocument(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDocument(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRestControllerApi.listDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageDocument(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageDocument(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRestControllerApi.pageDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readsDocument(docId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readsDocument(docId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRestControllerApi.readsDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewBoardDocument(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewBoardDocument(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRestControllerApi.reviewBoardDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewedDocument(docId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewedDocument(docId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRestControllerApi.reviewedDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Document} document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDocument(document, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDocument(document, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRestControllerApi.saveDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewDocument(docId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewDocument(docId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRestControllerApi.viewDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * DocumentRestControllerApi - factory interface
 * @export
 */
export const DocumentRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DocumentRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDocument(term, showDismissed, options) {
            return localVarFp.countDocument(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissDocument(id, options) {
            return localVarFp.deleteOrDismissDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchDocument(ids, options) {
            return localVarFp.deleteOrDismissInBatchDocument(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument(id, options) {
            return localVarFp.getDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocument(term, showDismissed, options) {
            return localVarFp.listDocument(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDocument(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageDocument(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readsDocument(docId, options) {
            return localVarFp.readsDocument(docId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewBoardDocument(options) {
            return localVarFp.reviewBoardDocument(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewedDocument(docId, options) {
            return localVarFp.reviewedDocument(docId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Document} document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDocument(document, options) {
            return localVarFp.saveDocument(document, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewDocument(docId, options) {
            return localVarFp.viewDocument(docId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DocumentRestControllerApi - object-oriented interface
 * @export
 * @class DocumentRestControllerApi
 * @extends {BaseAPI}
 */
export class DocumentRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    countDocument(term, showDismissed, options) {
        return DocumentRestControllerApiFp(this.configuration).countDocument(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    deleteOrDismissDocument(id, options) {
        return DocumentRestControllerApiFp(this.configuration).deleteOrDismissDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    deleteOrDismissInBatchDocument(ids, options) {
        return DocumentRestControllerApiFp(this.configuration).deleteOrDismissInBatchDocument(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    getDocument(id, options) {
        return DocumentRestControllerApiFp(this.configuration).getDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    listDocument(term, showDismissed, options) {
        return DocumentRestControllerApiFp(this.configuration).listDocument(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    pageDocument(page, size, sort, term, showDismissed, options) {
        return DocumentRestControllerApiFp(this.configuration).pageDocument(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    readsDocument(docId, options) {
        return DocumentRestControllerApiFp(this.configuration).readsDocument(docId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    reviewBoardDocument(options) {
        return DocumentRestControllerApiFp(this.configuration).reviewBoardDocument(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    reviewedDocument(docId, options) {
        return DocumentRestControllerApiFp(this.configuration).reviewedDocument(docId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Document} document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    saveDocument(document, options) {
        return DocumentRestControllerApiFp(this.configuration).saveDocument(document, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentRestControllerApi
     */
    viewDocument(docId, options) {
        return DocumentRestControllerApiFp(this.configuration).viewDocument(docId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DocumentTopicRestControllerApi - axios parameter creator
 * @export
 */
export const DocumentTopicRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDocumentTopic: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/document-topic/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissDocumentTopic: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissDocumentTopic', 'id', id);
            const localVarPath = `/api/admin/employee/document-topic/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchDocumentTopic: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchDocumentTopic', 'ids', ids);
            const localVarPath = `/api/admin/employee/document-topic/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentTopic: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumentTopic', 'id', id);
            const localVarPath = `/api/admin/employee/document-topic/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocumentTopic: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/document-topic/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDocumentTopic: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/document-topic/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {DocumentTopic} documentTopic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDocumentTopic: async (documentTopic, options = {}) => {
            // verify required parameter 'documentTopic' is not null or undefined
            assertParamExists('saveDocumentTopic', 'documentTopic', documentTopic);
            const localVarPath = `/api/admin/employee/document-topic/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(documentTopic, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DocumentTopicRestControllerApi - functional programming interface
 * @export
 */
export const DocumentTopicRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = DocumentTopicRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countDocumentTopic(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countDocumentTopic(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTopicRestControllerApi.countDocumentTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissDocumentTopic(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissDocumentTopic(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTopicRestControllerApi.deleteOrDismissDocumentTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchDocumentTopic(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchDocumentTopic(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTopicRestControllerApi.deleteOrDismissInBatchDocumentTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentTopic(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentTopic(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTopicRestControllerApi.getDocumentTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDocumentTopic(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDocumentTopic(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTopicRestControllerApi.listDocumentTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageDocumentTopic(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageDocumentTopic(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTopicRestControllerApi.pageDocumentTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {DocumentTopic} documentTopic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDocumentTopic(documentTopic, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDocumentTopic(documentTopic, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTopicRestControllerApi.saveDocumentTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * DocumentTopicRestControllerApi - factory interface
 * @export
 */
export const DocumentTopicRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DocumentTopicRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDocumentTopic(term, showDismissed, options) {
            return localVarFp.countDocumentTopic(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissDocumentTopic(id, options) {
            return localVarFp.deleteOrDismissDocumentTopic(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchDocumentTopic(ids, options) {
            return localVarFp.deleteOrDismissInBatchDocumentTopic(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentTopic(id, options) {
            return localVarFp.getDocumentTopic(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocumentTopic(term, showDismissed, options) {
            return localVarFp.listDocumentTopic(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDocumentTopic(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageDocumentTopic(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DocumentTopic} documentTopic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDocumentTopic(documentTopic, options) {
            return localVarFp.saveDocumentTopic(documentTopic, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DocumentTopicRestControllerApi - object-oriented interface
 * @export
 * @class DocumentTopicRestControllerApi
 * @extends {BaseAPI}
 */
export class DocumentTopicRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTopicRestControllerApi
     */
    countDocumentTopic(term, showDismissed, options) {
        return DocumentTopicRestControllerApiFp(this.configuration).countDocumentTopic(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTopicRestControllerApi
     */
    deleteOrDismissDocumentTopic(id, options) {
        return DocumentTopicRestControllerApiFp(this.configuration).deleteOrDismissDocumentTopic(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTopicRestControllerApi
     */
    deleteOrDismissInBatchDocumentTopic(ids, options) {
        return DocumentTopicRestControllerApiFp(this.configuration).deleteOrDismissInBatchDocumentTopic(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTopicRestControllerApi
     */
    getDocumentTopic(id, options) {
        return DocumentTopicRestControllerApiFp(this.configuration).getDocumentTopic(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTopicRestControllerApi
     */
    listDocumentTopic(term, showDismissed, options) {
        return DocumentTopicRestControllerApiFp(this.configuration).listDocumentTopic(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTopicRestControllerApi
     */
    pageDocumentTopic(page, size, sort, term, showDismissed, options) {
        return DocumentTopicRestControllerApiFp(this.configuration).pageDocumentTopic(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DocumentTopic} documentTopic
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTopicRestControllerApi
     */
    saveDocumentTopic(documentTopic, options) {
        return DocumentTopicRestControllerApiFp(this.configuration).saveDocumentTopic(documentTopic, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EmpDocumentRestControllerApi - axios parameter creator
 * @export
 */
export const EmpDocumentRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmployeeDocuments: async (options = {}) => {
            const localVarPath = `/api/employee/document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markEmployeeDocumentRead: async (docId, options = {}) => {
            // verify required parameter 'docId' is not null or undefined
            assertParamExists('markEmployeeDocumentRead', 'docId', docId);
            const localVarPath = `/api/employee/document/{docId}/read`
                .replace(`{${"docId"}}`, encodeURIComponent(String(docId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readEmployeeDocuments: async (options = {}) => {
            const localVarPath = `/api/employee/document/read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeDocument: async (docId, options = {}) => {
            // verify required parameter 'docId' is not null or undefined
            assertParamExists('viewEmployeeDocument', 'docId', docId);
            const localVarPath = `/api/employee/document/{docId}`
                .replace(`{${"docId"}}`, encodeURIComponent(String(docId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EmpDocumentRestControllerApi - functional programming interface
 * @export
 */
export const EmpDocumentRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = EmpDocumentRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEmployeeDocuments(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEmployeeDocuments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpDocumentRestControllerApi.listEmployeeDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markEmployeeDocumentRead(docId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markEmployeeDocumentRead(docId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpDocumentRestControllerApi.markEmployeeDocumentRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readEmployeeDocuments(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readEmployeeDocuments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpDocumentRestControllerApi.readEmployeeDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewEmployeeDocument(docId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewEmployeeDocument(docId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpDocumentRestControllerApi.viewEmployeeDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EmpDocumentRestControllerApi - factory interface
 * @export
 */
export const EmpDocumentRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EmpDocumentRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmployeeDocuments(options) {
            return localVarFp.listEmployeeDocuments(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markEmployeeDocumentRead(docId, options) {
            return localVarFp.markEmployeeDocumentRead(docId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readEmployeeDocuments(options) {
            return localVarFp.readEmployeeDocuments(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeDocument(docId, options) {
            return localVarFp.viewEmployeeDocument(docId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EmpDocumentRestControllerApi - object-oriented interface
 * @export
 * @class EmpDocumentRestControllerApi
 * @extends {BaseAPI}
 */
export class EmpDocumentRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpDocumentRestControllerApi
     */
    listEmployeeDocuments(options) {
        return EmpDocumentRestControllerApiFp(this.configuration).listEmployeeDocuments(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpDocumentRestControllerApi
     */
    markEmployeeDocumentRead(docId, options) {
        return EmpDocumentRestControllerApiFp(this.configuration).markEmployeeDocumentRead(docId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpDocumentRestControllerApi
     */
    readEmployeeDocuments(options) {
        return EmpDocumentRestControllerApiFp(this.configuration).readEmployeeDocuments(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpDocumentRestControllerApi
     */
    viewEmployeeDocument(docId, options) {
        return EmpDocumentRestControllerApiFp(this.configuration).viewEmployeeDocument(docId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EmpEvaluationRestControllerApi - axios parameter creator
 * @export
 */
export const EmpEvaluationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluationPoints: async (options = {}) => {
            const localVarPath = `/api/employee/evaluation/points`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPointResults: async (options = {}) => {
            const localVarPath = `/api/employee/evaluation/point-results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEmployeeEvaluation: async (page, size, sort, options = {}) => {
            const localVarPath = `/api/employee/evaluation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Evaluation} evaluation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeEvaluation: async (evaluation, options = {}) => {
            // verify required parameter 'evaluation' is not null or undefined
            assertParamExists('saveEmployeeEvaluation', 'evaluation', evaluation);
            const localVarPath = `/api/employee/evaluation/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(evaluation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EmpEvaluationRestControllerApi - functional programming interface
 * @export
 */
export const EmpEvaluationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = EmpEvaluationRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvaluationPoints(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvaluationPoints(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpEvaluationRestControllerApi.getEvaluationPoints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPointResults(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPointResults(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpEvaluationRestControllerApi.getPointResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageEmployeeEvaluation(page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageEmployeeEvaluation(page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpEvaluationRestControllerApi.pageEmployeeEvaluation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Evaluation} evaluation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEmployeeEvaluation(evaluation, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEmployeeEvaluation(evaluation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpEvaluationRestControllerApi.saveEmployeeEvaluation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EmpEvaluationRestControllerApi - factory interface
 * @export
 */
export const EmpEvaluationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EmpEvaluationRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluationPoints(options) {
            return localVarFp.getEvaluationPoints(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPointResults(options) {
            return localVarFp.getPointResults(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEmployeeEvaluation(page, size, sort, options) {
            return localVarFp.pageEmployeeEvaluation(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Evaluation} evaluation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeEvaluation(evaluation, options) {
            return localVarFp.saveEmployeeEvaluation(evaluation, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EmpEvaluationRestControllerApi - object-oriented interface
 * @export
 * @class EmpEvaluationRestControllerApi
 * @extends {BaseAPI}
 */
export class EmpEvaluationRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpEvaluationRestControllerApi
     */
    getEvaluationPoints(options) {
        return EmpEvaluationRestControllerApiFp(this.configuration).getEvaluationPoints(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpEvaluationRestControllerApi
     */
    getPointResults(options) {
        return EmpEvaluationRestControllerApiFp(this.configuration).getPointResults(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpEvaluationRestControllerApi
     */
    pageEmployeeEvaluation(page, size, sort, options) {
        return EmpEvaluationRestControllerApiFp(this.configuration).pageEmployeeEvaluation(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Evaluation} evaluation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpEvaluationRestControllerApi
     */
    saveEmployeeEvaluation(evaluation, options) {
        return EmpEvaluationRestControllerApiFp(this.configuration).saveEmployeeEvaluation(evaluation, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EmpLearningRestControllerApi - axios parameter creator
 * @export
 */
export const EmpLearningRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} code
         * @param {string} section
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageLearning: async (code, section, options = {}) => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getPageLearning', 'code', code);
            // verify required parameter 'section' is not null or undefined
            assertParamExists('getPageLearning', 'section', section);
            const localVarPath = `/api/employee/learning/wiki/{section}/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"section"}}`, encodeURIComponent(String(section)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EmpLearningRestControllerApi - functional programming interface
 * @export
 */
export const EmpLearningRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = EmpLearningRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} code
         * @param {string} section
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageLearning(code, section, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPageLearning(code, section, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpLearningRestControllerApi.getPageLearning']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EmpLearningRestControllerApi - factory interface
 * @export
 */
export const EmpLearningRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EmpLearningRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} code
         * @param {string} section
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageLearning(code, section, options) {
            return localVarFp.getPageLearning(code, section, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EmpLearningRestControllerApi - object-oriented interface
 * @export
 * @class EmpLearningRestControllerApi
 * @extends {BaseAPI}
 */
export class EmpLearningRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} code
     * @param {string} section
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpLearningRestControllerApi
     */
    getPageLearning(code, section, options) {
        return EmpLearningRestControllerApiFp(this.configuration).getPageLearning(code, section, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EmpManagerRestControllerApi - axios parameter creator
 * @export
 */
export const EmpManagerRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {Array<number>} vacationIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveManagedVacations: async (vacationIds, options = {}) => {
            // verify required parameter 'vacationIds' is not null or undefined
            assertParamExists('approveManagedVacations', 'vacationIds', vacationIds);
            const localVarPath = `/api/employee/manager/vacations/approve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (vacationIds) {
                localVarQueryParameter['vacationIds'] = vacationIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManagedPendingVacations: async (options = {}) => {
            const localVarPath = `/api/employee/manager/vacations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerStats: async (year, options = {}) => {
            const localVarPath = `/api/employee/manager/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EmpManagerRestControllerApi - functional programming interface
 * @export
 */
export const EmpManagerRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = EmpManagerRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {Array<number>} vacationIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveManagedVacations(vacationIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveManagedVacations(vacationIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpManagerRestControllerApi.approveManagedVacations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManagedPendingVacations(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManagedPendingVacations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpManagerRestControllerApi.getManagedPendingVacations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managerStats(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managerStats(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpManagerRestControllerApi.managerStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EmpManagerRestControllerApi - factory interface
 * @export
 */
export const EmpManagerRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EmpManagerRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {Array<number>} vacationIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveManagedVacations(vacationIds, options) {
            return localVarFp.approveManagedVacations(vacationIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManagedPendingVacations(options) {
            return localVarFp.getManagedPendingVacations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerStats(year, options) {
            return localVarFp.managerStats(year, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EmpManagerRestControllerApi - object-oriented interface
 * @export
 * @class EmpManagerRestControllerApi
 * @extends {BaseAPI}
 */
export class EmpManagerRestControllerApi extends BaseAPI {
    /**
     *
     * @param {Array<number>} vacationIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpManagerRestControllerApi
     */
    approveManagedVacations(vacationIds, options) {
        return EmpManagerRestControllerApiFp(this.configuration).approveManagedVacations(vacationIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpManagerRestControllerApi
     */
    getManagedPendingVacations(options) {
        return EmpManagerRestControllerApiFp(this.configuration).getManagedPendingVacations(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [year]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpManagerRestControllerApi
     */
    managerStats(year, options) {
        return EmpManagerRestControllerApiFp(this.configuration).managerStats(year, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EmpOrganizationRestControllerApi - axios parameter creator
 * @export
 */
export const EmpOrganizationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentManagementRoles: async (options = {}) => {
            const localVarPath = `/api/employee/management-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationChart: async (options = {}) => {
            const localVarPath = `/api/employee/organization-chart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EmpOrganizationRestControllerApi - functional programming interface
 * @export
 */
export const EmpOrganizationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = EmpOrganizationRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currentManagementRoles(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currentManagementRoles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpOrganizationRestControllerApi.currentManagementRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationChart(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationChart(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpOrganizationRestControllerApi.organizationChart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EmpOrganizationRestControllerApi - factory interface
 * @export
 */
export const EmpOrganizationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EmpOrganizationRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentManagementRoles(options) {
            return localVarFp.currentManagementRoles(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationChart(options) {
            return localVarFp.organizationChart(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EmpOrganizationRestControllerApi - object-oriented interface
 * @export
 * @class EmpOrganizationRestControllerApi
 * @extends {BaseAPI}
 */
export class EmpOrganizationRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpOrganizationRestControllerApi
     */
    currentManagementRoles(options) {
        return EmpOrganizationRestControllerApiFp(this.configuration).currentManagementRoles(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpOrganizationRestControllerApi
     */
    organizationChart(options) {
        return EmpOrganizationRestControllerApiFp(this.configuration).organizationChart(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EmpStatsRestControllerApi - axios parameter creator
 * @export
 */
export const EmpStatsRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomeStats: async (options = {}) => {
            const localVarPath = `/api/employee/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EmpStatsRestControllerApi - functional programming interface
 * @export
 */
export const EmpStatsRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = EmpStatsRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHomeStats(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHomeStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpStatsRestControllerApi.getHomeStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EmpStatsRestControllerApi - factory interface
 * @export
 */
export const EmpStatsRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EmpStatsRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomeStats(options) {
            return localVarFp.getHomeStats(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EmpStatsRestControllerApi - object-oriented interface
 * @export
 * @class EmpStatsRestControllerApi
 * @extends {BaseAPI}
 */
export class EmpStatsRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpStatsRestControllerApi
     */
    getHomeStats(options) {
        return EmpStatsRestControllerApiFp(this.configuration).getHomeStats(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EmpTimeClockRestControllerApi - axios parameter creator
 * @export
 */
export const EmpTimeClockRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clockIn: async (options = {}) => {
            const localVarPath = `/api/employee/timeclock/in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clockOut: async (options = {}) => {
            const localVarPath = `/api/employee/timeclock/out`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myMonth: async (year, month, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('myMonth', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('myMonth', 'month', month);
            const localVarPath = `/api/employee/timeclock/month`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {TimeClockCorrectionRequest} timeClockCorrectionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proposeCorrection: async (timeClockCorrectionRequest, options = {}) => {
            // verify required parameter 'timeClockCorrectionRequest' is not null or undefined
            assertParamExists('proposeCorrection', 'timeClockCorrectionRequest', timeClockCorrectionRequest);
            const localVarPath = `/api/employee/timeclock/correction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(timeClockCorrectionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statusTimeClock: async (options = {}) => {
            const localVarPath = `/api/employee/timeclock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EmpTimeClockRestControllerApi - functional programming interface
 * @export
 */
export const EmpTimeClockRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = EmpTimeClockRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clockIn(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clockIn(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpTimeClockRestControllerApi.clockIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clockOut(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clockOut(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpTimeClockRestControllerApi.clockOut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async myMonth(year, month, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.myMonth(year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpTimeClockRestControllerApi.myMonth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {TimeClockCorrectionRequest} timeClockCorrectionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proposeCorrection(timeClockCorrectionRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proposeCorrection(timeClockCorrectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpTimeClockRestControllerApi.proposeCorrection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statusTimeClock(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statusTimeClock(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpTimeClockRestControllerApi.statusTimeClock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EmpTimeClockRestControllerApi - factory interface
 * @export
 */
export const EmpTimeClockRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EmpTimeClockRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clockIn(options) {
            return localVarFp.clockIn(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clockOut(options) {
            return localVarFp.clockOut(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myMonth(year, month, options) {
            return localVarFp.myMonth(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TimeClockCorrectionRequest} timeClockCorrectionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proposeCorrection(timeClockCorrectionRequest, options) {
            return localVarFp.proposeCorrection(timeClockCorrectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statusTimeClock(options) {
            return localVarFp.statusTimeClock(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EmpTimeClockRestControllerApi - object-oriented interface
 * @export
 * @class EmpTimeClockRestControllerApi
 * @extends {BaseAPI}
 */
export class EmpTimeClockRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpTimeClockRestControllerApi
     */
    clockIn(options) {
        return EmpTimeClockRestControllerApiFp(this.configuration).clockIn(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpTimeClockRestControllerApi
     */
    clockOut(options) {
        return EmpTimeClockRestControllerApiFp(this.configuration).clockOut(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpTimeClockRestControllerApi
     */
    myMonth(year, month, options) {
        return EmpTimeClockRestControllerApiFp(this.configuration).myMonth(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TimeClockCorrectionRequest} timeClockCorrectionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpTimeClockRestControllerApi
     */
    proposeCorrection(timeClockCorrectionRequest, options) {
        return EmpTimeClockRestControllerApiFp(this.configuration).proposeCorrection(timeClockCorrectionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpTimeClockRestControllerApi
     */
    statusTimeClock(options) {
        return EmpTimeClockRestControllerApiFp(this.configuration).statusTimeClock(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EmpUploadRestControllerApi - axios parameter creator
 * @export
 */
export const EmpUploadRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeUploadTypes: async (options = {}) => {
            const localVarPath = `/api/employee/upload/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {number} [typeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEmployeeUpload: async (page, size, sort, term, typeId, options = {}) => {
            const localVarPath = `/api/employee/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (typeId !== undefined) {
                localVarQueryParameter['typeId'] = typeId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PersonDocument} personDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeUpload: async (personDocument, options = {}) => {
            // verify required parameter 'personDocument' is not null or undefined
            assertParamExists('saveEmployeeUpload', 'personDocument', personDocument);
            const localVarPath = `/api/employee/upload/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(personDocument, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeEstimationHours: async (year, month, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('viewEmployeeEstimationHours', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('viewEmployeeEstimationHours', 'month', month);
            const localVarPath = `/api/employee/upload/estimation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeUpload: async (docId, options = {}) => {
            // verify required parameter 'docId' is not null or undefined
            assertParamExists('viewEmployeeUpload', 'docId', docId);
            const localVarPath = `/api/employee/upload/{docId}`
                .replace(`{${"docId"}}`, encodeURIComponent(String(docId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EmpUploadRestControllerApi - functional programming interface
 * @export
 */
export const EmpUploadRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = EmpUploadRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeUploadTypes(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeUploadTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpUploadRestControllerApi.getEmployeeUploadTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {number} [typeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageEmployeeUpload(page, size, sort, term, typeId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageEmployeeUpload(page, size, sort, term, typeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpUploadRestControllerApi.pageEmployeeUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {PersonDocument} personDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEmployeeUpload(personDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEmployeeUpload(personDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpUploadRestControllerApi.saveEmployeeUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewEmployeeEstimationHours(year, month, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewEmployeeEstimationHours(year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpUploadRestControllerApi.viewEmployeeEstimationHours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewEmployeeUpload(docId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewEmployeeUpload(docId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpUploadRestControllerApi.viewEmployeeUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EmpUploadRestControllerApi - factory interface
 * @export
 */
export const EmpUploadRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EmpUploadRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeUploadTypes(options) {
            return localVarFp.getEmployeeUploadTypes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {number} [typeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEmployeeUpload(page, size, sort, term, typeId, options) {
            return localVarFp.pageEmployeeUpload(page, size, sort, term, typeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersonDocument} personDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeUpload(personDocument, options) {
            return localVarFp.saveEmployeeUpload(personDocument, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeEstimationHours(year, month, options) {
            return localVarFp.viewEmployeeEstimationHours(year, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeUpload(docId, options) {
            return localVarFp.viewEmployeeUpload(docId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EmpUploadRestControllerApi - object-oriented interface
 * @export
 * @class EmpUploadRestControllerApi
 * @extends {BaseAPI}
 */
export class EmpUploadRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpUploadRestControllerApi
     */
    getEmployeeUploadTypes(options) {
        return EmpUploadRestControllerApiFp(this.configuration).getEmployeeUploadTypes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {number} [typeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpUploadRestControllerApi
     */
    pageEmployeeUpload(page, size, sort, term, typeId, options) {
        return EmpUploadRestControllerApiFp(this.configuration).pageEmployeeUpload(page, size, sort, term, typeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersonDocument} personDocument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpUploadRestControllerApi
     */
    saveEmployeeUpload(personDocument, options) {
        return EmpUploadRestControllerApiFp(this.configuration).saveEmployeeUpload(personDocument, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpUploadRestControllerApi
     */
    viewEmployeeEstimationHours(year, month, options) {
        return EmpUploadRestControllerApiFp(this.configuration).viewEmployeeEstimationHours(year, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpUploadRestControllerApi
     */
    viewEmployeeUpload(docId, options) {
        return EmpUploadRestControllerApiFp(this.configuration).viewEmployeeUpload(docId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EmpVacationRestControllerApi - axios parameter creator
 * @export
 */
export const EmpVacationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeVacations: async (options = {}) => {
            const localVarPath = `/api/employee/vacations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {VacationRequest} vacationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newEmployeeVacationRequest: async (vacationRequest, options = {}) => {
            // verify required parameter 'vacationRequest' is not null or undefined
            assertParamExists('newEmployeeVacationRequest', 'vacationRequest', vacationRequest);
            const localVarPath = `/api/employee/vacations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(vacationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EmpVacationRestControllerApi - functional programming interface
 * @export
 */
export const EmpVacationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = EmpVacationRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeVacations(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeVacations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpVacationRestControllerApi.getEmployeeVacations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {VacationRequest} vacationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async newEmployeeVacationRequest(vacationRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.newEmployeeVacationRequest(vacationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpVacationRestControllerApi.newEmployeeVacationRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EmpVacationRestControllerApi - factory interface
 * @export
 */
export const EmpVacationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EmpVacationRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeVacations(options) {
            return localVarFp.getEmployeeVacations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {VacationRequest} vacationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newEmployeeVacationRequest(vacationRequest, options) {
            return localVarFp.newEmployeeVacationRequest(vacationRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EmpVacationRestControllerApi - object-oriented interface
 * @export
 * @class EmpVacationRestControllerApi
 * @extends {BaseAPI}
 */
export class EmpVacationRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpVacationRestControllerApi
     */
    getEmployeeVacations(options) {
        return EmpVacationRestControllerApiFp(this.configuration).getEmployeeVacations(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {VacationRequest} vacationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpVacationRestControllerApi
     */
    newEmployeeVacationRequest(vacationRequest, options) {
        return EmpVacationRestControllerApiFp(this.configuration).newEmployeeVacationRequest(vacationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EmpValidationRestControllerApi - axios parameter creator
 * @export
 */
export const EmpValidationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingValidations: async (options = {}) => {
            const localVarPath = `/api/employee/validations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EmpValidationRestControllerApi - functional programming interface
 * @export
 */
export const EmpValidationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = EmpValidationRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingValidations(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingValidations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpValidationRestControllerApi.getPendingValidations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EmpValidationRestControllerApi - factory interface
 * @export
 */
export const EmpValidationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EmpValidationRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingValidations(options) {
            return localVarFp.getPendingValidations(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EmpValidationRestControllerApi - object-oriented interface
 * @export
 * @class EmpValidationRestControllerApi
 * @extends {BaseAPI}
 */
export class EmpValidationRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpValidationRestControllerApi
     */
    getPendingValidations(options) {
        return EmpValidationRestControllerApiFp(this.configuration).getPendingValidations(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EmpWebPushRestControllerApi - axios parameter creator
 * @export
 */
export const EmpWebPushRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [endpoint]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statusWebPush: async (endpoint, options = {}) => {
            const localVarPath = `/api/employee/push`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (endpoint !== undefined) {
                localVarQueryParameter['endpoint'] = endpoint;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {WebPushSubscriptionRequest} webPushSubscriptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeWebPush: async (webPushSubscriptionRequest, options = {}) => {
            // verify required parameter 'webPushSubscriptionRequest' is not null or undefined
            assertParamExists('subscribeWebPush', 'webPushSubscriptionRequest', webPushSubscriptionRequest);
            const localVarPath = `/api/employee/push/subscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(webPushSubscriptionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testWebPush: async (options = {}) => {
            const localVarPath = `/api/employee/push/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {WebPushSubscriptionRequest} webPushSubscriptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeWebPush: async (webPushSubscriptionRequest, options = {}) => {
            // verify required parameter 'webPushSubscriptionRequest' is not null or undefined
            assertParamExists('unsubscribeWebPush', 'webPushSubscriptionRequest', webPushSubscriptionRequest);
            const localVarPath = `/api/employee/push/unsubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(webPushSubscriptionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EmpWebPushRestControllerApi - functional programming interface
 * @export
 */
export const EmpWebPushRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = EmpWebPushRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [endpoint]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statusWebPush(endpoint, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statusWebPush(endpoint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpWebPushRestControllerApi.statusWebPush']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {WebPushSubscriptionRequest} webPushSubscriptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeWebPush(webPushSubscriptionRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeWebPush(webPushSubscriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpWebPushRestControllerApi.subscribeWebPush']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testWebPush(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testWebPush(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpWebPushRestControllerApi.testWebPush']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {WebPushSubscriptionRequest} webPushSubscriptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeWebPush(webPushSubscriptionRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribeWebPush(webPushSubscriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmpWebPushRestControllerApi.unsubscribeWebPush']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EmpWebPushRestControllerApi - factory interface
 * @export
 */
export const EmpWebPushRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EmpWebPushRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [endpoint]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statusWebPush(endpoint, options) {
            return localVarFp.statusWebPush(endpoint, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebPushSubscriptionRequest} webPushSubscriptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeWebPush(webPushSubscriptionRequest, options) {
            return localVarFp.subscribeWebPush(webPushSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testWebPush(options) {
            return localVarFp.testWebPush(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WebPushSubscriptionRequest} webPushSubscriptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeWebPush(webPushSubscriptionRequest, options) {
            return localVarFp.unsubscribeWebPush(webPushSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EmpWebPushRestControllerApi - object-oriented interface
 * @export
 * @class EmpWebPushRestControllerApi
 * @extends {BaseAPI}
 */
export class EmpWebPushRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [endpoint]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpWebPushRestControllerApi
     */
    statusWebPush(endpoint, options) {
        return EmpWebPushRestControllerApiFp(this.configuration).statusWebPush(endpoint, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WebPushSubscriptionRequest} webPushSubscriptionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpWebPushRestControllerApi
     */
    subscribeWebPush(webPushSubscriptionRequest, options) {
        return EmpWebPushRestControllerApiFp(this.configuration).subscribeWebPush(webPushSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpWebPushRestControllerApi
     */
    testWebPush(options) {
        return EmpWebPushRestControllerApiFp(this.configuration).testWebPush(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WebPushSubscriptionRequest} webPushSubscriptionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmpWebPushRestControllerApi
     */
    unsubscribeWebPush(webPushSubscriptionRequest, options) {
        return EmpWebPushRestControllerApiFp(this.configuration).unsubscribeWebPush(webPushSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EmployeeRestControllerApi - axios parameter creator
 * @export
 */
export const EmployeeRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} centerId
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeBookings: async (centerId, month, options = {}) => {
            // verify required parameter 'centerId' is not null or undefined
            assertParamExists('getEmployeeBookings', 'centerId', centerId);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('getEmployeeBookings', 'month', month);
            const localVarPath = `/api/employee/book`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (centerId !== undefined) {
                localVarQueryParameter['centerId'] = centerId;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeDirectory: async (options = {}) => {
            const localVarPath = `/api/employee/directory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeHolidays: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getEmployeeHolidays', 'year', year);
            const localVarPath = `/api/employee/holiday`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeOwnHolidays: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getEmployeeOwnHolidays', 'year', year);
            const localVarPath = `/api/employee/holiday/mine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeePayrolls: async (page, size, sort, options = {}) => {
            const localVarPath = `/api/employee/payroll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeReminders: async (options = {}) => {
            const localVarPath = `/api/employee/reminders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeTrainingLevels: async (options = {}) => {
            const localVarPath = `/api/employee/training-levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeWorkCenters: async (options = {}) => {
            const localVarPath = `/api/employee/work-centers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastEvaluationDays: async (options = {}) => {
            const localVarPath = `/api/employee/lastEvaluationDays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} centerId
         * @param {string} date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeBooking: async (centerId, date, options = {}) => {
            // verify required parameter 'centerId' is not null or undefined
            assertParamExists('saveEmployeeBooking', 'centerId', centerId);
            // verify required parameter 'date' is not null or undefined
            assertParamExists('saveEmployeeBooking', 'date', date);
            const localVarPath = `/api/employee/book`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (centerId !== undefined) {
                localVarQueryParameter['centerId'] = centerId;
            }
            if (date !== undefined) {
                localVarQueryParameter['date'] = (date instanceof Date) ?
                    date.toISOString().substring(0, 10) :
                    date;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {EmployeeData} employeeData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeInfo: async (employeeData, options = {}) => {
            // verify required parameter 'employeeData' is not null or undefined
            assertParamExists('updateEmployeeInfo', 'employeeData', employeeData);
            const localVarPath = `/api/employee/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(employeeData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PersonLogData} personLogData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogData: async (personLogData, options = {}) => {
            // verify required parameter 'personLogData' is not null or undefined
            assertParamExists('uploadLogData', 'personLogData', personLogData);
            const localVarPath = `/api/employee/uploadLogData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(personLogData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeInfo: async (options = {}) => {
            const localVarPath = `/api/employee/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} payrollId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeePayroll: async (payrollId, options = {}) => {
            // verify required parameter 'payrollId' is not null or undefined
            assertParamExists('viewEmployeePayroll', 'payrollId', payrollId);
            const localVarPath = `/api/employee/payroll/{payrollId}`
                .replace(`{${"payrollId"}}`, encodeURIComponent(String(payrollId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} personId
         * @param {number} [width]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeePhoto: async (personId, width, options = {}) => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('viewEmployeePhoto', 'personId', personId);
            const localVarPath = `/api/employee/photo/{personId}`
                .replace(`{${"personId"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (width !== undefined) {
                localVarQueryParameter['width'] = width;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EmployeeRestControllerApi - functional programming interface
 * @export
 */
export const EmployeeRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = EmployeeRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} centerId
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeBookings(centerId, month, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeBookings(centerId, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeRestControllerApi.getEmployeeBookings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeDirectory(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeDirectory(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeRestControllerApi.getEmployeeDirectory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeHolidays(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeHolidays(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeRestControllerApi.getEmployeeHolidays']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeOwnHolidays(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeOwnHolidays(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeRestControllerApi.getEmployeeOwnHolidays']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeePayrolls(page, size, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeePayrolls(page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeRestControllerApi.getEmployeePayrolls']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeReminders(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeReminders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeRestControllerApi.getEmployeeReminders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeTrainingLevels(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeTrainingLevels(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeRestControllerApi.getEmployeeTrainingLevels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeWorkCenters(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeWorkCenters(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeRestControllerApi.getEmployeeWorkCenters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLastEvaluationDays(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLastEvaluationDays(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeRestControllerApi.getLastEvaluationDays']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} centerId
         * @param {string} date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEmployeeBooking(centerId, date, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEmployeeBooking(centerId, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeRestControllerApi.saveEmployeeBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {EmployeeData} employeeData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmployeeInfo(employeeData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmployeeInfo(employeeData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeRestControllerApi.updateEmployeeInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {PersonLogData} personLogData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadLogData(personLogData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadLogData(personLogData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeRestControllerApi.uploadLogData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewEmployeeInfo(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewEmployeeInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeRestControllerApi.viewEmployeeInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} payrollId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewEmployeePayroll(payrollId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewEmployeePayroll(payrollId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeRestControllerApi.viewEmployeePayroll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} personId
         * @param {number} [width]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewEmployeePhoto(personId, width, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewEmployeePhoto(personId, width, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeRestControllerApi.viewEmployeePhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EmployeeRestControllerApi - factory interface
 * @export
 */
export const EmployeeRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EmployeeRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} centerId
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeBookings(centerId, month, options) {
            return localVarFp.getEmployeeBookings(centerId, month, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeDirectory(options) {
            return localVarFp.getEmployeeDirectory(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeHolidays(year, options) {
            return localVarFp.getEmployeeHolidays(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeOwnHolidays(year, options) {
            return localVarFp.getEmployeeOwnHolidays(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeePayrolls(page, size, sort, options) {
            return localVarFp.getEmployeePayrolls(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeReminders(options) {
            return localVarFp.getEmployeeReminders(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeTrainingLevels(options) {
            return localVarFp.getEmployeeTrainingLevels(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeWorkCenters(options) {
            return localVarFp.getEmployeeWorkCenters(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastEvaluationDays(options) {
            return localVarFp.getLastEvaluationDays(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} centerId
         * @param {string} date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeBooking(centerId, date, options) {
            return localVarFp.saveEmployeeBooking(centerId, date, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EmployeeData} employeeData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeInfo(employeeData, options) {
            return localVarFp.updateEmployeeInfo(employeeData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersonLogData} personLogData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogData(personLogData, options) {
            return localVarFp.uploadLogData(personLogData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeeInfo(options) {
            return localVarFp.viewEmployeeInfo(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} payrollId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeePayroll(payrollId, options) {
            return localVarFp.viewEmployeePayroll(payrollId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {number} [width]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewEmployeePhoto(personId, width, options) {
            return localVarFp.viewEmployeePhoto(personId, width, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EmployeeRestControllerApi - object-oriented interface
 * @export
 * @class EmployeeRestControllerApi
 * @extends {BaseAPI}
 */
export class EmployeeRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} centerId
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    getEmployeeBookings(centerId, month, options) {
        return EmployeeRestControllerApiFp(this.configuration).getEmployeeBookings(centerId, month, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    getEmployeeDirectory(options) {
        return EmployeeRestControllerApiFp(this.configuration).getEmployeeDirectory(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    getEmployeeHolidays(year, options) {
        return EmployeeRestControllerApiFp(this.configuration).getEmployeeHolidays(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    getEmployeeOwnHolidays(year, options) {
        return EmployeeRestControllerApiFp(this.configuration).getEmployeeOwnHolidays(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    getEmployeePayrolls(page, size, sort, options) {
        return EmployeeRestControllerApiFp(this.configuration).getEmployeePayrolls(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    getEmployeeReminders(options) {
        return EmployeeRestControllerApiFp(this.configuration).getEmployeeReminders(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    getEmployeeTrainingLevels(options) {
        return EmployeeRestControllerApiFp(this.configuration).getEmployeeTrainingLevels(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    getEmployeeWorkCenters(options) {
        return EmployeeRestControllerApiFp(this.configuration).getEmployeeWorkCenters(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    getLastEvaluationDays(options) {
        return EmployeeRestControllerApiFp(this.configuration).getLastEvaluationDays(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} centerId
     * @param {string} date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    saveEmployeeBooking(centerId, date, options) {
        return EmployeeRestControllerApiFp(this.configuration).saveEmployeeBooking(centerId, date, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EmployeeData} employeeData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    updateEmployeeInfo(employeeData, options) {
        return EmployeeRestControllerApiFp(this.configuration).updateEmployeeInfo(employeeData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersonLogData} personLogData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    uploadLogData(personLogData, options) {
        return EmployeeRestControllerApiFp(this.configuration).uploadLogData(personLogData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    viewEmployeeInfo(options) {
        return EmployeeRestControllerApiFp(this.configuration).viewEmployeeInfo(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} payrollId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    viewEmployeePayroll(payrollId, options) {
        return EmployeeRestControllerApiFp(this.configuration).viewEmployeePayroll(payrollId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {number} [width]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeRestControllerApi
     */
    viewEmployeePhoto(personId, width, options) {
        return EmployeeRestControllerApiFp(this.configuration).viewEmployeePhoto(personId, width, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EmployeeStatsRestControllerApi - axios parameter creator
 * @export
 */
export const EmployeeStatsRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [date]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkNotifications: async (date, options = {}) => {
            const localVarPath = `/api/admin/employee/stats/month-notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (date !== undefined) {
                localVarQueryParameter['date'] = (date instanceof Date) ?
                    date.toISOString().substring(0, 10) :
                    date;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeStats: async (options = {}) => {
            const localVarPath = `/api/admin/employee/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EmployeeStatsRestControllerApi - functional programming interface
 * @export
 */
export const EmployeeStatsRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = EmployeeStatsRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [date]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkNotifications(date, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkNotifications(date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeStatsRestControllerApi.checkNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeStats(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeStatsRestControllerApi.getEmployeeStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EmployeeStatsRestControllerApi - factory interface
 * @export
 */
export const EmployeeStatsRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EmployeeStatsRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [date]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkNotifications(date, options) {
            return localVarFp.checkNotifications(date, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeStats(options) {
            return localVarFp.getEmployeeStats(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EmployeeStatsRestControllerApi - object-oriented interface
 * @export
 * @class EmployeeStatsRestControllerApi
 * @extends {BaseAPI}
 */
export class EmployeeStatsRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [date]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeStatsRestControllerApi
     */
    checkNotifications(date, options) {
        return EmployeeStatsRestControllerApiFp(this.configuration).checkNotifications(date, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeStatsRestControllerApi
     */
    getEmployeeStats(options) {
        return EmployeeStatsRestControllerApiFp(this.configuration).getEmployeeStats(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EvaluationPointRestControllerApi - axios parameter creator
 * @export
 */
export const EvaluationPointRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEvaluationPoint: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/evaluation/question/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissEvaluationPoint: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissEvaluationPoint', 'id', id);
            const localVarPath = `/api/admin/employee/evaluation/question/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchEvaluationPoint: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchEvaluationPoint', 'ids', ids);
            const localVarPath = `/api/admin/employee/evaluation/question/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluationPoint: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEvaluationPoint', 'id', id);
            const localVarPath = `/api/admin/employee/evaluation/question/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvaluationPoint: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/evaluation/question/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEvaluationPoint: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/evaluation/question/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {EvaluationPoint} evaluationPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvaluationPoint: async (evaluationPoint, options = {}) => {
            // verify required parameter 'evaluationPoint' is not null or undefined
            assertParamExists('saveEvaluationPoint', 'evaluationPoint', evaluationPoint);
            const localVarPath = `/api/admin/employee/evaluation/question/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(evaluationPoint, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EvaluationPointRestControllerApi - functional programming interface
 * @export
 */
export const EvaluationPointRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = EvaluationPointRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countEvaluationPoint(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countEvaluationPoint(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationPointRestControllerApi.countEvaluationPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissEvaluationPoint(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissEvaluationPoint(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationPointRestControllerApi.deleteOrDismissEvaluationPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchEvaluationPoint(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchEvaluationPoint(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationPointRestControllerApi.deleteOrDismissInBatchEvaluationPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvaluationPoint(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvaluationPoint(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationPointRestControllerApi.getEvaluationPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEvaluationPoint(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEvaluationPoint(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationPointRestControllerApi.listEvaluationPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageEvaluationPoint(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageEvaluationPoint(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationPointRestControllerApi.pageEvaluationPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {EvaluationPoint} evaluationPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEvaluationPoint(evaluationPoint, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEvaluationPoint(evaluationPoint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationPointRestControllerApi.saveEvaluationPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EvaluationPointRestControllerApi - factory interface
 * @export
 */
export const EvaluationPointRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EvaluationPointRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEvaluationPoint(term, showDismissed, options) {
            return localVarFp.countEvaluationPoint(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissEvaluationPoint(id, options) {
            return localVarFp.deleteOrDismissEvaluationPoint(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchEvaluationPoint(ids, options) {
            return localVarFp.deleteOrDismissInBatchEvaluationPoint(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluationPoint(id, options) {
            return localVarFp.getEvaluationPoint(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvaluationPoint(term, showDismissed, options) {
            return localVarFp.listEvaluationPoint(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEvaluationPoint(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageEvaluationPoint(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EvaluationPoint} evaluationPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvaluationPoint(evaluationPoint, options) {
            return localVarFp.saveEvaluationPoint(evaluationPoint, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EvaluationPointRestControllerApi - object-oriented interface
 * @export
 * @class EvaluationPointRestControllerApi
 * @extends {BaseAPI}
 */
export class EvaluationPointRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationPointRestControllerApi
     */
    countEvaluationPoint(term, showDismissed, options) {
        return EvaluationPointRestControllerApiFp(this.configuration).countEvaluationPoint(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationPointRestControllerApi
     */
    deleteOrDismissEvaluationPoint(id, options) {
        return EvaluationPointRestControllerApiFp(this.configuration).deleteOrDismissEvaluationPoint(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationPointRestControllerApi
     */
    deleteOrDismissInBatchEvaluationPoint(ids, options) {
        return EvaluationPointRestControllerApiFp(this.configuration).deleteOrDismissInBatchEvaluationPoint(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationPointRestControllerApi
     */
    getEvaluationPoint(id, options) {
        return EvaluationPointRestControllerApiFp(this.configuration).getEvaluationPoint(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationPointRestControllerApi
     */
    listEvaluationPoint(term, showDismissed, options) {
        return EvaluationPointRestControllerApiFp(this.configuration).listEvaluationPoint(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationPointRestControllerApi
     */
    pageEvaluationPoint(page, size, sort, term, showDismissed, options) {
        return EvaluationPointRestControllerApiFp(this.configuration).pageEvaluationPoint(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EvaluationPoint} evaluationPoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationPointRestControllerApi
     */
    saveEvaluationPoint(evaluationPoint, options) {
        return EvaluationPointRestControllerApiFp(this.configuration).saveEvaluationPoint(evaluationPoint, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EvaluationRestControllerApi - axios parameter creator
 * @export
 */
export const EvaluationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEvaluation: async (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/evaluation/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissEvaluation: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissEvaluation', 'id', id);
            const localVarPath = `/api/admin/employee/evaluation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchEvaluation: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchEvaluation', 'ids', ids);
            const localVarPath = `/api/admin/employee/evaluation/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluation: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEvaluation', 'id', id);
            const localVarPath = `/api/admin/employee/evaluation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvaluation: async (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/evaluation/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEvaluation: async (page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/evaluation/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Evaluation} evaluation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvaluation: async (evaluation, options = {}) => {
            // verify required parameter 'evaluation' is not null or undefined
            assertParamExists('saveEvaluation', 'evaluation', evaluation);
            const localVarPath = `/api/admin/employee/evaluation/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(evaluation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EvaluationRestControllerApi - functional programming interface
 * @export
 */
export const EvaluationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = EvaluationRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationRestControllerApi.countEvaluation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissEvaluation(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissEvaluation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationRestControllerApi.deleteOrDismissEvaluation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchEvaluation(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchEvaluation(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationRestControllerApi.deleteOrDismissInBatchEvaluation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvaluation(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvaluation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationRestControllerApi.getEvaluation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationRestControllerApi.listEvaluation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageEvaluation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageEvaluation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationRestControllerApi.pageEvaluation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Evaluation} evaluation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEvaluation(evaluation, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEvaluation(evaluation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationRestControllerApi.saveEvaluation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EvaluationRestControllerApi - factory interface
 * @export
 */
export const EvaluationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EvaluationRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissEvaluation(id, options) {
            return localVarFp.deleteOrDismissEvaluation(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchEvaluation(ids, options) {
            return localVarFp.deleteOrDismissInBatchEvaluation(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluation(id, options) {
            return localVarFp.getEvaluation(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEvaluation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pageEvaluation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Evaluation} evaluation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvaluation(evaluation, options) {
            return localVarFp.saveEvaluation(evaluation, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EvaluationRestControllerApi - object-oriented interface
 * @export
 * @class EvaluationRestControllerApi
 * @extends {BaseAPI}
 */
export class EvaluationRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationRestControllerApi
     */
    countEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return EvaluationRestControllerApiFp(this.configuration).countEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationRestControllerApi
     */
    deleteOrDismissEvaluation(id, options) {
        return EvaluationRestControllerApiFp(this.configuration).deleteOrDismissEvaluation(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationRestControllerApi
     */
    deleteOrDismissInBatchEvaluation(ids, options) {
        return EvaluationRestControllerApiFp(this.configuration).deleteOrDismissInBatchEvaluation(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationRestControllerApi
     */
    getEvaluation(id, options) {
        return EvaluationRestControllerApiFp(this.configuration).getEvaluation(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationRestControllerApi
     */
    listEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return EvaluationRestControllerApiFp(this.configuration).listEvaluation(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationRestControllerApi
     */
    pageEvaluation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return EvaluationRestControllerApiFp(this.configuration).pageEvaluation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Evaluation} evaluation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationRestControllerApi
     */
    saveEvaluation(evaluation, options) {
        return EvaluationRestControllerApiFp(this.configuration).saveEvaluation(evaluation, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EvaluationResultRestControllerApi - axios parameter creator
 * @export
 */
export const EvaluationResultRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEvaluationResult: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/evaluation/question/result/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissEvaluationResult: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissEvaluationResult', 'id', id);
            const localVarPath = `/api/admin/employee/evaluation/question/result/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchEvaluationResult: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchEvaluationResult', 'ids', ids);
            const localVarPath = `/api/admin/employee/evaluation/question/result/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluationResult: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEvaluationResult', 'id', id);
            const localVarPath = `/api/admin/employee/evaluation/question/result/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvaluationResult: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/evaluation/question/result/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEvaluationResult: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/evaluation/question/result/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {EvaluationResult} evaluationResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvaluationResult: async (evaluationResult, options = {}) => {
            // verify required parameter 'evaluationResult' is not null or undefined
            assertParamExists('saveEvaluationResult', 'evaluationResult', evaluationResult);
            const localVarPath = `/api/admin/employee/evaluation/question/result/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(evaluationResult, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EvaluationResultRestControllerApi - functional programming interface
 * @export
 */
export const EvaluationResultRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = EvaluationResultRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countEvaluationResult(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countEvaluationResult(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationResultRestControllerApi.countEvaluationResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissEvaluationResult(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissEvaluationResult(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationResultRestControllerApi.deleteOrDismissEvaluationResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchEvaluationResult(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchEvaluationResult(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationResultRestControllerApi.deleteOrDismissInBatchEvaluationResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvaluationResult(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvaluationResult(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationResultRestControllerApi.getEvaluationResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEvaluationResult(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEvaluationResult(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationResultRestControllerApi.listEvaluationResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageEvaluationResult(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageEvaluationResult(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationResultRestControllerApi.pageEvaluationResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {EvaluationResult} evaluationResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEvaluationResult(evaluationResult, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEvaluationResult(evaluationResult, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationResultRestControllerApi.saveEvaluationResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EvaluationResultRestControllerApi - factory interface
 * @export
 */
export const EvaluationResultRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EvaluationResultRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEvaluationResult(term, showDismissed, options) {
            return localVarFp.countEvaluationResult(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissEvaluationResult(id, options) {
            return localVarFp.deleteOrDismissEvaluationResult(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchEvaluationResult(ids, options) {
            return localVarFp.deleteOrDismissInBatchEvaluationResult(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluationResult(id, options) {
            return localVarFp.getEvaluationResult(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvaluationResult(term, showDismissed, options) {
            return localVarFp.listEvaluationResult(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageEvaluationResult(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageEvaluationResult(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EvaluationResult} evaluationResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvaluationResult(evaluationResult, options) {
            return localVarFp.saveEvaluationResult(evaluationResult, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EvaluationResultRestControllerApi - object-oriented interface
 * @export
 * @class EvaluationResultRestControllerApi
 * @extends {BaseAPI}
 */
export class EvaluationResultRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationResultRestControllerApi
     */
    countEvaluationResult(term, showDismissed, options) {
        return EvaluationResultRestControllerApiFp(this.configuration).countEvaluationResult(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationResultRestControllerApi
     */
    deleteOrDismissEvaluationResult(id, options) {
        return EvaluationResultRestControllerApiFp(this.configuration).deleteOrDismissEvaluationResult(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationResultRestControllerApi
     */
    deleteOrDismissInBatchEvaluationResult(ids, options) {
        return EvaluationResultRestControllerApiFp(this.configuration).deleteOrDismissInBatchEvaluationResult(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationResultRestControllerApi
     */
    getEvaluationResult(id, options) {
        return EvaluationResultRestControllerApiFp(this.configuration).getEvaluationResult(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationResultRestControllerApi
     */
    listEvaluationResult(term, showDismissed, options) {
        return EvaluationResultRestControllerApiFp(this.configuration).listEvaluationResult(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationResultRestControllerApi
     */
    pageEvaluationResult(page, size, sort, term, showDismissed, options) {
        return EvaluationResultRestControllerApiFp(this.configuration).pageEvaluationResult(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EvaluationResult} evaluationResult
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationResultRestControllerApi
     */
    saveEvaluationResult(evaluationResult, options) {
        return EvaluationResultRestControllerApiFp(this.configuration).saveEvaluationResult(evaluationResult, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FaceAdminCenterRestControllerApi - axios parameter creator
 * @export
 */
export const FaceAdminCenterRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countFaceAdminCenter: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/face-admin-center/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissFaceAdminCenter: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissFaceAdminCenter', 'id', id);
            const localVarPath = `/api/admin/billing/face-admin-center/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchFaceAdminCenter: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchFaceAdminCenter', 'ids', ids);
            const localVarPath = `/api/admin/billing/face-admin-center/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaceAdminCenter: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFaceAdminCenter', 'id', id);
            const localVarPath = `/api/admin/billing/face-admin-center/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFaceAdminCenter: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/face-admin-center/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageFaceAdminCenter: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/face-admin-center/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {FaceAdminCenter} faceAdminCenter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFaceAdminCenter: async (faceAdminCenter, options = {}) => {
            // verify required parameter 'faceAdminCenter' is not null or undefined
            assertParamExists('saveFaceAdminCenter', 'faceAdminCenter', faceAdminCenter);
            const localVarPath = `/api/admin/billing/face-admin-center/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(faceAdminCenter, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FaceAdminCenterRestControllerApi - functional programming interface
 * @export
 */
export const FaceAdminCenterRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = FaceAdminCenterRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countFaceAdminCenter(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countFaceAdminCenter(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FaceAdminCenterRestControllerApi.countFaceAdminCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissFaceAdminCenter(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissFaceAdminCenter(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FaceAdminCenterRestControllerApi.deleteOrDismissFaceAdminCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchFaceAdminCenter(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchFaceAdminCenter(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FaceAdminCenterRestControllerApi.deleteOrDismissInBatchFaceAdminCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFaceAdminCenter(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFaceAdminCenter(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FaceAdminCenterRestControllerApi.getFaceAdminCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFaceAdminCenter(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFaceAdminCenter(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FaceAdminCenterRestControllerApi.listFaceAdminCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageFaceAdminCenter(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageFaceAdminCenter(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FaceAdminCenterRestControllerApi.pageFaceAdminCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {FaceAdminCenter} faceAdminCenter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveFaceAdminCenter(faceAdminCenter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveFaceAdminCenter(faceAdminCenter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FaceAdminCenterRestControllerApi.saveFaceAdminCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * FaceAdminCenterRestControllerApi - factory interface
 * @export
 */
export const FaceAdminCenterRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FaceAdminCenterRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countFaceAdminCenter(term, showDismissed, options) {
            return localVarFp.countFaceAdminCenter(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissFaceAdminCenter(id, options) {
            return localVarFp.deleteOrDismissFaceAdminCenter(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchFaceAdminCenter(ids, options) {
            return localVarFp.deleteOrDismissInBatchFaceAdminCenter(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaceAdminCenter(id, options) {
            return localVarFp.getFaceAdminCenter(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFaceAdminCenter(term, showDismissed, options) {
            return localVarFp.listFaceAdminCenter(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageFaceAdminCenter(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageFaceAdminCenter(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {FaceAdminCenter} faceAdminCenter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFaceAdminCenter(faceAdminCenter, options) {
            return localVarFp.saveFaceAdminCenter(faceAdminCenter, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FaceAdminCenterRestControllerApi - object-oriented interface
 * @export
 * @class FaceAdminCenterRestControllerApi
 * @extends {BaseAPI}
 */
export class FaceAdminCenterRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaceAdminCenterRestControllerApi
     */
    countFaceAdminCenter(term, showDismissed, options) {
        return FaceAdminCenterRestControllerApiFp(this.configuration).countFaceAdminCenter(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaceAdminCenterRestControllerApi
     */
    deleteOrDismissFaceAdminCenter(id, options) {
        return FaceAdminCenterRestControllerApiFp(this.configuration).deleteOrDismissFaceAdminCenter(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaceAdminCenterRestControllerApi
     */
    deleteOrDismissInBatchFaceAdminCenter(ids, options) {
        return FaceAdminCenterRestControllerApiFp(this.configuration).deleteOrDismissInBatchFaceAdminCenter(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaceAdminCenterRestControllerApi
     */
    getFaceAdminCenter(id, options) {
        return FaceAdminCenterRestControllerApiFp(this.configuration).getFaceAdminCenter(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaceAdminCenterRestControllerApi
     */
    listFaceAdminCenter(term, showDismissed, options) {
        return FaceAdminCenterRestControllerApiFp(this.configuration).listFaceAdminCenter(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaceAdminCenterRestControllerApi
     */
    pageFaceAdminCenter(page, size, sort, term, showDismissed, options) {
        return FaceAdminCenterRestControllerApiFp(this.configuration).pageFaceAdminCenter(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {FaceAdminCenter} faceAdminCenter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaceAdminCenterRestControllerApi
     */
    saveFaceAdminCenter(faceAdminCenter, options) {
        return FaceAdminCenterRestControllerApiFp(this.configuration).saveFaceAdminCenter(faceAdminCenter, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FeedbackRestControllerApi - axios parameter creator
 * @export
 */
export const FeedbackRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {FeedbackRequest} feedbackRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFeedback: async (feedbackRequest, options = {}) => {
            // verify required parameter 'feedbackRequest' is not null or undefined
            assertParamExists('sendFeedback', 'feedbackRequest', feedbackRequest);
            const localVarPath = `/api/user/feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(feedbackRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FeedbackRestControllerApi - functional programming interface
 * @export
 */
export const FeedbackRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = FeedbackRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {FeedbackRequest} feedbackRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendFeedback(feedbackRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendFeedback(feedbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeedbackRestControllerApi.sendFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * FeedbackRestControllerApi - factory interface
 * @export
 */
export const FeedbackRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FeedbackRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {FeedbackRequest} feedbackRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFeedback(feedbackRequest, options) {
            return localVarFp.sendFeedback(feedbackRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FeedbackRestControllerApi - object-oriented interface
 * @export
 * @class FeedbackRestControllerApi
 * @extends {BaseAPI}
 */
export class FeedbackRestControllerApi extends BaseAPI {
    /**
     *
     * @param {FeedbackRequest} feedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedbackRestControllerApi
     */
    sendFeedback(feedbackRequest, options) {
        return FeedbackRestControllerApiFp(this.configuration).sendFeedback(feedbackRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FixedAssetRestControllerApi - axios parameter creator
 * @export
 */
export const FixedAssetRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CountFixedAssetStatusEnum} [status]
         * @param {CountFixedAssetAmortizationMethodEnum} [amortizationMethod]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countFixedAsset: async (status, amortizationMethod, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/fixed-asset/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (amortizationMethod !== undefined) {
                localVarQueryParameter['amortizationMethod'] = amortizationMethod;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissFixedAsset: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissFixedAsset', 'id', id);
            const localVarPath = `/api/admin/accounting/fixed-asset/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchFixedAsset: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchFixedAsset', 'ids', ids);
            const localVarPath = `/api/admin/accounting/fixed-asset/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFixedAsset: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFixedAsset', 'id', id);
            const localVarPath = `/api/admin/accounting/fixed-asset/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ListFixedAssetStatusEnum} [status]
         * @param {ListFixedAssetAmortizationMethodEnum} [amortizationMethod]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFixedAsset: async (status, amortizationMethod, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/fixed-asset/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (amortizationMethod !== undefined) {
                localVarQueryParameter['amortizationMethod'] = amortizationMethod;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageFixedAssetStatusEnum} [status]
         * @param {PageFixedAssetAmortizationMethodEnum} [amortizationMethod]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageFixedAsset: async (page, size, sort, status, amortizationMethod, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/fixed-asset/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (amortizationMethod !== undefined) {
                localVarQueryParameter['amortizationMethod'] = amortizationMethod;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {FixedAsset} fixedAsset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFixedAsset: async (fixedAsset, options = {}) => {
            // verify required parameter 'fixedAsset' is not null or undefined
            assertParamExists('saveFixedAsset', 'fixedAsset', fixedAsset);
            const localVarPath = `/api/admin/accounting/fixed-asset/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(fixedAsset, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleFixedAsset: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('scheduleFixedAsset', 'id', id);
            const localVarPath = `/api/admin/accounting/fixed-asset/{id}/schedule`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FixedAssetRestControllerApi - functional programming interface
 * @export
 */
export const FixedAssetRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = FixedAssetRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CountFixedAssetStatusEnum} [status]
         * @param {CountFixedAssetAmortizationMethodEnum} [amortizationMethod]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countFixedAsset(status, amortizationMethod, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countFixedAsset(status, amortizationMethod, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FixedAssetRestControllerApi.countFixedAsset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissFixedAsset(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissFixedAsset(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FixedAssetRestControllerApi.deleteOrDismissFixedAsset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchFixedAsset(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchFixedAsset(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FixedAssetRestControllerApi.deleteOrDismissInBatchFixedAsset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFixedAsset(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFixedAsset(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FixedAssetRestControllerApi.getFixedAsset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ListFixedAssetStatusEnum} [status]
         * @param {ListFixedAssetAmortizationMethodEnum} [amortizationMethod]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFixedAsset(status, amortizationMethod, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFixedAsset(status, amortizationMethod, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FixedAssetRestControllerApi.listFixedAsset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageFixedAssetStatusEnum} [status]
         * @param {PageFixedAssetAmortizationMethodEnum} [amortizationMethod]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageFixedAsset(page, size, sort, status, amortizationMethod, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageFixedAsset(page, size, sort, status, amortizationMethod, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FixedAssetRestControllerApi.pageFixedAsset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {FixedAsset} fixedAsset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveFixedAsset(fixedAsset, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveFixedAsset(fixedAsset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FixedAssetRestControllerApi.saveFixedAsset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleFixedAsset(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleFixedAsset(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FixedAssetRestControllerApi.scheduleFixedAsset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * FixedAssetRestControllerApi - factory interface
 * @export
 */
export const FixedAssetRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FixedAssetRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {CountFixedAssetStatusEnum} [status]
         * @param {CountFixedAssetAmortizationMethodEnum} [amortizationMethod]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countFixedAsset(status, amortizationMethod, term, showDismissed, options) {
            return localVarFp.countFixedAsset(status, amortizationMethod, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissFixedAsset(id, options) {
            return localVarFp.deleteOrDismissFixedAsset(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchFixedAsset(ids, options) {
            return localVarFp.deleteOrDismissInBatchFixedAsset(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFixedAsset(id, options) {
            return localVarFp.getFixedAsset(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ListFixedAssetStatusEnum} [status]
         * @param {ListFixedAssetAmortizationMethodEnum} [amortizationMethod]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFixedAsset(status, amortizationMethod, term, showDismissed, options) {
            return localVarFp.listFixedAsset(status, amortizationMethod, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageFixedAssetStatusEnum} [status]
         * @param {PageFixedAssetAmortizationMethodEnum} [amortizationMethod]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageFixedAsset(page, size, sort, status, amortizationMethod, term, showDismissed, options) {
            return localVarFp.pageFixedAsset(page, size, sort, status, amortizationMethod, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {FixedAsset} fixedAsset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFixedAsset(fixedAsset, options) {
            return localVarFp.saveFixedAsset(fixedAsset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleFixedAsset(id, options) {
            return localVarFp.scheduleFixedAsset(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FixedAssetRestControllerApi - object-oriented interface
 * @export
 * @class FixedAssetRestControllerApi
 * @extends {BaseAPI}
 */
export class FixedAssetRestControllerApi extends BaseAPI {
    /**
     *
     * @param {CountFixedAssetStatusEnum} [status]
     * @param {CountFixedAssetAmortizationMethodEnum} [amortizationMethod]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixedAssetRestControllerApi
     */
    countFixedAsset(status, amortizationMethod, term, showDismissed, options) {
        return FixedAssetRestControllerApiFp(this.configuration).countFixedAsset(status, amortizationMethod, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixedAssetRestControllerApi
     */
    deleteOrDismissFixedAsset(id, options) {
        return FixedAssetRestControllerApiFp(this.configuration).deleteOrDismissFixedAsset(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixedAssetRestControllerApi
     */
    deleteOrDismissInBatchFixedAsset(ids, options) {
        return FixedAssetRestControllerApiFp(this.configuration).deleteOrDismissInBatchFixedAsset(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixedAssetRestControllerApi
     */
    getFixedAsset(id, options) {
        return FixedAssetRestControllerApiFp(this.configuration).getFixedAsset(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ListFixedAssetStatusEnum} [status]
     * @param {ListFixedAssetAmortizationMethodEnum} [amortizationMethod]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixedAssetRestControllerApi
     */
    listFixedAsset(status, amortizationMethod, term, showDismissed, options) {
        return FixedAssetRestControllerApiFp(this.configuration).listFixedAsset(status, amortizationMethod, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {PageFixedAssetStatusEnum} [status]
     * @param {PageFixedAssetAmortizationMethodEnum} [amortizationMethod]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixedAssetRestControllerApi
     */
    pageFixedAsset(page, size, sort, status, amortizationMethod, term, showDismissed, options) {
        return FixedAssetRestControllerApiFp(this.configuration).pageFixedAsset(page, size, sort, status, amortizationMethod, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {FixedAsset} fixedAsset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixedAssetRestControllerApi
     */
    saveFixedAsset(fixedAsset, options) {
        return FixedAssetRestControllerApiFp(this.configuration).saveFixedAsset(fixedAsset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixedAssetRestControllerApi
     */
    scheduleFixedAsset(id, options) {
        return FixedAssetRestControllerApiFp(this.configuration).scheduleFixedAsset(id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountFixedAssetStatusEnum = {
    ACTIVO: 'ACTIVO',
    AMORTIZADO: 'AMORTIZADO',
    DADO_DE_BAJA: 'DADO_DE_BAJA'
};
/**
 * @export
 */
export const CountFixedAssetAmortizationMethodEnum = {
    LINEAL: 'LINEAL',
    DEGRESIVO: 'DEGRESIVO'
};
/**
 * @export
 */
export const ListFixedAssetStatusEnum = {
    ACTIVO: 'ACTIVO',
    AMORTIZADO: 'AMORTIZADO',
    DADO_DE_BAJA: 'DADO_DE_BAJA'
};
/**
 * @export
 */
export const ListFixedAssetAmortizationMethodEnum = {
    LINEAL: 'LINEAL',
    DEGRESIVO: 'DEGRESIVO'
};
/**
 * @export
 */
export const PageFixedAssetStatusEnum = {
    ACTIVO: 'ACTIVO',
    AMORTIZADO: 'AMORTIZADO',
    DADO_DE_BAJA: 'DADO_DE_BAJA'
};
/**
 * @export
 */
export const PageFixedAssetAmortizationMethodEnum = {
    LINEAL: 'LINEAL',
    DEGRESIVO: 'DEGRESIVO'
};
/**
 * HolidayRestControllerApi - axios parameter creator
 * @export
 */
export const HolidayRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [year]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countHoliday: async (year, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/holidays/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissHoliday: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissHoliday', 'id', id);
            const localVarPath = `/api/admin/employee/holidays/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchHoliday: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchHoliday', 'ids', ids);
            const localVarPath = `/api/admin/employee/holidays/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHoliday: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getHoliday', 'id', id);
            const localVarPath = `/api/admin/employee/holidays/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [year]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHoliday: async (year, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/holidays/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [year]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageHoliday: async (page, size, sort, year, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/holidays/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Holiday} holiday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveHoliday: async (holiday, options = {}) => {
            // verify required parameter 'holiday' is not null or undefined
            assertParamExists('saveHoliday', 'holiday', holiday);
            const localVarPath = `/api/admin/employee/holidays/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(holiday, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * HolidayRestControllerApi - functional programming interface
 * @export
 */
export const HolidayRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = HolidayRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [year]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countHoliday(year, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countHoliday(year, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HolidayRestControllerApi.countHoliday']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissHoliday(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissHoliday(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HolidayRestControllerApi.deleteOrDismissHoliday']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchHoliday(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchHoliday(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HolidayRestControllerApi.deleteOrDismissInBatchHoliday']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHoliday(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHoliday(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HolidayRestControllerApi.getHoliday']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [year]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listHoliday(year, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listHoliday(year, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HolidayRestControllerApi.listHoliday']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [year]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageHoliday(page, size, sort, year, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageHoliday(page, size, sort, year, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HolidayRestControllerApi.pageHoliday']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Holiday} holiday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveHoliday(holiday, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveHoliday(holiday, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HolidayRestControllerApi.saveHoliday']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * HolidayRestControllerApi - factory interface
 * @export
 */
export const HolidayRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HolidayRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [year]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countHoliday(year, term, showDismissed, options) {
            return localVarFp.countHoliday(year, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissHoliday(id, options) {
            return localVarFp.deleteOrDismissHoliday(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchHoliday(ids, options) {
            return localVarFp.deleteOrDismissInBatchHoliday(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHoliday(id, options) {
            return localVarFp.getHoliday(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [year]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHoliday(year, term, showDismissed, options) {
            return localVarFp.listHoliday(year, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [year]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageHoliday(page, size, sort, year, term, showDismissed, options) {
            return localVarFp.pageHoliday(page, size, sort, year, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Holiday} holiday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveHoliday(holiday, options) {
            return localVarFp.saveHoliday(holiday, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * HolidayRestControllerApi - object-oriented interface
 * @export
 * @class HolidayRestControllerApi
 * @extends {BaseAPI}
 */
export class HolidayRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [year]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidayRestControllerApi
     */
    countHoliday(year, term, showDismissed, options) {
        return HolidayRestControllerApiFp(this.configuration).countHoliday(year, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidayRestControllerApi
     */
    deleteOrDismissHoliday(id, options) {
        return HolidayRestControllerApiFp(this.configuration).deleteOrDismissHoliday(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidayRestControllerApi
     */
    deleteOrDismissInBatchHoliday(ids, options) {
        return HolidayRestControllerApiFp(this.configuration).deleteOrDismissInBatchHoliday(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidayRestControllerApi
     */
    getHoliday(id, options) {
        return HolidayRestControllerApiFp(this.configuration).getHoliday(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [year]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidayRestControllerApi
     */
    listHoliday(year, term, showDismissed, options) {
        return HolidayRestControllerApiFp(this.configuration).listHoliday(year, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [year]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidayRestControllerApi
     */
    pageHoliday(page, size, sort, year, term, showDismissed, options) {
        return HolidayRestControllerApiFp(this.configuration).pageHoliday(page, size, sort, year, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Holiday} holiday
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HolidayRestControllerApi
     */
    saveHoliday(holiday, options) {
        return HolidayRestControllerApiFp(this.configuration).saveHoliday(holiday, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ImpersonationRestControllerApi - axios parameter creator
 * @export
 */
export const ImpersonationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonationCandidates: async (options = {}) => {
            const localVarPath = `/api/admin/config/impersonation/candidates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonationStatus: async (options = {}) => {
            const localVarPath = `/api/user/impersonation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ImpersonationRestControllerApi - functional programming interface
 * @export
 */
export const ImpersonationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ImpersonationRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async impersonationCandidates(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.impersonationCandidates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImpersonationRestControllerApi.impersonationCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async impersonationStatus(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.impersonationStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImpersonationRestControllerApi.impersonationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ImpersonationRestControllerApi - factory interface
 * @export
 */
export const ImpersonationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ImpersonationRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonationCandidates(options) {
            return localVarFp.impersonationCandidates(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonationStatus(options) {
            return localVarFp.impersonationStatus(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ImpersonationRestControllerApi - object-oriented interface
 * @export
 * @class ImpersonationRestControllerApi
 * @extends {BaseAPI}
 */
export class ImpersonationRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpersonationRestControllerApi
     */
    impersonationCandidates(options) {
        return ImpersonationRestControllerApiFp(this.configuration).impersonationCandidates(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpersonationRestControllerApi
     */
    impersonationStatus(options) {
        return ImpersonationRestControllerApiFp(this.configuration).impersonationStatus(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * InterviewRestControllerApi - axios parameter creator
 * @export
 */
export const InterviewRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        boardInterview: async (options = {}) => {
            const localVarPath = `/api/admin/employee/interview/board`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countInterview: async (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/interview/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchInterview: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchInterview', 'ids', ids);
            const localVarPath = `/api/admin/employee/interview/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInterview: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissInterview', 'id', id);
            const localVarPath = `/api/admin/employee/interview/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterview: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInterview', 'id', id);
            const localVarPath = `/api/admin/employee/interview/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInterview: async (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/interview/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageInterview: async (page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/interview/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Interview} interview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveInterview: async (interview, options = {}) => {
            // verify required parameter 'interview' is not null or undefined
            assertParamExists('saveInterview', 'interview', interview);
            const localVarPath = `/api/admin/employee/interview/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(interview, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * InterviewRestControllerApi - functional programming interface
 * @export
 */
export const InterviewRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = InterviewRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async boardInterview(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.boardInterview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewRestControllerApi.boardInterview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countInterview(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countInterview(personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewRestControllerApi.countInterview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchInterview(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchInterview(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewRestControllerApi.deleteOrDismissInBatchInterview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInterview(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInterview(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewRestControllerApi.deleteOrDismissInterview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInterview(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInterview(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewRestControllerApi.getInterview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInterview(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInterview(personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewRestControllerApi.listInterview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageInterview(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageInterview(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewRestControllerApi.pageInterview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Interview} interview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveInterview(interview, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveInterview(interview, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewRestControllerApi.saveInterview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * InterviewRestControllerApi - factory interface
 * @export
 */
export const InterviewRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InterviewRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        boardInterview(options) {
            return localVarFp.boardInterview(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countInterview(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countInterview(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchInterview(ids, options) {
            return localVarFp.deleteOrDismissInBatchInterview(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInterview(id, options) {
            return localVarFp.deleteOrDismissInterview(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterview(id, options) {
            return localVarFp.getInterview(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInterview(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listInterview(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageInterview(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pageInterview(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Interview} interview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveInterview(interview, options) {
            return localVarFp.saveInterview(interview, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * InterviewRestControllerApi - object-oriented interface
 * @export
 * @class InterviewRestControllerApi
 * @extends {BaseAPI}
 */
export class InterviewRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewRestControllerApi
     */
    boardInterview(options) {
        return InterviewRestControllerApiFp(this.configuration).boardInterview(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewRestControllerApi
     */
    countInterview(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return InterviewRestControllerApiFp(this.configuration).countInterview(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewRestControllerApi
     */
    deleteOrDismissInBatchInterview(ids, options) {
        return InterviewRestControllerApiFp(this.configuration).deleteOrDismissInBatchInterview(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewRestControllerApi
     */
    deleteOrDismissInterview(id, options) {
        return InterviewRestControllerApiFp(this.configuration).deleteOrDismissInterview(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewRestControllerApi
     */
    getInterview(id, options) {
        return InterviewRestControllerApiFp(this.configuration).getInterview(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewRestControllerApi
     */
    listInterview(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return InterviewRestControllerApiFp(this.configuration).listInterview(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewRestControllerApi
     */
    pageInterview(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return InterviewRestControllerApiFp(this.configuration).pageInterview(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Interview} interview
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewRestControllerApi
     */
    saveInterview(interview, options) {
        return InterviewRestControllerApiFp(this.configuration).saveInterview(interview, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * JournalEntryRestControllerApi - axios parameter creator
 * @export
 */
export const JournalEntryRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelJournalEntry: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelJournalEntry', 'id', id);
            const localVarPath = `/api/admin/accounting/journal/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmJournalEntry: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('confirmJournalEntry', 'id', id);
            const localVarPath = `/api/admin/accounting/journal/{id}/confirm`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [periodId]
         * @param {CountJournalEntryStatusEnum} [status]
         * @param {CountJournalEntryOriginEnum} [origin]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countJournalEntry: async (periodId, status, origin, dateFrom, dateTo, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/journal/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (periodId !== undefined) {
                localVarQueryParameter['periodId'] = periodId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (origin !== undefined) {
                localVarQueryParameter['origin'] = origin;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString().substring(0, 10) :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString().substring(0, 10) :
                    dateTo;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} lineId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLineJournalEntry: async (lineId, options = {}) => {
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('deleteLineJournalEntry', 'lineId', lineId);
            const localVarPath = `/api/admin/accounting/journal/line/{lineId}`
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchJournalEntry: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchJournalEntry', 'ids', ids);
            const localVarPath = `/api/admin/accounting/journal/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissJournalEntry: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissJournalEntry', 'id', id);
            const localVarPath = `/api/admin/accounting/journal/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateJournalEntry: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('duplicateJournalEntry', 'id', id);
            const localVarPath = `/api/admin/accounting/journal/{id}/duplicate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJournalEntry: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getJournalEntry', 'id', id);
            const localVarPath = `/api/admin/accounting/journal/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isBalancedJournalEntry: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('isBalancedJournalEntry', 'id', id);
            const localVarPath = `/api/admin/accounting/journal/balanced/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [periodId]
         * @param {ListJournalEntryStatusEnum} [status]
         * @param {ListJournalEntryOriginEnum} [origin]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJournalEntry: async (periodId, status, origin, dateFrom, dateTo, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/journal/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (periodId !== undefined) {
                localVarQueryParameter['periodId'] = periodId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (origin !== undefined) {
                localVarQueryParameter['origin'] = origin;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString().substring(0, 10) :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString().substring(0, 10) :
                    dateTo;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [periodId]
         * @param {PageJournalEntryStatusEnum} [status]
         * @param {PageJournalEntryOriginEnum} [origin]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageJournalEntry: async (page, size, sort, periodId, status, origin, dateFrom, dateTo, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/journal/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (periodId !== undefined) {
                localVarQueryParameter['periodId'] = periodId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (origin !== undefined) {
                localVarQueryParameter['origin'] = origin;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString().substring(0, 10) :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString().substring(0, 10) :
                    dateTo;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopenJournalEntry: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reopenJournalEntry', 'id', id);
            const localVarPath = `/api/admin/accounting/journal/{id}/reopen`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {JournalEntry} journalEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveJournalEntry: async (journalEntry, options = {}) => {
            // verify required parameter 'journalEntry' is not null or undefined
            assertParamExists('saveJournalEntry', 'journalEntry', journalEntry);
            const localVarPath = `/api/admin/accounting/journal/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(journalEntry, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} journalId
         * @param {JournalLine} journalLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLineJournalEntry: async (journalId, journalLine, options = {}) => {
            // verify required parameter 'journalId' is not null or undefined
            assertParamExists('saveLineJournalEntry', 'journalId', journalId);
            // verify required parameter 'journalLine' is not null or undefined
            assertParamExists('saveLineJournalEntry', 'journalLine', journalLine);
            const localVarPath = `/api/admin/accounting/journal/{journalId}/line`
                .replace(`{${"journalId"}}`, encodeURIComponent(String(journalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(journalLine, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionsJournalEntry: async (options = {}) => {
            const localVarPath = `/api/admin/accounting/journal/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * JournalEntryRestControllerApi - functional programming interface
 * @export
 */
export const JournalEntryRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = JournalEntryRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelJournalEntry(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelJournalEntry(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalEntryRestControllerApi.cancelJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmJournalEntry(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmJournalEntry(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalEntryRestControllerApi.confirmJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [periodId]
         * @param {CountJournalEntryStatusEnum} [status]
         * @param {CountJournalEntryOriginEnum} [origin]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countJournalEntry(periodId, status, origin, dateFrom, dateTo, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countJournalEntry(periodId, status, origin, dateFrom, dateTo, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalEntryRestControllerApi.countJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} lineId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLineJournalEntry(lineId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLineJournalEntry(lineId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalEntryRestControllerApi.deleteLineJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchJournalEntry(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchJournalEntry(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalEntryRestControllerApi.deleteOrDismissInBatchJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissJournalEntry(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissJournalEntry(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalEntryRestControllerApi.deleteOrDismissJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateJournalEntry(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateJournalEntry(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalEntryRestControllerApi.duplicateJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJournalEntry(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJournalEntry(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalEntryRestControllerApi.getJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isBalancedJournalEntry(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isBalancedJournalEntry(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalEntryRestControllerApi.isBalancedJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [periodId]
         * @param {ListJournalEntryStatusEnum} [status]
         * @param {ListJournalEntryOriginEnum} [origin]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listJournalEntry(periodId, status, origin, dateFrom, dateTo, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listJournalEntry(periodId, status, origin, dateFrom, dateTo, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalEntryRestControllerApi.listJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [periodId]
         * @param {PageJournalEntryStatusEnum} [status]
         * @param {PageJournalEntryOriginEnum} [origin]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageJournalEntry(page, size, sort, periodId, status, origin, dateFrom, dateTo, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageJournalEntry(page, size, sort, periodId, status, origin, dateFrom, dateTo, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalEntryRestControllerApi.pageJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reopenJournalEntry(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reopenJournalEntry(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalEntryRestControllerApi.reopenJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {JournalEntry} journalEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveJournalEntry(journalEntry, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveJournalEntry(journalEntry, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalEntryRestControllerApi.saveJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} journalId
         * @param {JournalLine} journalLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveLineJournalEntry(journalId, journalLine, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveLineJournalEntry(journalId, journalLine, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalEntryRestControllerApi.saveLineJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestionsJournalEntry(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestionsJournalEntry(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalEntryRestControllerApi.suggestionsJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * JournalEntryRestControllerApi - factory interface
 * @export
 */
export const JournalEntryRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = JournalEntryRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelJournalEntry(id, options) {
            return localVarFp.cancelJournalEntry(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmJournalEntry(id, options) {
            return localVarFp.confirmJournalEntry(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [periodId]
         * @param {CountJournalEntryStatusEnum} [status]
         * @param {CountJournalEntryOriginEnum} [origin]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countJournalEntry(periodId, status, origin, dateFrom, dateTo, term, showDismissed, options) {
            return localVarFp.countJournalEntry(periodId, status, origin, dateFrom, dateTo, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} lineId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLineJournalEntry(lineId, options) {
            return localVarFp.deleteLineJournalEntry(lineId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchJournalEntry(ids, options) {
            return localVarFp.deleteOrDismissInBatchJournalEntry(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissJournalEntry(id, options) {
            return localVarFp.deleteOrDismissJournalEntry(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateJournalEntry(id, options) {
            return localVarFp.duplicateJournalEntry(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJournalEntry(id, options) {
            return localVarFp.getJournalEntry(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isBalancedJournalEntry(id, options) {
            return localVarFp.isBalancedJournalEntry(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [periodId]
         * @param {ListJournalEntryStatusEnum} [status]
         * @param {ListJournalEntryOriginEnum} [origin]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJournalEntry(periodId, status, origin, dateFrom, dateTo, term, showDismissed, options) {
            return localVarFp.listJournalEntry(periodId, status, origin, dateFrom, dateTo, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [periodId]
         * @param {PageJournalEntryStatusEnum} [status]
         * @param {PageJournalEntryOriginEnum} [origin]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageJournalEntry(page, size, sort, periodId, status, origin, dateFrom, dateTo, term, showDismissed, options) {
            return localVarFp.pageJournalEntry(page, size, sort, periodId, status, origin, dateFrom, dateTo, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopenJournalEntry(id, options) {
            return localVarFp.reopenJournalEntry(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {JournalEntry} journalEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveJournalEntry(journalEntry, options) {
            return localVarFp.saveJournalEntry(journalEntry, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} journalId
         * @param {JournalLine} journalLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLineJournalEntry(journalId, journalLine, options) {
            return localVarFp.saveLineJournalEntry(journalId, journalLine, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionsJournalEntry(options) {
            return localVarFp.suggestionsJournalEntry(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * JournalEntryRestControllerApi - object-oriented interface
 * @export
 * @class JournalEntryRestControllerApi
 * @extends {BaseAPI}
 */
export class JournalEntryRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalEntryRestControllerApi
     */
    cancelJournalEntry(id, options) {
        return JournalEntryRestControllerApiFp(this.configuration).cancelJournalEntry(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalEntryRestControllerApi
     */
    confirmJournalEntry(id, options) {
        return JournalEntryRestControllerApiFp(this.configuration).confirmJournalEntry(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [periodId]
     * @param {CountJournalEntryStatusEnum} [status]
     * @param {CountJournalEntryOriginEnum} [origin]
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalEntryRestControllerApi
     */
    countJournalEntry(periodId, status, origin, dateFrom, dateTo, term, showDismissed, options) {
        return JournalEntryRestControllerApiFp(this.configuration).countJournalEntry(periodId, status, origin, dateFrom, dateTo, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} lineId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalEntryRestControllerApi
     */
    deleteLineJournalEntry(lineId, options) {
        return JournalEntryRestControllerApiFp(this.configuration).deleteLineJournalEntry(lineId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalEntryRestControllerApi
     */
    deleteOrDismissInBatchJournalEntry(ids, options) {
        return JournalEntryRestControllerApiFp(this.configuration).deleteOrDismissInBatchJournalEntry(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalEntryRestControllerApi
     */
    deleteOrDismissJournalEntry(id, options) {
        return JournalEntryRestControllerApiFp(this.configuration).deleteOrDismissJournalEntry(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalEntryRestControllerApi
     */
    duplicateJournalEntry(id, options) {
        return JournalEntryRestControllerApiFp(this.configuration).duplicateJournalEntry(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalEntryRestControllerApi
     */
    getJournalEntry(id, options) {
        return JournalEntryRestControllerApiFp(this.configuration).getJournalEntry(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalEntryRestControllerApi
     */
    isBalancedJournalEntry(id, options) {
        return JournalEntryRestControllerApiFp(this.configuration).isBalancedJournalEntry(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [periodId]
     * @param {ListJournalEntryStatusEnum} [status]
     * @param {ListJournalEntryOriginEnum} [origin]
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalEntryRestControllerApi
     */
    listJournalEntry(periodId, status, origin, dateFrom, dateTo, term, showDismissed, options) {
        return JournalEntryRestControllerApiFp(this.configuration).listJournalEntry(periodId, status, origin, dateFrom, dateTo, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [periodId]
     * @param {PageJournalEntryStatusEnum} [status]
     * @param {PageJournalEntryOriginEnum} [origin]
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalEntryRestControllerApi
     */
    pageJournalEntry(page, size, sort, periodId, status, origin, dateFrom, dateTo, term, showDismissed, options) {
        return JournalEntryRestControllerApiFp(this.configuration).pageJournalEntry(page, size, sort, periodId, status, origin, dateFrom, dateTo, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalEntryRestControllerApi
     */
    reopenJournalEntry(id, options) {
        return JournalEntryRestControllerApiFp(this.configuration).reopenJournalEntry(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {JournalEntry} journalEntry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalEntryRestControllerApi
     */
    saveJournalEntry(journalEntry, options) {
        return JournalEntryRestControllerApiFp(this.configuration).saveJournalEntry(journalEntry, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} journalId
     * @param {JournalLine} journalLine
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalEntryRestControllerApi
     */
    saveLineJournalEntry(journalId, journalLine, options) {
        return JournalEntryRestControllerApiFp(this.configuration).saveLineJournalEntry(journalId, journalLine, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalEntryRestControllerApi
     */
    suggestionsJournalEntry(options) {
        return JournalEntryRestControllerApiFp(this.configuration).suggestionsJournalEntry(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountJournalEntryStatusEnum = {
    BORRADOR: 'BORRADOR',
    CONFIRMADO: 'CONFIRMADO',
    ANULADO: 'ANULADO'
};
/**
 * @export
 */
export const CountJournalEntryOriginEnum = {
    MANUAL: 'MANUAL',
    AUTO_FACTURA: 'AUTO_FACTURA',
    AUTO_NOMINA: 'AUTO_NOMINA',
    AUTO_COBRO: 'AUTO_COBRO',
    AUTO_AMORTIZACION: 'AUTO_AMORTIZACION',
    CONTASOL: 'CONTASOL',
    APERTURA: 'APERTURA',
    CIERRE: 'CIERRE',
    REGULARIZACION: 'REGULARIZACION'
};
/**
 * @export
 */
export const ListJournalEntryStatusEnum = {
    BORRADOR: 'BORRADOR',
    CONFIRMADO: 'CONFIRMADO',
    ANULADO: 'ANULADO'
};
/**
 * @export
 */
export const ListJournalEntryOriginEnum = {
    MANUAL: 'MANUAL',
    AUTO_FACTURA: 'AUTO_FACTURA',
    AUTO_NOMINA: 'AUTO_NOMINA',
    AUTO_COBRO: 'AUTO_COBRO',
    AUTO_AMORTIZACION: 'AUTO_AMORTIZACION',
    CONTASOL: 'CONTASOL',
    APERTURA: 'APERTURA',
    CIERRE: 'CIERRE',
    REGULARIZACION: 'REGULARIZACION'
};
/**
 * @export
 */
export const PageJournalEntryStatusEnum = {
    BORRADOR: 'BORRADOR',
    CONFIRMADO: 'CONFIRMADO',
    ANULADO: 'ANULADO'
};
/**
 * @export
 */
export const PageJournalEntryOriginEnum = {
    MANUAL: 'MANUAL',
    AUTO_FACTURA: 'AUTO_FACTURA',
    AUTO_NOMINA: 'AUTO_NOMINA',
    AUTO_COBRO: 'AUTO_COBRO',
    AUTO_AMORTIZACION: 'AUTO_AMORTIZACION',
    CONTASOL: 'CONTASOL',
    APERTURA: 'APERTURA',
    CIERRE: 'CIERRE',
    REGULARIZACION: 'REGULARIZACION'
};
/**
 * LeadRestControllerApi - axios parameter creator
 * @export
 */
export const LeadRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {number} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertLead: async (id, organizationId, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('convertLead', 'id', id);
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('convertLead', 'organizationId', organizationId);
            const localVarPath = `/api/admin/marketing/lead/{id}/convert`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CountLeadStatusEnum} [status]
         * @param {CountLeadSourceEnum} [source]
         * @param {boolean} [touchDue]
         * @param {CountLeadInOperationEnum} [inOperation]
         * @param {CountLeadMaintainedByEnum} [maintainedBy]
         * @param {number} [referredById]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countLead: async (status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/lead/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }
            if (touchDue !== undefined) {
                localVarQueryParameter['touchDue'] = touchDue;
            }
            if (inOperation !== undefined) {
                localVarQueryParameter['inOperation'] = inOperation;
            }
            if (maintainedBy !== undefined) {
                localVarQueryParameter['maintainedBy'] = maintainedBy;
            }
            if (referredById !== undefined) {
                localVarQueryParameter['referredById'] = referredById;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchLead: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchLead', 'ids', ids);
            const localVarPath = `/api/admin/marketing/lead/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissLead: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissLead', 'id', id);
            const localVarPath = `/api/admin/marketing/lead/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLead: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLead', 'id', id);
            const localVarPath = `/api/admin/marketing/lead/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ListLeadStatusEnum} [status]
         * @param {ListLeadSourceEnum} [source]
         * @param {boolean} [touchDue]
         * @param {ListLeadInOperationEnum} [inOperation]
         * @param {ListLeadMaintainedByEnum} [maintainedBy]
         * @param {number} [referredById]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLead: async (status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/lead/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }
            if (touchDue !== undefined) {
                localVarQueryParameter['touchDue'] = touchDue;
            }
            if (inOperation !== undefined) {
                localVarQueryParameter['inOperation'] = inOperation;
            }
            if (maintainedBy !== undefined) {
                localVarQueryParameter['maintainedBy'] = maintainedBy;
            }
            if (referredById !== undefined) {
                localVarQueryParameter['referredById'] = referredById;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageLeadStatusEnum} [status]
         * @param {PageLeadSourceEnum} [source]
         * @param {boolean} [touchDue]
         * @param {PageLeadInOperationEnum} [inOperation]
         * @param {PageLeadMaintainedByEnum} [maintainedBy]
         * @param {number} [referredById]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageLead: async (page, size, sort, status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/lead/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }
            if (touchDue !== undefined) {
                localVarQueryParameter['touchDue'] = touchDue;
            }
            if (inOperation !== undefined) {
                localVarQueryParameter['inOperation'] = inOperation;
            }
            if (maintainedBy !== undefined) {
                localVarQueryParameter['maintainedBy'] = maintainedBy;
            }
            if (referredById !== undefined) {
                localVarQueryParameter['referredById'] = referredById;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Lead} lead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLead: async (lead, options = {}) => {
            // verify required parameter 'lead' is not null or undefined
            assertParamExists('saveLead', 'lead', lead);
            const localVarPath = `/api/admin/marketing/lead/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(lead, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SummaryLeadStatusEnum} [status]
         * @param {SummaryLeadSourceEnum} [source]
         * @param {boolean} [touchDue]
         * @param {SummaryLeadInOperationEnum} [inOperation]
         * @param {SummaryLeadMaintainedByEnum} [maintainedBy]
         * @param {number} [referredById]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summaryLead: async (status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/lead/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }
            if (touchDue !== undefined) {
                localVarQueryParameter['touchDue'] = touchDue;
            }
            if (inOperation !== undefined) {
                localVarQueryParameter['inOperation'] = inOperation;
            }
            if (maintainedBy !== undefined) {
                localVarQueryParameter['maintainedBy'] = maintainedBy;
            }
            if (referredById !== undefined) {
                localVarQueryParameter['referredById'] = referredById;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LeadRestControllerApi - functional programming interface
 * @export
 */
export const LeadRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = LeadRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {number} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async convertLead(id, organizationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.convertLead(id, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadRestControllerApi.convertLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CountLeadStatusEnum} [status]
         * @param {CountLeadSourceEnum} [source]
         * @param {boolean} [touchDue]
         * @param {CountLeadInOperationEnum} [inOperation]
         * @param {CountLeadMaintainedByEnum} [maintainedBy]
         * @param {number} [referredById]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countLead(status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countLead(status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadRestControllerApi.countLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchLead(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchLead(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadRestControllerApi.deleteOrDismissInBatchLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissLead(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissLead(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadRestControllerApi.deleteOrDismissLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLead(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLead(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadRestControllerApi.getLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ListLeadStatusEnum} [status]
         * @param {ListLeadSourceEnum} [source]
         * @param {boolean} [touchDue]
         * @param {ListLeadInOperationEnum} [inOperation]
         * @param {ListLeadMaintainedByEnum} [maintainedBy]
         * @param {number} [referredById]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLead(status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLead(status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadRestControllerApi.listLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageLeadStatusEnum} [status]
         * @param {PageLeadSourceEnum} [source]
         * @param {boolean} [touchDue]
         * @param {PageLeadInOperationEnum} [inOperation]
         * @param {PageLeadMaintainedByEnum} [maintainedBy]
         * @param {number} [referredById]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageLead(page, size, sort, status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageLead(page, size, sort, status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadRestControllerApi.pageLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Lead} lead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveLead(lead, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveLead(lead, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadRestControllerApi.saveLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {SummaryLeadStatusEnum} [status]
         * @param {SummaryLeadSourceEnum} [source]
         * @param {boolean} [touchDue]
         * @param {SummaryLeadInOperationEnum} [inOperation]
         * @param {SummaryLeadMaintainedByEnum} [maintainedBy]
         * @param {number} [referredById]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async summaryLead(status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.summaryLead(status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadRestControllerApi.summaryLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * LeadRestControllerApi - factory interface
 * @export
 */
export const LeadRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LeadRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {number} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertLead(id, organizationId, options) {
            return localVarFp.convertLead(id, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CountLeadStatusEnum} [status]
         * @param {CountLeadSourceEnum} [source]
         * @param {boolean} [touchDue]
         * @param {CountLeadInOperationEnum} [inOperation]
         * @param {CountLeadMaintainedByEnum} [maintainedBy]
         * @param {number} [referredById]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countLead(status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options) {
            return localVarFp.countLead(status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchLead(ids, options) {
            return localVarFp.deleteOrDismissInBatchLead(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissLead(id, options) {
            return localVarFp.deleteOrDismissLead(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLead(id, options) {
            return localVarFp.getLead(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ListLeadStatusEnum} [status]
         * @param {ListLeadSourceEnum} [source]
         * @param {boolean} [touchDue]
         * @param {ListLeadInOperationEnum} [inOperation]
         * @param {ListLeadMaintainedByEnum} [maintainedBy]
         * @param {number} [referredById]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLead(status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options) {
            return localVarFp.listLead(status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageLeadStatusEnum} [status]
         * @param {PageLeadSourceEnum} [source]
         * @param {boolean} [touchDue]
         * @param {PageLeadInOperationEnum} [inOperation]
         * @param {PageLeadMaintainedByEnum} [maintainedBy]
         * @param {number} [referredById]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageLead(page, size, sort, status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options) {
            return localVarFp.pageLead(page, size, sort, status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Lead} lead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLead(lead, options) {
            return localVarFp.saveLead(lead, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SummaryLeadStatusEnum} [status]
         * @param {SummaryLeadSourceEnum} [source]
         * @param {boolean} [touchDue]
         * @param {SummaryLeadInOperationEnum} [inOperation]
         * @param {SummaryLeadMaintainedByEnum} [maintainedBy]
         * @param {number} [referredById]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summaryLead(status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options) {
            return localVarFp.summaryLead(status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LeadRestControllerApi - object-oriented interface
 * @export
 * @class LeadRestControllerApi
 * @extends {BaseAPI}
 */
export class LeadRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} id
     * @param {number} organizationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadRestControllerApi
     */
    convertLead(id, organizationId, options) {
        return LeadRestControllerApiFp(this.configuration).convertLead(id, organizationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CountLeadStatusEnum} [status]
     * @param {CountLeadSourceEnum} [source]
     * @param {boolean} [touchDue]
     * @param {CountLeadInOperationEnum} [inOperation]
     * @param {CountLeadMaintainedByEnum} [maintainedBy]
     * @param {number} [referredById]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadRestControllerApi
     */
    countLead(status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options) {
        return LeadRestControllerApiFp(this.configuration).countLead(status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadRestControllerApi
     */
    deleteOrDismissInBatchLead(ids, options) {
        return LeadRestControllerApiFp(this.configuration).deleteOrDismissInBatchLead(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadRestControllerApi
     */
    deleteOrDismissLead(id, options) {
        return LeadRestControllerApiFp(this.configuration).deleteOrDismissLead(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadRestControllerApi
     */
    getLead(id, options) {
        return LeadRestControllerApiFp(this.configuration).getLead(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ListLeadStatusEnum} [status]
     * @param {ListLeadSourceEnum} [source]
     * @param {boolean} [touchDue]
     * @param {ListLeadInOperationEnum} [inOperation]
     * @param {ListLeadMaintainedByEnum} [maintainedBy]
     * @param {number} [referredById]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadRestControllerApi
     */
    listLead(status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options) {
        return LeadRestControllerApiFp(this.configuration).listLead(status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {PageLeadStatusEnum} [status]
     * @param {PageLeadSourceEnum} [source]
     * @param {boolean} [touchDue]
     * @param {PageLeadInOperationEnum} [inOperation]
     * @param {PageLeadMaintainedByEnum} [maintainedBy]
     * @param {number} [referredById]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadRestControllerApi
     */
    pageLead(page, size, sort, status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options) {
        return LeadRestControllerApiFp(this.configuration).pageLead(page, size, sort, status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Lead} lead
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadRestControllerApi
     */
    saveLead(lead, options) {
        return LeadRestControllerApiFp(this.configuration).saveLead(lead, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SummaryLeadStatusEnum} [status]
     * @param {SummaryLeadSourceEnum} [source]
     * @param {boolean} [touchDue]
     * @param {SummaryLeadInOperationEnum} [inOperation]
     * @param {SummaryLeadMaintainedByEnum} [maintainedBy]
     * @param {number} [referredById]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadRestControllerApi
     */
    summaryLead(status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options) {
        return LeadRestControllerApiFp(this.configuration).summaryLead(status, source, touchDue, inOperation, maintainedBy, referredById, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountLeadStatusEnum = {
    NEW: 'NEW',
    CONTACTED: 'CONTACTED',
    QUALIFIED: 'QUALIFIED',
    CONVERTED: 'CONVERTED',
    DISCARDED: 'DISCARDED'
};
/**
 * @export
 */
export const CountLeadSourceEnum = {
    WEB_FORM: 'WEB_FORM',
    NEWSLETTER: 'NEWSLETTER',
    EMAIL_INBOUND: 'EMAIL_INBOUND',
    REFERRAL: 'REFERRAL',
    IMPORT: 'IMPORT',
    EVENT: 'EVENT',
    MANUAL: 'MANUAL',
    OUTBOUND: 'OUTBOUND',
    SOCIAL: 'SOCIAL',
    OTHER: 'OTHER'
};
/**
 * @export
 */
export const CountLeadInOperationEnum = {
    EN_OPERACION: 'EN_OPERACION',
    NO_ARRANCADO: 'NO_ARRANCADO'
};
/**
 * @export
 */
export const CountLeadMaintainedByEnum = {
    INTERNO: 'INTERNO',
    AGENCIA: 'AGENCIA',
    NADIE: 'NADIE'
};
/**
 * @export
 */
export const ListLeadStatusEnum = {
    NEW: 'NEW',
    CONTACTED: 'CONTACTED',
    QUALIFIED: 'QUALIFIED',
    CONVERTED: 'CONVERTED',
    DISCARDED: 'DISCARDED'
};
/**
 * @export
 */
export const ListLeadSourceEnum = {
    WEB_FORM: 'WEB_FORM',
    NEWSLETTER: 'NEWSLETTER',
    EMAIL_INBOUND: 'EMAIL_INBOUND',
    REFERRAL: 'REFERRAL',
    IMPORT: 'IMPORT',
    EVENT: 'EVENT',
    MANUAL: 'MANUAL',
    OUTBOUND: 'OUTBOUND',
    SOCIAL: 'SOCIAL',
    OTHER: 'OTHER'
};
/**
 * @export
 */
export const ListLeadInOperationEnum = {
    EN_OPERACION: 'EN_OPERACION',
    NO_ARRANCADO: 'NO_ARRANCADO'
};
/**
 * @export
 */
export const ListLeadMaintainedByEnum = {
    INTERNO: 'INTERNO',
    AGENCIA: 'AGENCIA',
    NADIE: 'NADIE'
};
/**
 * @export
 */
export const PageLeadStatusEnum = {
    NEW: 'NEW',
    CONTACTED: 'CONTACTED',
    QUALIFIED: 'QUALIFIED',
    CONVERTED: 'CONVERTED',
    DISCARDED: 'DISCARDED'
};
/**
 * @export
 */
export const PageLeadSourceEnum = {
    WEB_FORM: 'WEB_FORM',
    NEWSLETTER: 'NEWSLETTER',
    EMAIL_INBOUND: 'EMAIL_INBOUND',
    REFERRAL: 'REFERRAL',
    IMPORT: 'IMPORT',
    EVENT: 'EVENT',
    MANUAL: 'MANUAL',
    OUTBOUND: 'OUTBOUND',
    SOCIAL: 'SOCIAL',
    OTHER: 'OTHER'
};
/**
 * @export
 */
export const PageLeadInOperationEnum = {
    EN_OPERACION: 'EN_OPERACION',
    NO_ARRANCADO: 'NO_ARRANCADO'
};
/**
 * @export
 */
export const PageLeadMaintainedByEnum = {
    INTERNO: 'INTERNO',
    AGENCIA: 'AGENCIA',
    NADIE: 'NADIE'
};
/**
 * @export
 */
export const SummaryLeadStatusEnum = {
    NEW: 'NEW',
    CONTACTED: 'CONTACTED',
    QUALIFIED: 'QUALIFIED',
    CONVERTED: 'CONVERTED',
    DISCARDED: 'DISCARDED'
};
/**
 * @export
 */
export const SummaryLeadSourceEnum = {
    WEB_FORM: 'WEB_FORM',
    NEWSLETTER: 'NEWSLETTER',
    EMAIL_INBOUND: 'EMAIL_INBOUND',
    REFERRAL: 'REFERRAL',
    IMPORT: 'IMPORT',
    EVENT: 'EVENT',
    MANUAL: 'MANUAL',
    OUTBOUND: 'OUTBOUND',
    SOCIAL: 'SOCIAL',
    OTHER: 'OTHER'
};
/**
 * @export
 */
export const SummaryLeadInOperationEnum = {
    EN_OPERACION: 'EN_OPERACION',
    NO_ARRANCADO: 'NO_ARRANCADO'
};
/**
 * @export
 */
export const SummaryLeadMaintainedByEnum = {
    INTERNO: 'INTERNO',
    AGENCIA: 'AGENCIA',
    NADIE: 'NADIE'
};
/**
 * ManagementRoleAssignmentRestControllerApi - axios parameter creator
 * @export
 */
export const ManagementRoleAssignmentRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeManagementRoleAssignment: async (id, endDate, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('closeManagementRoleAssignment', 'id', id);
            const localVarPath = `/api/admin/quality/role-assignment/{id}/close`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substring(0, 10) :
                    endDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CountManagementRoleAssignmentRoleEnum} [role]
         * @param {number} [personId]
         * @param {boolean} [current]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countManagementRoleAssignment: async (role, personId, current, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/quality/role-assignment/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (current !== undefined) {
                localVarQueryParameter['current'] = current;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentManagementRoleAssignment: async (options = {}) => {
            const localVarPath = `/api/admin/quality/role-assignment/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchManagementRoleAssignment: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchManagementRoleAssignment', 'ids', ids);
            const localVarPath = `/api/admin/quality/role-assignment/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissManagementRoleAssignment: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissManagementRoleAssignment', 'id', id);
            const localVarPath = `/api/admin/quality/role-assignment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManagementRoleAssignment: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getManagementRoleAssignment', 'id', id);
            const localVarPath = `/api/admin/quality/role-assignment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ListManagementRoleAssignmentRoleEnum} [role]
         * @param {number} [personId]
         * @param {boolean} [current]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listManagementRoleAssignment: async (role, personId, current, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/quality/role-assignment/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (current !== undefined) {
                localVarQueryParameter['current'] = current;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageManagementRoleAssignmentRoleEnum} [role]
         * @param {number} [personId]
         * @param {boolean} [current]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageManagementRoleAssignment: async (page, size, sort, role, personId, current, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/quality/role-assignment/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (current !== undefined) {
                localVarQueryParameter['current'] = current;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ManagementRoleAssignment} managementRoleAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveManagementRoleAssignment: async (managementRoleAssignment, options = {}) => {
            // verify required parameter 'managementRoleAssignment' is not null or undefined
            assertParamExists('saveManagementRoleAssignment', 'managementRoleAssignment', managementRoleAssignment);
            const localVarPath = `/api/admin/quality/role-assignment/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(managementRoleAssignment, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ManagementRoleAssignmentRestControllerApi - functional programming interface
 * @export
 */
export const ManagementRoleAssignmentRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ManagementRoleAssignmentRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeManagementRoleAssignment(id, endDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeManagementRoleAssignment(id, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementRoleAssignmentRestControllerApi.closeManagementRoleAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CountManagementRoleAssignmentRoleEnum} [role]
         * @param {number} [personId]
         * @param {boolean} [current]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countManagementRoleAssignment(role, personId, current, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countManagementRoleAssignment(role, personId, current, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementRoleAssignmentRestControllerApi.countManagementRoleAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currentManagementRoleAssignment(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currentManagementRoleAssignment(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementRoleAssignmentRestControllerApi.currentManagementRoleAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchManagementRoleAssignment(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchManagementRoleAssignment(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementRoleAssignmentRestControllerApi.deleteOrDismissInBatchManagementRoleAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissManagementRoleAssignment(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissManagementRoleAssignment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementRoleAssignmentRestControllerApi.deleteOrDismissManagementRoleAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManagementRoleAssignment(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManagementRoleAssignment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementRoleAssignmentRestControllerApi.getManagementRoleAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ListManagementRoleAssignmentRoleEnum} [role]
         * @param {number} [personId]
         * @param {boolean} [current]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listManagementRoleAssignment(role, personId, current, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listManagementRoleAssignment(role, personId, current, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementRoleAssignmentRestControllerApi.listManagementRoleAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageManagementRoleAssignmentRoleEnum} [role]
         * @param {number} [personId]
         * @param {boolean} [current]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageManagementRoleAssignment(page, size, sort, role, personId, current, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageManagementRoleAssignment(page, size, sort, role, personId, current, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementRoleAssignmentRestControllerApi.pageManagementRoleAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ManagementRoleAssignment} managementRoleAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveManagementRoleAssignment(managementRoleAssignment, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveManagementRoleAssignment(managementRoleAssignment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementRoleAssignmentRestControllerApi.saveManagementRoleAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ManagementRoleAssignmentRestControllerApi - factory interface
 * @export
 */
export const ManagementRoleAssignmentRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ManagementRoleAssignmentRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeManagementRoleAssignment(id, endDate, options) {
            return localVarFp.closeManagementRoleAssignment(id, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CountManagementRoleAssignmentRoleEnum} [role]
         * @param {number} [personId]
         * @param {boolean} [current]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countManagementRoleAssignment(role, personId, current, term, showDismissed, options) {
            return localVarFp.countManagementRoleAssignment(role, personId, current, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentManagementRoleAssignment(options) {
            return localVarFp.currentManagementRoleAssignment(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchManagementRoleAssignment(ids, options) {
            return localVarFp.deleteOrDismissInBatchManagementRoleAssignment(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissManagementRoleAssignment(id, options) {
            return localVarFp.deleteOrDismissManagementRoleAssignment(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManagementRoleAssignment(id, options) {
            return localVarFp.getManagementRoleAssignment(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ListManagementRoleAssignmentRoleEnum} [role]
         * @param {number} [personId]
         * @param {boolean} [current]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listManagementRoleAssignment(role, personId, current, term, showDismissed, options) {
            return localVarFp.listManagementRoleAssignment(role, personId, current, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageManagementRoleAssignmentRoleEnum} [role]
         * @param {number} [personId]
         * @param {boolean} [current]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageManagementRoleAssignment(page, size, sort, role, personId, current, term, showDismissed, options) {
            return localVarFp.pageManagementRoleAssignment(page, size, sort, role, personId, current, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ManagementRoleAssignment} managementRoleAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveManagementRoleAssignment(managementRoleAssignment, options) {
            return localVarFp.saveManagementRoleAssignment(managementRoleAssignment, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ManagementRoleAssignmentRestControllerApi - object-oriented interface
 * @export
 * @class ManagementRoleAssignmentRestControllerApi
 * @extends {BaseAPI}
 */
export class ManagementRoleAssignmentRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} id
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementRoleAssignmentRestControllerApi
     */
    closeManagementRoleAssignment(id, endDate, options) {
        return ManagementRoleAssignmentRestControllerApiFp(this.configuration).closeManagementRoleAssignment(id, endDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CountManagementRoleAssignmentRoleEnum} [role]
     * @param {number} [personId]
     * @param {boolean} [current]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementRoleAssignmentRestControllerApi
     */
    countManagementRoleAssignment(role, personId, current, term, showDismissed, options) {
        return ManagementRoleAssignmentRestControllerApiFp(this.configuration).countManagementRoleAssignment(role, personId, current, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementRoleAssignmentRestControllerApi
     */
    currentManagementRoleAssignment(options) {
        return ManagementRoleAssignmentRestControllerApiFp(this.configuration).currentManagementRoleAssignment(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementRoleAssignmentRestControllerApi
     */
    deleteOrDismissInBatchManagementRoleAssignment(ids, options) {
        return ManagementRoleAssignmentRestControllerApiFp(this.configuration).deleteOrDismissInBatchManagementRoleAssignment(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementRoleAssignmentRestControllerApi
     */
    deleteOrDismissManagementRoleAssignment(id, options) {
        return ManagementRoleAssignmentRestControllerApiFp(this.configuration).deleteOrDismissManagementRoleAssignment(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementRoleAssignmentRestControllerApi
     */
    getManagementRoleAssignment(id, options) {
        return ManagementRoleAssignmentRestControllerApiFp(this.configuration).getManagementRoleAssignment(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ListManagementRoleAssignmentRoleEnum} [role]
     * @param {number} [personId]
     * @param {boolean} [current]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementRoleAssignmentRestControllerApi
     */
    listManagementRoleAssignment(role, personId, current, term, showDismissed, options) {
        return ManagementRoleAssignmentRestControllerApiFp(this.configuration).listManagementRoleAssignment(role, personId, current, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {PageManagementRoleAssignmentRoleEnum} [role]
     * @param {number} [personId]
     * @param {boolean} [current]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementRoleAssignmentRestControllerApi
     */
    pageManagementRoleAssignment(page, size, sort, role, personId, current, term, showDismissed, options) {
        return ManagementRoleAssignmentRestControllerApiFp(this.configuration).pageManagementRoleAssignment(page, size, sort, role, personId, current, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ManagementRoleAssignment} managementRoleAssignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementRoleAssignmentRestControllerApi
     */
    saveManagementRoleAssignment(managementRoleAssignment, options) {
        return ManagementRoleAssignmentRestControllerApiFp(this.configuration).saveManagementRoleAssignment(managementRoleAssignment, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountManagementRoleAssignmentRoleEnum = {
    MANAGEMENT: 'MANAGEMENT',
    INFORMATION_OWNER: 'INFORMATION_OWNER',
    SERVICE_OWNER: 'SERVICE_OWNER',
    SYSTEM_OWNER: 'SYSTEM_OWNER',
    SECURITY_OFFICER: 'SECURITY_OFFICER',
    QUALITY_COORDINATOR: 'QUALITY_COORDINATOR',
    INTERNAL_AUDITOR: 'INTERNAL_AUDITOR',
    SECURITY_CONTACT: 'SECURITY_CONTACT'
};
/**
 * @export
 */
export const ListManagementRoleAssignmentRoleEnum = {
    MANAGEMENT: 'MANAGEMENT',
    INFORMATION_OWNER: 'INFORMATION_OWNER',
    SERVICE_OWNER: 'SERVICE_OWNER',
    SYSTEM_OWNER: 'SYSTEM_OWNER',
    SECURITY_OFFICER: 'SECURITY_OFFICER',
    QUALITY_COORDINATOR: 'QUALITY_COORDINATOR',
    INTERNAL_AUDITOR: 'INTERNAL_AUDITOR',
    SECURITY_CONTACT: 'SECURITY_CONTACT'
};
/**
 * @export
 */
export const PageManagementRoleAssignmentRoleEnum = {
    MANAGEMENT: 'MANAGEMENT',
    INFORMATION_OWNER: 'INFORMATION_OWNER',
    SERVICE_OWNER: 'SERVICE_OWNER',
    SYSTEM_OWNER: 'SYSTEM_OWNER',
    SECURITY_OFFICER: 'SECURITY_OFFICER',
    QUALITY_COORDINATOR: 'QUALITY_COORDINATOR',
    INTERNAL_AUDITOR: 'INTERNAL_AUDITOR',
    SECURITY_CONTACT: 'SECURITY_CONTACT'
};
/**
 * OccupationRestControllerApi - axios parameter creator
 * @export
 */
export const OccupationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {Array<number>} [personId]
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        occupation: async (personId, year, options = {}) => {
            const localVarPath = `/api/admin/billing/occupation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OccupationRestControllerApi - functional programming interface
 * @export
 */
export const OccupationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = OccupationRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {Array<number>} [personId]
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async occupation(personId, year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.occupation(personId, year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OccupationRestControllerApi.occupation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OccupationRestControllerApi - factory interface
 * @export
 */
export const OccupationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OccupationRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {Array<number>} [personId]
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        occupation(personId, year, options) {
            return localVarFp.occupation(personId, year, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OccupationRestControllerApi - object-oriented interface
 * @export
 * @class OccupationRestControllerApi
 * @extends {BaseAPI}
 */
export class OccupationRestControllerApi extends BaseAPI {
    /**
     *
     * @param {Array<number>} [personId]
     * @param {number} [year]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OccupationRestControllerApi
     */
    occupation(personId, year, options) {
        return OccupationRestControllerApiFp(this.configuration).occupation(personId, year, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrgRequestRestControllerApi - axios parameter creator
 * @export
 */
export const OrgRequestRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [organizationId]
         * @param {number} [contactId]
         * @param {CountOrgRequestStatusEnum} [status]
         * @param {boolean} [openOnly]
         * @param {boolean} [actionDue]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOrgRequest: async (organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/org-request/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (contactId !== undefined) {
                localVarQueryParameter['contactId'] = contactId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (openOnly !== undefined) {
                localVarQueryParameter['openOnly'] = openOnly;
            }
            if (actionDue !== undefined) {
                localVarQueryParameter['actionDue'] = actionDue;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchOrgRequest: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchOrgRequest', 'ids', ids);
            const localVarPath = `/api/admin/marketing/org-request/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissOrgRequest: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissOrgRequest', 'id', id);
            const localVarPath = `/api/admin/marketing/org-request/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgRequest: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrgRequest', 'id', id);
            const localVarPath = `/api/admin/marketing/org-request/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [organizationId]
         * @param {number} [contactId]
         * @param {ListOrgRequestStatusEnum} [status]
         * @param {boolean} [openOnly]
         * @param {boolean} [actionDue]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrgRequest: async (organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/org-request/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (contactId !== undefined) {
                localVarQueryParameter['contactId'] = contactId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (openOnly !== undefined) {
                localVarQueryParameter['openOnly'] = openOnly;
            }
            if (actionDue !== undefined) {
                localVarQueryParameter['actionDue'] = actionDue;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyPresalesOrgRequest: async (options = {}) => {
            const localVarPath = `/api/admin/marketing/org-request/presales/notify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [organizationId]
         * @param {number} [contactId]
         * @param {PageOrgRequestStatusEnum} [status]
         * @param {boolean} [openOnly]
         * @param {boolean} [actionDue]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrgRequest: async (page, size, sort, organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/org-request/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (contactId !== undefined) {
                localVarQueryParameter['contactId'] = contactId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (openOnly !== undefined) {
                localVarQueryParameter['openOnly'] = openOnly;
            }
            if (actionDue !== undefined) {
                localVarQueryParameter['actionDue'] = actionDue;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presalesOrgRequest: async (options = {}) => {
            const localVarPath = `/api/admin/marketing/org-request/presales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshPresalesOrgRequest: async (options = {}) => {
            const localVarPath = `/api/admin/marketing/org-request/presales/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {OrgRequest} orgRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrgRequest: async (orgRequest, options = {}) => {
            // verify required parameter 'orgRequest' is not null or undefined
            assertParamExists('saveOrgRequest', 'orgRequest', orgRequest);
            const localVarPath = `/api/admin/marketing/org-request/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(orgRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrgRequestRestControllerApi - functional programming interface
 * @export
 */
export const OrgRequestRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrgRequestRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [organizationId]
         * @param {number} [contactId]
         * @param {CountOrgRequestStatusEnum} [status]
         * @param {boolean} [openOnly]
         * @param {boolean} [actionDue]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countOrgRequest(organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countOrgRequest(organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrgRequestRestControllerApi.countOrgRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchOrgRequest(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchOrgRequest(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrgRequestRestControllerApi.deleteOrDismissInBatchOrgRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissOrgRequest(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissOrgRequest(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrgRequestRestControllerApi.deleteOrDismissOrgRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgRequest(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgRequest(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrgRequestRestControllerApi.getOrgRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [organizationId]
         * @param {number} [contactId]
         * @param {ListOrgRequestStatusEnum} [status]
         * @param {boolean} [openOnly]
         * @param {boolean} [actionDue]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrgRequest(organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrgRequest(organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrgRequestRestControllerApi.listOrgRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifyPresalesOrgRequest(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifyPresalesOrgRequest(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrgRequestRestControllerApi.notifyPresalesOrgRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [organizationId]
         * @param {number} [contactId]
         * @param {PageOrgRequestStatusEnum} [status]
         * @param {boolean} [openOnly]
         * @param {boolean} [actionDue]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageOrgRequest(page, size, sort, organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageOrgRequest(page, size, sort, organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrgRequestRestControllerApi.pageOrgRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async presalesOrgRequest(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.presalesOrgRequest(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrgRequestRestControllerApi.presalesOrgRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshPresalesOrgRequest(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshPresalesOrgRequest(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrgRequestRestControllerApi.refreshPresalesOrgRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {OrgRequest} orgRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveOrgRequest(orgRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveOrgRequest(orgRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrgRequestRestControllerApi.saveOrgRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OrgRequestRestControllerApi - factory interface
 * @export
 */
export const OrgRequestRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrgRequestRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [organizationId]
         * @param {number} [contactId]
         * @param {CountOrgRequestStatusEnum} [status]
         * @param {boolean} [openOnly]
         * @param {boolean} [actionDue]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOrgRequest(organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options) {
            return localVarFp.countOrgRequest(organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchOrgRequest(ids, options) {
            return localVarFp.deleteOrDismissInBatchOrgRequest(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissOrgRequest(id, options) {
            return localVarFp.deleteOrDismissOrgRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgRequest(id, options) {
            return localVarFp.getOrgRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [organizationId]
         * @param {number} [contactId]
         * @param {ListOrgRequestStatusEnum} [status]
         * @param {boolean} [openOnly]
         * @param {boolean} [actionDue]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrgRequest(organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options) {
            return localVarFp.listOrgRequest(organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyPresalesOrgRequest(options) {
            return localVarFp.notifyPresalesOrgRequest(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [organizationId]
         * @param {number} [contactId]
         * @param {PageOrgRequestStatusEnum} [status]
         * @param {boolean} [openOnly]
         * @param {boolean} [actionDue]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrgRequest(page, size, sort, organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options) {
            return localVarFp.pageOrgRequest(page, size, sort, organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presalesOrgRequest(options) {
            return localVarFp.presalesOrgRequest(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshPresalesOrgRequest(options) {
            return localVarFp.refreshPresalesOrgRequest(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrgRequest} orgRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrgRequest(orgRequest, options) {
            return localVarFp.saveOrgRequest(orgRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrgRequestRestControllerApi - object-oriented interface
 * @export
 * @class OrgRequestRestControllerApi
 * @extends {BaseAPI}
 */
export class OrgRequestRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [organizationId]
     * @param {number} [contactId]
     * @param {CountOrgRequestStatusEnum} [status]
     * @param {boolean} [openOnly]
     * @param {boolean} [actionDue]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgRequestRestControllerApi
     */
    countOrgRequest(organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options) {
        return OrgRequestRestControllerApiFp(this.configuration).countOrgRequest(organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgRequestRestControllerApi
     */
    deleteOrDismissInBatchOrgRequest(ids, options) {
        return OrgRequestRestControllerApiFp(this.configuration).deleteOrDismissInBatchOrgRequest(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgRequestRestControllerApi
     */
    deleteOrDismissOrgRequest(id, options) {
        return OrgRequestRestControllerApiFp(this.configuration).deleteOrDismissOrgRequest(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgRequestRestControllerApi
     */
    getOrgRequest(id, options) {
        return OrgRequestRestControllerApiFp(this.configuration).getOrgRequest(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [organizationId]
     * @param {number} [contactId]
     * @param {ListOrgRequestStatusEnum} [status]
     * @param {boolean} [openOnly]
     * @param {boolean} [actionDue]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgRequestRestControllerApi
     */
    listOrgRequest(organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options) {
        return OrgRequestRestControllerApiFp(this.configuration).listOrgRequest(organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgRequestRestControllerApi
     */
    notifyPresalesOrgRequest(options) {
        return OrgRequestRestControllerApiFp(this.configuration).notifyPresalesOrgRequest(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [organizationId]
     * @param {number} [contactId]
     * @param {PageOrgRequestStatusEnum} [status]
     * @param {boolean} [openOnly]
     * @param {boolean} [actionDue]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgRequestRestControllerApi
     */
    pageOrgRequest(page, size, sort, organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options) {
        return OrgRequestRestControllerApiFp(this.configuration).pageOrgRequest(page, size, sort, organizationId, contactId, status, openOnly, actionDue, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgRequestRestControllerApi
     */
    presalesOrgRequest(options) {
        return OrgRequestRestControllerApiFp(this.configuration).presalesOrgRequest(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgRequestRestControllerApi
     */
    refreshPresalesOrgRequest(options) {
        return OrgRequestRestControllerApiFp(this.configuration).refreshPresalesOrgRequest(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrgRequest} orgRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgRequestRestControllerApi
     */
    saveOrgRequest(orgRequest, options) {
        return OrgRequestRestControllerApiFp(this.configuration).saveOrgRequest(orgRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountOrgRequestStatusEnum = {
    DETECTED: 'DETECTED',
    PROPOSED: 'PROPOSED',
    WON: 'WON',
    LOST: 'LOST',
    LOST_ON_PRICE: 'LOST_ON_PRICE'
};
/**
 * @export
 */
export const ListOrgRequestStatusEnum = {
    DETECTED: 'DETECTED',
    PROPOSED: 'PROPOSED',
    WON: 'WON',
    LOST: 'LOST',
    LOST_ON_PRICE: 'LOST_ON_PRICE'
};
/**
 * @export
 */
export const PageOrgRequestStatusEnum = {
    DETECTED: 'DETECTED',
    PROPOSED: 'PROPOSED',
    WON: 'WON',
    LOST: 'LOST',
    LOST_ON_PRICE: 'LOST_ON_PRICE'
};
/**
 * OrganizationRestControllerApi - axios parameter creator
 * @export
 */
export const OrganizationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CountOrganizationStatusEnum} [status]
         * @param {boolean} [baja]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOrganization: async (status, baja, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/organization/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (baja !== undefined) {
                localVarQueryParameter['baja'] = baja;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchOrganization: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchOrganization', 'ids', ids);
            const localVarPath = `/api/admin/marketing/organization/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissOrganization: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissOrganization', 'id', id);
            const localVarPath = `/api/admin/marketing/organization/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrganization', 'id', id);
            const localVarPath = `/api/admin/marketing/organization/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ListOrganizationStatusEnum} [status]
         * @param {boolean} [baja]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganization: async (status, baja, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/organization/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (baja !== undefined) {
                localVarQueryParameter['baja'] = baja;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageOrganizationStatusEnum} [status]
         * @param {boolean} [baja]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrganization: async (page, size, sort, status, baja, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/organization/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (baja !== undefined) {
                localVarQueryParameter['baja'] = baja;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Organization} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrganization: async (organization, options = {}) => {
            // verify required parameter 'organization' is not null or undefined
            assertParamExists('saveOrganization', 'organization', organization);
            const localVarPath = `/api/admin/marketing/organization/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(organization, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrganizationRestControllerApi - functional programming interface
 * @export
 */
export const OrganizationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrganizationRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CountOrganizationStatusEnum} [status]
         * @param {boolean} [baja]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countOrganization(status, baja, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countOrganization(status, baja, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRestControllerApi.countOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchOrganization(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchOrganization(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRestControllerApi.deleteOrDismissInBatchOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissOrganization(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissOrganization(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRestControllerApi.deleteOrDismissOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganization(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganization(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRestControllerApi.getOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ListOrganizationStatusEnum} [status]
         * @param {boolean} [baja]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrganization(status, baja, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrganization(status, baja, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRestControllerApi.listOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageOrganizationStatusEnum} [status]
         * @param {boolean} [baja]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageOrganization(page, size, sort, status, baja, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageOrganization(page, size, sort, status, baja, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRestControllerApi.pageOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Organization} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveOrganization(organization, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveOrganization(organization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRestControllerApi.saveOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OrganizationRestControllerApi - factory interface
 * @export
 */
export const OrganizationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrganizationRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {CountOrganizationStatusEnum} [status]
         * @param {boolean} [baja]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOrganization(status, baja, term, showDismissed, options) {
            return localVarFp.countOrganization(status, baja, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchOrganization(ids, options) {
            return localVarFp.deleteOrDismissInBatchOrganization(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissOrganization(id, options) {
            return localVarFp.deleteOrDismissOrganization(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization(id, options) {
            return localVarFp.getOrganization(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ListOrganizationStatusEnum} [status]
         * @param {boolean} [baja]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganization(status, baja, term, showDismissed, options) {
            return localVarFp.listOrganization(status, baja, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageOrganizationStatusEnum} [status]
         * @param {boolean} [baja]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrganization(page, size, sort, status, baja, term, showDismissed, options) {
            return localVarFp.pageOrganization(page, size, sort, status, baja, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Organization} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrganization(organization, options) {
            return localVarFp.saveOrganization(organization, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrganizationRestControllerApi - object-oriented interface
 * @export
 * @class OrganizationRestControllerApi
 * @extends {BaseAPI}
 */
export class OrganizationRestControllerApi extends BaseAPI {
    /**
     *
     * @param {CountOrganizationStatusEnum} [status]
     * @param {boolean} [baja]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationRestControllerApi
     */
    countOrganization(status, baja, term, showDismissed, options) {
        return OrganizationRestControllerApiFp(this.configuration).countOrganization(status, baja, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationRestControllerApi
     */
    deleteOrDismissInBatchOrganization(ids, options) {
        return OrganizationRestControllerApiFp(this.configuration).deleteOrDismissInBatchOrganization(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationRestControllerApi
     */
    deleteOrDismissOrganization(id, options) {
        return OrganizationRestControllerApiFp(this.configuration).deleteOrDismissOrganization(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationRestControllerApi
     */
    getOrganization(id, options) {
        return OrganizationRestControllerApiFp(this.configuration).getOrganization(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ListOrganizationStatusEnum} [status]
     * @param {boolean} [baja]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationRestControllerApi
     */
    listOrganization(status, baja, term, showDismissed, options) {
        return OrganizationRestControllerApiFp(this.configuration).listOrganization(status, baja, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {PageOrganizationStatusEnum} [status]
     * @param {boolean} [baja]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationRestControllerApi
     */
    pageOrganization(page, size, sort, status, baja, term, showDismissed, options) {
        return OrganizationRestControllerApiFp(this.configuration).pageOrganization(page, size, sort, status, baja, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Organization} organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationRestControllerApi
     */
    saveOrganization(organization, options) {
        return OrganizationRestControllerApiFp(this.configuration).saveOrganization(organization, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountOrganizationStatusEnum = {
    ACTIVO: 'ACTIVO',
    EX_CLIENTE: 'EX_CLIENTE',
    NO_REACTIVAR: 'NO_REACTIVAR'
};
/**
 * @export
 */
export const ListOrganizationStatusEnum = {
    ACTIVO: 'ACTIVO',
    EX_CLIENTE: 'EX_CLIENTE',
    NO_REACTIVAR: 'NO_REACTIVAR'
};
/**
 * @export
 */
export const PageOrganizationStatusEnum = {
    ACTIVO: 'ACTIVO',
    EX_CLIENTE: 'EX_CLIENTE',
    NO_REACTIVAR: 'NO_REACTIVAR'
};
/**
 * OrganizationUnitMemberRestControllerApi - axios parameter creator
 * @export
 */
export const OrganizationUnitMemberRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOrganizationUnitMember: async (personId, visibleByEmployee, term, showDismissed, options = {}) => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('countOrganizationUnitMember', 'personId', personId);
            const localVarPath = `/api/admin/employee/organization-unit-member/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchOrganizationUnitMember: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchOrganizationUnitMember', 'ids', ids);
            const localVarPath = `/api/admin/employee/organization-unit-member/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissOrganizationUnitMember: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissOrganizationUnitMember', 'id', id);
            const localVarPath = `/api/admin/employee/organization-unit-member/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUnitMember: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrganizationUnitMember', 'id', id);
            const localVarPath = `/api/admin/employee/organization-unit-member/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationUnitMember: async (personId, visibleByEmployee, term, showDismissed, options = {}) => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('listOrganizationUnitMember', 'personId', personId);
            const localVarPath = `/api/admin/employee/organization-unit-member/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} personId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrganizationUnitMember: async (personId, page, size, sort, visibleByEmployee, term, showDismissed, options = {}) => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('pageOrganizationUnitMember', 'personId', personId);
            const localVarPath = `/api/admin/employee/organization-unit-member/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {OrganizationUnitMember} organizationUnitMember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrganizationUnitMember: async (organizationUnitMember, options = {}) => {
            // verify required parameter 'organizationUnitMember' is not null or undefined
            assertParamExists('saveOrganizationUnitMember', 'organizationUnitMember', organizationUnitMember);
            const localVarPath = `/api/admin/employee/organization-unit-member/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(organizationUnitMember, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrganizationUnitMemberRestControllerApi - functional programming interface
 * @export
 */
export const OrganizationUnitMemberRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrganizationUnitMemberRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUnitMemberRestControllerApi.countOrganizationUnitMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchOrganizationUnitMember(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchOrganizationUnitMember(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUnitMemberRestControllerApi.deleteOrDismissInBatchOrganizationUnitMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissOrganizationUnitMember(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissOrganizationUnitMember(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUnitMemberRestControllerApi.deleteOrDismissOrganizationUnitMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationUnitMember(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationUnitMember(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUnitMemberRestControllerApi.getOrganizationUnitMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUnitMemberRestControllerApi.listOrganizationUnitMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} personId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageOrganizationUnitMember(personId, page, size, sort, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageOrganizationUnitMember(personId, page, size, sort, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUnitMemberRestControllerApi.pageOrganizationUnitMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {OrganizationUnitMember} organizationUnitMember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveOrganizationUnitMember(organizationUnitMember, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveOrganizationUnitMember(organizationUnitMember, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUnitMemberRestControllerApi.saveOrganizationUnitMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OrganizationUnitMemberRestControllerApi - factory interface
 * @export
 */
export const OrganizationUnitMemberRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrganizationUnitMemberRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchOrganizationUnitMember(ids, options) {
            return localVarFp.deleteOrDismissInBatchOrganizationUnitMember(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissOrganizationUnitMember(id, options) {
            return localVarFp.deleteOrDismissOrganizationUnitMember(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUnitMember(id, options) {
            return localVarFp.getOrganizationUnitMember(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrganizationUnitMember(personId, page, size, sort, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pageOrganizationUnitMember(personId, page, size, sort, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrganizationUnitMember} organizationUnitMember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrganizationUnitMember(organizationUnitMember, options) {
            return localVarFp.saveOrganizationUnitMember(organizationUnitMember, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrganizationUnitMemberRestControllerApi - object-oriented interface
 * @export
 * @class OrganizationUnitMemberRestControllerApi
 * @extends {BaseAPI}
 */
export class OrganizationUnitMemberRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} personId
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitMemberRestControllerApi
     */
    countOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options) {
        return OrganizationUnitMemberRestControllerApiFp(this.configuration).countOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitMemberRestControllerApi
     */
    deleteOrDismissInBatchOrganizationUnitMember(ids, options) {
        return OrganizationUnitMemberRestControllerApiFp(this.configuration).deleteOrDismissInBatchOrganizationUnitMember(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitMemberRestControllerApi
     */
    deleteOrDismissOrganizationUnitMember(id, options) {
        return OrganizationUnitMemberRestControllerApiFp(this.configuration).deleteOrDismissOrganizationUnitMember(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitMemberRestControllerApi
     */
    getOrganizationUnitMember(id, options) {
        return OrganizationUnitMemberRestControllerApiFp(this.configuration).getOrganizationUnitMember(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitMemberRestControllerApi
     */
    listOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options) {
        return OrganizationUnitMemberRestControllerApiFp(this.configuration).listOrganizationUnitMember(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitMemberRestControllerApi
     */
    pageOrganizationUnitMember(personId, page, size, sort, visibleByEmployee, term, showDismissed, options) {
        return OrganizationUnitMemberRestControllerApiFp(this.configuration).pageOrganizationUnitMember(personId, page, size, sort, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrganizationUnitMember} organizationUnitMember
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitMemberRestControllerApi
     */
    saveOrganizationUnitMember(organizationUnitMember, options) {
        return OrganizationUnitMemberRestControllerApiFp(this.configuration).saveOrganizationUnitMember(organizationUnitMember, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrganizationUnitRestControllerApi - axios parameter creator
 * @export
 */
export const OrganizationUnitRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOrganizationUnit: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/organization-unit/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchOrganizationUnit: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchOrganizationUnit', 'ids', ids);
            const localVarPath = `/api/admin/employee/organization-unit/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissOrganizationUnit: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissOrganizationUnit', 'id', id);
            const localVarPath = `/api/admin/employee/organization-unit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUnit: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrganizationUnit', 'id', id);
            const localVarPath = `/api/admin/employee/organization-unit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationUnit: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/organization-unit/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrganizationUnit: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/organization-unit/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {OrganizationUnit} organizationUnit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrganizationUnit: async (organizationUnit, options = {}) => {
            // verify required parameter 'organizationUnit' is not null or undefined
            assertParamExists('saveOrganizationUnit', 'organizationUnit', organizationUnit);
            const localVarPath = `/api/admin/employee/organization-unit/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(organizationUnit, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrganizationUnitRestControllerApi - functional programming interface
 * @export
 */
export const OrganizationUnitRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrganizationUnitRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countOrganizationUnit(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countOrganizationUnit(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUnitRestControllerApi.countOrganizationUnit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchOrganizationUnit(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchOrganizationUnit(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUnitRestControllerApi.deleteOrDismissInBatchOrganizationUnit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissOrganizationUnit(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissOrganizationUnit(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUnitRestControllerApi.deleteOrDismissOrganizationUnit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationUnit(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationUnit(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUnitRestControllerApi.getOrganizationUnit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrganizationUnit(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrganizationUnit(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUnitRestControllerApi.listOrganizationUnit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageOrganizationUnit(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageOrganizationUnit(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUnitRestControllerApi.pageOrganizationUnit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {OrganizationUnit} organizationUnit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveOrganizationUnit(organizationUnit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveOrganizationUnit(organizationUnit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationUnitRestControllerApi.saveOrganizationUnit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OrganizationUnitRestControllerApi - factory interface
 * @export
 */
export const OrganizationUnitRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrganizationUnitRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOrganizationUnit(term, showDismissed, options) {
            return localVarFp.countOrganizationUnit(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchOrganizationUnit(ids, options) {
            return localVarFp.deleteOrDismissInBatchOrganizationUnit(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissOrganizationUnit(id, options) {
            return localVarFp.deleteOrDismissOrganizationUnit(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationUnit(id, options) {
            return localVarFp.getOrganizationUnit(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationUnit(term, showDismissed, options) {
            return localVarFp.listOrganizationUnit(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrganizationUnit(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageOrganizationUnit(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrganizationUnit} organizationUnit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOrganizationUnit(organizationUnit, options) {
            return localVarFp.saveOrganizationUnit(organizationUnit, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrganizationUnitRestControllerApi - object-oriented interface
 * @export
 * @class OrganizationUnitRestControllerApi
 * @extends {BaseAPI}
 */
export class OrganizationUnitRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitRestControllerApi
     */
    countOrganizationUnit(term, showDismissed, options) {
        return OrganizationUnitRestControllerApiFp(this.configuration).countOrganizationUnit(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitRestControllerApi
     */
    deleteOrDismissInBatchOrganizationUnit(ids, options) {
        return OrganizationUnitRestControllerApiFp(this.configuration).deleteOrDismissInBatchOrganizationUnit(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitRestControllerApi
     */
    deleteOrDismissOrganizationUnit(id, options) {
        return OrganizationUnitRestControllerApiFp(this.configuration).deleteOrDismissOrganizationUnit(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitRestControllerApi
     */
    getOrganizationUnit(id, options) {
        return OrganizationUnitRestControllerApiFp(this.configuration).getOrganizationUnit(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitRestControllerApi
     */
    listOrganizationUnit(term, showDismissed, options) {
        return OrganizationUnitRestControllerApiFp(this.configuration).listOrganizationUnit(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitRestControllerApi
     */
    pageOrganizationUnit(page, size, sort, term, showDismissed, options) {
        return OrganizationUnitRestControllerApiFp(this.configuration).pageOrganizationUnit(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrganizationUnit} organizationUnit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUnitRestControllerApi
     */
    saveOrganizationUnit(organizationUnit, options) {
        return OrganizationUnitRestControllerApiFp(this.configuration).saveOrganizationUnit(organizationUnit, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OverviewRestControllerApi - axios parameter creator
 * @export
 */
export const OverviewRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {OverviewGranularityEnum} [granularity]
         * @param {number} [year]
         * @param {number} [index]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overview: async (granularity, year, index, options = {}) => {
            const localVarPath = `/api/admin/billing/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (index !== undefined) {
                localVarQueryParameter['index'] = index;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {OverviewSettings} overviewSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSettings: async (overviewSettings, options = {}) => {
            // verify required parameter 'overviewSettings' is not null or undefined
            assertParamExists('saveSettings', 'overviewSettings', overviewSettings);
            const localVarPath = `/api/admin/billing/overview/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(overviewSettings, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settings: async (options = {}) => {
            const localVarPath = `/api/admin/billing/overview/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OverviewRestControllerApi - functional programming interface
 * @export
 */
export const OverviewRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = OverviewRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {OverviewGranularityEnum} [granularity]
         * @param {number} [year]
         * @param {number} [index]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overview(granularity, year, index, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overview(granularity, year, index, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OverviewRestControllerApi.overview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {OverviewSettings} overviewSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSettings(overviewSettings, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSettings(overviewSettings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OverviewRestControllerApi.saveSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settings(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OverviewRestControllerApi.settings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OverviewRestControllerApi - factory interface
 * @export
 */
export const OverviewRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OverviewRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {OverviewGranularityEnum} [granularity]
         * @param {number} [year]
         * @param {number} [index]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overview(granularity, year, index, options) {
            return localVarFp.overview(granularity, year, index, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OverviewSettings} overviewSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSettings(overviewSettings, options) {
            return localVarFp.saveSettings(overviewSettings, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settings(options) {
            return localVarFp.settings(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OverviewRestControllerApi - object-oriented interface
 * @export
 * @class OverviewRestControllerApi
 * @extends {BaseAPI}
 */
export class OverviewRestControllerApi extends BaseAPI {
    /**
     *
     * @param {OverviewGranularityEnum} [granularity]
     * @param {number} [year]
     * @param {number} [index]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverviewRestControllerApi
     */
    overview(granularity, year, index, options) {
        return OverviewRestControllerApiFp(this.configuration).overview(granularity, year, index, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OverviewSettings} overviewSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverviewRestControllerApi
     */
    saveSettings(overviewSettings, options) {
        return OverviewRestControllerApiFp(this.configuration).saveSettings(overviewSettings, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverviewRestControllerApi
     */
    settings(options) {
        return OverviewRestControllerApiFp(this.configuration).settings(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const OverviewGranularityEnum = {
    MONTH: 'MONTH',
    QUARTER: 'QUARTER',
    YEAR: 'YEAR'
};
/**
 * PayrollPackRestControllerApi - axios parameter creator
 * @export
 */
export const PayrollPackRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPayrollPack: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/payroll/pack/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPayrollPack: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchPayrollPack', 'ids', ids);
            const localVarPath = `/api/admin/employee/payroll/pack/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPayrollPack: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissPayrollPack', 'id', id);
            const localVarPath = `/api/admin/employee/payroll/pack/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} payrollPackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCostsPayrollPack: async (payrollPackId, options = {}) => {
            // verify required parameter 'payrollPackId' is not null or undefined
            assertParamExists('downloadCostsPayrollPack', 'payrollPackId', payrollPackId);
            const localVarPath = `/api/admin/employee/payroll/pack/{payrollPackId}/costs/download`
                .replace(`{${"payrollPackId"}}`, encodeURIComponent(String(payrollPackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} payrollPackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPdfsPayrollPack: async (payrollPackId, options = {}) => {
            // verify required parameter 'payrollPackId' is not null or undefined
            assertParamExists('downloadPdfsPayrollPack', 'payrollPackId', payrollPackId);
            const localVarPath = `/api/admin/employee/payroll/pack/{payrollPackId}/payroll/download`
                .replace(`{${"payrollPackId"}}`, encodeURIComponent(String(payrollPackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayrollPack: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPayrollPack', 'id', id);
            const localVarPath = `/api/admin/employee/payroll/pack/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPayrollPack: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/payroll/pack/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePayrollPack: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/payroll/pack/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} payrollPackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPayrollPack: async (payrollPackId, options = {}) => {
            // verify required parameter 'payrollPackId' is not null or undefined
            assertParamExists('processPayrollPack', 'payrollPackId', payrollPackId);
            const localVarPath = `/api/admin/employee/payroll/pack/{payrollPackId}/process`
                .replace(`{${"payrollPackId"}}`, encodeURIComponent(String(payrollPackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PayrollPack} payrollPack
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePayrollPack: async (payrollPack, options = {}) => {
            // verify required parameter 'payrollPack' is not null or undefined
            assertParamExists('savePayrollPack', 'payrollPack', payrollPack);
            const localVarPath = `/api/admin/employee/payroll/pack/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(payrollPack, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PayrollPackRestControllerApi - functional programming interface
 * @export
 */
export const PayrollPackRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PayrollPackRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countPayrollPack(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countPayrollPack(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollPackRestControllerApi.countPayrollPack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchPayrollPack(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchPayrollPack(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollPackRestControllerApi.deleteOrDismissInBatchPayrollPack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissPayrollPack(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissPayrollPack(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollPackRestControllerApi.deleteOrDismissPayrollPack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} payrollPackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCostsPayrollPack(payrollPackId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCostsPayrollPack(payrollPackId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollPackRestControllerApi.downloadCostsPayrollPack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} payrollPackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPdfsPayrollPack(payrollPackId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPdfsPayrollPack(payrollPackId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollPackRestControllerApi.downloadPdfsPayrollPack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayrollPack(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayrollPack(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollPackRestControllerApi.getPayrollPack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPayrollPack(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPayrollPack(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollPackRestControllerApi.listPayrollPack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pagePayrollPack(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pagePayrollPack(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollPackRestControllerApi.pagePayrollPack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} payrollPackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processPayrollPack(payrollPackId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processPayrollPack(payrollPackId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollPackRestControllerApi.processPayrollPack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {PayrollPack} payrollPack
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePayrollPack(payrollPack, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePayrollPack(payrollPack, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollPackRestControllerApi.savePayrollPack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PayrollPackRestControllerApi - factory interface
 * @export
 */
export const PayrollPackRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PayrollPackRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPayrollPack(term, showDismissed, options) {
            return localVarFp.countPayrollPack(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPayrollPack(ids, options) {
            return localVarFp.deleteOrDismissInBatchPayrollPack(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPayrollPack(id, options) {
            return localVarFp.deleteOrDismissPayrollPack(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} payrollPackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCostsPayrollPack(payrollPackId, options) {
            return localVarFp.downloadCostsPayrollPack(payrollPackId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} payrollPackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPdfsPayrollPack(payrollPackId, options) {
            return localVarFp.downloadPdfsPayrollPack(payrollPackId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayrollPack(id, options) {
            return localVarFp.getPayrollPack(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPayrollPack(term, showDismissed, options) {
            return localVarFp.listPayrollPack(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePayrollPack(page, size, sort, term, showDismissed, options) {
            return localVarFp.pagePayrollPack(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} payrollPackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPayrollPack(payrollPackId, options) {
            return localVarFp.processPayrollPack(payrollPackId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PayrollPack} payrollPack
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePayrollPack(payrollPack, options) {
            return localVarFp.savePayrollPack(payrollPack, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PayrollPackRestControllerApi - object-oriented interface
 * @export
 * @class PayrollPackRestControllerApi
 * @extends {BaseAPI}
 */
export class PayrollPackRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    countPayrollPack(term, showDismissed, options) {
        return PayrollPackRestControllerApiFp(this.configuration).countPayrollPack(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    deleteOrDismissInBatchPayrollPack(ids, options) {
        return PayrollPackRestControllerApiFp(this.configuration).deleteOrDismissInBatchPayrollPack(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    deleteOrDismissPayrollPack(id, options) {
        return PayrollPackRestControllerApiFp(this.configuration).deleteOrDismissPayrollPack(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} payrollPackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    downloadCostsPayrollPack(payrollPackId, options) {
        return PayrollPackRestControllerApiFp(this.configuration).downloadCostsPayrollPack(payrollPackId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} payrollPackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    downloadPdfsPayrollPack(payrollPackId, options) {
        return PayrollPackRestControllerApiFp(this.configuration).downloadPdfsPayrollPack(payrollPackId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    getPayrollPack(id, options) {
        return PayrollPackRestControllerApiFp(this.configuration).getPayrollPack(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    listPayrollPack(term, showDismissed, options) {
        return PayrollPackRestControllerApiFp(this.configuration).listPayrollPack(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    pagePayrollPack(page, size, sort, term, showDismissed, options) {
        return PayrollPackRestControllerApiFp(this.configuration).pagePayrollPack(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} payrollPackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    processPayrollPack(payrollPackId, options) {
        return PayrollPackRestControllerApiFp(this.configuration).processPayrollPack(payrollPackId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PayrollPack} payrollPack
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollPackRestControllerApi
     */
    savePayrollPack(payrollPack, options) {
        return PayrollPackRestControllerApiFp(this.configuration).savePayrollPack(payrollPack, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PayrollRestControllerApi - axios parameter creator
 * @export
 */
export const PayrollRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annualSummaryPayroll: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('annualSummaryPayroll', 'year', year);
            const localVarPath = `/api/admin/employee/payroll/annual-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPayroll: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/payroll/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPayroll: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchPayroll', 'ids', ids);
            const localVarPath = `/api/admin/employee/payroll/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPayroll: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissPayroll', 'id', id);
            const localVarPath = `/api/admin/employee/payroll/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} payrollId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPayroll: async (payrollId, options = {}) => {
            // verify required parameter 'payrollId' is not null or undefined
            assertParamExists('downloadPayroll', 'payrollId', payrollId);
            const localVarPath = `/api/admin/employee/payroll/{payrollId}/download`
                .replace(`{${"payrollId"}}`, encodeURIComponent(String(payrollId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayroll: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPayroll', 'id', id);
            const localVarPath = `/api/admin/employee/payroll/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPayroll: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/payroll/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePayroll: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/payroll/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Payroll} payroll
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePayroll: async (payroll, options = {}) => {
            // verify required parameter 'payroll' is not null or undefined
            assertParamExists('savePayroll', 'payroll', payroll);
            const localVarPath = `/api/admin/employee/payroll/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(payroll, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PayrollRestControllerApi - functional programming interface
 * @export
 */
export const PayrollRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PayrollRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async annualSummaryPayroll(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.annualSummaryPayroll(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollRestControllerApi.annualSummaryPayroll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countPayroll(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countPayroll(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollRestControllerApi.countPayroll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchPayroll(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchPayroll(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollRestControllerApi.deleteOrDismissInBatchPayroll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissPayroll(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissPayroll(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollRestControllerApi.deleteOrDismissPayroll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} payrollId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPayroll(payrollId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPayroll(payrollId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollRestControllerApi.downloadPayroll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayroll(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayroll(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollRestControllerApi.getPayroll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPayroll(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPayroll(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollRestControllerApi.listPayroll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pagePayroll(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pagePayroll(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollRestControllerApi.pagePayroll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Payroll} payroll
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePayroll(payroll, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePayroll(payroll, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayrollRestControllerApi.savePayroll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PayrollRestControllerApi - factory interface
 * @export
 */
export const PayrollRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PayrollRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annualSummaryPayroll(year, options) {
            return localVarFp.annualSummaryPayroll(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPayroll(term, showDismissed, options) {
            return localVarFp.countPayroll(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPayroll(ids, options) {
            return localVarFp.deleteOrDismissInBatchPayroll(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPayroll(id, options) {
            return localVarFp.deleteOrDismissPayroll(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} payrollId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPayroll(payrollId, options) {
            return localVarFp.downloadPayroll(payrollId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayroll(id, options) {
            return localVarFp.getPayroll(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPayroll(term, showDismissed, options) {
            return localVarFp.listPayroll(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePayroll(page, size, sort, term, showDismissed, options) {
            return localVarFp.pagePayroll(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Payroll} payroll
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePayroll(payroll, options) {
            return localVarFp.savePayroll(payroll, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PayrollRestControllerApi - object-oriented interface
 * @export
 * @class PayrollRestControllerApi
 * @extends {BaseAPI}
 */
export class PayrollRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollRestControllerApi
     */
    annualSummaryPayroll(year, options) {
        return PayrollRestControllerApiFp(this.configuration).annualSummaryPayroll(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollRestControllerApi
     */
    countPayroll(term, showDismissed, options) {
        return PayrollRestControllerApiFp(this.configuration).countPayroll(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollRestControllerApi
     */
    deleteOrDismissInBatchPayroll(ids, options) {
        return PayrollRestControllerApiFp(this.configuration).deleteOrDismissInBatchPayroll(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollRestControllerApi
     */
    deleteOrDismissPayroll(id, options) {
        return PayrollRestControllerApiFp(this.configuration).deleteOrDismissPayroll(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} payrollId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollRestControllerApi
     */
    downloadPayroll(payrollId, options) {
        return PayrollRestControllerApiFp(this.configuration).downloadPayroll(payrollId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollRestControllerApi
     */
    getPayroll(id, options) {
        return PayrollRestControllerApiFp(this.configuration).getPayroll(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollRestControllerApi
     */
    listPayroll(term, showDismissed, options) {
        return PayrollRestControllerApiFp(this.configuration).listPayroll(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollRestControllerApi
     */
    pagePayroll(page, size, sort, term, showDismissed, options) {
        return PayrollRestControllerApiFp(this.configuration).pagePayroll(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Payroll} payroll
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayrollRestControllerApi
     */
    savePayroll(payroll, options) {
        return PayrollRestControllerApiFp(this.configuration).savePayroll(payroll, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PendingRestControllerApi - axios parameter creator
 * @export
 */
export const PendingRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {PendingActionRequest} pendingActionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actPending: async (pendingActionRequest, options = {}) => {
            // verify required parameter 'pendingActionRequest' is not null or undefined
            assertParamExists('actPending', 'pendingActionRequest', pendingActionRequest);
            const localVarPath = `/api/admin/pending/action`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(pendingActionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {boolean} [all]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        boardPending: async (all, options = {}) => {
            const localVarPath = `/api/admin/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (all !== undefined) {
                localVarQueryParameter['all'] = all;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PendingRestControllerApi - functional programming interface
 * @export
 */
export const PendingRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PendingRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {PendingActionRequest} pendingActionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actPending(pendingActionRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actPending(pendingActionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PendingRestControllerApi.actPending']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {boolean} [all]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async boardPending(all, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.boardPending(all, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PendingRestControllerApi.boardPending']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PendingRestControllerApi - factory interface
 * @export
 */
export const PendingRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PendingRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {PendingActionRequest} pendingActionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actPending(pendingActionRequest, options) {
            return localVarFp.actPending(pendingActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [all]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        boardPending(all, options) {
            return localVarFp.boardPending(all, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PendingRestControllerApi - object-oriented interface
 * @export
 * @class PendingRestControllerApi
 * @extends {BaseAPI}
 */
export class PendingRestControllerApi extends BaseAPI {
    /**
     *
     * @param {PendingActionRequest} pendingActionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PendingRestControllerApi
     */
    actPending(pendingActionRequest, options) {
        return PendingRestControllerApiFp(this.configuration).actPending(pendingActionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [all]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PendingRestControllerApi
     */
    boardPending(all, options) {
        return PendingRestControllerApiFp(this.configuration).boardPending(all, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PersonDocumentRestControllerApi - axios parameter creator
 * @export
 */
export const PersonDocumentRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [typeId]
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonDocument: async (typeId, personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/person/document/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (typeId !== undefined) {
                localVarQueryParameter['typeId'] = typeId;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonDocument: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchPersonDocument', 'ids', ids);
            const localVarPath = `/api/admin/employee/person/document/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonDocument: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissPersonDocument', 'id', id);
            const localVarPath = `/api/admin/employee/person/document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [year]
         * @param {number} [type]
         * @param {number} [person]
         * @param {boolean} [includeFormer]
         * @param {boolean} [namePrefix]
         * @param {boolean} [flat]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPersonDocument: async (year, type, person, includeFormer, namePrefix, flat, options = {}) => {
            const localVarPath = `/api/admin/employee/person/document/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (person !== undefined) {
                localVarQueryParameter['person'] = person;
            }
            if (includeFormer !== undefined) {
                localVarQueryParameter['includeFormer'] = includeFormer;
            }
            if (namePrefix !== undefined) {
                localVarQueryParameter['namePrefix'] = namePrefix;
            }
            if (flat !== undefined) {
                localVarQueryParameter['flat'] = flat;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [year]
         * @param {number} [type]
         * @param {number} [person]
         * @param {boolean} [includeFormer]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSummaryPersonDocument: async (year, type, person, includeFormer, options = {}) => {
            const localVarPath = `/api/admin/employee/person/document/export/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (person !== undefined) {
                localVarQueryParameter['person'] = person;
            }
            if (includeFormer !== undefined) {
                localVarQueryParameter['includeFormer'] = includeFormer;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonDocument: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPersonDocument', 'id', id);
            const localVarPath = `/api/admin/employee/person/document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [typeId]
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonDocument: async (typeId, personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/person/document/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (typeId !== undefined) {
                localVarQueryParameter['typeId'] = typeId;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [typeId]
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonDocument: async (page, size, sort, typeId, personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/person/document/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (typeId !== undefined) {
                localVarQueryParameter['typeId'] = typeId;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PersonDocument} personDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonDocument: async (personDocument, options = {}) => {
            // verify required parameter 'personDocument' is not null or undefined
            assertParamExists('savePersonDocument', 'personDocument', personDocument);
            const localVarPath = `/api/admin/employee/person/document/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(personDocument, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewPersonDocument: async (docId, options = {}) => {
            // verify required parameter 'docId' is not null or undefined
            assertParamExists('viewPersonDocument', 'docId', docId);
            const localVarPath = `/api/admin/employee/person/document/view/{docId}`
                .replace(`{${"docId"}}`, encodeURIComponent(String(docId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PersonDocumentRestControllerApi - functional programming interface
 * @export
 */
export const PersonDocumentRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PersonDocumentRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [typeId]
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countPersonDocument(typeId, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countPersonDocument(typeId, personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRestControllerApi.countPersonDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchPersonDocument(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchPersonDocument(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRestControllerApi.deleteOrDismissInBatchPersonDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissPersonDocument(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissPersonDocument(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRestControllerApi.deleteOrDismissPersonDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [year]
         * @param {number} [type]
         * @param {number} [person]
         * @param {boolean} [includeFormer]
         * @param {boolean} [namePrefix]
         * @param {boolean} [flat]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPersonDocument(year, type, person, includeFormer, namePrefix, flat, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportPersonDocument(year, type, person, includeFormer, namePrefix, flat, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRestControllerApi.exportPersonDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [year]
         * @param {number} [type]
         * @param {number} [person]
         * @param {boolean} [includeFormer]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportSummaryPersonDocument(year, type, person, includeFormer, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportSummaryPersonDocument(year, type, person, includeFormer, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRestControllerApi.exportSummaryPersonDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonDocument(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonDocument(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRestControllerApi.getPersonDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [typeId]
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPersonDocument(typeId, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPersonDocument(typeId, personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRestControllerApi.listPersonDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [typeId]
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pagePersonDocument(page, size, sort, typeId, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pagePersonDocument(page, size, sort, typeId, personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRestControllerApi.pagePersonDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {PersonDocument} personDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePersonDocument(personDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePersonDocument(personDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRestControllerApi.savePersonDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewPersonDocument(docId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewPersonDocument(docId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRestControllerApi.viewPersonDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PersonDocumentRestControllerApi - factory interface
 * @export
 */
export const PersonDocumentRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PersonDocumentRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [typeId]
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonDocument(typeId, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countPersonDocument(typeId, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonDocument(ids, options) {
            return localVarFp.deleteOrDismissInBatchPersonDocument(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonDocument(id, options) {
            return localVarFp.deleteOrDismissPersonDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [year]
         * @param {number} [type]
         * @param {number} [person]
         * @param {boolean} [includeFormer]
         * @param {boolean} [namePrefix]
         * @param {boolean} [flat]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPersonDocument(year, type, person, includeFormer, namePrefix, flat, options) {
            return localVarFp.exportPersonDocument(year, type, person, includeFormer, namePrefix, flat, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [year]
         * @param {number} [type]
         * @param {number} [person]
         * @param {boolean} [includeFormer]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSummaryPersonDocument(year, type, person, includeFormer, options) {
            return localVarFp.exportSummaryPersonDocument(year, type, person, includeFormer, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonDocument(id, options) {
            return localVarFp.getPersonDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [typeId]
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonDocument(typeId, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listPersonDocument(typeId, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [typeId]
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonDocument(page, size, sort, typeId, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pagePersonDocument(page, size, sort, typeId, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersonDocument} personDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonDocument(personDocument, options) {
            return localVarFp.savePersonDocument(personDocument, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewPersonDocument(docId, options) {
            return localVarFp.viewPersonDocument(docId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PersonDocumentRestControllerApi - object-oriented interface
 * @export
 * @class PersonDocumentRestControllerApi
 * @extends {BaseAPI}
 */
export class PersonDocumentRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [typeId]
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    countPersonDocument(typeId, personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return PersonDocumentRestControllerApiFp(this.configuration).countPersonDocument(typeId, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    deleteOrDismissInBatchPersonDocument(ids, options) {
        return PersonDocumentRestControllerApiFp(this.configuration).deleteOrDismissInBatchPersonDocument(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    deleteOrDismissPersonDocument(id, options) {
        return PersonDocumentRestControllerApiFp(this.configuration).deleteOrDismissPersonDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [year]
     * @param {number} [type]
     * @param {number} [person]
     * @param {boolean} [includeFormer]
     * @param {boolean} [namePrefix]
     * @param {boolean} [flat]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    exportPersonDocument(year, type, person, includeFormer, namePrefix, flat, options) {
        return PersonDocumentRestControllerApiFp(this.configuration).exportPersonDocument(year, type, person, includeFormer, namePrefix, flat, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [year]
     * @param {number} [type]
     * @param {number} [person]
     * @param {boolean} [includeFormer]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    exportSummaryPersonDocument(year, type, person, includeFormer, options) {
        return PersonDocumentRestControllerApiFp(this.configuration).exportSummaryPersonDocument(year, type, person, includeFormer, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    getPersonDocument(id, options) {
        return PersonDocumentRestControllerApiFp(this.configuration).getPersonDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [typeId]
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    listPersonDocument(typeId, personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return PersonDocumentRestControllerApiFp(this.configuration).listPersonDocument(typeId, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [typeId]
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    pagePersonDocument(page, size, sort, typeId, personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return PersonDocumentRestControllerApiFp(this.configuration).pagePersonDocument(page, size, sort, typeId, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersonDocument} personDocument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    savePersonDocument(personDocument, options) {
        return PersonDocumentRestControllerApiFp(this.configuration).savePersonDocument(personDocument, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRestControllerApi
     */
    viewPersonDocument(docId, options) {
        return PersonDocumentRestControllerApiFp(this.configuration).viewPersonDocument(docId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PersonDocumentRetentionRestControllerApi - axios parameter creator
 * @export
 */
export const PersonDocumentRetentionRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonDocumentRetention: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/quality/retention/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonDocumentRetention: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchPersonDocumentRetention', 'ids', ids);
            const localVarPath = `/api/admin/quality/retention/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonDocumentRetention: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissPersonDocumentRetention', 'id', id);
            const localVarPath = `/api/admin/quality/retention/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expiredCandidatesPersonDocumentRetention: async (options = {}) => {
            const localVarPath = `/api/admin/quality/retention/expired-candidates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expiredPersonDocumentRetention: async (options = {}) => {
            const localVarPath = `/api/admin/quality/retention/expired`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonDocumentRetention: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPersonDocumentRetention', 'id', id);
            const localVarPath = `/api/admin/quality/retention/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonDocumentRetention: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/quality/retention/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonDocumentRetention: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/quality/retention/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PersonDocumentRetention} personDocumentRetention
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonDocumentRetention: async (personDocumentRetention, options = {}) => {
            // verify required parameter 'personDocumentRetention' is not null or undefined
            assertParamExists('savePersonDocumentRetention', 'personDocumentRetention', personDocumentRetention);
            const localVarPath = `/api/admin/quality/retention/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(personDocumentRetention, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PersonDocumentRetentionRestControllerApi - functional programming interface
 * @export
 */
export const PersonDocumentRetentionRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PersonDocumentRetentionRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countPersonDocumentRetention(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countPersonDocumentRetention(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRetentionRestControllerApi.countPersonDocumentRetention']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchPersonDocumentRetention(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchPersonDocumentRetention(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRetentionRestControllerApi.deleteOrDismissInBatchPersonDocumentRetention']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissPersonDocumentRetention(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissPersonDocumentRetention(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRetentionRestControllerApi.deleteOrDismissPersonDocumentRetention']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expiredCandidatesPersonDocumentRetention(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expiredCandidatesPersonDocumentRetention(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRetentionRestControllerApi.expiredCandidatesPersonDocumentRetention']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expiredPersonDocumentRetention(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expiredPersonDocumentRetention(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRetentionRestControllerApi.expiredPersonDocumentRetention']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonDocumentRetention(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonDocumentRetention(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRetentionRestControllerApi.getPersonDocumentRetention']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPersonDocumentRetention(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPersonDocumentRetention(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRetentionRestControllerApi.listPersonDocumentRetention']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pagePersonDocumentRetention(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pagePersonDocumentRetention(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRetentionRestControllerApi.pagePersonDocumentRetention']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {PersonDocumentRetention} personDocumentRetention
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePersonDocumentRetention(personDocumentRetention, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePersonDocumentRetention(personDocumentRetention, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentRetentionRestControllerApi.savePersonDocumentRetention']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PersonDocumentRetentionRestControllerApi - factory interface
 * @export
 */
export const PersonDocumentRetentionRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PersonDocumentRetentionRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonDocumentRetention(term, showDismissed, options) {
            return localVarFp.countPersonDocumentRetention(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonDocumentRetention(ids, options) {
            return localVarFp.deleteOrDismissInBatchPersonDocumentRetention(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonDocumentRetention(id, options) {
            return localVarFp.deleteOrDismissPersonDocumentRetention(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expiredCandidatesPersonDocumentRetention(options) {
            return localVarFp.expiredCandidatesPersonDocumentRetention(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expiredPersonDocumentRetention(options) {
            return localVarFp.expiredPersonDocumentRetention(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonDocumentRetention(id, options) {
            return localVarFp.getPersonDocumentRetention(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonDocumentRetention(term, showDismissed, options) {
            return localVarFp.listPersonDocumentRetention(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonDocumentRetention(page, size, sort, term, showDismissed, options) {
            return localVarFp.pagePersonDocumentRetention(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersonDocumentRetention} personDocumentRetention
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonDocumentRetention(personDocumentRetention, options) {
            return localVarFp.savePersonDocumentRetention(personDocumentRetention, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PersonDocumentRetentionRestControllerApi - object-oriented interface
 * @export
 * @class PersonDocumentRetentionRestControllerApi
 * @extends {BaseAPI}
 */
export class PersonDocumentRetentionRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRetentionRestControllerApi
     */
    countPersonDocumentRetention(term, showDismissed, options) {
        return PersonDocumentRetentionRestControllerApiFp(this.configuration).countPersonDocumentRetention(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRetentionRestControllerApi
     */
    deleteOrDismissInBatchPersonDocumentRetention(ids, options) {
        return PersonDocumentRetentionRestControllerApiFp(this.configuration).deleteOrDismissInBatchPersonDocumentRetention(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRetentionRestControllerApi
     */
    deleteOrDismissPersonDocumentRetention(id, options) {
        return PersonDocumentRetentionRestControllerApiFp(this.configuration).deleteOrDismissPersonDocumentRetention(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRetentionRestControllerApi
     */
    expiredCandidatesPersonDocumentRetention(options) {
        return PersonDocumentRetentionRestControllerApiFp(this.configuration).expiredCandidatesPersonDocumentRetention(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRetentionRestControllerApi
     */
    expiredPersonDocumentRetention(options) {
        return PersonDocumentRetentionRestControllerApiFp(this.configuration).expiredPersonDocumentRetention(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRetentionRestControllerApi
     */
    getPersonDocumentRetention(id, options) {
        return PersonDocumentRetentionRestControllerApiFp(this.configuration).getPersonDocumentRetention(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRetentionRestControllerApi
     */
    listPersonDocumentRetention(term, showDismissed, options) {
        return PersonDocumentRetentionRestControllerApiFp(this.configuration).listPersonDocumentRetention(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRetentionRestControllerApi
     */
    pagePersonDocumentRetention(page, size, sort, term, showDismissed, options) {
        return PersonDocumentRetentionRestControllerApiFp(this.configuration).pagePersonDocumentRetention(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersonDocumentRetention} personDocumentRetention
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentRetentionRestControllerApi
     */
    savePersonDocumentRetention(personDocumentRetention, options) {
        return PersonDocumentRetentionRestControllerApiFp(this.configuration).savePersonDocumentRetention(personDocumentRetention, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PersonDocumentTypeRestControllerApi - axios parameter creator
 * @export
 */
export const PersonDocumentTypeRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonDocumentType: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/person/document/type/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonDocumentTypeDocumentsPersonDocumentType: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('countPersonDocumentTypeDocumentsPersonDocumentType', 'id', id);
            const localVarPath = `/api/admin/employee/person/document/type/{id}/documents/count`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonDocumentType: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchPersonDocumentType', 'ids', ids);
            const localVarPath = `/api/admin/employee/person/document/type/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonDocumentType: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissPersonDocumentType', 'id', id);
            const localVarPath = `/api/admin/employee/person/document/type/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonDocumentType: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPersonDocumentType', 'id', id);
            const localVarPath = `/api/admin/employee/person/document/type/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonDocumentType: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/person/document/type/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonDocumentType: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/person/document/type/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {number} [months]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewPersonDocumentTypeRecalculationPersonDocumentType: async (id, months, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('previewPersonDocumentTypeRecalculationPersonDocumentType', 'id', id);
            const localVarPath = `/api/admin/employee/person/document/type/{id}/expirations/preview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (months !== undefined) {
                localVarQueryParameter['months'] = months;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {number} expectedChanges
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculatePersonDocumentTypeExpirationsPersonDocumentType: async (id, expectedChanges, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('recalculatePersonDocumentTypeExpirationsPersonDocumentType', 'id', id);
            // verify required parameter 'expectedChanges' is not null or undefined
            assertParamExists('recalculatePersonDocumentTypeExpirationsPersonDocumentType', 'expectedChanges', expectedChanges);
            const localVarPath = `/api/admin/employee/person/document/type/{id}/expirations/recalculate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (expectedChanges !== undefined) {
                localVarQueryParameter['expectedChanges'] = expectedChanges;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PersonDocumentType} personDocumentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonDocumentType: async (personDocumentType, options = {}) => {
            // verify required parameter 'personDocumentType' is not null or undefined
            assertParamExists('savePersonDocumentType', 'personDocumentType', personDocumentType);
            const localVarPath = `/api/admin/employee/person/document/type/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(personDocumentType, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PersonDocumentTypeRestControllerApi - functional programming interface
 * @export
 */
export const PersonDocumentTypeRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PersonDocumentTypeRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countPersonDocumentType(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countPersonDocumentType(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentTypeRestControllerApi.countPersonDocumentType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countPersonDocumentTypeDocumentsPersonDocumentType(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countPersonDocumentTypeDocumentsPersonDocumentType(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentTypeRestControllerApi.countPersonDocumentTypeDocumentsPersonDocumentType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchPersonDocumentType(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchPersonDocumentType(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentTypeRestControllerApi.deleteOrDismissInBatchPersonDocumentType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissPersonDocumentType(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissPersonDocumentType(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentTypeRestControllerApi.deleteOrDismissPersonDocumentType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonDocumentType(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonDocumentType(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentTypeRestControllerApi.getPersonDocumentType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPersonDocumentType(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPersonDocumentType(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentTypeRestControllerApi.listPersonDocumentType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pagePersonDocumentType(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pagePersonDocumentType(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentTypeRestControllerApi.pagePersonDocumentType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {number} [months]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewPersonDocumentTypeRecalculationPersonDocumentType(id, months, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewPersonDocumentTypeRecalculationPersonDocumentType(id, months, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentTypeRestControllerApi.previewPersonDocumentTypeRecalculationPersonDocumentType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {number} expectedChanges
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recalculatePersonDocumentTypeExpirationsPersonDocumentType(id, expectedChanges, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recalculatePersonDocumentTypeExpirationsPersonDocumentType(id, expectedChanges, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentTypeRestControllerApi.recalculatePersonDocumentTypeExpirationsPersonDocumentType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {PersonDocumentType} personDocumentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePersonDocumentType(personDocumentType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePersonDocumentType(personDocumentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonDocumentTypeRestControllerApi.savePersonDocumentType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PersonDocumentTypeRestControllerApi - factory interface
 * @export
 */
export const PersonDocumentTypeRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PersonDocumentTypeRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonDocumentType(term, showDismissed, options) {
            return localVarFp.countPersonDocumentType(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonDocumentTypeDocumentsPersonDocumentType(id, options) {
            return localVarFp.countPersonDocumentTypeDocumentsPersonDocumentType(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonDocumentType(ids, options) {
            return localVarFp.deleteOrDismissInBatchPersonDocumentType(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonDocumentType(id, options) {
            return localVarFp.deleteOrDismissPersonDocumentType(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonDocumentType(id, options) {
            return localVarFp.getPersonDocumentType(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonDocumentType(term, showDismissed, options) {
            return localVarFp.listPersonDocumentType(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonDocumentType(page, size, sort, term, showDismissed, options) {
            return localVarFp.pagePersonDocumentType(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} [months]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewPersonDocumentTypeRecalculationPersonDocumentType(id, months, options) {
            return localVarFp.previewPersonDocumentTypeRecalculationPersonDocumentType(id, months, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} expectedChanges
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculatePersonDocumentTypeExpirationsPersonDocumentType(id, expectedChanges, options) {
            return localVarFp.recalculatePersonDocumentTypeExpirationsPersonDocumentType(id, expectedChanges, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersonDocumentType} personDocumentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonDocumentType(personDocumentType, options) {
            return localVarFp.savePersonDocumentType(personDocumentType, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PersonDocumentTypeRestControllerApi - object-oriented interface
 * @export
 * @class PersonDocumentTypeRestControllerApi
 * @extends {BaseAPI}
 */
export class PersonDocumentTypeRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentTypeRestControllerApi
     */
    countPersonDocumentType(term, showDismissed, options) {
        return PersonDocumentTypeRestControllerApiFp(this.configuration).countPersonDocumentType(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentTypeRestControllerApi
     */
    countPersonDocumentTypeDocumentsPersonDocumentType(id, options) {
        return PersonDocumentTypeRestControllerApiFp(this.configuration).countPersonDocumentTypeDocumentsPersonDocumentType(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentTypeRestControllerApi
     */
    deleteOrDismissInBatchPersonDocumentType(ids, options) {
        return PersonDocumentTypeRestControllerApiFp(this.configuration).deleteOrDismissInBatchPersonDocumentType(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentTypeRestControllerApi
     */
    deleteOrDismissPersonDocumentType(id, options) {
        return PersonDocumentTypeRestControllerApiFp(this.configuration).deleteOrDismissPersonDocumentType(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentTypeRestControllerApi
     */
    getPersonDocumentType(id, options) {
        return PersonDocumentTypeRestControllerApiFp(this.configuration).getPersonDocumentType(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentTypeRestControllerApi
     */
    listPersonDocumentType(term, showDismissed, options) {
        return PersonDocumentTypeRestControllerApiFp(this.configuration).listPersonDocumentType(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentTypeRestControllerApi
     */
    pagePersonDocumentType(page, size, sort, term, showDismissed, options) {
        return PersonDocumentTypeRestControllerApiFp(this.configuration).pagePersonDocumentType(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} [months]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentTypeRestControllerApi
     */
    previewPersonDocumentTypeRecalculationPersonDocumentType(id, months, options) {
        return PersonDocumentTypeRestControllerApiFp(this.configuration).previewPersonDocumentTypeRecalculationPersonDocumentType(id, months, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} expectedChanges
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentTypeRestControllerApi
     */
    recalculatePersonDocumentTypeExpirationsPersonDocumentType(id, expectedChanges, options) {
        return PersonDocumentTypeRestControllerApiFp(this.configuration).recalculatePersonDocumentTypeExpirationsPersonDocumentType(id, expectedChanges, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersonDocumentType} personDocumentType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonDocumentTypeRestControllerApi
     */
    savePersonDocumentType(personDocumentType, options) {
        return PersonDocumentTypeRestControllerApiFp(this.configuration).savePersonDocumentType(personDocumentType, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PersonEventRestControllerApi - axios parameter creator
 * @export
 */
export const PersonEventRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonEvent: async (personId, visibleByEmployee, term, showDismissed, options = {}) => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('countPersonEvent', 'personId', personId);
            const localVarPath = `/api/admin/employee/event/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonEvent: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchPersonEvent', 'ids', ids);
            const localVarPath = `/api/admin/employee/event/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonEvent: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissPersonEvent', 'id', id);
            const localVarPath = `/api/admin/employee/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonEvent: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPersonEvent', 'id', id);
            const localVarPath = `/api/admin/employee/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonEvent: async (personId, visibleByEmployee, term, showDismissed, options = {}) => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('listPersonEvent', 'personId', personId);
            const localVarPath = `/api/admin/employee/event/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} personId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonEvent: async (personId, page, size, sort, visibleByEmployee, term, showDismissed, options = {}) => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('pagePersonEvent', 'personId', personId);
            const localVarPath = `/api/admin/employee/event/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PersonEvent} personEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonEvent: async (personEvent, options = {}) => {
            // verify required parameter 'personEvent' is not null or undefined
            assertParamExists('savePersonEvent', 'personEvent', personEvent);
            const localVarPath = `/api/admin/employee/event/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(personEvent, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PersonEventRestControllerApi - functional programming interface
 * @export
 */
export const PersonEventRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PersonEventRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countPersonEvent(personId, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countPersonEvent(personId, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonEventRestControllerApi.countPersonEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchPersonEvent(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchPersonEvent(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonEventRestControllerApi.deleteOrDismissInBatchPersonEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissPersonEvent(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissPersonEvent(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonEventRestControllerApi.deleteOrDismissPersonEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonEvent(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonEvent(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonEventRestControllerApi.getPersonEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPersonEvent(personId, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPersonEvent(personId, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonEventRestControllerApi.listPersonEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} personId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pagePersonEvent(personId, page, size, sort, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pagePersonEvent(personId, page, size, sort, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonEventRestControllerApi.pagePersonEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {PersonEvent} personEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePersonEvent(personEvent, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePersonEvent(personEvent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonEventRestControllerApi.savePersonEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PersonEventRestControllerApi - factory interface
 * @export
 */
export const PersonEventRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PersonEventRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonEvent(personId, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countPersonEvent(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonEvent(ids, options) {
            return localVarFp.deleteOrDismissInBatchPersonEvent(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonEvent(id, options) {
            return localVarFp.deleteOrDismissPersonEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonEvent(id, options) {
            return localVarFp.getPersonEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonEvent(personId, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listPersonEvent(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonEvent(personId, page, size, sort, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pagePersonEvent(personId, page, size, sort, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersonEvent} personEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonEvent(personEvent, options) {
            return localVarFp.savePersonEvent(personEvent, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PersonEventRestControllerApi - object-oriented interface
 * @export
 * @class PersonEventRestControllerApi
 * @extends {BaseAPI}
 */
export class PersonEventRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} personId
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonEventRestControllerApi
     */
    countPersonEvent(personId, visibleByEmployee, term, showDismissed, options) {
        return PersonEventRestControllerApiFp(this.configuration).countPersonEvent(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonEventRestControllerApi
     */
    deleteOrDismissInBatchPersonEvent(ids, options) {
        return PersonEventRestControllerApiFp(this.configuration).deleteOrDismissInBatchPersonEvent(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonEventRestControllerApi
     */
    deleteOrDismissPersonEvent(id, options) {
        return PersonEventRestControllerApiFp(this.configuration).deleteOrDismissPersonEvent(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonEventRestControllerApi
     */
    getPersonEvent(id, options) {
        return PersonEventRestControllerApiFp(this.configuration).getPersonEvent(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonEventRestControllerApi
     */
    listPersonEvent(personId, visibleByEmployee, term, showDismissed, options) {
        return PersonEventRestControllerApiFp(this.configuration).listPersonEvent(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonEventRestControllerApi
     */
    pagePersonEvent(personId, page, size, sort, visibleByEmployee, term, showDismissed, options) {
        return PersonEventRestControllerApiFp(this.configuration).pagePersonEvent(personId, page, size, sort, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersonEvent} personEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonEventRestControllerApi
     */
    savePersonEvent(personEvent, options) {
        return PersonEventRestControllerApiFp(this.configuration).savePersonEvent(personEvent, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PersonManagementRoleRestControllerApi - axios parameter creator
 * @export
 */
export const PersonManagementRoleRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listByPerson: async (personId, options = {}) => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('listByPerson', 'personId', personId);
            const localVarPath = `/api/admin/employee/person-management-role/{personId}`
                .replace(`{${"personId"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PersonManagementRoleRestControllerApi - functional programming interface
 * @export
 */
export const PersonManagementRoleRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PersonManagementRoleRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listByPerson(personId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listByPerson(personId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonManagementRoleRestControllerApi.listByPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PersonManagementRoleRestControllerApi - factory interface
 * @export
 */
export const PersonManagementRoleRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PersonManagementRoleRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listByPerson(personId, options) {
            return localVarFp.listByPerson(personId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PersonManagementRoleRestControllerApi - object-oriented interface
 * @export
 * @class PersonManagementRoleRestControllerApi
 * @extends {BaseAPI}
 */
export class PersonManagementRoleRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} personId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonManagementRoleRestControllerApi
     */
    listByPerson(personId, options) {
        return PersonManagementRoleRestControllerApiFp(this.configuration).listByPerson(personId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PersonReminderRestControllerApi - axios parameter creator
 * @export
 */
export const PersonReminderRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonReminder: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/reminder/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonReminder: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchPersonReminder', 'ids', ids);
            const localVarPath = `/api/admin/employee/reminder/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonReminder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissPersonReminder', 'id', id);
            const localVarPath = `/api/admin/employee/reminder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonReminder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPersonReminder', 'id', id);
            const localVarPath = `/api/admin/employee/reminder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonReminder: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/reminder/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonReminder: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/reminder/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PersonReminder} personReminder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonReminder: async (personReminder, options = {}) => {
            // verify required parameter 'personReminder' is not null or undefined
            assertParamExists('savePersonReminder', 'personReminder', personReminder);
            const localVarPath = `/api/admin/employee/reminder/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(personReminder, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PersonReminderRestControllerApi - functional programming interface
 * @export
 */
export const PersonReminderRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PersonReminderRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countPersonReminder(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countPersonReminder(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonReminderRestControllerApi.countPersonReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchPersonReminder(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchPersonReminder(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonReminderRestControllerApi.deleteOrDismissInBatchPersonReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissPersonReminder(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissPersonReminder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonReminderRestControllerApi.deleteOrDismissPersonReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonReminder(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonReminder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonReminderRestControllerApi.getPersonReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPersonReminder(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPersonReminder(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonReminderRestControllerApi.listPersonReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pagePersonReminder(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pagePersonReminder(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonReminderRestControllerApi.pagePersonReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {PersonReminder} personReminder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePersonReminder(personReminder, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePersonReminder(personReminder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonReminderRestControllerApi.savePersonReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PersonReminderRestControllerApi - factory interface
 * @export
 */
export const PersonReminderRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PersonReminderRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPersonReminder(term, showDismissed, options) {
            return localVarFp.countPersonReminder(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPersonReminder(ids, options) {
            return localVarFp.deleteOrDismissInBatchPersonReminder(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPersonReminder(id, options) {
            return localVarFp.deleteOrDismissPersonReminder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonReminder(id, options) {
            return localVarFp.getPersonReminder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonReminder(term, showDismissed, options) {
            return localVarFp.listPersonReminder(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePersonReminder(page, size, sort, term, showDismissed, options) {
            return localVarFp.pagePersonReminder(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersonReminder} personReminder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonReminder(personReminder, options) {
            return localVarFp.savePersonReminder(personReminder, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PersonReminderRestControllerApi - object-oriented interface
 * @export
 * @class PersonReminderRestControllerApi
 * @extends {BaseAPI}
 */
export class PersonReminderRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonReminderRestControllerApi
     */
    countPersonReminder(term, showDismissed, options) {
        return PersonReminderRestControllerApiFp(this.configuration).countPersonReminder(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonReminderRestControllerApi
     */
    deleteOrDismissInBatchPersonReminder(ids, options) {
        return PersonReminderRestControllerApiFp(this.configuration).deleteOrDismissInBatchPersonReminder(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonReminderRestControllerApi
     */
    deleteOrDismissPersonReminder(id, options) {
        return PersonReminderRestControllerApiFp(this.configuration).deleteOrDismissPersonReminder(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonReminderRestControllerApi
     */
    getPersonReminder(id, options) {
        return PersonReminderRestControllerApiFp(this.configuration).getPersonReminder(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonReminderRestControllerApi
     */
    listPersonReminder(term, showDismissed, options) {
        return PersonReminderRestControllerApiFp(this.configuration).listPersonReminder(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonReminderRestControllerApi
     */
    pagePersonReminder(page, size, sort, term, showDismissed, options) {
        return PersonReminderRestControllerApiFp(this.configuration).pagePersonReminder(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersonReminder} personReminder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonReminderRestControllerApi
     */
    savePersonReminder(personReminder, options) {
        return PersonReminderRestControllerApiFp(this.configuration).savePersonReminder(personReminder, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PersonRestControllerApi - axios parameter creator
 * @export
 */
export const PersonRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPerson: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/person/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationHelpPerson: async (personId, options = {}) => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('dedicationHelpPerson', 'personId', personId);
            const localVarPath = `/api/admin/employee/person/{personId}/dedication-help`
                .replace(`{${"personId"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPerson: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchPerson', 'ids', ids);
            const localVarPath = `/api/admin/employee/person/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPerson: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissPerson', 'id', id);
            const localVarPath = `/api/admin/employee/person/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAbsencesPerson: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('exportAbsencesPerson', 'year', year);
            const localVarPath = `/api/admin/employee/person/export-absences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPeoplePerson: async (options = {}) => {
            const localVarPath = `/api/admin/employee/person/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerson: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPerson', 'id', id);
            const localVarPath = `/api/admin/employee/person/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPerson: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/person/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {boolean} [dryRun]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        normalizePhotosPerson: async (dryRun, options = {}) => {
            const localVarPath = `/api/admin/employee/person/photos/normalize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (dryRun !== undefined) {
                localVarQueryParameter['dryRun'] = dryRun;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePerson: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/person/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Person} person
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePerson: async (person, options = {}) => {
            // verify required parameter 'person' is not null or undefined
            assertParamExists('savePerson', 'person', person);
            const localVarPath = `/api/admin/employee/person/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(person, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summaryPerson: async (personId, options = {}) => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('summaryPerson', 'personId', personId);
            const localVarPath = `/api/admin/employee/person/{personId}/summary`
                .replace(`{${"personId"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} personId
         * @param {number} [width]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewPhotoPerson: async (personId, width, options = {}) => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('viewPhotoPerson', 'personId', personId);
            const localVarPath = `/api/admin/employee/person/photo/{personId}`
                .replace(`{${"personId"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (width !== undefined) {
                localVarQueryParameter['width'] = width;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PersonRestControllerApi - functional programming interface
 * @export
 */
export const PersonRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PersonRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countPerson(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countPerson(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonRestControllerApi.countPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dedicationHelpPerson(personId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dedicationHelpPerson(personId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonRestControllerApi.dedicationHelpPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchPerson(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchPerson(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonRestControllerApi.deleteOrDismissInBatchPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissPerson(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissPerson(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonRestControllerApi.deleteOrDismissPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAbsencesPerson(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAbsencesPerson(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonRestControllerApi.exportAbsencesPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPeoplePerson(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportPeoplePerson(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonRestControllerApi.exportPeoplePerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPerson(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPerson(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonRestControllerApi.getPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPerson(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPerson(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonRestControllerApi.listPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {boolean} [dryRun]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async normalizePhotosPerson(dryRun, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.normalizePhotosPerson(dryRun, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonRestControllerApi.normalizePhotosPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pagePerson(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pagePerson(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonRestControllerApi.pagePerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Person} person
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePerson(person, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePerson(person, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonRestControllerApi.savePerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async summaryPerson(personId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.summaryPerson(personId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonRestControllerApi.summaryPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} personId
         * @param {number} [width]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewPhotoPerson(personId, width, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewPhotoPerson(personId, width, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonRestControllerApi.viewPhotoPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PersonRestControllerApi - factory interface
 * @export
 */
export const PersonRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PersonRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPerson(term, showDismissed, options) {
            return localVarFp.countPerson(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dedicationHelpPerson(personId, options) {
            return localVarFp.dedicationHelpPerson(personId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchPerson(ids, options) {
            return localVarFp.deleteOrDismissInBatchPerson(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissPerson(id, options) {
            return localVarFp.deleteOrDismissPerson(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAbsencesPerson(year, options) {
            return localVarFp.exportAbsencesPerson(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPeoplePerson(options) {
            return localVarFp.exportPeoplePerson(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerson(id, options) {
            return localVarFp.getPerson(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPerson(term, showDismissed, options) {
            return localVarFp.listPerson(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [dryRun]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        normalizePhotosPerson(dryRun, options) {
            return localVarFp.normalizePhotosPerson(dryRun, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePerson(page, size, sort, term, showDismissed, options) {
            return localVarFp.pagePerson(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Person} person
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePerson(person, options) {
            return localVarFp.savePerson(person, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summaryPerson(personId, options) {
            return localVarFp.summaryPerson(personId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {number} [width]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewPhotoPerson(personId, width, options) {
            return localVarFp.viewPhotoPerson(personId, width, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PersonRestControllerApi - object-oriented interface
 * @export
 * @class PersonRestControllerApi
 * @extends {BaseAPI}
 */
export class PersonRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    countPerson(term, showDismissed, options) {
        return PersonRestControllerApiFp(this.configuration).countPerson(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    dedicationHelpPerson(personId, options) {
        return PersonRestControllerApiFp(this.configuration).dedicationHelpPerson(personId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    deleteOrDismissInBatchPerson(ids, options) {
        return PersonRestControllerApiFp(this.configuration).deleteOrDismissInBatchPerson(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    deleteOrDismissPerson(id, options) {
        return PersonRestControllerApiFp(this.configuration).deleteOrDismissPerson(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    exportAbsencesPerson(year, options) {
        return PersonRestControllerApiFp(this.configuration).exportAbsencesPerson(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    exportPeoplePerson(options) {
        return PersonRestControllerApiFp(this.configuration).exportPeoplePerson(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    getPerson(id, options) {
        return PersonRestControllerApiFp(this.configuration).getPerson(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    listPerson(term, showDismissed, options) {
        return PersonRestControllerApiFp(this.configuration).listPerson(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [dryRun]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    normalizePhotosPerson(dryRun, options) {
        return PersonRestControllerApiFp(this.configuration).normalizePhotosPerson(dryRun, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    pagePerson(page, size, sort, term, showDismissed, options) {
        return PersonRestControllerApiFp(this.configuration).pagePerson(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Person} person
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    savePerson(person, options) {
        return PersonRestControllerApiFp(this.configuration).savePerson(person, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    summaryPerson(personId, options) {
        return PersonRestControllerApiFp(this.configuration).summaryPerson(personId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {number} [width]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonRestControllerApi
     */
    viewPhotoPerson(personId, width, options) {
        return PersonRestControllerApiFp(this.configuration).viewPhotoPerson(personId, width, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PubCustomerSupportRestControllerApi - axios parameter creator
 * @export
 */
export const PubCustomerSupportRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [t]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeSupport: async (t, options = {}) => {
            const localVarPath = `/api/pub/customer/support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (t !== undefined) {
                localVarQueryParameter['t'] = t;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CustomerEvaluationResult} customerEvaluationResult
         * @param {string} [t]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeSupport: async (customerEvaluationResult, t, options = {}) => {
            // verify required parameter 'customerEvaluationResult' is not null or undefined
            assertParamExists('saveEmployeeSupport', 'customerEvaluationResult', customerEvaluationResult);
            const localVarPath = `/api/pub/customer/support/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (t !== undefined) {
                localVarQueryParameter['t'] = t;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(customerEvaluationResult, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PubCustomerSupportRestControllerApi - functional programming interface
 * @export
 */
export const PubCustomerSupportRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PubCustomerSupportRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [t]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeSupport(t, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeSupport(t, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PubCustomerSupportRestControllerApi.getEmployeeSupport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CustomerEvaluationResult} customerEvaluationResult
         * @param {string} [t]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEmployeeSupport(customerEvaluationResult, t, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEmployeeSupport(customerEvaluationResult, t, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PubCustomerSupportRestControllerApi.saveEmployeeSupport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PubCustomerSupportRestControllerApi - factory interface
 * @export
 */
export const PubCustomerSupportRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PubCustomerSupportRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [t]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeSupport(t, options) {
            return localVarFp.getEmployeeSupport(t, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CustomerEvaluationResult} customerEvaluationResult
         * @param {string} [t]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEmployeeSupport(customerEvaluationResult, t, options) {
            return localVarFp.saveEmployeeSupport(customerEvaluationResult, t, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PubCustomerSupportRestControllerApi - object-oriented interface
 * @export
 * @class PubCustomerSupportRestControllerApi
 * @extends {BaseAPI}
 */
export class PubCustomerSupportRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [t]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PubCustomerSupportRestControllerApi
     */
    getEmployeeSupport(t, options) {
        return PubCustomerSupportRestControllerApiFp(this.configuration).getEmployeeSupport(t, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CustomerEvaluationResult} customerEvaluationResult
     * @param {string} [t]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PubCustomerSupportRestControllerApi
     */
    saveEmployeeSupport(customerEvaluationResult, t, options) {
        return PubCustomerSupportRestControllerApiFp(this.configuration).saveEmployeeSupport(customerEvaluationResult, t, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PublicContactRestControllerApi - axios parameter creator
 * @export
 */
export const PublicContactRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ContactForm} contactForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendContactEmail: async (contactForm, options = {}) => {
            // verify required parameter 'contactForm' is not null or undefined
            assertParamExists('sendContactEmail', 'contactForm', contactForm);
            const localVarPath = `/api/pub/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(contactForm, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SubscribeForm} subscribeForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe: async (subscribeForm, options = {}) => {
            // verify required parameter 'subscribeForm' is not null or undefined
            assertParamExists('subscribe', 'subscribeForm', subscribeForm);
            const localVarPath = `/api/pub/contact/subscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(subscribeForm, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PublicContactRestControllerApi - functional programming interface
 * @export
 */
export const PublicContactRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = PublicContactRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {ContactForm} contactForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendContactEmail(contactForm, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendContactEmail(contactForm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicContactRestControllerApi.sendContactEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {SubscribeForm} subscribeForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribe(subscribeForm, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribe(subscribeForm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicContactRestControllerApi.subscribe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PublicContactRestControllerApi - factory interface
 * @export
 */
export const PublicContactRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PublicContactRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {ContactForm} contactForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendContactEmail(contactForm, options) {
            return localVarFp.sendContactEmail(contactForm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SubscribeForm} subscribeForm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe(subscribeForm, options) {
            return localVarFp.subscribe(subscribeForm, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PublicContactRestControllerApi - object-oriented interface
 * @export
 * @class PublicContactRestControllerApi
 * @extends {BaseAPI}
 */
export class PublicContactRestControllerApi extends BaseAPI {
    /**
     *
     * @param {ContactForm} contactForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicContactRestControllerApi
     */
    sendContactEmail(contactForm, options) {
        return PublicContactRestControllerApiFp(this.configuration).sendContactEmail(contactForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SubscribeForm} subscribeForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicContactRestControllerApi
     */
    subscribe(subscribeForm, options) {
        return PublicContactRestControllerApiFp(this.configuration).subscribe(subscribeForm, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * QualityActionRestControllerApi - axios parameter creator
 * @export
 */
export const QualityActionRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [findingId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countQualityAction: async (findingId, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/quality/action/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (findingId !== undefined) {
                localVarQueryParameter['findingId'] = findingId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchQualityAction: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchQualityAction', 'ids', ids);
            const localVarPath = `/api/admin/quality/action/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissQualityAction: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissQualityAction', 'id', id);
            const localVarPath = `/api/admin/quality/action/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQualityAction: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQualityAction', 'id', id);
            const localVarPath = `/api/admin/quality/action/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [findingId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQualityAction: async (findingId, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/quality/action/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (findingId !== undefined) {
                localVarQueryParameter['findingId'] = findingId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [findingId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageQualityAction: async (page, size, sort, findingId, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/quality/action/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (findingId !== undefined) {
                localVarQueryParameter['findingId'] = findingId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {QualityAction} qualityAction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveQualityAction: async (qualityAction, options = {}) => {
            // verify required parameter 'qualityAction' is not null or undefined
            assertParamExists('saveQualityAction', 'qualityAction', qualityAction);
            const localVarPath = `/api/admin/quality/action/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(qualityAction, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * QualityActionRestControllerApi - functional programming interface
 * @export
 */
export const QualityActionRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = QualityActionRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [findingId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countQualityAction(findingId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countQualityAction(findingId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QualityActionRestControllerApi.countQualityAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchQualityAction(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchQualityAction(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QualityActionRestControllerApi.deleteOrDismissInBatchQualityAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissQualityAction(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissQualityAction(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QualityActionRestControllerApi.deleteOrDismissQualityAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQualityAction(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQualityAction(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QualityActionRestControllerApi.getQualityAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [findingId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listQualityAction(findingId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listQualityAction(findingId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QualityActionRestControllerApi.listQualityAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [findingId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageQualityAction(page, size, sort, findingId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageQualityAction(page, size, sort, findingId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QualityActionRestControllerApi.pageQualityAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {QualityAction} qualityAction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveQualityAction(qualityAction, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveQualityAction(qualityAction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QualityActionRestControllerApi.saveQualityAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * QualityActionRestControllerApi - factory interface
 * @export
 */
export const QualityActionRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = QualityActionRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [findingId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countQualityAction(findingId, term, showDismissed, options) {
            return localVarFp.countQualityAction(findingId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchQualityAction(ids, options) {
            return localVarFp.deleteOrDismissInBatchQualityAction(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissQualityAction(id, options) {
            return localVarFp.deleteOrDismissQualityAction(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQualityAction(id, options) {
            return localVarFp.getQualityAction(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [findingId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQualityAction(findingId, term, showDismissed, options) {
            return localVarFp.listQualityAction(findingId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [findingId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageQualityAction(page, size, sort, findingId, term, showDismissed, options) {
            return localVarFp.pageQualityAction(page, size, sort, findingId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {QualityAction} qualityAction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveQualityAction(qualityAction, options) {
            return localVarFp.saveQualityAction(qualityAction, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * QualityActionRestControllerApi - object-oriented interface
 * @export
 * @class QualityActionRestControllerApi
 * @extends {BaseAPI}
 */
export class QualityActionRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [findingId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualityActionRestControllerApi
     */
    countQualityAction(findingId, term, showDismissed, options) {
        return QualityActionRestControllerApiFp(this.configuration).countQualityAction(findingId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualityActionRestControllerApi
     */
    deleteOrDismissInBatchQualityAction(ids, options) {
        return QualityActionRestControllerApiFp(this.configuration).deleteOrDismissInBatchQualityAction(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualityActionRestControllerApi
     */
    deleteOrDismissQualityAction(id, options) {
        return QualityActionRestControllerApiFp(this.configuration).deleteOrDismissQualityAction(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualityActionRestControllerApi
     */
    getQualityAction(id, options) {
        return QualityActionRestControllerApiFp(this.configuration).getQualityAction(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [findingId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualityActionRestControllerApi
     */
    listQualityAction(findingId, term, showDismissed, options) {
        return QualityActionRestControllerApiFp(this.configuration).listQualityAction(findingId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [findingId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualityActionRestControllerApi
     */
    pageQualityAction(page, size, sort, findingId, term, showDismissed, options) {
        return QualityActionRestControllerApiFp(this.configuration).pageQualityAction(page, size, sort, findingId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {QualityAction} qualityAction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualityActionRestControllerApi
     */
    saveQualityAction(qualityAction, options) {
        return QualityActionRestControllerApiFp(this.configuration).saveQualityAction(qualityAction, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * QualityFindingRestControllerApi - axios parameter creator
 * @export
 */
export const QualityFindingRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [year]
         * @param {CountQualityFindingTypeEnum} [type]
         * @param {CountQualityFindingStatusEnum} [status]
         * @param {boolean} [open]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countQualityFinding: async (year, type, status, open, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/quality/finding/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (open !== undefined) {
                localVarQueryParameter['open'] = open;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchQualityFinding: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchQualityFinding', 'ids', ids);
            const localVarPath = `/api/admin/quality/finding/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissQualityFinding: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissQualityFinding', 'id', id);
            const localVarPath = `/api/admin/quality/finding/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQualityFinding: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQualityFinding', 'id', id);
            const localVarPath = `/api/admin/quality/finding/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [year]
         * @param {ListQualityFindingTypeEnum} [type]
         * @param {ListQualityFindingStatusEnum} [status]
         * @param {boolean} [open]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQualityFinding: async (year, type, status, open, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/quality/finding/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (open !== undefined) {
                localVarQueryParameter['open'] = open;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [year]
         * @param {PageQualityFindingTypeEnum} [type]
         * @param {PageQualityFindingStatusEnum} [status]
         * @param {boolean} [open]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageQualityFinding: async (page, size, sort, year, type, status, open, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/quality/finding/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (open !== undefined) {
                localVarQueryParameter['open'] = open;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {QualityFinding} qualityFinding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveQualityFinding: async (qualityFinding, options = {}) => {
            // verify required parameter 'qualityFinding' is not null or undefined
            assertParamExists('saveQualityFinding', 'qualityFinding', qualityFinding);
            const localVarPath = `/api/admin/quality/finding/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(qualityFinding, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summaryQualityFinding: async (year, options = {}) => {
            const localVarPath = `/api/admin/quality/finding/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewQualityFinding: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('viewQualityFinding', 'id', id);
            const localVarPath = `/api/admin/quality/finding/view/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * QualityFindingRestControllerApi - functional programming interface
 * @export
 */
export const QualityFindingRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = QualityFindingRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [year]
         * @param {CountQualityFindingTypeEnum} [type]
         * @param {CountQualityFindingStatusEnum} [status]
         * @param {boolean} [open]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countQualityFinding(year, type, status, open, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countQualityFinding(year, type, status, open, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QualityFindingRestControllerApi.countQualityFinding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchQualityFinding(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchQualityFinding(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QualityFindingRestControllerApi.deleteOrDismissInBatchQualityFinding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissQualityFinding(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissQualityFinding(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QualityFindingRestControllerApi.deleteOrDismissQualityFinding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQualityFinding(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQualityFinding(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QualityFindingRestControllerApi.getQualityFinding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [year]
         * @param {ListQualityFindingTypeEnum} [type]
         * @param {ListQualityFindingStatusEnum} [status]
         * @param {boolean} [open]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listQualityFinding(year, type, status, open, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listQualityFinding(year, type, status, open, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QualityFindingRestControllerApi.listQualityFinding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [year]
         * @param {PageQualityFindingTypeEnum} [type]
         * @param {PageQualityFindingStatusEnum} [status]
         * @param {boolean} [open]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageQualityFinding(page, size, sort, year, type, status, open, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageQualityFinding(page, size, sort, year, type, status, open, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QualityFindingRestControllerApi.pageQualityFinding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {QualityFinding} qualityFinding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveQualityFinding(qualityFinding, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveQualityFinding(qualityFinding, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QualityFindingRestControllerApi.saveQualityFinding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async summaryQualityFinding(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.summaryQualityFinding(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QualityFindingRestControllerApi.summaryQualityFinding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewQualityFinding(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewQualityFinding(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QualityFindingRestControllerApi.viewQualityFinding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * QualityFindingRestControllerApi - factory interface
 * @export
 */
export const QualityFindingRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = QualityFindingRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [year]
         * @param {CountQualityFindingTypeEnum} [type]
         * @param {CountQualityFindingStatusEnum} [status]
         * @param {boolean} [open]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countQualityFinding(year, type, status, open, term, showDismissed, options) {
            return localVarFp.countQualityFinding(year, type, status, open, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchQualityFinding(ids, options) {
            return localVarFp.deleteOrDismissInBatchQualityFinding(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissQualityFinding(id, options) {
            return localVarFp.deleteOrDismissQualityFinding(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQualityFinding(id, options) {
            return localVarFp.getQualityFinding(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [year]
         * @param {ListQualityFindingTypeEnum} [type]
         * @param {ListQualityFindingStatusEnum} [status]
         * @param {boolean} [open]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQualityFinding(year, type, status, open, term, showDismissed, options) {
            return localVarFp.listQualityFinding(year, type, status, open, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [year]
         * @param {PageQualityFindingTypeEnum} [type]
         * @param {PageQualityFindingStatusEnum} [status]
         * @param {boolean} [open]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageQualityFinding(page, size, sort, year, type, status, open, term, showDismissed, options) {
            return localVarFp.pageQualityFinding(page, size, sort, year, type, status, open, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {QualityFinding} qualityFinding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveQualityFinding(qualityFinding, options) {
            return localVarFp.saveQualityFinding(qualityFinding, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summaryQualityFinding(year, options) {
            return localVarFp.summaryQualityFinding(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewQualityFinding(id, options) {
            return localVarFp.viewQualityFinding(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * QualityFindingRestControllerApi - object-oriented interface
 * @export
 * @class QualityFindingRestControllerApi
 * @extends {BaseAPI}
 */
export class QualityFindingRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [year]
     * @param {CountQualityFindingTypeEnum} [type]
     * @param {CountQualityFindingStatusEnum} [status]
     * @param {boolean} [open]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualityFindingRestControllerApi
     */
    countQualityFinding(year, type, status, open, term, showDismissed, options) {
        return QualityFindingRestControllerApiFp(this.configuration).countQualityFinding(year, type, status, open, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualityFindingRestControllerApi
     */
    deleteOrDismissInBatchQualityFinding(ids, options) {
        return QualityFindingRestControllerApiFp(this.configuration).deleteOrDismissInBatchQualityFinding(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualityFindingRestControllerApi
     */
    deleteOrDismissQualityFinding(id, options) {
        return QualityFindingRestControllerApiFp(this.configuration).deleteOrDismissQualityFinding(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualityFindingRestControllerApi
     */
    getQualityFinding(id, options) {
        return QualityFindingRestControllerApiFp(this.configuration).getQualityFinding(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [year]
     * @param {ListQualityFindingTypeEnum} [type]
     * @param {ListQualityFindingStatusEnum} [status]
     * @param {boolean} [open]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualityFindingRestControllerApi
     */
    listQualityFinding(year, type, status, open, term, showDismissed, options) {
        return QualityFindingRestControllerApiFp(this.configuration).listQualityFinding(year, type, status, open, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [year]
     * @param {PageQualityFindingTypeEnum} [type]
     * @param {PageQualityFindingStatusEnum} [status]
     * @param {boolean} [open]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualityFindingRestControllerApi
     */
    pageQualityFinding(page, size, sort, year, type, status, open, term, showDismissed, options) {
        return QualityFindingRestControllerApiFp(this.configuration).pageQualityFinding(page, size, sort, year, type, status, open, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {QualityFinding} qualityFinding
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualityFindingRestControllerApi
     */
    saveQualityFinding(qualityFinding, options) {
        return QualityFindingRestControllerApiFp(this.configuration).saveQualityFinding(qualityFinding, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [year]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualityFindingRestControllerApi
     */
    summaryQualityFinding(year, options) {
        return QualityFindingRestControllerApiFp(this.configuration).summaryQualityFinding(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QualityFindingRestControllerApi
     */
    viewQualityFinding(id, options) {
        return QualityFindingRestControllerApiFp(this.configuration).viewQualityFinding(id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountQualityFindingTypeEnum = {
    NO_CONFORMIDAD: 'NO_CONFORMIDAD',
    INCIDENTE_SEGURIDAD: 'INCIDENTE_SEGURIDAD',
    RECLAMACION: 'RECLAMACION',
    OPORTUNIDAD_MEJORA: 'OPORTUNIDAD_MEJORA'
};
/**
 * @export
 */
export const CountQualityFindingStatusEnum = {
    ABIERTA: 'ABIERTA',
    EN_ANALISIS: 'EN_ANALISIS',
    EN_TRATAMIENTO: 'EN_TRATAMIENTO',
    PENDIENTE_EFICACIA: 'PENDIENTE_EFICACIA',
    CERRADA: 'CERRADA'
};
/**
 * @export
 */
export const ListQualityFindingTypeEnum = {
    NO_CONFORMIDAD: 'NO_CONFORMIDAD',
    INCIDENTE_SEGURIDAD: 'INCIDENTE_SEGURIDAD',
    RECLAMACION: 'RECLAMACION',
    OPORTUNIDAD_MEJORA: 'OPORTUNIDAD_MEJORA'
};
/**
 * @export
 */
export const ListQualityFindingStatusEnum = {
    ABIERTA: 'ABIERTA',
    EN_ANALISIS: 'EN_ANALISIS',
    EN_TRATAMIENTO: 'EN_TRATAMIENTO',
    PENDIENTE_EFICACIA: 'PENDIENTE_EFICACIA',
    CERRADA: 'CERRADA'
};
/**
 * @export
 */
export const PageQualityFindingTypeEnum = {
    NO_CONFORMIDAD: 'NO_CONFORMIDAD',
    INCIDENTE_SEGURIDAD: 'INCIDENTE_SEGURIDAD',
    RECLAMACION: 'RECLAMACION',
    OPORTUNIDAD_MEJORA: 'OPORTUNIDAD_MEJORA'
};
/**
 * @export
 */
export const PageQualityFindingStatusEnum = {
    ABIERTA: 'ABIERTA',
    EN_ANALISIS: 'EN_ANALISIS',
    EN_TRATAMIENTO: 'EN_TRATAMIENTO',
    PENDIENTE_EFICACIA: 'PENDIENTE_EFICACIA',
    CERRADA: 'CERRADA'
};
/**
 * ReconciliationRestControllerApi - axios parameter creator
 * @export
 */
export const ReconciliationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} bankAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoReconcile: async (bankAccountId, options = {}) => {
            // verify required parameter 'bankAccountId' is not null or undefined
            assertParamExists('autoReconcile', 'bankAccountId', bankAccountId);
            const localVarPath = `/api/admin/accounting/reconciliation/auto/{bankAccountId}`
                .replace(`{${"bankAccountId"}}`, encodeURIComponent(String(bankAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} lineId
         * @param {number} movementId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reconcile: async (lineId, movementId, options = {}) => {
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('reconcile', 'lineId', lineId);
            // verify required parameter 'movementId' is not null or undefined
            assertParamExists('reconcile', 'movementId', movementId);
            const localVarPath = `/api/admin/accounting/reconciliation/{lineId}/reconcile/{movementId}`
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)))
                .replace(`{${"movementId"}}`, encodeURIComponent(String(movementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} lineId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unreconcile: async (lineId, options = {}) => {
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('unreconcile', 'lineId', lineId);
            const localVarPath = `/api/admin/accounting/reconciliation/{lineId}/unreconcile`
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ReconciliationRestControllerApi - functional programming interface
 * @export
 */
export const ReconciliationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReconciliationRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} bankAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autoReconcile(bankAccountId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autoReconcile(bankAccountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReconciliationRestControllerApi.autoReconcile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} lineId
         * @param {number} movementId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reconcile(lineId, movementId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reconcile(lineId, movementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReconciliationRestControllerApi.reconcile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} lineId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unreconcile(lineId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unreconcile(lineId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReconciliationRestControllerApi.unreconcile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ReconciliationRestControllerApi - factory interface
 * @export
 */
export const ReconciliationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReconciliationRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} bankAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoReconcile(bankAccountId, options) {
            return localVarFp.autoReconcile(bankAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} lineId
         * @param {number} movementId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reconcile(lineId, movementId, options) {
            return localVarFp.reconcile(lineId, movementId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} lineId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unreconcile(lineId, options) {
            return localVarFp.unreconcile(lineId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReconciliationRestControllerApi - object-oriented interface
 * @export
 * @class ReconciliationRestControllerApi
 * @extends {BaseAPI}
 */
export class ReconciliationRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} bankAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReconciliationRestControllerApi
     */
    autoReconcile(bankAccountId, options) {
        return ReconciliationRestControllerApiFp(this.configuration).autoReconcile(bankAccountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} lineId
     * @param {number} movementId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReconciliationRestControllerApi
     */
    reconcile(lineId, movementId, options) {
        return ReconciliationRestControllerApiFp(this.configuration).reconcile(lineId, movementId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} lineId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReconciliationRestControllerApi
     */
    unreconcile(lineId, options) {
        return ReconciliationRestControllerApiFp(this.configuration).unreconcile(lineId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RecordAttachmentRestControllerApi - axios parameter creator
 * @export
 */
export const RecordAttachmentRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CountRecordAttachmentRecordTypeEnum} recordType
         * @param {number} recordId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countRecordAttachment: async (recordType, recordId, term, showDismissed, options = {}) => {
            // verify required parameter 'recordType' is not null or undefined
            assertParamExists('countRecordAttachment', 'recordType', recordType);
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('countRecordAttachment', 'recordId', recordId);
            const localVarPath = `/api/admin/record-attachment/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (recordType !== undefined) {
                localVarQueryParameter['recordType'] = recordType;
            }
            if (recordId !== undefined) {
                localVarQueryParameter['recordId'] = recordId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchRecordAttachment: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchRecordAttachment', 'ids', ids);
            const localVarPath = `/api/admin/record-attachment/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissRecordAttachment: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissRecordAttachment', 'id', id);
            const localVarPath = `/api/admin/record-attachment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecordAttachment: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRecordAttachment', 'id', id);
            const localVarPath = `/api/admin/record-attachment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ListRecordAttachmentRecordTypeEnum} recordType
         * @param {number} recordId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecordAttachment: async (recordType, recordId, term, showDismissed, options = {}) => {
            // verify required parameter 'recordType' is not null or undefined
            assertParamExists('listRecordAttachment', 'recordType', recordType);
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('listRecordAttachment', 'recordId', recordId);
            const localVarPath = `/api/admin/record-attachment/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (recordType !== undefined) {
                localVarQueryParameter['recordType'] = recordType;
            }
            if (recordId !== undefined) {
                localVarQueryParameter['recordId'] = recordId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PageRecordAttachmentRecordTypeEnum} recordType
         * @param {number} recordId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRecordAttachment: async (recordType, recordId, page, size, sort, term, showDismissed, options = {}) => {
            // verify required parameter 'recordType' is not null or undefined
            assertParamExists('pageRecordAttachment', 'recordType', recordType);
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('pageRecordAttachment', 'recordId', recordId);
            const localVarPath = `/api/admin/record-attachment/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (recordType !== undefined) {
                localVarQueryParameter['recordType'] = recordType;
            }
            if (recordId !== undefined) {
                localVarQueryParameter['recordId'] = recordId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RecordAttachment} recordAttachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRecordAttachment: async (recordAttachment, options = {}) => {
            // verify required parameter 'recordAttachment' is not null or undefined
            assertParamExists('saveRecordAttachment', 'recordAttachment', recordAttachment);
            const localVarPath = `/api/admin/record-attachment/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(recordAttachment, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewRecordAttachment: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('viewRecordAttachment', 'id', id);
            const localVarPath = `/api/admin/record-attachment/view/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RecordAttachmentRestControllerApi - functional programming interface
 * @export
 */
export const RecordAttachmentRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = RecordAttachmentRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CountRecordAttachmentRecordTypeEnum} recordType
         * @param {number} recordId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countRecordAttachment(recordType, recordId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countRecordAttachment(recordType, recordId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecordAttachmentRestControllerApi.countRecordAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchRecordAttachment(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchRecordAttachment(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecordAttachmentRestControllerApi.deleteOrDismissInBatchRecordAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissRecordAttachment(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissRecordAttachment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecordAttachmentRestControllerApi.deleteOrDismissRecordAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecordAttachment(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecordAttachment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecordAttachmentRestControllerApi.getRecordAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ListRecordAttachmentRecordTypeEnum} recordType
         * @param {number} recordId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRecordAttachment(recordType, recordId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRecordAttachment(recordType, recordId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecordAttachmentRestControllerApi.listRecordAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {PageRecordAttachmentRecordTypeEnum} recordType
         * @param {number} recordId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageRecordAttachment(recordType, recordId, page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageRecordAttachment(recordType, recordId, page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecordAttachmentRestControllerApi.pageRecordAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {RecordAttachment} recordAttachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveRecordAttachment(recordAttachment, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveRecordAttachment(recordAttachment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecordAttachmentRestControllerApi.saveRecordAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewRecordAttachment(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewRecordAttachment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecordAttachmentRestControllerApi.viewRecordAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * RecordAttachmentRestControllerApi - factory interface
 * @export
 */
export const RecordAttachmentRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RecordAttachmentRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {CountRecordAttachmentRecordTypeEnum} recordType
         * @param {number} recordId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countRecordAttachment(recordType, recordId, term, showDismissed, options) {
            return localVarFp.countRecordAttachment(recordType, recordId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchRecordAttachment(ids, options) {
            return localVarFp.deleteOrDismissInBatchRecordAttachment(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissRecordAttachment(id, options) {
            return localVarFp.deleteOrDismissRecordAttachment(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecordAttachment(id, options) {
            return localVarFp.getRecordAttachment(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ListRecordAttachmentRecordTypeEnum} recordType
         * @param {number} recordId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecordAttachment(recordType, recordId, term, showDismissed, options) {
            return localVarFp.listRecordAttachment(recordType, recordId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PageRecordAttachmentRecordTypeEnum} recordType
         * @param {number} recordId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRecordAttachment(recordType, recordId, page, size, sort, term, showDismissed, options) {
            return localVarFp.pageRecordAttachment(recordType, recordId, page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RecordAttachment} recordAttachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRecordAttachment(recordAttachment, options) {
            return localVarFp.saveRecordAttachment(recordAttachment, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewRecordAttachment(id, options) {
            return localVarFp.viewRecordAttachment(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RecordAttachmentRestControllerApi - object-oriented interface
 * @export
 * @class RecordAttachmentRestControllerApi
 * @extends {BaseAPI}
 */
export class RecordAttachmentRestControllerApi extends BaseAPI {
    /**
     *
     * @param {CountRecordAttachmentRecordTypeEnum} recordType
     * @param {number} recordId
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecordAttachmentRestControllerApi
     */
    countRecordAttachment(recordType, recordId, term, showDismissed, options) {
        return RecordAttachmentRestControllerApiFp(this.configuration).countRecordAttachment(recordType, recordId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecordAttachmentRestControllerApi
     */
    deleteOrDismissInBatchRecordAttachment(ids, options) {
        return RecordAttachmentRestControllerApiFp(this.configuration).deleteOrDismissInBatchRecordAttachment(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecordAttachmentRestControllerApi
     */
    deleteOrDismissRecordAttachment(id, options) {
        return RecordAttachmentRestControllerApiFp(this.configuration).deleteOrDismissRecordAttachment(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecordAttachmentRestControllerApi
     */
    getRecordAttachment(id, options) {
        return RecordAttachmentRestControllerApiFp(this.configuration).getRecordAttachment(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ListRecordAttachmentRecordTypeEnum} recordType
     * @param {number} recordId
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecordAttachmentRestControllerApi
     */
    listRecordAttachment(recordType, recordId, term, showDismissed, options) {
        return RecordAttachmentRestControllerApiFp(this.configuration).listRecordAttachment(recordType, recordId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PageRecordAttachmentRecordTypeEnum} recordType
     * @param {number} recordId
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecordAttachmentRestControllerApi
     */
    pageRecordAttachment(recordType, recordId, page, size, sort, term, showDismissed, options) {
        return RecordAttachmentRestControllerApiFp(this.configuration).pageRecordAttachment(recordType, recordId, page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RecordAttachment} recordAttachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecordAttachmentRestControllerApi
     */
    saveRecordAttachment(recordAttachment, options) {
        return RecordAttachmentRestControllerApiFp(this.configuration).saveRecordAttachment(recordAttachment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecordAttachmentRestControllerApi
     */
    viewRecordAttachment(id, options) {
        return RecordAttachmentRestControllerApiFp(this.configuration).viewRecordAttachment(id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountRecordAttachmentRecordTypeEnum = {
    BUDGET: 'BUDGET',
    BILL: 'BILL',
    CUSTOMER: 'CUSTOMER',
    SUPPLIER: 'SUPPLIER',
    ORGANIZATION: 'ORGANIZATION',
    ORG_REQUEST: 'ORG_REQUEST'
};
/**
 * @export
 */
export const ListRecordAttachmentRecordTypeEnum = {
    BUDGET: 'BUDGET',
    BILL: 'BILL',
    CUSTOMER: 'CUSTOMER',
    SUPPLIER: 'SUPPLIER',
    ORGANIZATION: 'ORGANIZATION',
    ORG_REQUEST: 'ORG_REQUEST'
};
/**
 * @export
 */
export const PageRecordAttachmentRecordTypeEnum = {
    BUDGET: 'BUDGET',
    BILL: 'BILL',
    CUSTOMER: 'CUSTOMER',
    SUPPLIER: 'SUPPLIER',
    ORGANIZATION: 'ORGANIZATION',
    ORG_REQUEST: 'ORG_REQUEST'
};
/**
 * RecruitmentDocumentRestControllerApi - axios parameter creator
 * @export
 */
export const RecruitmentDocumentRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} recruitmentId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countRecruitmentDocument: async (recruitmentId, term, showDismissed, options = {}) => {
            // verify required parameter 'recruitmentId' is not null or undefined
            assertParamExists('countRecruitmentDocument', 'recruitmentId', recruitmentId);
            const localVarPath = `/api/admin/recruitment/recruitment/document/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (recruitmentId !== undefined) {
                localVarQueryParameter['recruitmentId'] = recruitmentId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchRecruitmentDocument: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchRecruitmentDocument', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/recruitment/document/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissRecruitmentDocument: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissRecruitmentDocument', 'id', id);
            const localVarPath = `/api/admin/recruitment/recruitment/document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentDocument: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRecruitmentDocument', 'id', id);
            const localVarPath = `/api/admin/recruitment/recruitment/document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} recruitmentId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecruitmentDocument: async (recruitmentId, term, showDismissed, options = {}) => {
            // verify required parameter 'recruitmentId' is not null or undefined
            assertParamExists('listRecruitmentDocument', 'recruitmentId', recruitmentId);
            const localVarPath = `/api/admin/recruitment/recruitment/document/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (recruitmentId !== undefined) {
                localVarQueryParameter['recruitmentId'] = recruitmentId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} recruitmentId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRecruitmentDocument: async (recruitmentId, page, size, sort, term, showDismissed, options = {}) => {
            // verify required parameter 'recruitmentId' is not null or undefined
            assertParamExists('pageRecruitmentDocument', 'recruitmentId', recruitmentId);
            const localVarPath = `/api/admin/recruitment/recruitment/document/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (recruitmentId !== undefined) {
                localVarQueryParameter['recruitmentId'] = recruitmentId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RecruitmentDocument} recruitmentDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRecruitmentDocument: async (recruitmentDocument, options = {}) => {
            // verify required parameter 'recruitmentDocument' is not null or undefined
            assertParamExists('saveRecruitmentDocument', 'recruitmentDocument', recruitmentDocument);
            const localVarPath = `/api/admin/recruitment/recruitment/document/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(recruitmentDocument, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewRecruitmentDocumentRecruitmentDocument: async (docId, options = {}) => {
            // verify required parameter 'docId' is not null or undefined
            assertParamExists('viewRecruitmentDocumentRecruitmentDocument', 'docId', docId);
            const localVarPath = `/api/admin/recruitment/recruitment/document/view/{docId}`
                .replace(`{${"docId"}}`, encodeURIComponent(String(docId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RecruitmentDocumentRestControllerApi - functional programming interface
 * @export
 */
export const RecruitmentDocumentRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = RecruitmentDocumentRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} recruitmentId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countRecruitmentDocument(recruitmentId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countRecruitmentDocument(recruitmentId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentDocumentRestControllerApi.countRecruitmentDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchRecruitmentDocument(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchRecruitmentDocument(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentDocumentRestControllerApi.deleteOrDismissInBatchRecruitmentDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissRecruitmentDocument(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissRecruitmentDocument(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentDocumentRestControllerApi.deleteOrDismissRecruitmentDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecruitmentDocument(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecruitmentDocument(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentDocumentRestControllerApi.getRecruitmentDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} recruitmentId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRecruitmentDocument(recruitmentId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRecruitmentDocument(recruitmentId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentDocumentRestControllerApi.listRecruitmentDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} recruitmentId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageRecruitmentDocument(recruitmentId, page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageRecruitmentDocument(recruitmentId, page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentDocumentRestControllerApi.pageRecruitmentDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {RecruitmentDocument} recruitmentDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveRecruitmentDocument(recruitmentDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveRecruitmentDocument(recruitmentDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentDocumentRestControllerApi.saveRecruitmentDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewRecruitmentDocumentRecruitmentDocument(docId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewRecruitmentDocumentRecruitmentDocument(docId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentDocumentRestControllerApi.viewRecruitmentDocumentRecruitmentDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * RecruitmentDocumentRestControllerApi - factory interface
 * @export
 */
export const RecruitmentDocumentRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RecruitmentDocumentRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} recruitmentId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countRecruitmentDocument(recruitmentId, term, showDismissed, options) {
            return localVarFp.countRecruitmentDocument(recruitmentId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchRecruitmentDocument(ids, options) {
            return localVarFp.deleteOrDismissInBatchRecruitmentDocument(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissRecruitmentDocument(id, options) {
            return localVarFp.deleteOrDismissRecruitmentDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentDocument(id, options) {
            return localVarFp.getRecruitmentDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} recruitmentId
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecruitmentDocument(recruitmentId, term, showDismissed, options) {
            return localVarFp.listRecruitmentDocument(recruitmentId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} recruitmentId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRecruitmentDocument(recruitmentId, page, size, sort, term, showDismissed, options) {
            return localVarFp.pageRecruitmentDocument(recruitmentId, page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RecruitmentDocument} recruitmentDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRecruitmentDocument(recruitmentDocument, options) {
            return localVarFp.saveRecruitmentDocument(recruitmentDocument, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} docId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewRecruitmentDocumentRecruitmentDocument(docId, options) {
            return localVarFp.viewRecruitmentDocumentRecruitmentDocument(docId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RecruitmentDocumentRestControllerApi - object-oriented interface
 * @export
 * @class RecruitmentDocumentRestControllerApi
 * @extends {BaseAPI}
 */
export class RecruitmentDocumentRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} recruitmentId
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentDocumentRestControllerApi
     */
    countRecruitmentDocument(recruitmentId, term, showDismissed, options) {
        return RecruitmentDocumentRestControllerApiFp(this.configuration).countRecruitmentDocument(recruitmentId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentDocumentRestControllerApi
     */
    deleteOrDismissInBatchRecruitmentDocument(ids, options) {
        return RecruitmentDocumentRestControllerApiFp(this.configuration).deleteOrDismissInBatchRecruitmentDocument(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentDocumentRestControllerApi
     */
    deleteOrDismissRecruitmentDocument(id, options) {
        return RecruitmentDocumentRestControllerApiFp(this.configuration).deleteOrDismissRecruitmentDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentDocumentRestControllerApi
     */
    getRecruitmentDocument(id, options) {
        return RecruitmentDocumentRestControllerApiFp(this.configuration).getRecruitmentDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} recruitmentId
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentDocumentRestControllerApi
     */
    listRecruitmentDocument(recruitmentId, term, showDismissed, options) {
        return RecruitmentDocumentRestControllerApiFp(this.configuration).listRecruitmentDocument(recruitmentId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} recruitmentId
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentDocumentRestControllerApi
     */
    pageRecruitmentDocument(recruitmentId, page, size, sort, term, showDismissed, options) {
        return RecruitmentDocumentRestControllerApiFp(this.configuration).pageRecruitmentDocument(recruitmentId, page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RecruitmentDocument} recruitmentDocument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentDocumentRestControllerApi
     */
    saveRecruitmentDocument(recruitmentDocument, options) {
        return RecruitmentDocumentRestControllerApiFp(this.configuration).saveRecruitmentDocument(recruitmentDocument, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentDocumentRestControllerApi
     */
    viewRecruitmentDocumentRecruitmentDocument(docId, options) {
        return RecruitmentDocumentRestControllerApiFp(this.configuration).viewRecruitmentDocumentRecruitmentDocument(docId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RecruitmentRestControllerApi - axios parameter creator
 * @export
 */
export const RecruitmentRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} recruitmentId
         * @param {Applicant} applicant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addApplicantRecruitment: async (recruitmentId, applicant, options = {}) => {
            // verify required parameter 'recruitmentId' is not null or undefined
            assertParamExists('addApplicantRecruitment', 'recruitmentId', recruitmentId);
            // verify required parameter 'applicant' is not null or undefined
            assertParamExists('addApplicantRecruitment', 'applicant', applicant);
            const localVarPath = `/api/admin/recruitment/recruitment/append`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (recruitmentId !== undefined) {
                localVarQueryParameter['recruitmentId'] = recruitmentId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(applicant, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countRecruitment: async (active, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/recruitment/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchRecruitment: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchRecruitment', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/recruitment/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissRecruitment: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissRecruitment', 'id', id);
            const localVarPath = `/api/admin/recruitment/recruitment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitment: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRecruitment', 'id', id);
            const localVarPath = `/api/admin/recruitment/recruitment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecruitment: async (active, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/recruitment/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRecruitment: async (page, size, sort, active, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/recruitment/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Recruitment} recruitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRecruitment: async (recruitment, options = {}) => {
            // verify required parameter 'recruitment' is not null or undefined
            assertParamExists('saveRecruitment', 'recruitment', recruitment);
            const localVarPath = `/api/admin/recruitment/recruitment/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(recruitment, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startStateRecruitment: async (options = {}) => {
            const localVarPath = `/api/admin/recruitment/recruitment/startState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RecruitmentRestControllerApi - functional programming interface
 * @export
 */
export const RecruitmentRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = RecruitmentRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} recruitmentId
         * @param {Applicant} applicant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addApplicantRecruitment(recruitmentId, applicant, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addApplicantRecruitment(recruitmentId, applicant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentRestControllerApi.addApplicantRecruitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countRecruitment(active, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countRecruitment(active, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentRestControllerApi.countRecruitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchRecruitment(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchRecruitment(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentRestControllerApi.deleteOrDismissInBatchRecruitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissRecruitment(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissRecruitment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentRestControllerApi.deleteOrDismissRecruitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecruitment(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecruitment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentRestControllerApi.getRecruitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRecruitment(active, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRecruitment(active, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentRestControllerApi.listRecruitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageRecruitment(page, size, sort, active, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageRecruitment(page, size, sort, active, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentRestControllerApi.pageRecruitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Recruitment} recruitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveRecruitment(recruitment, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveRecruitment(recruitment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentRestControllerApi.saveRecruitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startStateRecruitment(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startStateRecruitment(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentRestControllerApi.startStateRecruitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * RecruitmentRestControllerApi - factory interface
 * @export
 */
export const RecruitmentRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RecruitmentRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} recruitmentId
         * @param {Applicant} applicant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addApplicantRecruitment(recruitmentId, applicant, options) {
            return localVarFp.addApplicantRecruitment(recruitmentId, applicant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countRecruitment(active, term, showDismissed, options) {
            return localVarFp.countRecruitment(active, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchRecruitment(ids, options) {
            return localVarFp.deleteOrDismissInBatchRecruitment(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissRecruitment(id, options) {
            return localVarFp.deleteOrDismissRecruitment(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitment(id, options) {
            return localVarFp.getRecruitment(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecruitment(active, term, showDismissed, options) {
            return localVarFp.listRecruitment(active, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [active]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRecruitment(page, size, sort, active, term, showDismissed, options) {
            return localVarFp.pageRecruitment(page, size, sort, active, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Recruitment} recruitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRecruitment(recruitment, options) {
            return localVarFp.saveRecruitment(recruitment, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startStateRecruitment(options) {
            return localVarFp.startStateRecruitment(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RecruitmentRestControllerApi - object-oriented interface
 * @export
 * @class RecruitmentRestControllerApi
 * @extends {BaseAPI}
 */
export class RecruitmentRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} recruitmentId
     * @param {Applicant} applicant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentRestControllerApi
     */
    addApplicantRecruitment(recruitmentId, applicant, options) {
        return RecruitmentRestControllerApiFp(this.configuration).addApplicantRecruitment(recruitmentId, applicant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [active]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentRestControllerApi
     */
    countRecruitment(active, term, showDismissed, options) {
        return RecruitmentRestControllerApiFp(this.configuration).countRecruitment(active, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentRestControllerApi
     */
    deleteOrDismissInBatchRecruitment(ids, options) {
        return RecruitmentRestControllerApiFp(this.configuration).deleteOrDismissInBatchRecruitment(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentRestControllerApi
     */
    deleteOrDismissRecruitment(id, options) {
        return RecruitmentRestControllerApiFp(this.configuration).deleteOrDismissRecruitment(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentRestControllerApi
     */
    getRecruitment(id, options) {
        return RecruitmentRestControllerApiFp(this.configuration).getRecruitment(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [active]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentRestControllerApi
     */
    listRecruitment(active, term, showDismissed, options) {
        return RecruitmentRestControllerApiFp(this.configuration).listRecruitment(active, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {boolean} [active]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentRestControllerApi
     */
    pageRecruitment(page, size, sort, active, term, showDismissed, options) {
        return RecruitmentRestControllerApiFp(this.configuration).pageRecruitment(page, size, sort, active, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Recruitment} recruitment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentRestControllerApi
     */
    saveRecruitment(recruitment, options) {
        return RecruitmentRestControllerApiFp(this.configuration).saveRecruitment(recruitment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentRestControllerApi
     */
    startStateRecruitment(options) {
        return RecruitmentRestControllerApiFp(this.configuration).startStateRecruitment(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RecruitmentStatsRestControllerApi - axios parameter creator
 * @export
 */
export const RecruitmentStatsRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentStats: async (options = {}) => {
            const localVarPath = `/api/admin/recruitment/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RecruitmentStatsRestControllerApi - functional programming interface
 * @export
 */
export const RecruitmentStatsRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = RecruitmentStatsRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecruitmentStats(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecruitmentStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecruitmentStatsRestControllerApi.getRecruitmentStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * RecruitmentStatsRestControllerApi - factory interface
 * @export
 */
export const RecruitmentStatsRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RecruitmentStatsRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentStats(options) {
            return localVarFp.getRecruitmentStats(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RecruitmentStatsRestControllerApi - object-oriented interface
 * @export
 * @class RecruitmentStatsRestControllerApi
 * @extends {BaseAPI}
 */
export class RecruitmentStatsRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentStatsRestControllerApi
     */
    getRecruitmentStats(options) {
        return RecruitmentStatsRestControllerApiFp(this.configuration).getRecruitmentStats(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RequiredDocumentsRestControllerApi - axios parameter creator
 * @export
 */
export const RequiredDocumentsRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportRequiredDocuments: async (options = {}) => {
            const localVarPath = `/api/admin/quality/required-documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RequiredDocumentsRestControllerApi - functional programming interface
 * @export
 */
export const RequiredDocumentsRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = RequiredDocumentsRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportRequiredDocuments(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportRequiredDocuments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequiredDocumentsRestControllerApi.reportRequiredDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * RequiredDocumentsRestControllerApi - factory interface
 * @export
 */
export const RequiredDocumentsRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RequiredDocumentsRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportRequiredDocuments(options) {
            return localVarFp.reportRequiredDocuments(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RequiredDocumentsRestControllerApi - object-oriented interface
 * @export
 * @class RequiredDocumentsRestControllerApi
 * @extends {BaseAPI}
 */
export class RequiredDocumentsRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequiredDocumentsRestControllerApi
     */
    reportRequiredDocuments(options) {
        return RequiredDocumentsRestControllerApiFp(this.configuration).reportRequiredDocuments(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SalaryRestControllerApi - axios parameter creator
 * @export
 */
export const SalaryRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSalary: async (personId, visibleByEmployee, term, showDismissed, options = {}) => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('countSalary', 'personId', personId);
            const localVarPath = `/api/admin/employee/person/salaries/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSalary: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchSalary', 'ids', ids);
            const localVarPath = `/api/admin/employee/person/salaries/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSalary: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissSalary', 'id', id);
            const localVarPath = `/api/admin/employee/person/salaries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} salaryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateSalary: async (salaryId, options = {}) => {
            // verify required parameter 'salaryId' is not null or undefined
            assertParamExists('duplicateSalary', 'salaryId', salaryId);
            const localVarPath = `/api/admin/employee/person/salaries/duplicate/{salaryId}`
                .replace(`{${"salaryId"}}`, encodeURIComponent(String(salaryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalary: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalary', 'id', id);
            const localVarPath = `/api/admin/employee/person/salaries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalary: async (personId, visibleByEmployee, term, showDismissed, options = {}) => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('listSalary', 'personId', personId);
            const localVarPath = `/api/admin/employee/person/salaries/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} personId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSalary: async (personId, page, size, sort, visibleByEmployee, term, showDismissed, options = {}) => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('pageSalary', 'personId', personId);
            const localVarPath = `/api/admin/employee/person/salaries/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [months]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateAuditSalary: async (months, options = {}) => {
            const localVarPath = `/api/admin/employee/person/salaries/rate-audit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (months !== undefined) {
                localVarQueryParameter['months'] = months;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Salary} salary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSalary: async (salary, options = {}) => {
            // verify required parameter 'salary' is not null or undefined
            assertParamExists('saveSalary', 'salary', salary);
            const localVarPath = `/api/admin/employee/person/salaries/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(salary, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SalaryRestControllerApi - functional programming interface
 * @export
 */
export const SalaryRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SalaryRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countSalary(personId, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countSalary(personId, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalaryRestControllerApi.countSalary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchSalary(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchSalary(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalaryRestControllerApi.deleteOrDismissInBatchSalary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissSalary(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissSalary(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalaryRestControllerApi.deleteOrDismissSalary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} salaryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateSalary(salaryId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateSalary(salaryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalaryRestControllerApi.duplicateSalary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalary(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalary(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalaryRestControllerApi.getSalary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSalary(personId, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSalary(personId, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalaryRestControllerApi.listSalary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} personId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSalary(personId, page, size, sort, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSalary(personId, page, size, sort, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalaryRestControllerApi.pageSalary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [months]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rateAuditSalary(months, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rateAuditSalary(months, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalaryRestControllerApi.rateAuditSalary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Salary} salary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSalary(salary, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSalary(salary, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalaryRestControllerApi.saveSalary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SalaryRestControllerApi - factory interface
 * @export
 */
export const SalaryRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SalaryRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSalary(personId, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countSalary(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSalary(ids, options) {
            return localVarFp.deleteOrDismissInBatchSalary(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSalary(id, options) {
            return localVarFp.deleteOrDismissSalary(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} salaryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateSalary(salaryId, options) {
            return localVarFp.duplicateSalary(salaryId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalary(id, options) {
            return localVarFp.getSalary(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalary(personId, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listSalary(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} personId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSalary(personId, page, size, sort, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pageSalary(personId, page, size, sort, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [months]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateAuditSalary(months, options) {
            return localVarFp.rateAuditSalary(months, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Salary} salary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSalary(salary, options) {
            return localVarFp.saveSalary(salary, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SalaryRestControllerApi - object-oriented interface
 * @export
 * @class SalaryRestControllerApi
 * @extends {BaseAPI}
 */
export class SalaryRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} personId
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalaryRestControllerApi
     */
    countSalary(personId, visibleByEmployee, term, showDismissed, options) {
        return SalaryRestControllerApiFp(this.configuration).countSalary(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalaryRestControllerApi
     */
    deleteOrDismissInBatchSalary(ids, options) {
        return SalaryRestControllerApiFp(this.configuration).deleteOrDismissInBatchSalary(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalaryRestControllerApi
     */
    deleteOrDismissSalary(id, options) {
        return SalaryRestControllerApiFp(this.configuration).deleteOrDismissSalary(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} salaryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalaryRestControllerApi
     */
    duplicateSalary(salaryId, options) {
        return SalaryRestControllerApiFp(this.configuration).duplicateSalary(salaryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalaryRestControllerApi
     */
    getSalary(id, options) {
        return SalaryRestControllerApiFp(this.configuration).getSalary(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalaryRestControllerApi
     */
    listSalary(personId, visibleByEmployee, term, showDismissed, options) {
        return SalaryRestControllerApiFp(this.configuration).listSalary(personId, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} personId
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalaryRestControllerApi
     */
    pageSalary(personId, page, size, sort, visibleByEmployee, term, showDismissed, options) {
        return SalaryRestControllerApiFp(this.configuration).pageSalary(personId, page, size, sort, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [months]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalaryRestControllerApi
     */
    rateAuditSalary(months, options) {
        return SalaryRestControllerApiFp(this.configuration).rateAuditSalary(months, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Salary} salary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalaryRestControllerApi
     */
    saveSalary(salary, options) {
        return SalaryRestControllerApiFp(this.configuration).saveSalary(salary, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SearchRestControllerApi - axios parameter creator
 * @export
 */
export const SearchRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindex: async (options = {}) => {
            const localVarPath = `/api/admin/search/reindex`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} q
         * @param {Array<SearchTypesEnum>} [types]
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [perType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (q, types, from, to, perType, options = {}) => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('search', 'q', q);
            const localVarPath = `/api/admin/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (types) {
                localVarQueryParameter['types'] = types;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString().substring(0, 10) :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString().substring(0, 10) :
                    to;
            }
            if (perType !== undefined) {
                localVarQueryParameter['perType'] = perType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SearchRestControllerApi - functional programming interface
 * @export
 */
export const SearchRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SearchRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindex(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindex(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchRestControllerApi.reindex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} q
         * @param {Array<SearchTypesEnum>} [types]
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [perType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(q, types, from, to, perType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(q, types, from, to, perType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchRestControllerApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SearchRestControllerApi - factory interface
 * @export
 */
export const SearchRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SearchRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindex(options) {
            return localVarFp.reindex(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} q
         * @param {Array<SearchTypesEnum>} [types]
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [perType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(q, types, from, to, perType, options) {
            return localVarFp.search(q, types, from, to, perType, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SearchRestControllerApi - object-oriented interface
 * @export
 * @class SearchRestControllerApi
 * @extends {BaseAPI}
 */
export class SearchRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchRestControllerApi
     */
    reindex(options) {
        return SearchRestControllerApiFp(this.configuration).reindex(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} q
     * @param {Array<SearchTypesEnum>} [types]
     * @param {string} [from]
     * @param {string} [to]
     * @param {number} [perType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchRestControllerApi
     */
    search(q, types, from, to, perType, options) {
        return SearchRestControllerApiFp(this.configuration).search(q, types, from, to, perType, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const SearchTypesEnum = {
    PERSON: 'PERSON',
    PERSON_DOCUMENT: 'PERSON_DOCUMENT',
    TRAINING_RECORD: 'TRAINING_RECORD',
    CANDIDATE: 'CANDIDATE',
    CANDIDATE_DOCUMENT: 'CANDIDATE_DOCUMENT',
    LEVEL_TEST: 'LEVEL_TEST',
    LEVEL_SOLUTION: 'LEVEL_SOLUTION',
    RECRUITMENT: 'RECRUITMENT',
    RECRUITMENT_DOCUMENT: 'RECRUITMENT_DOCUMENT',
    CUSTOMER: 'CUSTOMER',
    BILL: 'BILL',
    BUDGET: 'BUDGET',
    SUPPLIER: 'SUPPLIER',
    SUPPLIER_BILL: 'SUPPLIER_BILL',
    ORGANIZATION: 'ORGANIZATION',
    CONTACT: 'CONTACT',
    LEAD: 'LEAD',
    ORG_REQUEST: 'ORG_REQUEST',
    QUALITY_FINDING: 'QUALITY_FINDING',
    ACCESS_REVIEW: 'ACCESS_REVIEW',
    COMPANY_DOCUMENT: 'COMPANY_DOCUMENT',
    WIKI_PAGE: 'WIKI_PAGE',
    RECORD_ATTACHMENT: 'RECORD_ATTACHMENT'
};
/**
 * SepaMandateRestControllerApi - axios parameter creator
 * @export
 */
export const SepaMandateRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activeSepaMandate: async (customerId, options = {}) => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('activeSepaMandate', 'customerId', customerId);
            const localVarPath = `/api/admin/billing/sepa-mandate/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        byCustomerSepaMandate: async (customerId, options = {}) => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('byCustomerSepaMandate', 'customerId', customerId);
            const localVarPath = `/api/admin/billing/sepa-mandate/by-customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [customerId]
         * @param {CountSepaMandateStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSepaMandate: async (customerId, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/sepa-mandate/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSepaMandate: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchSepaMandate', 'ids', ids);
            const localVarPath = `/api/admin/billing/sepa-mandate/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSepaMandate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissSepaMandate', 'id', id);
            const localVarPath = `/api/admin/billing/sepa-mandate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} mandateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSepaMandate: async (mandateId, options = {}) => {
            // verify required parameter 'mandateId' is not null or undefined
            assertParamExists('downloadSepaMandate', 'mandateId', mandateId);
            const localVarPath = `/api/admin/billing/sepa-mandate/{mandateId}/download`
                .replace(`{${"mandateId"}}`, encodeURIComponent(String(mandateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSepaMandate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSepaMandate', 'id', id);
            const localVarPath = `/api/admin/billing/sepa-mandate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [customerId]
         * @param {ListSepaMandateStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSepaMandate: async (customerId, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/sepa-mandate/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [customerId]
         * @param {PageSepaMandateStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSepaMandate: async (page, size, sort, customerId, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/sepa-mandate/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} mandateId
         * @param {string} [motivo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeSepaMandate: async (mandateId, motivo, options = {}) => {
            // verify required parameter 'mandateId' is not null or undefined
            assertParamExists('revokeSepaMandate', 'mandateId', mandateId);
            const localVarPath = `/api/admin/billing/sepa-mandate/{mandateId}/revoke`
                .replace(`{${"mandateId"}}`, encodeURIComponent(String(mandateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (motivo !== undefined) {
                localVarQueryParameter['motivo'] = motivo;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SepaMandate} sepaMandate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSepaMandate: async (sepaMandate, options = {}) => {
            // verify required parameter 'sepaMandate' is not null or undefined
            assertParamExists('saveSepaMandate', 'sepaMandate', sepaMandate);
            const localVarPath = `/api/admin/billing/sepa-mandate/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(sepaMandate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SepaMandateRestControllerApi - functional programming interface
 * @export
 */
export const SepaMandateRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SepaMandateRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activeSepaMandate(customerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activeSepaMandate(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateRestControllerApi.activeSepaMandate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async byCustomerSepaMandate(customerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.byCustomerSepaMandate(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateRestControllerApi.byCustomerSepaMandate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [customerId]
         * @param {CountSepaMandateStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countSepaMandate(customerId, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countSepaMandate(customerId, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateRestControllerApi.countSepaMandate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchSepaMandate(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchSepaMandate(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateRestControllerApi.deleteOrDismissInBatchSepaMandate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissSepaMandate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissSepaMandate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateRestControllerApi.deleteOrDismissSepaMandate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} mandateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSepaMandate(mandateId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSepaMandate(mandateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateRestControllerApi.downloadSepaMandate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSepaMandate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSepaMandate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateRestControllerApi.getSepaMandate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [customerId]
         * @param {ListSepaMandateStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSepaMandate(customerId, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSepaMandate(customerId, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateRestControllerApi.listSepaMandate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [customerId]
         * @param {PageSepaMandateStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSepaMandate(page, size, sort, customerId, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSepaMandate(page, size, sort, customerId, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateRestControllerApi.pageSepaMandate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} mandateId
         * @param {string} [motivo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeSepaMandate(mandateId, motivo, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeSepaMandate(mandateId, motivo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateRestControllerApi.revokeSepaMandate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {SepaMandate} sepaMandate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSepaMandate(sepaMandate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSepaMandate(sepaMandate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateRestControllerApi.saveSepaMandate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SepaMandateRestControllerApi - factory interface
 * @export
 */
export const SepaMandateRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SepaMandateRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activeSepaMandate(customerId, options) {
            return localVarFp.activeSepaMandate(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        byCustomerSepaMandate(customerId, options) {
            return localVarFp.byCustomerSepaMandate(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [customerId]
         * @param {CountSepaMandateStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSepaMandate(customerId, status, term, showDismissed, options) {
            return localVarFp.countSepaMandate(customerId, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSepaMandate(ids, options) {
            return localVarFp.deleteOrDismissInBatchSepaMandate(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSepaMandate(id, options) {
            return localVarFp.deleteOrDismissSepaMandate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} mandateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSepaMandate(mandateId, options) {
            return localVarFp.downloadSepaMandate(mandateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSepaMandate(id, options) {
            return localVarFp.getSepaMandate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [customerId]
         * @param {ListSepaMandateStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSepaMandate(customerId, status, term, showDismissed, options) {
            return localVarFp.listSepaMandate(customerId, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [customerId]
         * @param {PageSepaMandateStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSepaMandate(page, size, sort, customerId, status, term, showDismissed, options) {
            return localVarFp.pageSepaMandate(page, size, sort, customerId, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} mandateId
         * @param {string} [motivo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeSepaMandate(mandateId, motivo, options) {
            return localVarFp.revokeSepaMandate(mandateId, motivo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SepaMandate} sepaMandate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSepaMandate(sepaMandate, options) {
            return localVarFp.saveSepaMandate(sepaMandate, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SepaMandateRestControllerApi - object-oriented interface
 * @export
 * @class SepaMandateRestControllerApi
 * @extends {BaseAPI}
 */
export class SepaMandateRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} customerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaMandateRestControllerApi
     */
    activeSepaMandate(customerId, options) {
        return SepaMandateRestControllerApiFp(this.configuration).activeSepaMandate(customerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} customerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaMandateRestControllerApi
     */
    byCustomerSepaMandate(customerId, options) {
        return SepaMandateRestControllerApiFp(this.configuration).byCustomerSepaMandate(customerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [customerId]
     * @param {CountSepaMandateStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaMandateRestControllerApi
     */
    countSepaMandate(customerId, status, term, showDismissed, options) {
        return SepaMandateRestControllerApiFp(this.configuration).countSepaMandate(customerId, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaMandateRestControllerApi
     */
    deleteOrDismissInBatchSepaMandate(ids, options) {
        return SepaMandateRestControllerApiFp(this.configuration).deleteOrDismissInBatchSepaMandate(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaMandateRestControllerApi
     */
    deleteOrDismissSepaMandate(id, options) {
        return SepaMandateRestControllerApiFp(this.configuration).deleteOrDismissSepaMandate(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} mandateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaMandateRestControllerApi
     */
    downloadSepaMandate(mandateId, options) {
        return SepaMandateRestControllerApiFp(this.configuration).downloadSepaMandate(mandateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaMandateRestControllerApi
     */
    getSepaMandate(id, options) {
        return SepaMandateRestControllerApiFp(this.configuration).getSepaMandate(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [customerId]
     * @param {ListSepaMandateStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaMandateRestControllerApi
     */
    listSepaMandate(customerId, status, term, showDismissed, options) {
        return SepaMandateRestControllerApiFp(this.configuration).listSepaMandate(customerId, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [customerId]
     * @param {PageSepaMandateStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaMandateRestControllerApi
     */
    pageSepaMandate(page, size, sort, customerId, status, term, showDismissed, options) {
        return SepaMandateRestControllerApiFp(this.configuration).pageSepaMandate(page, size, sort, customerId, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} mandateId
     * @param {string} [motivo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaMandateRestControllerApi
     */
    revokeSepaMandate(mandateId, motivo, options) {
        return SepaMandateRestControllerApiFp(this.configuration).revokeSepaMandate(mandateId, motivo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SepaMandate} sepaMandate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaMandateRestControllerApi
     */
    saveSepaMandate(sepaMandate, options) {
        return SepaMandateRestControllerApiFp(this.configuration).saveSepaMandate(sepaMandate, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountSepaMandateStatusEnum = {
    ACTIVO: 'ACTIVO',
    REVOCADO: 'REVOCADO',
    CADUCADO: 'CADUCADO'
};
/**
 * @export
 */
export const ListSepaMandateStatusEnum = {
    ACTIVO: 'ACTIVO',
    REVOCADO: 'REVOCADO',
    CADUCADO: 'CADUCADO'
};
/**
 * @export
 */
export const PageSepaMandateStatusEnum = {
    ACTIVO: 'ACTIVO',
    REVOCADO: 'REVOCADO',
    CADUCADO: 'CADUCADO'
};
/**
 * SepaRemittanceRestControllerApi - axios parameter creator
 * @export
 */
export const SepaRemittanceRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} remittanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billsSepaRemittance: async (remittanceId, options = {}) => {
            // verify required parameter 'remittanceId' is not null or undefined
            assertParamExists('billsSepaRemittance', 'remittanceId', remittanceId);
            const localVarPath = `/api/admin/billing/sepa-remittance/{remittanceId}/bills`
                .replace(`{${"remittanceId"}}`, encodeURIComponent(String(remittanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CountSepaRemittanceStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSepaRemittance: async (status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/sepa-remittance/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSepaRemittance: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchSepaRemittance', 'ids', ids);
            const localVarPath = `/api/admin/billing/sepa-remittance/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSepaRemittance: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissSepaRemittance', 'id', id);
            const localVarPath = `/api/admin/billing/sepa-remittance/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} remittanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discardSepaRemittance: async (remittanceId, options = {}) => {
            // verify required parameter 'remittanceId' is not null or undefined
            assertParamExists('discardSepaRemittance', 'remittanceId', remittanceId);
            const localVarPath = `/api/admin/billing/sepa-remittance/{remittanceId}/discard`
                .replace(`{${"remittanceId"}}`, encodeURIComponent(String(remittanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSepaRemittance: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSepaRemittance', 'id', id);
            const localVarPath = `/api/admin/billing/sepa-remittance/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ListSepaRemittanceStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSepaRemittance: async (status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/sepa-remittance/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageSepaRemittanceStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSepaRemittance: async (page, size, sort, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/billing/sepa-remittance/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} collectionDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareSepaRemittance: async (collectionDate, options = {}) => {
            // verify required parameter 'collectionDate' is not null or undefined
            assertParamExists('prepareSepaRemittance', 'collectionDate', collectionDate);
            const localVarPath = `/api/admin/billing/sepa-remittance/prepare`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (collectionDate !== undefined) {
                localVarQueryParameter['collectionDate'] = (collectionDate instanceof Date) ?
                    collectionDate.toISOString().substring(0, 10) :
                    collectionDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} remittanceId
         * @param {string} [presentedDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presentSepaRemittance: async (remittanceId, presentedDate, options = {}) => {
            // verify required parameter 'remittanceId' is not null or undefined
            assertParamExists('presentSepaRemittance', 'remittanceId', remittanceId);
            const localVarPath = `/api/admin/billing/sepa-remittance/{remittanceId}/present`
                .replace(`{${"remittanceId"}}`, encodeURIComponent(String(remittanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (presentedDate !== undefined) {
                localVarQueryParameter['presentedDate'] = (presentedDate instanceof Date) ?
                    presentedDate.toISOString().substring(0, 10) :
                    presentedDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} billId
         * @param {string} reason
         * @param {string} [returnedDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerReturnSepaRemittance: async (billId, reason, returnedDate, options = {}) => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('registerReturnSepaRemittance', 'billId', billId);
            // verify required parameter 'reason' is not null or undefined
            assertParamExists('registerReturnSepaRemittance', 'reason', reason);
            const localVarPath = `/api/admin/billing/sepa-remittance/return`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (billId !== undefined) {
                localVarQueryParameter['billId'] = billId;
            }
            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }
            if (returnedDate !== undefined) {
                localVarQueryParameter['returnedDate'] = (returnedDate instanceof Date) ?
                    returnedDate.toISOString().substring(0, 10) :
                    returnedDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnedSepaRemittance: async (from, to, options = {}) => {
            const localVarPath = `/api/admin/billing/sepa-remittance/returned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString().substring(0, 10) :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString().substring(0, 10) :
                    to;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SepaRemittance} sepaRemittance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSepaRemittance: async (sepaRemittance, options = {}) => {
            // verify required parameter 'sepaRemittance' is not null or undefined
            assertParamExists('saveSepaRemittance', 'sepaRemittance', sepaRemittance);
            const localVarPath = `/api/admin/billing/sepa-remittance/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(sepaRemittance, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} remittanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        xmlSepaRemittance: async (remittanceId, options = {}) => {
            // verify required parameter 'remittanceId' is not null or undefined
            assertParamExists('xmlSepaRemittance', 'remittanceId', remittanceId);
            const localVarPath = `/api/admin/billing/sepa-remittance/{remittanceId}/xml`
                .replace(`{${"remittanceId"}}`, encodeURIComponent(String(remittanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SepaRemittanceRestControllerApi - functional programming interface
 * @export
 */
export const SepaRemittanceRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SepaRemittanceRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} remittanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billsSepaRemittance(remittanceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billsSepaRemittance(remittanceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaRemittanceRestControllerApi.billsSepaRemittance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CountSepaRemittanceStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countSepaRemittance(status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countSepaRemittance(status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaRemittanceRestControllerApi.countSepaRemittance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchSepaRemittance(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchSepaRemittance(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaRemittanceRestControllerApi.deleteOrDismissInBatchSepaRemittance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissSepaRemittance(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissSepaRemittance(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaRemittanceRestControllerApi.deleteOrDismissSepaRemittance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} remittanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discardSepaRemittance(remittanceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discardSepaRemittance(remittanceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaRemittanceRestControllerApi.discardSepaRemittance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSepaRemittance(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSepaRemittance(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaRemittanceRestControllerApi.getSepaRemittance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ListSepaRemittanceStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSepaRemittance(status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSepaRemittance(status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaRemittanceRestControllerApi.listSepaRemittance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageSepaRemittanceStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSepaRemittance(page, size, sort, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSepaRemittance(page, size, sort, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaRemittanceRestControllerApi.pageSepaRemittance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} collectionDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prepareSepaRemittance(collectionDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.prepareSepaRemittance(collectionDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaRemittanceRestControllerApi.prepareSepaRemittance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} remittanceId
         * @param {string} [presentedDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async presentSepaRemittance(remittanceId, presentedDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.presentSepaRemittance(remittanceId, presentedDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaRemittanceRestControllerApi.presentSepaRemittance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} billId
         * @param {string} reason
         * @param {string} [returnedDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerReturnSepaRemittance(billId, reason, returnedDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerReturnSepaRemittance(billId, reason, returnedDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaRemittanceRestControllerApi.registerReturnSepaRemittance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async returnedSepaRemittance(from, to, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.returnedSepaRemittance(from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaRemittanceRestControllerApi.returnedSepaRemittance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {SepaRemittance} sepaRemittance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSepaRemittance(sepaRemittance, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSepaRemittance(sepaRemittance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaRemittanceRestControllerApi.saveSepaRemittance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} remittanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async xmlSepaRemittance(remittanceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.xmlSepaRemittance(remittanceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaRemittanceRestControllerApi.xmlSepaRemittance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SepaRemittanceRestControllerApi - factory interface
 * @export
 */
export const SepaRemittanceRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SepaRemittanceRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} remittanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billsSepaRemittance(remittanceId, options) {
            return localVarFp.billsSepaRemittance(remittanceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CountSepaRemittanceStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSepaRemittance(status, term, showDismissed, options) {
            return localVarFp.countSepaRemittance(status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSepaRemittance(ids, options) {
            return localVarFp.deleteOrDismissInBatchSepaRemittance(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSepaRemittance(id, options) {
            return localVarFp.deleteOrDismissSepaRemittance(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} remittanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discardSepaRemittance(remittanceId, options) {
            return localVarFp.discardSepaRemittance(remittanceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSepaRemittance(id, options) {
            return localVarFp.getSepaRemittance(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ListSepaRemittanceStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSepaRemittance(status, term, showDismissed, options) {
            return localVarFp.listSepaRemittance(status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageSepaRemittanceStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSepaRemittance(page, size, sort, status, term, showDismissed, options) {
            return localVarFp.pageSepaRemittance(page, size, sort, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} collectionDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareSepaRemittance(collectionDate, options) {
            return localVarFp.prepareSepaRemittance(collectionDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} remittanceId
         * @param {string} [presentedDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presentSepaRemittance(remittanceId, presentedDate, options) {
            return localVarFp.presentSepaRemittance(remittanceId, presentedDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} billId
         * @param {string} reason
         * @param {string} [returnedDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerReturnSepaRemittance(billId, reason, returnedDate, options) {
            return localVarFp.registerReturnSepaRemittance(billId, reason, returnedDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnedSepaRemittance(from, to, options) {
            return localVarFp.returnedSepaRemittance(from, to, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SepaRemittance} sepaRemittance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSepaRemittance(sepaRemittance, options) {
            return localVarFp.saveSepaRemittance(sepaRemittance, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} remittanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        xmlSepaRemittance(remittanceId, options) {
            return localVarFp.xmlSepaRemittance(remittanceId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SepaRemittanceRestControllerApi - object-oriented interface
 * @export
 * @class SepaRemittanceRestControllerApi
 * @extends {BaseAPI}
 */
export class SepaRemittanceRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} remittanceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaRemittanceRestControllerApi
     */
    billsSepaRemittance(remittanceId, options) {
        return SepaRemittanceRestControllerApiFp(this.configuration).billsSepaRemittance(remittanceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CountSepaRemittanceStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaRemittanceRestControllerApi
     */
    countSepaRemittance(status, term, showDismissed, options) {
        return SepaRemittanceRestControllerApiFp(this.configuration).countSepaRemittance(status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaRemittanceRestControllerApi
     */
    deleteOrDismissInBatchSepaRemittance(ids, options) {
        return SepaRemittanceRestControllerApiFp(this.configuration).deleteOrDismissInBatchSepaRemittance(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaRemittanceRestControllerApi
     */
    deleteOrDismissSepaRemittance(id, options) {
        return SepaRemittanceRestControllerApiFp(this.configuration).deleteOrDismissSepaRemittance(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} remittanceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaRemittanceRestControllerApi
     */
    discardSepaRemittance(remittanceId, options) {
        return SepaRemittanceRestControllerApiFp(this.configuration).discardSepaRemittance(remittanceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaRemittanceRestControllerApi
     */
    getSepaRemittance(id, options) {
        return SepaRemittanceRestControllerApiFp(this.configuration).getSepaRemittance(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ListSepaRemittanceStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaRemittanceRestControllerApi
     */
    listSepaRemittance(status, term, showDismissed, options) {
        return SepaRemittanceRestControllerApiFp(this.configuration).listSepaRemittance(status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {PageSepaRemittanceStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaRemittanceRestControllerApi
     */
    pageSepaRemittance(page, size, sort, status, term, showDismissed, options) {
        return SepaRemittanceRestControllerApiFp(this.configuration).pageSepaRemittance(page, size, sort, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} collectionDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaRemittanceRestControllerApi
     */
    prepareSepaRemittance(collectionDate, options) {
        return SepaRemittanceRestControllerApiFp(this.configuration).prepareSepaRemittance(collectionDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} remittanceId
     * @param {string} [presentedDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaRemittanceRestControllerApi
     */
    presentSepaRemittance(remittanceId, presentedDate, options) {
        return SepaRemittanceRestControllerApiFp(this.configuration).presentSepaRemittance(remittanceId, presentedDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} billId
     * @param {string} reason
     * @param {string} [returnedDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaRemittanceRestControllerApi
     */
    registerReturnSepaRemittance(billId, reason, returnedDate, options) {
        return SepaRemittanceRestControllerApiFp(this.configuration).registerReturnSepaRemittance(billId, reason, returnedDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [from]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaRemittanceRestControllerApi
     */
    returnedSepaRemittance(from, to, options) {
        return SepaRemittanceRestControllerApiFp(this.configuration).returnedSepaRemittance(from, to, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SepaRemittance} sepaRemittance
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaRemittanceRestControllerApi
     */
    saveSepaRemittance(sepaRemittance, options) {
        return SepaRemittanceRestControllerApiFp(this.configuration).saveSepaRemittance(sepaRemittance, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} remittanceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SepaRemittanceRestControllerApi
     */
    xmlSepaRemittance(remittanceId, options) {
        return SepaRemittanceRestControllerApiFp(this.configuration).xmlSepaRemittance(remittanceId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountSepaRemittanceStatusEnum = {
    BORRADOR: 'BORRADOR',
    PRESENTADA: 'PRESENTADA'
};
/**
 * @export
 */
export const ListSepaRemittanceStatusEnum = {
    BORRADOR: 'BORRADOR',
    PRESENTADA: 'PRESENTADA'
};
/**
 * @export
 */
export const PageSepaRemittanceStatusEnum = {
    BORRADOR: 'BORRADOR',
    PRESENTADA: 'PRESENTADA'
};
/**
 * SkillLevelRestControllerApi - axios parameter creator
 * @export
 */
export const SkillLevelRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSkillLevel: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/skilllevel/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSkillLevel: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchSkillLevel', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/skilllevel/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSkillLevel: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissSkillLevel', 'id', id);
            const localVarPath = `/api/admin/recruitment/skilllevel/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkillLevel: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSkillLevel', 'id', id);
            const localVarPath = `/api/admin/recruitment/skilllevel/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkillLevel: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/skilllevel/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSkillLevel: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/skilllevel/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SkillLevel} skillLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSkillLevel: async (skillLevel, options = {}) => {
            // verify required parameter 'skillLevel' is not null or undefined
            assertParamExists('saveSkillLevel', 'skillLevel', skillLevel);
            const localVarPath = `/api/admin/recruitment/skilllevel/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(skillLevel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SkillLevelRestControllerApi - functional programming interface
 * @export
 */
export const SkillLevelRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SkillLevelRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countSkillLevel(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countSkillLevel(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillLevelRestControllerApi.countSkillLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchSkillLevel(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchSkillLevel(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillLevelRestControllerApi.deleteOrDismissInBatchSkillLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissSkillLevel(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissSkillLevel(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillLevelRestControllerApi.deleteOrDismissSkillLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSkillLevel(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSkillLevel(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillLevelRestControllerApi.getSkillLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSkillLevel(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSkillLevel(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillLevelRestControllerApi.listSkillLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSkillLevel(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSkillLevel(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillLevelRestControllerApi.pageSkillLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {SkillLevel} skillLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSkillLevel(skillLevel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSkillLevel(skillLevel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillLevelRestControllerApi.saveSkillLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SkillLevelRestControllerApi - factory interface
 * @export
 */
export const SkillLevelRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SkillLevelRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSkillLevel(term, showDismissed, options) {
            return localVarFp.countSkillLevel(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSkillLevel(ids, options) {
            return localVarFp.deleteOrDismissInBatchSkillLevel(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSkillLevel(id, options) {
            return localVarFp.deleteOrDismissSkillLevel(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkillLevel(id, options) {
            return localVarFp.getSkillLevel(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkillLevel(term, showDismissed, options) {
            return localVarFp.listSkillLevel(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSkillLevel(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageSkillLevel(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SkillLevel} skillLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSkillLevel(skillLevel, options) {
            return localVarFp.saveSkillLevel(skillLevel, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SkillLevelRestControllerApi - object-oriented interface
 * @export
 * @class SkillLevelRestControllerApi
 * @extends {BaseAPI}
 */
export class SkillLevelRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillLevelRestControllerApi
     */
    countSkillLevel(term, showDismissed, options) {
        return SkillLevelRestControllerApiFp(this.configuration).countSkillLevel(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillLevelRestControllerApi
     */
    deleteOrDismissInBatchSkillLevel(ids, options) {
        return SkillLevelRestControllerApiFp(this.configuration).deleteOrDismissInBatchSkillLevel(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillLevelRestControllerApi
     */
    deleteOrDismissSkillLevel(id, options) {
        return SkillLevelRestControllerApiFp(this.configuration).deleteOrDismissSkillLevel(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillLevelRestControllerApi
     */
    getSkillLevel(id, options) {
        return SkillLevelRestControllerApiFp(this.configuration).getSkillLevel(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillLevelRestControllerApi
     */
    listSkillLevel(term, showDismissed, options) {
        return SkillLevelRestControllerApiFp(this.configuration).listSkillLevel(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillLevelRestControllerApi
     */
    pageSkillLevel(page, size, sort, term, showDismissed, options) {
        return SkillLevelRestControllerApiFp(this.configuration).pageSkillLevel(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SkillLevel} skillLevel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillLevelRestControllerApi
     */
    saveSkillLevel(skillLevel, options) {
        return SkillLevelRestControllerApiFp(this.configuration).saveSkillLevel(skillLevel, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SkillRestControllerApi - axios parameter creator
 * @export
 */
export const SkillRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSkill: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/skill/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSkill: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchSkill', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/skill/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSkill: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissSkill', 'id', id);
            const localVarPath = `/api/admin/recruitment/skill/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkill: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSkill', 'id', id);
            const localVarPath = `/api/admin/recruitment/skill/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkill: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/skill/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSkill: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/skill/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Skill} skill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSkill: async (skill, options = {}) => {
            // verify required parameter 'skill' is not null or undefined
            assertParamExists('saveSkill', 'skill', skill);
            const localVarPath = `/api/admin/recruitment/skill/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(skill, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SkillRestControllerApi - functional programming interface
 * @export
 */
export const SkillRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SkillRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countSkill(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countSkill(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillRestControllerApi.countSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchSkill(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchSkill(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillRestControllerApi.deleteOrDismissInBatchSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissSkill(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissSkill(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillRestControllerApi.deleteOrDismissSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSkill(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSkill(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillRestControllerApi.getSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSkill(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSkill(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillRestControllerApi.listSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSkill(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSkill(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillRestControllerApi.pageSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Skill} skill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSkill(skill, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSkill(skill, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillRestControllerApi.saveSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SkillRestControllerApi - factory interface
 * @export
 */
export const SkillRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SkillRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSkill(term, showDismissed, options) {
            return localVarFp.countSkill(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSkill(ids, options) {
            return localVarFp.deleteOrDismissInBatchSkill(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSkill(id, options) {
            return localVarFp.deleteOrDismissSkill(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkill(id, options) {
            return localVarFp.getSkill(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkill(term, showDismissed, options) {
            return localVarFp.listSkill(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSkill(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageSkill(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Skill} skill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSkill(skill, options) {
            return localVarFp.saveSkill(skill, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SkillRestControllerApi - object-oriented interface
 * @export
 * @class SkillRestControllerApi
 * @extends {BaseAPI}
 */
export class SkillRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillRestControllerApi
     */
    countSkill(term, showDismissed, options) {
        return SkillRestControllerApiFp(this.configuration).countSkill(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillRestControllerApi
     */
    deleteOrDismissInBatchSkill(ids, options) {
        return SkillRestControllerApiFp(this.configuration).deleteOrDismissInBatchSkill(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillRestControllerApi
     */
    deleteOrDismissSkill(id, options) {
        return SkillRestControllerApiFp(this.configuration).deleteOrDismissSkill(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillRestControllerApi
     */
    getSkill(id, options) {
        return SkillRestControllerApiFp(this.configuration).getSkill(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillRestControllerApi
     */
    listSkill(term, showDismissed, options) {
        return SkillRestControllerApiFp(this.configuration).listSkill(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillRestControllerApi
     */
    pageSkill(page, size, sort, term, showDismissed, options) {
        return SkillRestControllerApiFp(this.configuration).pageSkill(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Skill} skill
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillRestControllerApi
     */
    saveSkill(skill, options) {
        return SkillRestControllerApiFp(this.configuration).saveSkill(skill, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SocialAccountRestControllerApi - axios parameter creator
 * @export
 */
export const SocialAccountRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CountSocialAccountProviderEnum} [provider]
         * @param {CountSocialAccountStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSocialAccount: async (provider, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/social/account/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSocialAccount: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchSocialAccount', 'ids', ids);
            const localVarPath = `/api/admin/marketing/social/account/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSocialAccount: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissSocialAccount', 'id', id);
            const localVarPath = `/api/admin/marketing/social/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialAccount: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSocialAccount', 'id', id);
            const localVarPath = `/api/admin/marketing/social/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ListSocialAccountProviderEnum} [provider]
         * @param {ListSocialAccountStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSocialAccount: async (provider, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/social/account/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageSocialAccountProviderEnum} [provider]
         * @param {PageSocialAccountStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSocialAccount: async (page, size, sort, provider, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/social/account/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SocialAccount} socialAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSocialAccount: async (socialAccount, options = {}) => {
            // verify required parameter 'socialAccount' is not null or undefined
            assertParamExists('saveSocialAccount', 'socialAccount', socialAccount);
            const localVarPath = `/api/admin/marketing/social/account/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(socialAccount, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SocialAccountRestControllerApi - functional programming interface
 * @export
 */
export const SocialAccountRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SocialAccountRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CountSocialAccountProviderEnum} [provider]
         * @param {CountSocialAccountStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countSocialAccount(provider, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countSocialAccount(provider, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialAccountRestControllerApi.countSocialAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchSocialAccount(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchSocialAccount(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialAccountRestControllerApi.deleteOrDismissInBatchSocialAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissSocialAccount(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissSocialAccount(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialAccountRestControllerApi.deleteOrDismissSocialAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSocialAccount(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSocialAccount(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialAccountRestControllerApi.getSocialAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ListSocialAccountProviderEnum} [provider]
         * @param {ListSocialAccountStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSocialAccount(provider, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSocialAccount(provider, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialAccountRestControllerApi.listSocialAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageSocialAccountProviderEnum} [provider]
         * @param {PageSocialAccountStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSocialAccount(page, size, sort, provider, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSocialAccount(page, size, sort, provider, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialAccountRestControllerApi.pageSocialAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {SocialAccount} socialAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSocialAccount(socialAccount, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSocialAccount(socialAccount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialAccountRestControllerApi.saveSocialAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SocialAccountRestControllerApi - factory interface
 * @export
 */
export const SocialAccountRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SocialAccountRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {CountSocialAccountProviderEnum} [provider]
         * @param {CountSocialAccountStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSocialAccount(provider, status, term, showDismissed, options) {
            return localVarFp.countSocialAccount(provider, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSocialAccount(ids, options) {
            return localVarFp.deleteOrDismissInBatchSocialAccount(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSocialAccount(id, options) {
            return localVarFp.deleteOrDismissSocialAccount(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialAccount(id, options) {
            return localVarFp.getSocialAccount(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ListSocialAccountProviderEnum} [provider]
         * @param {ListSocialAccountStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSocialAccount(provider, status, term, showDismissed, options) {
            return localVarFp.listSocialAccount(provider, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageSocialAccountProviderEnum} [provider]
         * @param {PageSocialAccountStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSocialAccount(page, size, sort, provider, status, term, showDismissed, options) {
            return localVarFp.pageSocialAccount(page, size, sort, provider, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SocialAccount} socialAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSocialAccount(socialAccount, options) {
            return localVarFp.saveSocialAccount(socialAccount, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SocialAccountRestControllerApi - object-oriented interface
 * @export
 * @class SocialAccountRestControllerApi
 * @extends {BaseAPI}
 */
export class SocialAccountRestControllerApi extends BaseAPI {
    /**
     *
     * @param {CountSocialAccountProviderEnum} [provider]
     * @param {CountSocialAccountStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialAccountRestControllerApi
     */
    countSocialAccount(provider, status, term, showDismissed, options) {
        return SocialAccountRestControllerApiFp(this.configuration).countSocialAccount(provider, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialAccountRestControllerApi
     */
    deleteOrDismissInBatchSocialAccount(ids, options) {
        return SocialAccountRestControllerApiFp(this.configuration).deleteOrDismissInBatchSocialAccount(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialAccountRestControllerApi
     */
    deleteOrDismissSocialAccount(id, options) {
        return SocialAccountRestControllerApiFp(this.configuration).deleteOrDismissSocialAccount(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialAccountRestControllerApi
     */
    getSocialAccount(id, options) {
        return SocialAccountRestControllerApiFp(this.configuration).getSocialAccount(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ListSocialAccountProviderEnum} [provider]
     * @param {ListSocialAccountStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialAccountRestControllerApi
     */
    listSocialAccount(provider, status, term, showDismissed, options) {
        return SocialAccountRestControllerApiFp(this.configuration).listSocialAccount(provider, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {PageSocialAccountProviderEnum} [provider]
     * @param {PageSocialAccountStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialAccountRestControllerApi
     */
    pageSocialAccount(page, size, sort, provider, status, term, showDismissed, options) {
        return SocialAccountRestControllerApiFp(this.configuration).pageSocialAccount(page, size, sort, provider, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SocialAccount} socialAccount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialAccountRestControllerApi
     */
    saveSocialAccount(socialAccount, options) {
        return SocialAccountRestControllerApiFp(this.configuration).saveSocialAccount(socialAccount, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountSocialAccountProviderEnum = {
    FACEBOOK: 'FACEBOOK',
    INSTAGRAM: 'INSTAGRAM',
    LINKEDIN: 'LINKEDIN'
};
/**
 * @export
 */
export const CountSocialAccountStatusEnum = {
    CONNECTED: 'CONNECTED',
    EXPIRED: 'EXPIRED',
    DISCONNECTED: 'DISCONNECTED',
    ERROR: 'ERROR'
};
/**
 * @export
 */
export const ListSocialAccountProviderEnum = {
    FACEBOOK: 'FACEBOOK',
    INSTAGRAM: 'INSTAGRAM',
    LINKEDIN: 'LINKEDIN'
};
/**
 * @export
 */
export const ListSocialAccountStatusEnum = {
    CONNECTED: 'CONNECTED',
    EXPIRED: 'EXPIRED',
    DISCONNECTED: 'DISCONNECTED',
    ERROR: 'ERROR'
};
/**
 * @export
 */
export const PageSocialAccountProviderEnum = {
    FACEBOOK: 'FACEBOOK',
    INSTAGRAM: 'INSTAGRAM',
    LINKEDIN: 'LINKEDIN'
};
/**
 * @export
 */
export const PageSocialAccountStatusEnum = {
    CONNECTED: 'CONNECTED',
    EXPIRED: 'EXPIRED',
    DISCONNECTED: 'DISCONNECTED',
    ERROR: 'ERROR'
};
/**
 * SocialCallbackControllerApi - axios parameter creator
 * @export
 */
export const SocialCallbackControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} provider
         * @param {string} [code]
         * @param {string} [state]
         * @param {string} [error]
         * @param {string} [errorDescription]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callback: async (provider, code, state, error, errorDescription, options = {}) => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('callback', 'provider', provider);
            const localVarPath = `/api/pub/marketing/social/{provider}/callback`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            if (error !== undefined) {
                localVarQueryParameter['error'] = error;
            }
            if (errorDescription !== undefined) {
                localVarQueryParameter['error_description'] = errorDescription;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SocialCallbackControllerApi - functional programming interface
 * @export
 */
export const SocialCallbackControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SocialCallbackControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} provider
         * @param {string} [code]
         * @param {string} [state]
         * @param {string} [error]
         * @param {string} [errorDescription]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callback(provider, code, state, error, errorDescription, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callback(provider, code, state, error, errorDescription, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialCallbackControllerApi.callback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SocialCallbackControllerApi - factory interface
 * @export
 */
export const SocialCallbackControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SocialCallbackControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} provider
         * @param {string} [code]
         * @param {string} [state]
         * @param {string} [error]
         * @param {string} [errorDescription]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callback(provider, code, state, error, errorDescription, options) {
            return localVarFp.callback(provider, code, state, error, errorDescription, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SocialCallbackControllerApi - object-oriented interface
 * @export
 * @class SocialCallbackControllerApi
 * @extends {BaseAPI}
 */
export class SocialCallbackControllerApi extends BaseAPI {
    /**
     *
     * @param {string} provider
     * @param {string} [code]
     * @param {string} [state]
     * @param {string} [error]
     * @param {string} [errorDescription]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialCallbackControllerApi
     */
    callback(provider, code, state, error, errorDescription, options) {
        return SocialCallbackControllerApiFp(this.configuration).callback(provider, code, state, error, errorDescription, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SocialConnectRestControllerApi - axios parameter creator
 * @export
 */
export const SocialConnectRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collect: async (options = {}) => {
            const localVarPath = `/api/admin/marketing/social/insights/collect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} provider
         * @param {boolean} [asMember]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connect: async (provider, asMember, options = {}) => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('connect', 'provider', provider);
            const localVarPath = `/api/admin/marketing/social/connect/{provider}`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (asMember !== undefined) {
                localVarQueryParameter['asMember'] = asMember;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} postId
         * @param {Array<PublishProvidersEnum>} [providers]
         * @param {boolean} [linkedinAsMember]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publish: async (postId, providers, linkedinAsMember, options = {}) => {
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('publish', 'postId', postId);
            const localVarPath = `/api/admin/marketing/social/publish/{postId}`
                .replace(`{${"postId"}}`, encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (providers) {
                localVarQueryParameter['providers'] = providers;
            }
            if (linkedinAsMember !== undefined) {
                localVarQueryParameter['linkedinAsMember'] = linkedinAsMember;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokens: async (options = {}) => {
            const localVarPath = `/api/admin/marketing/social/tokens/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} publicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retract: async (publicationId, options = {}) => {
            // verify required parameter 'publicationId' is not null or undefined
            assertParamExists('retract', 'publicationId', publicationId);
            const localVarPath = `/api/admin/marketing/social/publication/{publicationId}/remote`
                .replace(`{${"publicationId"}}`, encodeURIComponent(String(publicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTokens: async (options = {}) => {
            const localVarPath = `/api/admin/marketing/social/tokens/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SocialConnectRestControllerApi - functional programming interface
 * @export
 */
export const SocialConnectRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SocialConnectRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async collect(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.collect(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialConnectRestControllerApi.collect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} provider
         * @param {boolean} [asMember]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connect(provider, asMember, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connect(provider, asMember, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialConnectRestControllerApi.connect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} postId
         * @param {Array<PublishProvidersEnum>} [providers]
         * @param {boolean} [linkedinAsMember]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publish(postId, providers, linkedinAsMember, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publish(postId, providers, linkedinAsMember, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialConnectRestControllerApi.publish']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshTokens(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshTokens(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialConnectRestControllerApi.refreshTokens']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} publicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retract(publicationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retract(publicationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialConnectRestControllerApi.retract']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyTokens(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyTokens(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialConnectRestControllerApi.verifyTokens']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SocialConnectRestControllerApi - factory interface
 * @export
 */
export const SocialConnectRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SocialConnectRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collect(options) {
            return localVarFp.collect(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} provider
         * @param {boolean} [asMember]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connect(provider, asMember, options) {
            return localVarFp.connect(provider, asMember, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} postId
         * @param {Array<PublishProvidersEnum>} [providers]
         * @param {boolean} [linkedinAsMember]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publish(postId, providers, linkedinAsMember, options) {
            return localVarFp.publish(postId, providers, linkedinAsMember, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokens(options) {
            return localVarFp.refreshTokens(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} publicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retract(publicationId, options) {
            return localVarFp.retract(publicationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTokens(options) {
            return localVarFp.verifyTokens(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SocialConnectRestControllerApi - object-oriented interface
 * @export
 * @class SocialConnectRestControllerApi
 * @extends {BaseAPI}
 */
export class SocialConnectRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialConnectRestControllerApi
     */
    collect(options) {
        return SocialConnectRestControllerApiFp(this.configuration).collect(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} provider
     * @param {boolean} [asMember]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialConnectRestControllerApi
     */
    connect(provider, asMember, options) {
        return SocialConnectRestControllerApiFp(this.configuration).connect(provider, asMember, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} postId
     * @param {Array<PublishProvidersEnum>} [providers]
     * @param {boolean} [linkedinAsMember]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialConnectRestControllerApi
     */
    publish(postId, providers, linkedinAsMember, options) {
        return SocialConnectRestControllerApiFp(this.configuration).publish(postId, providers, linkedinAsMember, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialConnectRestControllerApi
     */
    refreshTokens(options) {
        return SocialConnectRestControllerApiFp(this.configuration).refreshTokens(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} publicationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialConnectRestControllerApi
     */
    retract(publicationId, options) {
        return SocialConnectRestControllerApiFp(this.configuration).retract(publicationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialConnectRestControllerApi
     */
    verifyTokens(options) {
        return SocialConnectRestControllerApiFp(this.configuration).verifyTokens(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const PublishProvidersEnum = {
    FACEBOOK: 'FACEBOOK',
    INSTAGRAM: 'INSTAGRAM',
    LINKEDIN: 'LINKEDIN'
};
/**
 * SocialInsightRestControllerApi - axios parameter creator
 * @export
 */
export const SocialInsightRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [publicationId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSocialInsight: async (publicationId, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/social/insight/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (publicationId !== undefined) {
                localVarQueryParameter['publicationId'] = publicationId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSocialInsight: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchSocialInsight', 'ids', ids);
            const localVarPath = `/api/admin/marketing/social/insight/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSocialInsight: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissSocialInsight', 'id', id);
            const localVarPath = `/api/admin/marketing/social/insight/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialInsight: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSocialInsight', 'id', id);
            const localVarPath = `/api/admin/marketing/social/insight/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [publicationId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSocialInsight: async (publicationId, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/social/insight/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (publicationId !== undefined) {
                localVarQueryParameter['publicationId'] = publicationId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [publicationId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSocialInsight: async (page, size, sort, publicationId, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/social/insight/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (publicationId !== undefined) {
                localVarQueryParameter['publicationId'] = publicationId;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SocialInsight} socialInsight
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSocialInsight: async (socialInsight, options = {}) => {
            // verify required parameter 'socialInsight' is not null or undefined
            assertParamExists('saveSocialInsight', 'socialInsight', socialInsight);
            const localVarPath = `/api/admin/marketing/social/insight/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(socialInsight, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SocialInsightRestControllerApi - functional programming interface
 * @export
 */
export const SocialInsightRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SocialInsightRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [publicationId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countSocialInsight(publicationId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countSocialInsight(publicationId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialInsightRestControllerApi.countSocialInsight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchSocialInsight(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchSocialInsight(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialInsightRestControllerApi.deleteOrDismissInBatchSocialInsight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissSocialInsight(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissSocialInsight(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialInsightRestControllerApi.deleteOrDismissSocialInsight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSocialInsight(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSocialInsight(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialInsightRestControllerApi.getSocialInsight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [publicationId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSocialInsight(publicationId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSocialInsight(publicationId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialInsightRestControllerApi.listSocialInsight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [publicationId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSocialInsight(page, size, sort, publicationId, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSocialInsight(page, size, sort, publicationId, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialInsightRestControllerApi.pageSocialInsight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {SocialInsight} socialInsight
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSocialInsight(socialInsight, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSocialInsight(socialInsight, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialInsightRestControllerApi.saveSocialInsight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SocialInsightRestControllerApi - factory interface
 * @export
 */
export const SocialInsightRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SocialInsightRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [publicationId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSocialInsight(publicationId, term, showDismissed, options) {
            return localVarFp.countSocialInsight(publicationId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSocialInsight(ids, options) {
            return localVarFp.deleteOrDismissInBatchSocialInsight(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSocialInsight(id, options) {
            return localVarFp.deleteOrDismissSocialInsight(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialInsight(id, options) {
            return localVarFp.getSocialInsight(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [publicationId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSocialInsight(publicationId, term, showDismissed, options) {
            return localVarFp.listSocialInsight(publicationId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [publicationId]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSocialInsight(page, size, sort, publicationId, term, showDismissed, options) {
            return localVarFp.pageSocialInsight(page, size, sort, publicationId, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SocialInsight} socialInsight
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSocialInsight(socialInsight, options) {
            return localVarFp.saveSocialInsight(socialInsight, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SocialInsightRestControllerApi - object-oriented interface
 * @export
 * @class SocialInsightRestControllerApi
 * @extends {BaseAPI}
 */
export class SocialInsightRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [publicationId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialInsightRestControllerApi
     */
    countSocialInsight(publicationId, term, showDismissed, options) {
        return SocialInsightRestControllerApiFp(this.configuration).countSocialInsight(publicationId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialInsightRestControllerApi
     */
    deleteOrDismissInBatchSocialInsight(ids, options) {
        return SocialInsightRestControllerApiFp(this.configuration).deleteOrDismissInBatchSocialInsight(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialInsightRestControllerApi
     */
    deleteOrDismissSocialInsight(id, options) {
        return SocialInsightRestControllerApiFp(this.configuration).deleteOrDismissSocialInsight(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialInsightRestControllerApi
     */
    getSocialInsight(id, options) {
        return SocialInsightRestControllerApiFp(this.configuration).getSocialInsight(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [publicationId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialInsightRestControllerApi
     */
    listSocialInsight(publicationId, term, showDismissed, options) {
        return SocialInsightRestControllerApiFp(this.configuration).listSocialInsight(publicationId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [publicationId]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialInsightRestControllerApi
     */
    pageSocialInsight(page, size, sort, publicationId, term, showDismissed, options) {
        return SocialInsightRestControllerApiFp(this.configuration).pageSocialInsight(page, size, sort, publicationId, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SocialInsight} socialInsight
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialInsightRestControllerApi
     */
    saveSocialInsight(socialInsight, options) {
        return SocialInsightRestControllerApiFp(this.configuration).saveSocialInsight(socialInsight, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SocialPostRestControllerApi - axios parameter creator
 * @export
 */
export const SocialPostRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CountSocialPostStatusEnum} [status]
         * @param {string} [segment]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSocialPost: async (status, segment, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/social/post/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (segment !== undefined) {
                localVarQueryParameter['segment'] = segment;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSocialPost: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchSocialPost', 'ids', ids);
            const localVarPath = `/api/admin/marketing/social/post/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSocialPost: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissSocialPost', 'id', id);
            const localVarPath = `/api/admin/marketing/social/post/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialPost: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSocialPost', 'id', id);
            const localVarPath = `/api/admin/marketing/social/post/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ListSocialPostStatusEnum} [status]
         * @param {string} [segment]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSocialPost: async (status, segment, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/social/post/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (segment !== undefined) {
                localVarQueryParameter['segment'] = segment;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageSocialPostStatusEnum} [status]
         * @param {string} [segment]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSocialPost: async (page, size, sort, status, segment, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/social/post/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (segment !== undefined) {
                localVarQueryParameter['segment'] = segment;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SocialPost} socialPost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSocialPost: async (socialPost, options = {}) => {
            // verify required parameter 'socialPost' is not null or undefined
            assertParamExists('saveSocialPost', 'socialPost', socialPost);
            const localVarPath = `/api/admin/marketing/social/post/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(socialPost, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SocialPostRestControllerApi - functional programming interface
 * @export
 */
export const SocialPostRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SocialPostRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CountSocialPostStatusEnum} [status]
         * @param {string} [segment]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countSocialPost(status, segment, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countSocialPost(status, segment, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialPostRestControllerApi.countSocialPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchSocialPost(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchSocialPost(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialPostRestControllerApi.deleteOrDismissInBatchSocialPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissSocialPost(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissSocialPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialPostRestControllerApi.deleteOrDismissSocialPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSocialPost(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSocialPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialPostRestControllerApi.getSocialPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ListSocialPostStatusEnum} [status]
         * @param {string} [segment]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSocialPost(status, segment, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSocialPost(status, segment, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialPostRestControllerApi.listSocialPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageSocialPostStatusEnum} [status]
         * @param {string} [segment]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSocialPost(page, size, sort, status, segment, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSocialPost(page, size, sort, status, segment, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialPostRestControllerApi.pageSocialPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {SocialPost} socialPost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSocialPost(socialPost, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSocialPost(socialPost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialPostRestControllerApi.saveSocialPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SocialPostRestControllerApi - factory interface
 * @export
 */
export const SocialPostRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SocialPostRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {CountSocialPostStatusEnum} [status]
         * @param {string} [segment]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSocialPost(status, segment, term, showDismissed, options) {
            return localVarFp.countSocialPost(status, segment, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSocialPost(ids, options) {
            return localVarFp.deleteOrDismissInBatchSocialPost(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSocialPost(id, options) {
            return localVarFp.deleteOrDismissSocialPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialPost(id, options) {
            return localVarFp.getSocialPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ListSocialPostStatusEnum} [status]
         * @param {string} [segment]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSocialPost(status, segment, term, showDismissed, options) {
            return localVarFp.listSocialPost(status, segment, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {PageSocialPostStatusEnum} [status]
         * @param {string} [segment]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSocialPost(page, size, sort, status, segment, term, showDismissed, options) {
            return localVarFp.pageSocialPost(page, size, sort, status, segment, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SocialPost} socialPost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSocialPost(socialPost, options) {
            return localVarFp.saveSocialPost(socialPost, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SocialPostRestControllerApi - object-oriented interface
 * @export
 * @class SocialPostRestControllerApi
 * @extends {BaseAPI}
 */
export class SocialPostRestControllerApi extends BaseAPI {
    /**
     *
     * @param {CountSocialPostStatusEnum} [status]
     * @param {string} [segment]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialPostRestControllerApi
     */
    countSocialPost(status, segment, term, showDismissed, options) {
        return SocialPostRestControllerApiFp(this.configuration).countSocialPost(status, segment, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialPostRestControllerApi
     */
    deleteOrDismissInBatchSocialPost(ids, options) {
        return SocialPostRestControllerApiFp(this.configuration).deleteOrDismissInBatchSocialPost(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialPostRestControllerApi
     */
    deleteOrDismissSocialPost(id, options) {
        return SocialPostRestControllerApiFp(this.configuration).deleteOrDismissSocialPost(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialPostRestControllerApi
     */
    getSocialPost(id, options) {
        return SocialPostRestControllerApiFp(this.configuration).getSocialPost(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ListSocialPostStatusEnum} [status]
     * @param {string} [segment]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialPostRestControllerApi
     */
    listSocialPost(status, segment, term, showDismissed, options) {
        return SocialPostRestControllerApiFp(this.configuration).listSocialPost(status, segment, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {PageSocialPostStatusEnum} [status]
     * @param {string} [segment]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialPostRestControllerApi
     */
    pageSocialPost(page, size, sort, status, segment, term, showDismissed, options) {
        return SocialPostRestControllerApiFp(this.configuration).pageSocialPost(page, size, sort, status, segment, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SocialPost} socialPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialPostRestControllerApi
     */
    saveSocialPost(socialPost, options) {
        return SocialPostRestControllerApiFp(this.configuration).saveSocialPost(socialPost, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountSocialPostStatusEnum = {
    DRAFT: 'DRAFT',
    SCHEDULED: 'SCHEDULED',
    PUBLISHED: 'PUBLISHED',
    PARTIAL: 'PARTIAL',
    FAILED: 'FAILED'
};
/**
 * @export
 */
export const ListSocialPostStatusEnum = {
    DRAFT: 'DRAFT',
    SCHEDULED: 'SCHEDULED',
    PUBLISHED: 'PUBLISHED',
    PARTIAL: 'PARTIAL',
    FAILED: 'FAILED'
};
/**
 * @export
 */
export const PageSocialPostStatusEnum = {
    DRAFT: 'DRAFT',
    SCHEDULED: 'SCHEDULED',
    PUBLISHED: 'PUBLISHED',
    PARTIAL: 'PARTIAL',
    FAILED: 'FAILED'
};
/**
 * SocialPublicationRestControllerApi - axios parameter creator
 * @export
 */
export const SocialPublicationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [postId]
         * @param {CountSocialPublicationProviderEnum} [provider]
         * @param {CountSocialPublicationStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSocialPublication: async (postId, provider, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/social/publication/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (postId !== undefined) {
                localVarQueryParameter['postId'] = postId;
            }
            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSocialPublication: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchSocialPublication', 'ids', ids);
            const localVarPath = `/api/admin/marketing/social/publication/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSocialPublication: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissSocialPublication', 'id', id);
            const localVarPath = `/api/admin/marketing/social/publication/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialPublication: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSocialPublication', 'id', id);
            const localVarPath = `/api/admin/marketing/social/publication/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [postId]
         * @param {ListSocialPublicationProviderEnum} [provider]
         * @param {ListSocialPublicationStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSocialPublication: async (postId, provider, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/social/publication/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (postId !== undefined) {
                localVarQueryParameter['postId'] = postId;
            }
            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [postId]
         * @param {PageSocialPublicationProviderEnum} [provider]
         * @param {PageSocialPublicationStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSocialPublication: async (page, size, sort, postId, provider, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/marketing/social/publication/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (postId !== undefined) {
                localVarQueryParameter['postId'] = postId;
            }
            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SocialPublication} socialPublication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSocialPublication: async (socialPublication, options = {}) => {
            // verify required parameter 'socialPublication' is not null or undefined
            assertParamExists('saveSocialPublication', 'socialPublication', socialPublication);
            const localVarPath = `/api/admin/marketing/social/publication/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(socialPublication, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SocialPublicationRestControllerApi - functional programming interface
 * @export
 */
export const SocialPublicationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SocialPublicationRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [postId]
         * @param {CountSocialPublicationProviderEnum} [provider]
         * @param {CountSocialPublicationStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countSocialPublication(postId, provider, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countSocialPublication(postId, provider, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialPublicationRestControllerApi.countSocialPublication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchSocialPublication(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchSocialPublication(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialPublicationRestControllerApi.deleteOrDismissInBatchSocialPublication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissSocialPublication(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissSocialPublication(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialPublicationRestControllerApi.deleteOrDismissSocialPublication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSocialPublication(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSocialPublication(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialPublicationRestControllerApi.getSocialPublication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [postId]
         * @param {ListSocialPublicationProviderEnum} [provider]
         * @param {ListSocialPublicationStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSocialPublication(postId, provider, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSocialPublication(postId, provider, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialPublicationRestControllerApi.listSocialPublication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [postId]
         * @param {PageSocialPublicationProviderEnum} [provider]
         * @param {PageSocialPublicationStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSocialPublication(page, size, sort, postId, provider, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSocialPublication(page, size, sort, postId, provider, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialPublicationRestControllerApi.pageSocialPublication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {SocialPublication} socialPublication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSocialPublication(socialPublication, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSocialPublication(socialPublication, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialPublicationRestControllerApi.saveSocialPublication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SocialPublicationRestControllerApi - factory interface
 * @export
 */
export const SocialPublicationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SocialPublicationRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [postId]
         * @param {CountSocialPublicationProviderEnum} [provider]
         * @param {CountSocialPublicationStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSocialPublication(postId, provider, status, term, showDismissed, options) {
            return localVarFp.countSocialPublication(postId, provider, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSocialPublication(ids, options) {
            return localVarFp.deleteOrDismissInBatchSocialPublication(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSocialPublication(id, options) {
            return localVarFp.deleteOrDismissSocialPublication(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialPublication(id, options) {
            return localVarFp.getSocialPublication(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [postId]
         * @param {ListSocialPublicationProviderEnum} [provider]
         * @param {ListSocialPublicationStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSocialPublication(postId, provider, status, term, showDismissed, options) {
            return localVarFp.listSocialPublication(postId, provider, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [postId]
         * @param {PageSocialPublicationProviderEnum} [provider]
         * @param {PageSocialPublicationStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSocialPublication(page, size, sort, postId, provider, status, term, showDismissed, options) {
            return localVarFp.pageSocialPublication(page, size, sort, postId, provider, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SocialPublication} socialPublication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSocialPublication(socialPublication, options) {
            return localVarFp.saveSocialPublication(socialPublication, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SocialPublicationRestControllerApi - object-oriented interface
 * @export
 * @class SocialPublicationRestControllerApi
 * @extends {BaseAPI}
 */
export class SocialPublicationRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [postId]
     * @param {CountSocialPublicationProviderEnum} [provider]
     * @param {CountSocialPublicationStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialPublicationRestControllerApi
     */
    countSocialPublication(postId, provider, status, term, showDismissed, options) {
        return SocialPublicationRestControllerApiFp(this.configuration).countSocialPublication(postId, provider, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialPublicationRestControllerApi
     */
    deleteOrDismissInBatchSocialPublication(ids, options) {
        return SocialPublicationRestControllerApiFp(this.configuration).deleteOrDismissInBatchSocialPublication(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialPublicationRestControllerApi
     */
    deleteOrDismissSocialPublication(id, options) {
        return SocialPublicationRestControllerApiFp(this.configuration).deleteOrDismissSocialPublication(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialPublicationRestControllerApi
     */
    getSocialPublication(id, options) {
        return SocialPublicationRestControllerApiFp(this.configuration).getSocialPublication(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [postId]
     * @param {ListSocialPublicationProviderEnum} [provider]
     * @param {ListSocialPublicationStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialPublicationRestControllerApi
     */
    listSocialPublication(postId, provider, status, term, showDismissed, options) {
        return SocialPublicationRestControllerApiFp(this.configuration).listSocialPublication(postId, provider, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [postId]
     * @param {PageSocialPublicationProviderEnum} [provider]
     * @param {PageSocialPublicationStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialPublicationRestControllerApi
     */
    pageSocialPublication(page, size, sort, postId, provider, status, term, showDismissed, options) {
        return SocialPublicationRestControllerApiFp(this.configuration).pageSocialPublication(page, size, sort, postId, provider, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SocialPublication} socialPublication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialPublicationRestControllerApi
     */
    saveSocialPublication(socialPublication, options) {
        return SocialPublicationRestControllerApiFp(this.configuration).saveSocialPublication(socialPublication, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountSocialPublicationProviderEnum = {
    FACEBOOK: 'FACEBOOK',
    INSTAGRAM: 'INSTAGRAM',
    LINKEDIN: 'LINKEDIN'
};
/**
 * @export
 */
export const CountSocialPublicationStatusEnum = {
    PENDING: 'PENDING',
    PUBLISHED: 'PUBLISHED',
    FAILED: 'FAILED'
};
/**
 * @export
 */
export const ListSocialPublicationProviderEnum = {
    FACEBOOK: 'FACEBOOK',
    INSTAGRAM: 'INSTAGRAM',
    LINKEDIN: 'LINKEDIN'
};
/**
 * @export
 */
export const ListSocialPublicationStatusEnum = {
    PENDING: 'PENDING',
    PUBLISHED: 'PUBLISHED',
    FAILED: 'FAILED'
};
/**
 * @export
 */
export const PageSocialPublicationProviderEnum = {
    FACEBOOK: 'FACEBOOK',
    INSTAGRAM: 'INSTAGRAM',
    LINKEDIN: 'LINKEDIN'
};
/**
 * @export
 */
export const PageSocialPublicationStatusEnum = {
    PENDING: 'PENDING',
    PUBLISHED: 'PUBLISHED',
    FAILED: 'FAILED'
};
/**
 * SupplierBillRestControllerApi - axios parameter creator
 * @export
 */
export const SupplierBillRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [supplierId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupplierBill: async (supplierId, dateFrom, dateTo, pending, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/supplier-bill/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString().substring(0, 10) :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString().substring(0, 10) :
                    dateTo;
            }
            if (pending !== undefined) {
                localVarQueryParameter['pending'] = pending;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} lineId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLineSupplierBill: async (lineId, options = {}) => {
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('deleteLineSupplierBill', 'lineId', lineId);
            const localVarPath = `/api/admin/accounting/supplier-bill/line/{lineId}`
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupplierBill: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchSupplierBill', 'ids', ids);
            const localVarPath = `/api/admin/accounting/supplier-bill/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupplierBill: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissSupplierBill', 'id', id);
            const localVarPath = `/api/admin/accounting/supplier-bill/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAccountingSupplierBill: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('generateAccountingSupplierBill', 'id', id);
            const localVarPath = `/api/admin/accounting/supplier-bill/{id}/accounting`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierBill: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSupplierBill', 'id', id);
            const localVarPath = `/api/admin/accounting/supplier-bill/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [supplierId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupplierBill: async (supplierId, dateFrom, dateTo, pending, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/supplier-bill/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString().substring(0, 10) :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString().substring(0, 10) :
                    dateTo;
            }
            if (pending !== undefined) {
                localVarQueryParameter['pending'] = pending;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [supplierId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupplierBill: async (page, size, sort, supplierId, dateFrom, dateTo, pending, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/supplier-bill/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString().substring(0, 10) :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString().substring(0, 10) :
                    dateTo;
            }
            if (pending !== undefined) {
                localVarQueryParameter['pending'] = pending;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} billId
         * @param {SupplierBillLine} supplierBillLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLineSupplierBill: async (billId, supplierBillLine, options = {}) => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('saveLineSupplierBill', 'billId', billId);
            // verify required parameter 'supplierBillLine' is not null or undefined
            assertParamExists('saveLineSupplierBill', 'supplierBillLine', supplierBillLine);
            const localVarPath = `/api/admin/accounting/supplier-bill/{billId}/line`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(supplierBillLine, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SupplierBill} supplierBill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupplierBill: async (supplierBill, options = {}) => {
            // verify required parameter 'supplierBill' is not null or undefined
            assertParamExists('saveSupplierBill', 'supplierBill', supplierBill);
            const localVarPath = `/api/admin/accounting/supplier-bill/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(supplierBill, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scanStatusSupplierBill: async (options = {}) => {
            const localVarPath = `/api/admin/accounting/supplier-bill/scan/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ScanSupplierBillRequest} [scanSupplierBillRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scanSupplierBill: async (scanSupplierBillRequest, options = {}) => {
            const localVarPath = `/api/admin/accounting/supplier-bill/scan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(scanSupplierBillRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SupplierBillRestControllerApi - functional programming interface
 * @export
 */
export const SupplierBillRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SupplierBillRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [supplierId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countSupplierBill(supplierId, dateFrom, dateTo, pending, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countSupplierBill(supplierId, dateFrom, dateTo, pending, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierBillRestControllerApi.countSupplierBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} lineId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLineSupplierBill(lineId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLineSupplierBill(lineId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierBillRestControllerApi.deleteLineSupplierBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchSupplierBill(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchSupplierBill(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierBillRestControllerApi.deleteOrDismissInBatchSupplierBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissSupplierBill(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissSupplierBill(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierBillRestControllerApi.deleteOrDismissSupplierBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateAccountingSupplierBill(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateAccountingSupplierBill(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierBillRestControllerApi.generateAccountingSupplierBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierBill(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierBill(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierBillRestControllerApi.getSupplierBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [supplierId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSupplierBill(supplierId, dateFrom, dateTo, pending, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSupplierBill(supplierId, dateFrom, dateTo, pending, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierBillRestControllerApi.listSupplierBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [supplierId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSupplierBill(page, size, sort, supplierId, dateFrom, dateTo, pending, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSupplierBill(page, size, sort, supplierId, dateFrom, dateTo, pending, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierBillRestControllerApi.pageSupplierBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} billId
         * @param {SupplierBillLine} supplierBillLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveLineSupplierBill(billId, supplierBillLine, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveLineSupplierBill(billId, supplierBillLine, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierBillRestControllerApi.saveLineSupplierBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {SupplierBill} supplierBill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSupplierBill(supplierBill, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSupplierBill(supplierBill, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierBillRestControllerApi.saveSupplierBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scanStatusSupplierBill(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scanStatusSupplierBill(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierBillRestControllerApi.scanStatusSupplierBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ScanSupplierBillRequest} [scanSupplierBillRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scanSupplierBill(scanSupplierBillRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scanSupplierBill(scanSupplierBillRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierBillRestControllerApi.scanSupplierBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SupplierBillRestControllerApi - factory interface
 * @export
 */
export const SupplierBillRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SupplierBillRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [supplierId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupplierBill(supplierId, dateFrom, dateTo, pending, term, showDismissed, options) {
            return localVarFp.countSupplierBill(supplierId, dateFrom, dateTo, pending, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} lineId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLineSupplierBill(lineId, options) {
            return localVarFp.deleteLineSupplierBill(lineId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupplierBill(ids, options) {
            return localVarFp.deleteOrDismissInBatchSupplierBill(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupplierBill(id, options) {
            return localVarFp.deleteOrDismissSupplierBill(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAccountingSupplierBill(id, options) {
            return localVarFp.generateAccountingSupplierBill(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierBill(id, options) {
            return localVarFp.getSupplierBill(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [supplierId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupplierBill(supplierId, dateFrom, dateTo, pending, term, showDismissed, options) {
            return localVarFp.listSupplierBill(supplierId, dateFrom, dateTo, pending, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [supplierId]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {boolean} [pending]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupplierBill(page, size, sort, supplierId, dateFrom, dateTo, pending, term, showDismissed, options) {
            return localVarFp.pageSupplierBill(page, size, sort, supplierId, dateFrom, dateTo, pending, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} billId
         * @param {SupplierBillLine} supplierBillLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLineSupplierBill(billId, supplierBillLine, options) {
            return localVarFp.saveLineSupplierBill(billId, supplierBillLine, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SupplierBill} supplierBill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupplierBill(supplierBill, options) {
            return localVarFp.saveSupplierBill(supplierBill, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scanStatusSupplierBill(options) {
            return localVarFp.scanStatusSupplierBill(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ScanSupplierBillRequest} [scanSupplierBillRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scanSupplierBill(scanSupplierBillRequest, options) {
            return localVarFp.scanSupplierBill(scanSupplierBillRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SupplierBillRestControllerApi - object-oriented interface
 * @export
 * @class SupplierBillRestControllerApi
 * @extends {BaseAPI}
 */
export class SupplierBillRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [supplierId]
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {boolean} [pending]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierBillRestControllerApi
     */
    countSupplierBill(supplierId, dateFrom, dateTo, pending, term, showDismissed, options) {
        return SupplierBillRestControllerApiFp(this.configuration).countSupplierBill(supplierId, dateFrom, dateTo, pending, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} lineId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierBillRestControllerApi
     */
    deleteLineSupplierBill(lineId, options) {
        return SupplierBillRestControllerApiFp(this.configuration).deleteLineSupplierBill(lineId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierBillRestControllerApi
     */
    deleteOrDismissInBatchSupplierBill(ids, options) {
        return SupplierBillRestControllerApiFp(this.configuration).deleteOrDismissInBatchSupplierBill(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierBillRestControllerApi
     */
    deleteOrDismissSupplierBill(id, options) {
        return SupplierBillRestControllerApiFp(this.configuration).deleteOrDismissSupplierBill(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierBillRestControllerApi
     */
    generateAccountingSupplierBill(id, options) {
        return SupplierBillRestControllerApiFp(this.configuration).generateAccountingSupplierBill(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierBillRestControllerApi
     */
    getSupplierBill(id, options) {
        return SupplierBillRestControllerApiFp(this.configuration).getSupplierBill(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [supplierId]
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {boolean} [pending]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierBillRestControllerApi
     */
    listSupplierBill(supplierId, dateFrom, dateTo, pending, term, showDismissed, options) {
        return SupplierBillRestControllerApiFp(this.configuration).listSupplierBill(supplierId, dateFrom, dateTo, pending, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [supplierId]
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {boolean} [pending]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierBillRestControllerApi
     */
    pageSupplierBill(page, size, sort, supplierId, dateFrom, dateTo, pending, term, showDismissed, options) {
        return SupplierBillRestControllerApiFp(this.configuration).pageSupplierBill(page, size, sort, supplierId, dateFrom, dateTo, pending, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} billId
     * @param {SupplierBillLine} supplierBillLine
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierBillRestControllerApi
     */
    saveLineSupplierBill(billId, supplierBillLine, options) {
        return SupplierBillRestControllerApiFp(this.configuration).saveLineSupplierBill(billId, supplierBillLine, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SupplierBill} supplierBill
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierBillRestControllerApi
     */
    saveSupplierBill(supplierBill, options) {
        return SupplierBillRestControllerApiFp(this.configuration).saveSupplierBill(supplierBill, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierBillRestControllerApi
     */
    scanStatusSupplierBill(options) {
        return SupplierBillRestControllerApiFp(this.configuration).scanStatusSupplierBill(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ScanSupplierBillRequest} [scanSupplierBillRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierBillRestControllerApi
     */
    scanSupplierBill(scanSupplierBillRequest, options) {
        return SupplierBillRestControllerApiFp(this.configuration).scanSupplierBill(scanSupplierBillRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SupplierRestControllerApi - axios parameter creator
 * @export
 */
export const SupplierRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [nif]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupplier: async (nif, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/supplier/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (nif !== undefined) {
                localVarQueryParameter['nif'] = nif;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupplier: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchSupplier', 'ids', ids);
            const localVarPath = `/api/admin/accounting/supplier/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupplier: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissSupplier', 'id', id);
            const localVarPath = `/api/admin/accounting/supplier/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplier: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSupplier', 'id', id);
            const localVarPath = `/api/admin/accounting/supplier/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [nif]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupplier: async (nif, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/supplier/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (nif !== undefined) {
                localVarQueryParameter['nif'] = nif;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [nif]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupplier: async (page, size, sort, nif, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/supplier/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (nif !== undefined) {
                localVarQueryParameter['nif'] = nif;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Supplier} supplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupplier: async (supplier, options = {}) => {
            // verify required parameter 'supplier' is not null or undefined
            assertParamExists('saveSupplier', 'supplier', supplier);
            const localVarPath = `/api/admin/accounting/supplier/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(supplier, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SupplierRestControllerApi - functional programming interface
 * @export
 */
export const SupplierRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SupplierRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [nif]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countSupplier(nif, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countSupplier(nif, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierRestControllerApi.countSupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchSupplier(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchSupplier(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierRestControllerApi.deleteOrDismissInBatchSupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissSupplier(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissSupplier(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierRestControllerApi.deleteOrDismissSupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplier(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplier(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierRestControllerApi.getSupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [nif]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSupplier(nif, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSupplier(nif, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierRestControllerApi.listSupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [nif]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSupplier(page, size, sort, nif, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSupplier(page, size, sort, nif, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierRestControllerApi.pageSupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Supplier} supplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSupplier(supplier, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSupplier(supplier, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierRestControllerApi.saveSupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SupplierRestControllerApi - factory interface
 * @export
 */
export const SupplierRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SupplierRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [nif]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupplier(nif, term, showDismissed, options) {
            return localVarFp.countSupplier(nif, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupplier(ids, options) {
            return localVarFp.deleteOrDismissInBatchSupplier(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupplier(id, options) {
            return localVarFp.deleteOrDismissSupplier(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplier(id, options) {
            return localVarFp.getSupplier(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [nif]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupplier(nif, term, showDismissed, options) {
            return localVarFp.listSupplier(nif, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [nif]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupplier(page, size, sort, nif, term, showDismissed, options) {
            return localVarFp.pageSupplier(page, size, sort, nif, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Supplier} supplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupplier(supplier, options) {
            return localVarFp.saveSupplier(supplier, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SupplierRestControllerApi - object-oriented interface
 * @export
 * @class SupplierRestControllerApi
 * @extends {BaseAPI}
 */
export class SupplierRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [nif]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierRestControllerApi
     */
    countSupplier(nif, term, showDismissed, options) {
        return SupplierRestControllerApiFp(this.configuration).countSupplier(nif, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierRestControllerApi
     */
    deleteOrDismissInBatchSupplier(ids, options) {
        return SupplierRestControllerApiFp(this.configuration).deleteOrDismissInBatchSupplier(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierRestControllerApi
     */
    deleteOrDismissSupplier(id, options) {
        return SupplierRestControllerApiFp(this.configuration).deleteOrDismissSupplier(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierRestControllerApi
     */
    getSupplier(id, options) {
        return SupplierRestControllerApiFp(this.configuration).getSupplier(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [nif]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierRestControllerApi
     */
    listSupplier(nif, term, showDismissed, options) {
        return SupplierRestControllerApiFp(this.configuration).listSupplier(nif, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [nif]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierRestControllerApi
     */
    pageSupplier(page, size, sort, nif, term, showDismissed, options) {
        return SupplierRestControllerApiFp(this.configuration).pageSupplier(page, size, sort, nif, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Supplier} supplier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierRestControllerApi
     */
    saveSupplier(supplier, options) {
        return SupplierRestControllerApiFp(this.configuration).saveSupplier(supplier, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SupportGroupRestControllerApi - axios parameter creator
 * @export
 */
export const SupportGroupRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportGroup: async (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/support-group/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportGroup: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchSupportGroup', 'ids', ids);
            const localVarPath = `/api/admin/employee/support-group/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportGroup: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissSupportGroup', 'id', id);
            const localVarPath = `/api/admin/employee/support-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportGroup: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSupportGroup', 'id', id);
            const localVarPath = `/api/admin/employee/support-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportGroup: async (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/support-group/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportGroup: async (page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/support-group/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SupportGroup} supportGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportGroup: async (supportGroup, options = {}) => {
            // verify required parameter 'supportGroup' is not null or undefined
            assertParamExists('saveSupportGroup', 'supportGroup', supportGroup);
            const localVarPath = `/api/admin/employee/support-group/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(supportGroup, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SupportGroupRestControllerApi - functional programming interface
 * @export
 */
export const SupportGroupRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SupportGroupRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportGroupRestControllerApi.countSupportGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchSupportGroup(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchSupportGroup(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportGroupRestControllerApi.deleteOrDismissInBatchSupportGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissSupportGroup(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissSupportGroup(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportGroupRestControllerApi.deleteOrDismissSupportGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportGroup(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportGroup(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportGroupRestControllerApi.getSupportGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportGroupRestControllerApi.listSupportGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSupportGroup(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSupportGroup(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportGroupRestControllerApi.pageSupportGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {SupportGroup} supportGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSupportGroup(supportGroup, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSupportGroup(supportGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportGroupRestControllerApi.saveSupportGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SupportGroupRestControllerApi - factory interface
 * @export
 */
export const SupportGroupRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SupportGroupRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportGroup(ids, options) {
            return localVarFp.deleteOrDismissInBatchSupportGroup(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportGroup(id, options) {
            return localVarFp.deleteOrDismissSupportGroup(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportGroup(id, options) {
            return localVarFp.getSupportGroup(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportGroup(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pageSupportGroup(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SupportGroup} supportGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportGroup(supportGroup, options) {
            return localVarFp.saveSupportGroup(supportGroup, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SupportGroupRestControllerApi - object-oriented interface
 * @export
 * @class SupportGroupRestControllerApi
 * @extends {BaseAPI}
 */
export class SupportGroupRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportGroupRestControllerApi
     */
    countSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return SupportGroupRestControllerApiFp(this.configuration).countSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportGroupRestControllerApi
     */
    deleteOrDismissInBatchSupportGroup(ids, options) {
        return SupportGroupRestControllerApiFp(this.configuration).deleteOrDismissInBatchSupportGroup(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportGroupRestControllerApi
     */
    deleteOrDismissSupportGroup(id, options) {
        return SupportGroupRestControllerApiFp(this.configuration).deleteOrDismissSupportGroup(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportGroupRestControllerApi
     */
    getSupportGroup(id, options) {
        return SupportGroupRestControllerApiFp(this.configuration).getSupportGroup(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportGroupRestControllerApi
     */
    listSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return SupportGroupRestControllerApiFp(this.configuration).listSupportGroup(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportGroupRestControllerApi
     */
    pageSupportGroup(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return SupportGroupRestControllerApiFp(this.configuration).pageSupportGroup(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SupportGroup} supportGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportGroupRestControllerApi
     */
    saveSupportGroup(supportGroup, options) {
        return SupportGroupRestControllerApiFp(this.configuration).saveSupportGroup(supportGroup, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SupportLinkRestControllerApi - axios parameter creator
 * @export
 */
export const SupportLinkRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportLink: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/support-link/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportLink: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchSupportLink', 'ids', ids);
            const localVarPath = `/api/admin/employee/support-link/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportLink: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissSupportLink', 'id', id);
            const localVarPath = `/api/admin/employee/support-link/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportLink: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSupportLink', 'id', id);
            const localVarPath = `/api/admin/employee/support-link/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportLink: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/support-link/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportLink: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/support-link/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SupportLink} supportLink
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportLink: async (supportLink, options = {}) => {
            // verify required parameter 'supportLink' is not null or undefined
            assertParamExists('saveSupportLink', 'supportLink', supportLink);
            const localVarPath = `/api/admin/employee/support-link/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(supportLink, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SupportLinkRestControllerApi - functional programming interface
 * @export
 */
export const SupportLinkRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SupportLinkRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countSupportLink(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countSupportLink(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportLinkRestControllerApi.countSupportLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchSupportLink(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchSupportLink(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportLinkRestControllerApi.deleteOrDismissInBatchSupportLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissSupportLink(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissSupportLink(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportLinkRestControllerApi.deleteOrDismissSupportLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportLink(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportLink(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportLinkRestControllerApi.getSupportLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSupportLink(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSupportLink(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportLinkRestControllerApi.listSupportLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSupportLink(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSupportLink(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportLinkRestControllerApi.pageSupportLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {SupportLink} supportLink
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSupportLink(supportLink, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSupportLink(supportLink, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportLinkRestControllerApi.saveSupportLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SupportLinkRestControllerApi - factory interface
 * @export
 */
export const SupportLinkRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SupportLinkRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportLink(term, showDismissed, options) {
            return localVarFp.countSupportLink(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportLink(ids, options) {
            return localVarFp.deleteOrDismissInBatchSupportLink(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportLink(id, options) {
            return localVarFp.deleteOrDismissSupportLink(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportLink(id, options) {
            return localVarFp.getSupportLink(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportLink(term, showDismissed, options) {
            return localVarFp.listSupportLink(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportLink(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageSupportLink(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SupportLink} supportLink
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportLink(supportLink, options) {
            return localVarFp.saveSupportLink(supportLink, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SupportLinkRestControllerApi - object-oriented interface
 * @export
 * @class SupportLinkRestControllerApi
 * @extends {BaseAPI}
 */
export class SupportLinkRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportLinkRestControllerApi
     */
    countSupportLink(term, showDismissed, options) {
        return SupportLinkRestControllerApiFp(this.configuration).countSupportLink(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportLinkRestControllerApi
     */
    deleteOrDismissInBatchSupportLink(ids, options) {
        return SupportLinkRestControllerApiFp(this.configuration).deleteOrDismissInBatchSupportLink(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportLinkRestControllerApi
     */
    deleteOrDismissSupportLink(id, options) {
        return SupportLinkRestControllerApiFp(this.configuration).deleteOrDismissSupportLink(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportLinkRestControllerApi
     */
    getSupportLink(id, options) {
        return SupportLinkRestControllerApiFp(this.configuration).getSupportLink(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportLinkRestControllerApi
     */
    listSupportLink(term, showDismissed, options) {
        return SupportLinkRestControllerApiFp(this.configuration).listSupportLink(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportLinkRestControllerApi
     */
    pageSupportLink(page, size, sort, term, showDismissed, options) {
        return SupportLinkRestControllerApiFp(this.configuration).pageSupportLink(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SupportLink} supportLink
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportLinkRestControllerApi
     */
    saveSupportLink(supportLink, options) {
        return SupportLinkRestControllerApiFp(this.configuration).saveSupportLink(supportLink, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SupportPointRestControllerApi - axios parameter creator
 * @export
 */
export const SupportPointRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportPoint: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/support/question/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportPoint: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchSupportPoint', 'ids', ids);
            const localVarPath = `/api/admin/employee/support/question/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportPoint: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissSupportPoint', 'id', id);
            const localVarPath = `/api/admin/employee/support/question/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportPoint: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSupportPoint', 'id', id);
            const localVarPath = `/api/admin/employee/support/question/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportPoint: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/support/question/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportPoint: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/support/question/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SupportPoint} supportPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportPoint: async (supportPoint, options = {}) => {
            // verify required parameter 'supportPoint' is not null or undefined
            assertParamExists('saveSupportPoint', 'supportPoint', supportPoint);
            const localVarPath = `/api/admin/employee/support/question/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(supportPoint, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SupportPointRestControllerApi - functional programming interface
 * @export
 */
export const SupportPointRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SupportPointRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countSupportPoint(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countSupportPoint(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportPointRestControllerApi.countSupportPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchSupportPoint(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchSupportPoint(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportPointRestControllerApi.deleteOrDismissInBatchSupportPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissSupportPoint(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissSupportPoint(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportPointRestControllerApi.deleteOrDismissSupportPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportPoint(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportPoint(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportPointRestControllerApi.getSupportPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSupportPoint(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSupportPoint(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportPointRestControllerApi.listSupportPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSupportPoint(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSupportPoint(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportPointRestControllerApi.pageSupportPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {SupportPoint} supportPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSupportPoint(supportPoint, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSupportPoint(supportPoint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportPointRestControllerApi.saveSupportPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SupportPointRestControllerApi - factory interface
 * @export
 */
export const SupportPointRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SupportPointRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportPoint(term, showDismissed, options) {
            return localVarFp.countSupportPoint(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportPoint(ids, options) {
            return localVarFp.deleteOrDismissInBatchSupportPoint(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportPoint(id, options) {
            return localVarFp.deleteOrDismissSupportPoint(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportPoint(id, options) {
            return localVarFp.getSupportPoint(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportPoint(term, showDismissed, options) {
            return localVarFp.listSupportPoint(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportPoint(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageSupportPoint(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SupportPoint} supportPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportPoint(supportPoint, options) {
            return localVarFp.saveSupportPoint(supportPoint, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SupportPointRestControllerApi - object-oriented interface
 * @export
 * @class SupportPointRestControllerApi
 * @extends {BaseAPI}
 */
export class SupportPointRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportPointRestControllerApi
     */
    countSupportPoint(term, showDismissed, options) {
        return SupportPointRestControllerApiFp(this.configuration).countSupportPoint(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportPointRestControllerApi
     */
    deleteOrDismissInBatchSupportPoint(ids, options) {
        return SupportPointRestControllerApiFp(this.configuration).deleteOrDismissInBatchSupportPoint(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportPointRestControllerApi
     */
    deleteOrDismissSupportPoint(id, options) {
        return SupportPointRestControllerApiFp(this.configuration).deleteOrDismissSupportPoint(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportPointRestControllerApi
     */
    getSupportPoint(id, options) {
        return SupportPointRestControllerApiFp(this.configuration).getSupportPoint(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportPointRestControllerApi
     */
    listSupportPoint(term, showDismissed, options) {
        return SupportPointRestControllerApiFp(this.configuration).listSupportPoint(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportPointRestControllerApi
     */
    pageSupportPoint(page, size, sort, term, showDismissed, options) {
        return SupportPointRestControllerApiFp(this.configuration).pageSupportPoint(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SupportPoint} supportPoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportPointRestControllerApi
     */
    saveSupportPoint(supportPoint, options) {
        return SupportPointRestControllerApiFp(this.configuration).saveSupportPoint(supportPoint, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SupportRestControllerApi - axios parameter creator
 * @export
 */
export const SupportRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupport: async (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/support/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupport: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchSupport', 'ids', ids);
            const localVarPath = `/api/admin/employee/support/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupport: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissSupport', 'id', id);
            const localVarPath = `/api/admin/employee/support/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupport: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSupport', 'id', id);
            const localVarPath = `/api/admin/employee/support/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupport: async (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/support/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupport: async (page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/support/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Support} support
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupport: async (support, options = {}) => {
            // verify required parameter 'support' is not null or undefined
            assertParamExists('saveSupport', 'support', support);
            const localVarPath = `/api/admin/employee/support/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(support, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SupportRestControllerApi - functional programming interface
 * @export
 */
export const SupportRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SupportRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countSupport(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countSupport(personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportRestControllerApi.countSupport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchSupport(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchSupport(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportRestControllerApi.deleteOrDismissInBatchSupport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissSupport(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissSupport(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportRestControllerApi.deleteOrDismissSupport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupport(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupport(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportRestControllerApi.getSupport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSupport(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSupport(personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportRestControllerApi.listSupport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSupport(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSupport(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportRestControllerApi.pageSupport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Support} support
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSupport(support, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSupport(support, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportRestControllerApi.saveSupport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SupportRestControllerApi - factory interface
 * @export
 */
export const SupportRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SupportRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupport(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countSupport(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupport(ids, options) {
            return localVarFp.deleteOrDismissInBatchSupport(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupport(id, options) {
            return localVarFp.deleteOrDismissSupport(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupport(id, options) {
            return localVarFp.getSupport(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupport(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listSupport(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupport(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pageSupport(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Support} support
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupport(support, options) {
            return localVarFp.saveSupport(support, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SupportRestControllerApi - object-oriented interface
 * @export
 * @class SupportRestControllerApi
 * @extends {BaseAPI}
 */
export class SupportRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportRestControllerApi
     */
    countSupport(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return SupportRestControllerApiFp(this.configuration).countSupport(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportRestControllerApi
     */
    deleteOrDismissInBatchSupport(ids, options) {
        return SupportRestControllerApiFp(this.configuration).deleteOrDismissInBatchSupport(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportRestControllerApi
     */
    deleteOrDismissSupport(id, options) {
        return SupportRestControllerApiFp(this.configuration).deleteOrDismissSupport(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportRestControllerApi
     */
    getSupport(id, options) {
        return SupportRestControllerApiFp(this.configuration).getSupport(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportRestControllerApi
     */
    listSupport(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return SupportRestControllerApiFp(this.configuration).listSupport(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportRestControllerApi
     */
    pageSupport(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return SupportRestControllerApiFp(this.configuration).pageSupport(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Support} support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportRestControllerApi
     */
    saveSupport(support, options) {
        return SupportRestControllerApiFp(this.configuration).saveSupport(support, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SupportResultRestControllerApi - axios parameter creator
 * @export
 */
export const SupportResultRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportResult: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/support/question/result/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportResult: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchSupportResult', 'ids', ids);
            const localVarPath = `/api/admin/employee/support/question/result/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportResult: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissSupportResult', 'id', id);
            const localVarPath = `/api/admin/employee/support/question/result/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportResult: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSupportResult', 'id', id);
            const localVarPath = `/api/admin/employee/support/question/result/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportResult: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/support/question/result/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportResult: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/support/question/result/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SupportResult} supportResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportResult: async (supportResult, options = {}) => {
            // verify required parameter 'supportResult' is not null or undefined
            assertParamExists('saveSupportResult', 'supportResult', supportResult);
            const localVarPath = `/api/admin/employee/support/question/result/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(supportResult, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SupportResultRestControllerApi - functional programming interface
 * @export
 */
export const SupportResultRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SupportResultRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countSupportResult(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countSupportResult(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportResultRestControllerApi.countSupportResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchSupportResult(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchSupportResult(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportResultRestControllerApi.deleteOrDismissInBatchSupportResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissSupportResult(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissSupportResult(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportResultRestControllerApi.deleteOrDismissSupportResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportResult(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportResult(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportResultRestControllerApi.getSupportResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSupportResult(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSupportResult(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportResultRestControllerApi.listSupportResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSupportResult(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSupportResult(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportResultRestControllerApi.pageSupportResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {SupportResult} supportResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSupportResult(supportResult, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSupportResult(supportResult, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportResultRestControllerApi.saveSupportResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SupportResultRestControllerApi - factory interface
 * @export
 */
export const SupportResultRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SupportResultRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSupportResult(term, showDismissed, options) {
            return localVarFp.countSupportResult(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchSupportResult(ids, options) {
            return localVarFp.deleteOrDismissInBatchSupportResult(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissSupportResult(id, options) {
            return localVarFp.deleteOrDismissSupportResult(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportResult(id, options) {
            return localVarFp.getSupportResult(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportResult(term, showDismissed, options) {
            return localVarFp.listSupportResult(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSupportResult(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageSupportResult(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SupportResult} supportResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSupportResult(supportResult, options) {
            return localVarFp.saveSupportResult(supportResult, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SupportResultRestControllerApi - object-oriented interface
 * @export
 * @class SupportResultRestControllerApi
 * @extends {BaseAPI}
 */
export class SupportResultRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportResultRestControllerApi
     */
    countSupportResult(term, showDismissed, options) {
        return SupportResultRestControllerApiFp(this.configuration).countSupportResult(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportResultRestControllerApi
     */
    deleteOrDismissInBatchSupportResult(ids, options) {
        return SupportResultRestControllerApiFp(this.configuration).deleteOrDismissInBatchSupportResult(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportResultRestControllerApi
     */
    deleteOrDismissSupportResult(id, options) {
        return SupportResultRestControllerApiFp(this.configuration).deleteOrDismissSupportResult(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportResultRestControllerApi
     */
    getSupportResult(id, options) {
        return SupportResultRestControllerApiFp(this.configuration).getSupportResult(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportResultRestControllerApi
     */
    listSupportResult(term, showDismissed, options) {
        return SupportResultRestControllerApiFp(this.configuration).listSupportResult(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportResultRestControllerApi
     */
    pageSupportResult(page, size, sort, term, showDismissed, options) {
        return SupportResultRestControllerApiFp(this.configuration).pageSupportResult(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SupportResult} supportResult
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportResultRestControllerApi
     */
    saveSupportResult(supportResult, options) {
        return SupportResultRestControllerApiFp(this.configuration).saveSupportResult(supportResult, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SupportSlaRestControllerApi - axios parameter creator
 * @export
 */
export const SupportSlaRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        report: async (year, month, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('report', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('report', 'month', month);
            const localVarPath = `/api/admin/billing/support-sla`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SupportSlaRestControllerApi - functional programming interface
 * @export
 */
export const SupportSlaRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SupportSlaRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async report(year, month, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.report(year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportSlaRestControllerApi.report']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SupportSlaRestControllerApi - factory interface
 * @export
 */
export const SupportSlaRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SupportSlaRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        report(year, month, options) {
            return localVarFp.report(year, month, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SupportSlaRestControllerApi - object-oriented interface
 * @export
 * @class SupportSlaRestControllerApi
 * @extends {BaseAPI}
 */
export class SupportSlaRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportSlaRestControllerApi
     */
    report(year, month, options) {
        return SupportSlaRestControllerApiFp(this.configuration).report(year, month, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TaxCalendarRestControllerApi - axios parameter creator
 * @export
 */
export const TaxCalendarRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxAlerts: async (options = {}) => {
            const localVarPath = `/api/admin/accounting/tax-calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TaxCalendarRestControllerApi - functional programming interface
 * @export
 */
export const TaxCalendarRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = TaxCalendarRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaxAlerts(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaxAlerts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxCalendarRestControllerApi.getTaxAlerts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TaxCalendarRestControllerApi - factory interface
 * @export
 */
export const TaxCalendarRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TaxCalendarRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxAlerts(options) {
            return localVarFp.getTaxAlerts(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TaxCalendarRestControllerApi - object-oriented interface
 * @export
 * @class TaxCalendarRestControllerApi
 * @extends {BaseAPI}
 */
export class TaxCalendarRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxCalendarRestControllerApi
     */
    getTaxAlerts(options) {
        return TaxCalendarRestControllerApiFp(this.configuration).getTaxAlerts(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TaxModelsRestControllerApi - axios parameter creator
 * @export
 */
export const TaxModelsRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} year
         * @param {Modelo200BreakdownRequest} modelo200BreakdownRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeModelo200Breakdown: async (year, modelo200BreakdownRequest, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('completeModelo200Breakdown', 'year', year);
            // verify required parameter 'modelo200BreakdownRequest' is not null or undefined
            assertParamExists('completeModelo200Breakdown', 'modelo200BreakdownRequest', modelo200BreakdownRequest);
            const localVarPath = `/api/admin/accounting/tax-models/modelo200/{year}/breakdown`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(modelo200BreakdownRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {boolean} [preview]
         * @param {Modelo200Request} [modelo200Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateModelo200: async (year, preview, modelo200Request, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('generateModelo200', 'year', year);
            const localVarPath = `/api/admin/accounting/tax-models/modelo200/{year}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (preview !== undefined) {
                localVarQueryParameter['preview'] = preview;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(modelo200Request, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModelo115: async (year, quarter, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getModelo115', 'year', year);
            // verify required parameter 'quarter' is not null or undefined
            assertParamExists('getModelo115', 'quarter', quarter);
            const localVarPath = `/api/admin/accounting/tax-models/modelo115/{year}/{quarter}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"quarter"}}`, encodeURIComponent(String(quarter)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModelo130: async (year, quarter, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getModelo130', 'year', year);
            // verify required parameter 'quarter' is not null or undefined
            assertParamExists('getModelo130', 'quarter', quarter);
            const localVarPath = `/api/admin/accounting/tax-models/modelo130/{year}/{quarter}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"quarter"}}`, encodeURIComponent(String(quarter)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModelo180: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getModelo180', 'year', year);
            const localVarPath = `/api/admin/accounting/tax-models/modelo180/{year}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModelo303: async (year, quarter, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getModelo303', 'year', year);
            // verify required parameter 'quarter' is not null or undefined
            assertParamExists('getModelo303', 'quarter', quarter);
            const localVarPath = `/api/admin/accounting/tax-models/modelo303/{year}/{quarter}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"quarter"}}`, encodeURIComponent(String(quarter)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModelo349: async (year, quarter, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getModelo349', 'year', year);
            // verify required parameter 'quarter' is not null or undefined
            assertParamExists('getModelo349', 'quarter', quarter);
            const localVarPath = `/api/admin/accounting/tax-models/modelo349/{year}/{quarter}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"quarter"}}`, encodeURIComponent(String(quarter)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelo111: async (year, quarter, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('modelo111', 'year', year);
            // verify required parameter 'quarter' is not null or undefined
            assertParamExists('modelo111', 'quarter', quarter);
            const localVarPath = `/api/admin/accounting/tax-models/modelo111/{year}/{quarter}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"quarter"}}`, encodeURIComponent(String(quarter)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelo190: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('modelo190', 'year', year);
            const localVarPath = `/api/admin/accounting/tax-models/modelo190/{year}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelo200BreakdownStatus: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('modelo200BreakdownStatus', 'year', year);
            const localVarPath = `/api/admin/accounting/tax-models/modelo200/{year}/breakdown`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {boolean} [preview]
         * @param {Modelo202Request} [modelo202Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelo202: async (year, preview, modelo202Request, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('modelo202', 'year', year);
            const localVarPath = `/api/admin/accounting/tax-models/modelo202/{year}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (preview !== undefined) {
                localVarQueryParameter['preview'] = preview;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(modelo202Request, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} [threshold]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelo347: async (year, threshold, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('modelo347', 'year', year);
            const localVarPath = `/api/admin/accounting/tax-models/modelo347/{year}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (threshold !== undefined) {
                localVarQueryParameter['threshold'] = threshold;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelo390: async (year, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('modelo390', 'year', year);
            const localVarPath = `/api/admin/accounting/tax-models/modelo390/{year}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TaxModelsRestControllerApi - functional programming interface
 * @export
 */
export const TaxModelsRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = TaxModelsRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {Modelo200BreakdownRequest} modelo200BreakdownRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeModelo200Breakdown(year, modelo200BreakdownRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeModelo200Breakdown(year, modelo200BreakdownRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxModelsRestControllerApi.completeModelo200Breakdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {boolean} [preview]
         * @param {Modelo200Request} [modelo200Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateModelo200(year, preview, modelo200Request, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateModelo200(year, preview, modelo200Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxModelsRestControllerApi.generateModelo200']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModelo115(year, quarter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModelo115(year, quarter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxModelsRestControllerApi.getModelo115']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModelo130(year, quarter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModelo130(year, quarter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxModelsRestControllerApi.getModelo130']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModelo180(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModelo180(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxModelsRestControllerApi.getModelo180']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModelo303(year, quarter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModelo303(year, quarter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxModelsRestControllerApi.getModelo303']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModelo349(year, quarter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModelo349(year, quarter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxModelsRestControllerApi.getModelo349']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelo111(year, quarter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelo111(year, quarter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxModelsRestControllerApi.modelo111']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelo190(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelo190(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxModelsRestControllerApi.modelo190']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelo200BreakdownStatus(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelo200BreakdownStatus(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxModelsRestControllerApi.modelo200BreakdownStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {boolean} [preview]
         * @param {Modelo202Request} [modelo202Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelo202(year, preview, modelo202Request, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelo202(year, preview, modelo202Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxModelsRestControllerApi.modelo202']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} [threshold]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelo347(year, threshold, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelo347(year, threshold, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxModelsRestControllerApi.modelo347']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelo390(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelo390(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxModelsRestControllerApi.modelo390']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TaxModelsRestControllerApi - factory interface
 * @export
 */
export const TaxModelsRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TaxModelsRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {Modelo200BreakdownRequest} modelo200BreakdownRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeModelo200Breakdown(year, modelo200BreakdownRequest, options) {
            return localVarFp.completeModelo200Breakdown(year, modelo200BreakdownRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {boolean} [preview]
         * @param {Modelo200Request} [modelo200Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateModelo200(year, preview, modelo200Request, options) {
            return localVarFp.generateModelo200(year, preview, modelo200Request, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModelo115(year, quarter, options) {
            return localVarFp.getModelo115(year, quarter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModelo130(year, quarter, options) {
            return localVarFp.getModelo130(year, quarter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModelo180(year, options) {
            return localVarFp.getModelo180(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModelo303(year, quarter, options) {
            return localVarFp.getModelo303(year, quarter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModelo349(year, quarter, options) {
            return localVarFp.getModelo349(year, quarter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelo111(year, quarter, options) {
            return localVarFp.modelo111(year, quarter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelo190(year, options) {
            return localVarFp.modelo190(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelo200BreakdownStatus(year, options) {
            return localVarFp.modelo200BreakdownStatus(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {boolean} [preview]
         * @param {Modelo202Request} [modelo202Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelo202(year, preview, modelo202Request, options) {
            return localVarFp.modelo202(year, preview, modelo202Request, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} [threshold]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelo347(year, threshold, options) {
            return localVarFp.modelo347(year, threshold, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelo390(year, options) {
            return localVarFp.modelo390(year, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TaxModelsRestControllerApi - object-oriented interface
 * @export
 * @class TaxModelsRestControllerApi
 * @extends {BaseAPI}
 */
export class TaxModelsRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} year
     * @param {Modelo200BreakdownRequest} modelo200BreakdownRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxModelsRestControllerApi
     */
    completeModelo200Breakdown(year, modelo200BreakdownRequest, options) {
        return TaxModelsRestControllerApiFp(this.configuration).completeModelo200Breakdown(year, modelo200BreakdownRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {boolean} [preview]
     * @param {Modelo200Request} [modelo200Request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxModelsRestControllerApi
     */
    generateModelo200(year, preview, modelo200Request, options) {
        return TaxModelsRestControllerApiFp(this.configuration).generateModelo200(year, preview, modelo200Request, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} quarter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxModelsRestControllerApi
     */
    getModelo115(year, quarter, options) {
        return TaxModelsRestControllerApiFp(this.configuration).getModelo115(year, quarter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} quarter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxModelsRestControllerApi
     */
    getModelo130(year, quarter, options) {
        return TaxModelsRestControllerApiFp(this.configuration).getModelo130(year, quarter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxModelsRestControllerApi
     */
    getModelo180(year, options) {
        return TaxModelsRestControllerApiFp(this.configuration).getModelo180(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} quarter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxModelsRestControllerApi
     */
    getModelo303(year, quarter, options) {
        return TaxModelsRestControllerApiFp(this.configuration).getModelo303(year, quarter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} quarter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxModelsRestControllerApi
     */
    getModelo349(year, quarter, options) {
        return TaxModelsRestControllerApiFp(this.configuration).getModelo349(year, quarter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} quarter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxModelsRestControllerApi
     */
    modelo111(year, quarter, options) {
        return TaxModelsRestControllerApiFp(this.configuration).modelo111(year, quarter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxModelsRestControllerApi
     */
    modelo190(year, options) {
        return TaxModelsRestControllerApiFp(this.configuration).modelo190(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxModelsRestControllerApi
     */
    modelo200BreakdownStatus(year, options) {
        return TaxModelsRestControllerApiFp(this.configuration).modelo200BreakdownStatus(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {boolean} [preview]
     * @param {Modelo202Request} [modelo202Request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxModelsRestControllerApi
     */
    modelo202(year, preview, modelo202Request, options) {
        return TaxModelsRestControllerApiFp(this.configuration).modelo202(year, preview, modelo202Request, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} [threshold]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxModelsRestControllerApi
     */
    modelo347(year, threshold, options) {
        return TaxModelsRestControllerApiFp(this.configuration).modelo347(year, threshold, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxModelsRestControllerApi
     */
    modelo390(year, options) {
        return TaxModelsRestControllerApiFp(this.configuration).modelo390(year, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TaxSubmissionRestControllerApi - axios parameter creator
 * @export
 */
export const TaxSubmissionRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [year]
         * @param {CountTaxSubmissionModelTypeEnum} [modelType]
         * @param {CountTaxSubmissionStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTaxSubmission: async (year, modelType, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/tax-submission/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (modelType !== undefined) {
                localVarQueryParameter['modelType'] = modelType;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchTaxSubmission: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchTaxSubmission', 'ids', ids);
            const localVarPath = `/api/admin/accounting/tax-submission/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissTaxSubmission: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissTaxSubmission', 'id', id);
            const localVarPath = `/api/admin/accounting/tax-submission/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxSubmission: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTaxSubmission', 'id', id);
            const localVarPath = `/api/admin/accounting/tax-submission/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [year]
         * @param {ListTaxSubmissionModelTypeEnum} [modelType]
         * @param {ListTaxSubmissionStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTaxSubmission: async (year, modelType, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/tax-submission/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (modelType !== undefined) {
                localVarQueryParameter['modelType'] = modelType;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [year]
         * @param {PageTaxSubmissionModelTypeEnum} [modelType]
         * @param {PageTaxSubmissionStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTaxSubmission: async (page, size, sort, year, modelType, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/tax-submission/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (modelType !== undefined) {
                localVarQueryParameter['modelType'] = modelType;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {TaxSubmission} taxSubmission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTaxSubmission: async (taxSubmission, options = {}) => {
            // verify required parameter 'taxSubmission' is not null or undefined
            assertParamExists('saveTaxSubmission', 'taxSubmission', taxSubmission);
            const localVarPath = `/api/admin/accounting/tax-submission/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(taxSubmission, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TaxSubmissionRestControllerApi - functional programming interface
 * @export
 */
export const TaxSubmissionRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = TaxSubmissionRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [year]
         * @param {CountTaxSubmissionModelTypeEnum} [modelType]
         * @param {CountTaxSubmissionStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countTaxSubmission(year, modelType, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countTaxSubmission(year, modelType, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxSubmissionRestControllerApi.countTaxSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchTaxSubmission(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchTaxSubmission(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxSubmissionRestControllerApi.deleteOrDismissInBatchTaxSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissTaxSubmission(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissTaxSubmission(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxSubmissionRestControllerApi.deleteOrDismissTaxSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaxSubmission(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaxSubmission(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxSubmissionRestControllerApi.getTaxSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [year]
         * @param {ListTaxSubmissionModelTypeEnum} [modelType]
         * @param {ListTaxSubmissionStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTaxSubmission(year, modelType, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTaxSubmission(year, modelType, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxSubmissionRestControllerApi.listTaxSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [year]
         * @param {PageTaxSubmissionModelTypeEnum} [modelType]
         * @param {PageTaxSubmissionStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageTaxSubmission(page, size, sort, year, modelType, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageTaxSubmission(page, size, sort, year, modelType, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxSubmissionRestControllerApi.pageTaxSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {TaxSubmission} taxSubmission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTaxSubmission(taxSubmission, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTaxSubmission(taxSubmission, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxSubmissionRestControllerApi.saveTaxSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TaxSubmissionRestControllerApi - factory interface
 * @export
 */
export const TaxSubmissionRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TaxSubmissionRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [year]
         * @param {CountTaxSubmissionModelTypeEnum} [modelType]
         * @param {CountTaxSubmissionStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTaxSubmission(year, modelType, status, term, showDismissed, options) {
            return localVarFp.countTaxSubmission(year, modelType, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchTaxSubmission(ids, options) {
            return localVarFp.deleteOrDismissInBatchTaxSubmission(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissTaxSubmission(id, options) {
            return localVarFp.deleteOrDismissTaxSubmission(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxSubmission(id, options) {
            return localVarFp.getTaxSubmission(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [year]
         * @param {ListTaxSubmissionModelTypeEnum} [modelType]
         * @param {ListTaxSubmissionStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTaxSubmission(year, modelType, status, term, showDismissed, options) {
            return localVarFp.listTaxSubmission(year, modelType, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [year]
         * @param {PageTaxSubmissionModelTypeEnum} [modelType]
         * @param {PageTaxSubmissionStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTaxSubmission(page, size, sort, year, modelType, status, term, showDismissed, options) {
            return localVarFp.pageTaxSubmission(page, size, sort, year, modelType, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TaxSubmission} taxSubmission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTaxSubmission(taxSubmission, options) {
            return localVarFp.saveTaxSubmission(taxSubmission, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TaxSubmissionRestControllerApi - object-oriented interface
 * @export
 * @class TaxSubmissionRestControllerApi
 * @extends {BaseAPI}
 */
export class TaxSubmissionRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [year]
     * @param {CountTaxSubmissionModelTypeEnum} [modelType]
     * @param {CountTaxSubmissionStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxSubmissionRestControllerApi
     */
    countTaxSubmission(year, modelType, status, term, showDismissed, options) {
        return TaxSubmissionRestControllerApiFp(this.configuration).countTaxSubmission(year, modelType, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxSubmissionRestControllerApi
     */
    deleteOrDismissInBatchTaxSubmission(ids, options) {
        return TaxSubmissionRestControllerApiFp(this.configuration).deleteOrDismissInBatchTaxSubmission(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxSubmissionRestControllerApi
     */
    deleteOrDismissTaxSubmission(id, options) {
        return TaxSubmissionRestControllerApiFp(this.configuration).deleteOrDismissTaxSubmission(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxSubmissionRestControllerApi
     */
    getTaxSubmission(id, options) {
        return TaxSubmissionRestControllerApiFp(this.configuration).getTaxSubmission(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [year]
     * @param {ListTaxSubmissionModelTypeEnum} [modelType]
     * @param {ListTaxSubmissionStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxSubmissionRestControllerApi
     */
    listTaxSubmission(year, modelType, status, term, showDismissed, options) {
        return TaxSubmissionRestControllerApiFp(this.configuration).listTaxSubmission(year, modelType, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [year]
     * @param {PageTaxSubmissionModelTypeEnum} [modelType]
     * @param {PageTaxSubmissionStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxSubmissionRestControllerApi
     */
    pageTaxSubmission(page, size, sort, year, modelType, status, term, showDismissed, options) {
        return TaxSubmissionRestControllerApiFp(this.configuration).pageTaxSubmission(page, size, sort, year, modelType, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TaxSubmission} taxSubmission
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxSubmissionRestControllerApi
     */
    saveTaxSubmission(taxSubmission, options) {
        return TaxSubmissionRestControllerApiFp(this.configuration).saveTaxSubmission(taxSubmission, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountTaxSubmissionModelTypeEnum = {
    M303_IVA: 'M303_IVA',
    M111_IRPF: 'M111_IRPF',
    M190_IRPF_ANUAL: 'M190_IRPF_ANUAL',
    M202_IS: 'M202_IS',
    M200_IS_ANUAL: 'M200_IS_ANUAL',
    M390_IVA_ANUAL: 'M390_IVA_ANUAL',
    M347_TERCEROS: 'M347_TERCEROS',
    M115_ALQUILER: 'M115_ALQUILER',
    M180_ALQUILER_ANUAL: 'M180_ALQUILER_ANUAL',
    M349_INTRACOMUNITARIO: 'M349_INTRACOMUNITARIO',
    M130_IRPF_AUTONOMO: 'M130_IRPF_AUTONOMO',
    LEGALIZACION_LIBROS: 'LEGALIZACION_LIBROS',
    APROBACION_CUENTAS: 'APROBACION_CUENTAS',
    DOCUMENTACION_DEPOSITO: 'DOCUMENTACION_DEPOSITO',
    DEPOSITO_CUENTAS: 'DEPOSITO_CUENTAS',
    SEGUROS_SOCIALES: 'SEGUROS_SOCIALES',
    PAGO_NOMINAS: 'PAGO_NOMINAS'
};
/**
 * @export
 */
export const CountTaxSubmissionStatusEnum = {
    PENDIENTE: 'PENDIENTE',
    PRESENTADO: 'PRESENTADO',
    ACEPTADO: 'ACEPTADO',
    RECHAZADO: 'RECHAZADO'
};
/**
 * @export
 */
export const ListTaxSubmissionModelTypeEnum = {
    M303_IVA: 'M303_IVA',
    M111_IRPF: 'M111_IRPF',
    M190_IRPF_ANUAL: 'M190_IRPF_ANUAL',
    M202_IS: 'M202_IS',
    M200_IS_ANUAL: 'M200_IS_ANUAL',
    M390_IVA_ANUAL: 'M390_IVA_ANUAL',
    M347_TERCEROS: 'M347_TERCEROS',
    M115_ALQUILER: 'M115_ALQUILER',
    M180_ALQUILER_ANUAL: 'M180_ALQUILER_ANUAL',
    M349_INTRACOMUNITARIO: 'M349_INTRACOMUNITARIO',
    M130_IRPF_AUTONOMO: 'M130_IRPF_AUTONOMO',
    LEGALIZACION_LIBROS: 'LEGALIZACION_LIBROS',
    APROBACION_CUENTAS: 'APROBACION_CUENTAS',
    DOCUMENTACION_DEPOSITO: 'DOCUMENTACION_DEPOSITO',
    DEPOSITO_CUENTAS: 'DEPOSITO_CUENTAS',
    SEGUROS_SOCIALES: 'SEGUROS_SOCIALES',
    PAGO_NOMINAS: 'PAGO_NOMINAS'
};
/**
 * @export
 */
export const ListTaxSubmissionStatusEnum = {
    PENDIENTE: 'PENDIENTE',
    PRESENTADO: 'PRESENTADO',
    ACEPTADO: 'ACEPTADO',
    RECHAZADO: 'RECHAZADO'
};
/**
 * @export
 */
export const PageTaxSubmissionModelTypeEnum = {
    M303_IVA: 'M303_IVA',
    M111_IRPF: 'M111_IRPF',
    M190_IRPF_ANUAL: 'M190_IRPF_ANUAL',
    M202_IS: 'M202_IS',
    M200_IS_ANUAL: 'M200_IS_ANUAL',
    M390_IVA_ANUAL: 'M390_IVA_ANUAL',
    M347_TERCEROS: 'M347_TERCEROS',
    M115_ALQUILER: 'M115_ALQUILER',
    M180_ALQUILER_ANUAL: 'M180_ALQUILER_ANUAL',
    M349_INTRACOMUNITARIO: 'M349_INTRACOMUNITARIO',
    M130_IRPF_AUTONOMO: 'M130_IRPF_AUTONOMO',
    LEGALIZACION_LIBROS: 'LEGALIZACION_LIBROS',
    APROBACION_CUENTAS: 'APROBACION_CUENTAS',
    DOCUMENTACION_DEPOSITO: 'DOCUMENTACION_DEPOSITO',
    DEPOSITO_CUENTAS: 'DEPOSITO_CUENTAS',
    SEGUROS_SOCIALES: 'SEGUROS_SOCIALES',
    PAGO_NOMINAS: 'PAGO_NOMINAS'
};
/**
 * @export
 */
export const PageTaxSubmissionStatusEnum = {
    PENDIENTE: 'PENDIENTE',
    PRESENTADO: 'PRESENTADO',
    ACEPTADO: 'ACEPTADO',
    RECHAZADO: 'RECHAZADO'
};
/**
 * TemplateRestControllerApi - axios parameter creator
 * @export
 */
export const TemplateRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTemplate: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/config/template/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchTemplate: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchTemplate', 'ids', ids);
            const localVarPath = `/api/admin/config/template/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissTemplate', 'id', id);
            const localVarPath = `/api/admin/config/template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTemplate', 'id', id);
            const localVarPath = `/api/admin/config/template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplate: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/config/template/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTemplate: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/config/template/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Template} template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTemplate: async (template, options = {}) => {
            // verify required parameter 'template' is not null or undefined
            assertParamExists('saveTemplate', 'template', template);
            const localVarPath = `/api/admin/config/template/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(template, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TemplateRestControllerApi - functional programming interface
 * @export
 */
export const TemplateRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = TemplateRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countTemplate(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countTemplate(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateRestControllerApi.countTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchTemplate(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchTemplate(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateRestControllerApi.deleteOrDismissInBatchTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissTemplate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateRestControllerApi.deleteOrDismissTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateRestControllerApi.getTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTemplate(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTemplate(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateRestControllerApi.listTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageTemplate(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageTemplate(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateRestControllerApi.pageTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Template} template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTemplate(template, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTemplate(template, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplateRestControllerApi.saveTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TemplateRestControllerApi - factory interface
 * @export
 */
export const TemplateRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TemplateRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTemplate(term, showDismissed, options) {
            return localVarFp.countTemplate(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchTemplate(ids, options) {
            return localVarFp.deleteOrDismissInBatchTemplate(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissTemplate(id, options) {
            return localVarFp.deleteOrDismissTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate(id, options) {
            return localVarFp.getTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplate(term, showDismissed, options) {
            return localVarFp.listTemplate(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTemplate(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageTemplate(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Template} template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTemplate(template, options) {
            return localVarFp.saveTemplate(template, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TemplateRestControllerApi - object-oriented interface
 * @export
 * @class TemplateRestControllerApi
 * @extends {BaseAPI}
 */
export class TemplateRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateRestControllerApi
     */
    countTemplate(term, showDismissed, options) {
        return TemplateRestControllerApiFp(this.configuration).countTemplate(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateRestControllerApi
     */
    deleteOrDismissInBatchTemplate(ids, options) {
        return TemplateRestControllerApiFp(this.configuration).deleteOrDismissInBatchTemplate(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateRestControllerApi
     */
    deleteOrDismissTemplate(id, options) {
        return TemplateRestControllerApiFp(this.configuration).deleteOrDismissTemplate(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateRestControllerApi
     */
    getTemplate(id, options) {
        return TemplateRestControllerApiFp(this.configuration).getTemplate(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateRestControllerApi
     */
    listTemplate(term, showDismissed, options) {
        return TemplateRestControllerApiFp(this.configuration).listTemplate(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateRestControllerApi
     */
    pageTemplate(page, size, sort, term, showDismissed, options) {
        return TemplateRestControllerApiFp(this.configuration).pageTemplate(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Template} template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateRestControllerApi
     */
    saveTemplate(template, options) {
        return TemplateRestControllerApiFp(this.configuration).saveTemplate(template, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TimeClockRestControllerApi - axios parameter creator
 * @export
 */
export const TimeClockRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {TimeClockReviewRequest} [timeClockReviewRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveCorrection: async (id, timeClockReviewRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('approveCorrection', 'id', id);
            const localVarPath = `/api/admin/employee/timeclock/corrections/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(timeClockReviewRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CorrectionsStatusEnum} [status]
         * @param {number} [personId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corrections: async (status, personId, options = {}) => {
            const localVarPath = `/api/admin/employee/timeclock/corrections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crossCheck: async (from, to, options = {}) => {
            const localVarPath = `/api/admin/employee/timeclock/crosscheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString().substring(0, 10) :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString().substring(0, 10) :
                    to;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {number} [personId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monthReport: async (year, month, personId, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('monthReport', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('monthReport', 'month', month);
            const localVarPath = `/api/admin/employee/timeclock/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {number} [personId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monthReportCsv: async (year, month, personId, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('monthReportCsv', 'year', year);
            // verify required parameter 'month' is not null or undefined
            assertParamExists('monthReportCsv', 'month', month);
            const localVarPath = `/api/admin/employee/timeclock/report.csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {TimeClockReviewRequest} timeClockReviewRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCorrection: async (id, timeClockReviewRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rejectCorrection', 'id', id);
            // verify required parameter 'timeClockReviewRequest' is not null or undefined
            assertParamExists('rejectCorrection', 'timeClockReviewRequest', timeClockReviewRequest);
            const localVarPath = `/api/admin/employee/timeclock/corrections/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(timeClockReviewRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TimeClockRestControllerApi - functional programming interface
 * @export
 */
export const TimeClockRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = TimeClockRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {TimeClockReviewRequest} [timeClockReviewRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveCorrection(id, timeClockReviewRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveCorrection(id, timeClockReviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeClockRestControllerApi.approveCorrection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CorrectionsStatusEnum} [status]
         * @param {number} [personId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async corrections(status, personId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.corrections(status, personId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeClockRestControllerApi.corrections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crossCheck(from, to, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crossCheck(from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeClockRestControllerApi.crossCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {number} [personId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monthReport(year, month, personId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monthReport(year, month, personId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeClockRestControllerApi.monthReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {number} [personId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monthReportCsv(year, month, personId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monthReportCsv(year, month, personId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeClockRestControllerApi.monthReportCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {TimeClockReviewRequest} timeClockReviewRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectCorrection(id, timeClockReviewRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectCorrection(id, timeClockReviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeClockRestControllerApi.rejectCorrection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TimeClockRestControllerApi - factory interface
 * @export
 */
export const TimeClockRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TimeClockRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {TimeClockReviewRequest} [timeClockReviewRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveCorrection(id, timeClockReviewRequest, options) {
            return localVarFp.approveCorrection(id, timeClockReviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CorrectionsStatusEnum} [status]
         * @param {number} [personId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corrections(status, personId, options) {
            return localVarFp.corrections(status, personId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crossCheck(from, to, options) {
            return localVarFp.crossCheck(from, to, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {number} [personId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monthReport(year, month, personId, options) {
            return localVarFp.monthReport(year, month, personId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} month
         * @param {number} [personId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monthReportCsv(year, month, personId, options) {
            return localVarFp.monthReportCsv(year, month, personId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {TimeClockReviewRequest} timeClockReviewRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCorrection(id, timeClockReviewRequest, options) {
            return localVarFp.rejectCorrection(id, timeClockReviewRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TimeClockRestControllerApi - object-oriented interface
 * @export
 * @class TimeClockRestControllerApi
 * @extends {BaseAPI}
 */
export class TimeClockRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} id
     * @param {TimeClockReviewRequest} [timeClockReviewRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeClockRestControllerApi
     */
    approveCorrection(id, timeClockReviewRequest, options) {
        return TimeClockRestControllerApiFp(this.configuration).approveCorrection(id, timeClockReviewRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CorrectionsStatusEnum} [status]
     * @param {number} [personId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeClockRestControllerApi
     */
    corrections(status, personId, options) {
        return TimeClockRestControllerApiFp(this.configuration).corrections(status, personId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [from]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeClockRestControllerApi
     */
    crossCheck(from, to, options) {
        return TimeClockRestControllerApiFp(this.configuration).crossCheck(from, to, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {number} [personId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeClockRestControllerApi
     */
    monthReport(year, month, personId, options) {
        return TimeClockRestControllerApiFp(this.configuration).monthReport(year, month, personId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} month
     * @param {number} [personId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeClockRestControllerApi
     */
    monthReportCsv(year, month, personId, options) {
        return TimeClockRestControllerApiFp(this.configuration).monthReportCsv(year, month, personId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {TimeClockReviewRequest} timeClockReviewRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeClockRestControllerApi
     */
    rejectCorrection(id, timeClockReviewRequest, options) {
        return TimeClockRestControllerApiFp(this.configuration).rejectCorrection(id, timeClockReviewRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CorrectionsStatusEnum = {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED'
};
/**
 * TrainingLevelRestControllerApi - axios parameter creator
 * @export
 */
export const TrainingLevelRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTrainingLevel: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/training-level/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchTrainingLevel: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchTrainingLevel', 'ids', ids);
            const localVarPath = `/api/admin/recruitment/training-level/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissTrainingLevel: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissTrainingLevel', 'id', id);
            const localVarPath = `/api/admin/recruitment/training-level/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrainingLevel: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTrainingLevel', 'id', id);
            const localVarPath = `/api/admin/recruitment/training-level/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrainingLevel: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/training-level/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTrainingLevel: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/recruitment/training-level/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {TrainingLevel} trainingLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTrainingLevel: async (trainingLevel, options = {}) => {
            // verify required parameter 'trainingLevel' is not null or undefined
            assertParamExists('saveTrainingLevel', 'trainingLevel', trainingLevel);
            const localVarPath = `/api/admin/recruitment/training-level/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(trainingLevel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TrainingLevelRestControllerApi - functional programming interface
 * @export
 */
export const TrainingLevelRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = TrainingLevelRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countTrainingLevel(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countTrainingLevel(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrainingLevelRestControllerApi.countTrainingLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchTrainingLevel(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchTrainingLevel(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrainingLevelRestControllerApi.deleteOrDismissInBatchTrainingLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissTrainingLevel(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissTrainingLevel(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrainingLevelRestControllerApi.deleteOrDismissTrainingLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrainingLevel(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrainingLevel(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrainingLevelRestControllerApi.getTrainingLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTrainingLevel(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTrainingLevel(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrainingLevelRestControllerApi.listTrainingLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageTrainingLevel(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageTrainingLevel(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrainingLevelRestControllerApi.pageTrainingLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {TrainingLevel} trainingLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTrainingLevel(trainingLevel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTrainingLevel(trainingLevel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrainingLevelRestControllerApi.saveTrainingLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TrainingLevelRestControllerApi - factory interface
 * @export
 */
export const TrainingLevelRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TrainingLevelRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTrainingLevel(term, showDismissed, options) {
            return localVarFp.countTrainingLevel(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchTrainingLevel(ids, options) {
            return localVarFp.deleteOrDismissInBatchTrainingLevel(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissTrainingLevel(id, options) {
            return localVarFp.deleteOrDismissTrainingLevel(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrainingLevel(id, options) {
            return localVarFp.getTrainingLevel(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrainingLevel(term, showDismissed, options) {
            return localVarFp.listTrainingLevel(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTrainingLevel(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageTrainingLevel(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TrainingLevel} trainingLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTrainingLevel(trainingLevel, options) {
            return localVarFp.saveTrainingLevel(trainingLevel, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TrainingLevelRestControllerApi - object-oriented interface
 * @export
 * @class TrainingLevelRestControllerApi
 * @extends {BaseAPI}
 */
export class TrainingLevelRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingLevelRestControllerApi
     */
    countTrainingLevel(term, showDismissed, options) {
        return TrainingLevelRestControllerApiFp(this.configuration).countTrainingLevel(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingLevelRestControllerApi
     */
    deleteOrDismissInBatchTrainingLevel(ids, options) {
        return TrainingLevelRestControllerApiFp(this.configuration).deleteOrDismissInBatchTrainingLevel(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingLevelRestControllerApi
     */
    deleteOrDismissTrainingLevel(id, options) {
        return TrainingLevelRestControllerApiFp(this.configuration).deleteOrDismissTrainingLevel(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingLevelRestControllerApi
     */
    getTrainingLevel(id, options) {
        return TrainingLevelRestControllerApiFp(this.configuration).getTrainingLevel(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingLevelRestControllerApi
     */
    listTrainingLevel(term, showDismissed, options) {
        return TrainingLevelRestControllerApiFp(this.configuration).listTrainingLevel(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingLevelRestControllerApi
     */
    pageTrainingLevel(page, size, sort, term, showDismissed, options) {
        return TrainingLevelRestControllerApiFp(this.configuration).pageTrainingLevel(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TrainingLevel} trainingLevel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingLevelRestControllerApi
     */
    saveTrainingLevel(trainingLevel, options) {
        return TrainingLevelRestControllerApiFp(this.configuration).saveTrainingLevel(trainingLevel, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TrainingRecordRestControllerApi - axios parameter creator
 * @export
 */
export const TrainingRecordRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {CountTrainingRecordKindEnum} [kind]
         * @param {CountTrainingRecordStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTrainingRecord: async (personId, year, kind, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/training-record/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchTrainingRecord: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchTrainingRecord', 'ids', ids);
            const localVarPath = `/api/admin/employee/training-record/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissTrainingRecord: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissTrainingRecord', 'id', id);
            const localVarPath = `/api/admin/employee/training-record/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrainingRecord: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTrainingRecord', 'id', id);
            const localVarPath = `/api/admin/employee/training-record/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {ListTrainingRecordKindEnum} [kind]
         * @param {ListTrainingRecordStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrainingRecord: async (personId, year, kind, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/training-record/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {PageTrainingRecordKindEnum} [kind]
         * @param {PageTrainingRecordStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTrainingRecord: async (page, size, sort, personId, year, kind, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/training-record/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {TrainingSessionDto} trainingSessionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerSessionTrainingRecord: async (trainingSessionDto, options = {}) => {
            // verify required parameter 'trainingSessionDto' is not null or undefined
            assertParamExists('registerSessionTrainingRecord', 'trainingSessionDto', trainingSessionDto);
            const localVarPath = `/api/admin/employee/training-record/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(trainingSessionDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTrainingRecord: async (year, options = {}) => {
            const localVarPath = `/api/admin/employee/training-record/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {TrainingRecord} trainingRecord
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTrainingRecord: async (trainingRecord, options = {}) => {
            // verify required parameter 'trainingRecord' is not null or undefined
            assertParamExists('saveTrainingRecord', 'trainingRecord', trainingRecord);
            const localVarPath = `/api/admin/employee/training-record/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(trainingRecord, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewTrainingRecord: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('viewTrainingRecord', 'id', id);
            const localVarPath = `/api/admin/employee/training-record/view/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TrainingRecordRestControllerApi - functional programming interface
 * @export
 */
export const TrainingRecordRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = TrainingRecordRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {CountTrainingRecordKindEnum} [kind]
         * @param {CountTrainingRecordStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countTrainingRecord(personId, year, kind, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countTrainingRecord(personId, year, kind, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrainingRecordRestControllerApi.countTrainingRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchTrainingRecord(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchTrainingRecord(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrainingRecordRestControllerApi.deleteOrDismissInBatchTrainingRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissTrainingRecord(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissTrainingRecord(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrainingRecordRestControllerApi.deleteOrDismissTrainingRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrainingRecord(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrainingRecord(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrainingRecordRestControllerApi.getTrainingRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {ListTrainingRecordKindEnum} [kind]
         * @param {ListTrainingRecordStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTrainingRecord(personId, year, kind, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTrainingRecord(personId, year, kind, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrainingRecordRestControllerApi.listTrainingRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {PageTrainingRecordKindEnum} [kind]
         * @param {PageTrainingRecordStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageTrainingRecord(page, size, sort, personId, year, kind, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageTrainingRecord(page, size, sort, personId, year, kind, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrainingRecordRestControllerApi.pageTrainingRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {TrainingSessionDto} trainingSessionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerSessionTrainingRecord(trainingSessionDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerSessionTrainingRecord(trainingSessionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrainingRecordRestControllerApi.registerSessionTrainingRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportTrainingRecord(year, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportTrainingRecord(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrainingRecordRestControllerApi.reportTrainingRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {TrainingRecord} trainingRecord
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTrainingRecord(trainingRecord, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTrainingRecord(trainingRecord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrainingRecordRestControllerApi.saveTrainingRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewTrainingRecord(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewTrainingRecord(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrainingRecordRestControllerApi.viewTrainingRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TrainingRecordRestControllerApi - factory interface
 * @export
 */
export const TrainingRecordRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TrainingRecordRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {CountTrainingRecordKindEnum} [kind]
         * @param {CountTrainingRecordStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTrainingRecord(personId, year, kind, status, term, showDismissed, options) {
            return localVarFp.countTrainingRecord(personId, year, kind, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchTrainingRecord(ids, options) {
            return localVarFp.deleteOrDismissInBatchTrainingRecord(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissTrainingRecord(id, options) {
            return localVarFp.deleteOrDismissTrainingRecord(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrainingRecord(id, options) {
            return localVarFp.getTrainingRecord(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {ListTrainingRecordKindEnum} [kind]
         * @param {ListTrainingRecordStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrainingRecord(personId, year, kind, status, term, showDismissed, options) {
            return localVarFp.listTrainingRecord(personId, year, kind, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {PageTrainingRecordKindEnum} [kind]
         * @param {PageTrainingRecordStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTrainingRecord(page, size, sort, personId, year, kind, status, term, showDismissed, options) {
            return localVarFp.pageTrainingRecord(page, size, sort, personId, year, kind, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TrainingSessionDto} trainingSessionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerSessionTrainingRecord(trainingSessionDto, options) {
            return localVarFp.registerSessionTrainingRecord(trainingSessionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTrainingRecord(year, options) {
            return localVarFp.reportTrainingRecord(year, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TrainingRecord} trainingRecord
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTrainingRecord(trainingRecord, options) {
            return localVarFp.saveTrainingRecord(trainingRecord, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewTrainingRecord(id, options) {
            return localVarFp.viewTrainingRecord(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TrainingRecordRestControllerApi - object-oriented interface
 * @export
 * @class TrainingRecordRestControllerApi
 * @extends {BaseAPI}
 */
export class TrainingRecordRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {CountTrainingRecordKindEnum} [kind]
     * @param {CountTrainingRecordStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingRecordRestControllerApi
     */
    countTrainingRecord(personId, year, kind, status, term, showDismissed, options) {
        return TrainingRecordRestControllerApiFp(this.configuration).countTrainingRecord(personId, year, kind, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingRecordRestControllerApi
     */
    deleteOrDismissInBatchTrainingRecord(ids, options) {
        return TrainingRecordRestControllerApiFp(this.configuration).deleteOrDismissInBatchTrainingRecord(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingRecordRestControllerApi
     */
    deleteOrDismissTrainingRecord(id, options) {
        return TrainingRecordRestControllerApiFp(this.configuration).deleteOrDismissTrainingRecord(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingRecordRestControllerApi
     */
    getTrainingRecord(id, options) {
        return TrainingRecordRestControllerApiFp(this.configuration).getTrainingRecord(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {ListTrainingRecordKindEnum} [kind]
     * @param {ListTrainingRecordStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingRecordRestControllerApi
     */
    listTrainingRecord(personId, year, kind, status, term, showDismissed, options) {
        return TrainingRecordRestControllerApiFp(this.configuration).listTrainingRecord(personId, year, kind, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [personId]
     * @param {number} [year]
     * @param {PageTrainingRecordKindEnum} [kind]
     * @param {PageTrainingRecordStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingRecordRestControllerApi
     */
    pageTrainingRecord(page, size, sort, personId, year, kind, status, term, showDismissed, options) {
        return TrainingRecordRestControllerApiFp(this.configuration).pageTrainingRecord(page, size, sort, personId, year, kind, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TrainingSessionDto} trainingSessionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingRecordRestControllerApi
     */
    registerSessionTrainingRecord(trainingSessionDto, options) {
        return TrainingRecordRestControllerApiFp(this.configuration).registerSessionTrainingRecord(trainingSessionDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [year]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingRecordRestControllerApi
     */
    reportTrainingRecord(year, options) {
        return TrainingRecordRestControllerApiFp(this.configuration).reportTrainingRecord(year, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TrainingRecord} trainingRecord
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingRecordRestControllerApi
     */
    saveTrainingRecord(trainingRecord, options) {
        return TrainingRecordRestControllerApiFp(this.configuration).saveTrainingRecord(trainingRecord, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingRecordRestControllerApi
     */
    viewTrainingRecord(id, options) {
        return TrainingRecordRestControllerApiFp(this.configuration).viewTrainingRecord(id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountTrainingRecordKindEnum = {
    FORMACION: 'FORMACION',
    CONCIENCIACION: 'CONCIENCIACION'
};
/**
 * @export
 */
export const CountTrainingRecordStatusEnum = {
    PLANIFICADA: 'PLANIFICADA',
    REALIZADA: 'REALIZADA',
    CANCELADA: 'CANCELADA'
};
/**
 * @export
 */
export const ListTrainingRecordKindEnum = {
    FORMACION: 'FORMACION',
    CONCIENCIACION: 'CONCIENCIACION'
};
/**
 * @export
 */
export const ListTrainingRecordStatusEnum = {
    PLANIFICADA: 'PLANIFICADA',
    REALIZADA: 'REALIZADA',
    CANCELADA: 'CANCELADA'
};
/**
 * @export
 */
export const PageTrainingRecordKindEnum = {
    FORMACION: 'FORMACION',
    CONCIENCIACION: 'CONCIENCIACION'
};
/**
 * @export
 */
export const PageTrainingRecordStatusEnum = {
    PLANIFICADA: 'PLANIFICADA',
    REALIZADA: 'REALIZADA',
    CANCELADA: 'CANCELADA'
};
/**
 * UserRestControllerApi - axios parameter creator
 * @export
 */
export const UserRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        info: async (options = {}) => {
            const localVarPath = `/api/user/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [width]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photo: async (width, options = {}) => {
            const localVarPath = `/api/user/photo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (width !== undefined) {
                localVarQueryParameter['width'] = width;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserRestControllerApi - functional programming interface
 * @export
 */
export const UserRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async info(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.info(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserRestControllerApi.info']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [width]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async photo(width, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.photo(width, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserRestControllerApi.photo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * UserRestControllerApi - factory interface
 * @export
 */
export const UserRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        info(options) {
            return localVarFp.info(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [width]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photo(width, options) {
            return localVarFp.photo(width, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserRestControllerApi - object-oriented interface
 * @export
 * @class UserRestControllerApi
 * @extends {BaseAPI}
 */
export class UserRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRestControllerApi
     */
    info(options) {
        return UserRestControllerApiFp(this.configuration).info(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [width]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRestControllerApi
     */
    photo(width, options) {
        return UserRestControllerApiFp(this.configuration).photo(width, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * VacationRestControllerApi - axios parameter creator
 * @export
 */
export const VacationRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {boolean} checked
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkJustificationVacation: async (id, checked, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('checkJustificationVacation', 'id', id);
            // verify required parameter 'checked' is not null or undefined
            assertParamExists('checkJustificationVacation', 'checked', checked);
            const localVarPath = `/api/admin/employee/vacations/{id}/justification`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (checked !== undefined) {
                localVarQueryParameter['checked'] = checked;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countVacation: async (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/vacations/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchVacation: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchVacation', 'ids', ids);
            const localVarPath = `/api/admin/employee/vacations/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissVacation: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissVacation', 'id', id);
            const localVarPath = `/api/admin/employee/vacations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} startDate
         * @param {string} endDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolidayCalendarVacation: async (startDate, endDate, options = {}) => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getHolidayCalendarVacation', 'startDate', startDate);
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getHolidayCalendarVacation', 'endDate', endDate);
            const localVarPath = `/api/admin/employee/vacations/calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substring(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substring(0, 10) :
                    endDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVacation: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVacation', 'id', id);
            const localVarPath = `/api/admin/employee/vacations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVacation: async (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/vacations/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageVacation: async (page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/vacations/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Vacation} vacation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveVacation: async (vacation, options = {}) => {
            // verify required parameter 'vacation' is not null or undefined
            assertParamExists('saveVacation', 'vacation', vacation);
            const localVarPath = `/api/admin/employee/vacations/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(vacation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * VacationRestControllerApi - functional programming interface
 * @export
 */
export const VacationRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = VacationRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {boolean} checked
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkJustificationVacation(id, checked, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkJustificationVacation(id, checked, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VacationRestControllerApi.checkJustificationVacation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countVacation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countVacation(personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VacationRestControllerApi.countVacation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchVacation(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchVacation(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VacationRestControllerApi.deleteOrDismissInBatchVacation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissVacation(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissVacation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VacationRestControllerApi.deleteOrDismissVacation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} startDate
         * @param {string} endDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHolidayCalendarVacation(startDate, endDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHolidayCalendarVacation(startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VacationRestControllerApi.getHolidayCalendarVacation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVacation(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVacation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VacationRestControllerApi.getVacation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVacation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVacation(personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VacationRestControllerApi.listVacation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageVacation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageVacation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VacationRestControllerApi.pageVacation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Vacation} vacation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveVacation(vacation, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveVacation(vacation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VacationRestControllerApi.saveVacation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * VacationRestControllerApi - factory interface
 * @export
 */
export const VacationRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VacationRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {boolean} checked
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkJustificationVacation(id, checked, options) {
            return localVarFp.checkJustificationVacation(id, checked, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countVacation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countVacation(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchVacation(ids, options) {
            return localVarFp.deleteOrDismissInBatchVacation(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissVacation(id, options) {
            return localVarFp.deleteOrDismissVacation(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} startDate
         * @param {string} endDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolidayCalendarVacation(startDate, endDate, options) {
            return localVarFp.getHolidayCalendarVacation(startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVacation(id, options) {
            return localVarFp.getVacation(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVacation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listVacation(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageVacation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pageVacation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Vacation} vacation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveVacation(vacation, options) {
            return localVarFp.saveVacation(vacation, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VacationRestControllerApi - object-oriented interface
 * @export
 * @class VacationRestControllerApi
 * @extends {BaseAPI}
 */
export class VacationRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} id
     * @param {boolean} checked
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VacationRestControllerApi
     */
    checkJustificationVacation(id, checked, options) {
        return VacationRestControllerApiFp(this.configuration).checkJustificationVacation(id, checked, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VacationRestControllerApi
     */
    countVacation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return VacationRestControllerApiFp(this.configuration).countVacation(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VacationRestControllerApi
     */
    deleteOrDismissInBatchVacation(ids, options) {
        return VacationRestControllerApiFp(this.configuration).deleteOrDismissInBatchVacation(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VacationRestControllerApi
     */
    deleteOrDismissVacation(id, options) {
        return VacationRestControllerApiFp(this.configuration).deleteOrDismissVacation(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} startDate
     * @param {string} endDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VacationRestControllerApi
     */
    getHolidayCalendarVacation(startDate, endDate, options) {
        return VacationRestControllerApiFp(this.configuration).getHolidayCalendarVacation(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VacationRestControllerApi
     */
    getVacation(id, options) {
        return VacationRestControllerApiFp(this.configuration).getVacation(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VacationRestControllerApi
     */
    listVacation(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return VacationRestControllerApiFp(this.configuration).listVacation(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VacationRestControllerApi
     */
    pageVacation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return VacationRestControllerApiFp(this.configuration).pageVacation(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Vacation} vacation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VacationRestControllerApi
     */
    saveVacation(vacation, options) {
        return VacationRestControllerApiFp(this.configuration).saveVacation(vacation, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * VatBookRestControllerApi - axios parameter creator
 * @export
 */
export const VatBookRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {CalculateVatBookTypeEnum} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateVatBook: async (year, quarter, type, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('calculateVatBook', 'year', year);
            // verify required parameter 'quarter' is not null or undefined
            assertParamExists('calculateVatBook', 'quarter', quarter);
            // verify required parameter 'type' is not null or undefined
            assertParamExists('calculateVatBook', 'type', type);
            const localVarPath = `/api/admin/accounting/vat-book/calculate/{year}/{quarter}/{type}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"quarter"}}`, encodeURIComponent(String(quarter)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [year]
         * @param {number} [quarter]
         * @param {CountVatBookBookTypeEnum} [bookType]
         * @param {CountVatBookStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countVatBook: async (year, quarter, bookType, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/vat-book/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (quarter !== undefined) {
                localVarQueryParameter['quarter'] = quarter;
            }
            if (bookType !== undefined) {
                localVarQueryParameter['bookType'] = bookType;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchVatBook: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchVatBook', 'ids', ids);
            const localVarPath = `/api/admin/accounting/vat-book/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissVatBook: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissVatBook', 'id', id);
            const localVarPath = `/api/admin/accounting/vat-book/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVatBook: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVatBook', 'id', id);
            const localVarPath = `/api/admin/accounting/vat-book/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issuedRegisterVatBook: async (year, quarter, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('issuedRegisterVatBook', 'year', year);
            // verify required parameter 'quarter' is not null or undefined
            assertParamExists('issuedRegisterVatBook', 'quarter', quarter);
            const localVarPath = `/api/admin/accounting/vat-book/registro/{year}/{quarter}/expedidas`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"quarter"}}`, encodeURIComponent(String(quarter)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [year]
         * @param {number} [quarter]
         * @param {ListVatBookBookTypeEnum} [bookType]
         * @param {ListVatBookStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVatBook: async (year, quarter, bookType, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/vat-book/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (quarter !== undefined) {
                localVarQueryParameter['quarter'] = quarter;
            }
            if (bookType !== undefined) {
                localVarQueryParameter['bookType'] = bookType;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [year]
         * @param {number} [quarter]
         * @param {PageVatBookBookTypeEnum} [bookType]
         * @param {PageVatBookStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageVatBook: async (page, size, sort, year, quarter, bookType, status, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/vat-book/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (quarter !== undefined) {
                localVarQueryParameter['quarter'] = quarter;
            }
            if (bookType !== undefined) {
                localVarQueryParameter['bookType'] = bookType;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivedRegisterVatBook: async (year, quarter, options = {}) => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('receivedRegisterVatBook', 'year', year);
            // verify required parameter 'quarter' is not null or undefined
            assertParamExists('receivedRegisterVatBook', 'quarter', quarter);
            const localVarPath = `/api/admin/accounting/vat-book/registro/{year}/{quarter}/recibidas`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"quarter"}}`, encodeURIComponent(String(quarter)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {VatBook} vatBook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveVatBook: async (vatBook, options = {}) => {
            // verify required parameter 'vatBook' is not null or undefined
            assertParamExists('saveVatBook', 'vatBook', vatBook);
            const localVarPath = `/api/admin/accounting/vat-book/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(vatBook, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * VatBookRestControllerApi - functional programming interface
 * @export
 */
export const VatBookRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = VatBookRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {CalculateVatBookTypeEnum} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateVatBook(year, quarter, type, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateVatBook(year, quarter, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VatBookRestControllerApi.calculateVatBook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [year]
         * @param {number} [quarter]
         * @param {CountVatBookBookTypeEnum} [bookType]
         * @param {CountVatBookStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countVatBook(year, quarter, bookType, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countVatBook(year, quarter, bookType, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VatBookRestControllerApi.countVatBook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchVatBook(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchVatBook(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VatBookRestControllerApi.deleteOrDismissInBatchVatBook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissVatBook(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissVatBook(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VatBookRestControllerApi.deleteOrDismissVatBook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVatBook(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVatBook(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VatBookRestControllerApi.getVatBook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async issuedRegisterVatBook(year, quarter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.issuedRegisterVatBook(year, quarter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VatBookRestControllerApi.issuedRegisterVatBook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [year]
         * @param {number} [quarter]
         * @param {ListVatBookBookTypeEnum} [bookType]
         * @param {ListVatBookStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVatBook(year, quarter, bookType, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVatBook(year, quarter, bookType, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VatBookRestControllerApi.listVatBook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [year]
         * @param {number} [quarter]
         * @param {PageVatBookBookTypeEnum} [bookType]
         * @param {PageVatBookStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageVatBook(page, size, sort, year, quarter, bookType, status, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageVatBook(page, size, sort, year, quarter, bookType, status, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VatBookRestControllerApi.pageVatBook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receivedRegisterVatBook(year, quarter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receivedRegisterVatBook(year, quarter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VatBookRestControllerApi.receivedRegisterVatBook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {VatBook} vatBook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveVatBook(vatBook, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveVatBook(vatBook, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VatBookRestControllerApi.saveVatBook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * VatBookRestControllerApi - factory interface
 * @export
 */
export const VatBookRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VatBookRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {CalculateVatBookTypeEnum} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateVatBook(year, quarter, type, options) {
            return localVarFp.calculateVatBook(year, quarter, type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [year]
         * @param {number} [quarter]
         * @param {CountVatBookBookTypeEnum} [bookType]
         * @param {CountVatBookStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countVatBook(year, quarter, bookType, status, term, showDismissed, options) {
            return localVarFp.countVatBook(year, quarter, bookType, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchVatBook(ids, options) {
            return localVarFp.deleteOrDismissInBatchVatBook(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissVatBook(id, options) {
            return localVarFp.deleteOrDismissVatBook(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVatBook(id, options) {
            return localVarFp.getVatBook(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issuedRegisterVatBook(year, quarter, options) {
            return localVarFp.issuedRegisterVatBook(year, quarter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [year]
         * @param {number} [quarter]
         * @param {ListVatBookBookTypeEnum} [bookType]
         * @param {ListVatBookStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVatBook(year, quarter, bookType, status, term, showDismissed, options) {
            return localVarFp.listVatBook(year, quarter, bookType, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [year]
         * @param {number} [quarter]
         * @param {PageVatBookBookTypeEnum} [bookType]
         * @param {PageVatBookStatusEnum} [status]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageVatBook(page, size, sort, year, quarter, bookType, status, term, showDismissed, options) {
            return localVarFp.pageVatBook(page, size, sort, year, quarter, bookType, status, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} year
         * @param {number} quarter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivedRegisterVatBook(year, quarter, options) {
            return localVarFp.receivedRegisterVatBook(year, quarter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {VatBook} vatBook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveVatBook(vatBook, options) {
            return localVarFp.saveVatBook(vatBook, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VatBookRestControllerApi - object-oriented interface
 * @export
 * @class VatBookRestControllerApi
 * @extends {BaseAPI}
 */
export class VatBookRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} year
     * @param {number} quarter
     * @param {CalculateVatBookTypeEnum} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatBookRestControllerApi
     */
    calculateVatBook(year, quarter, type, options) {
        return VatBookRestControllerApiFp(this.configuration).calculateVatBook(year, quarter, type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [year]
     * @param {number} [quarter]
     * @param {CountVatBookBookTypeEnum} [bookType]
     * @param {CountVatBookStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatBookRestControllerApi
     */
    countVatBook(year, quarter, bookType, status, term, showDismissed, options) {
        return VatBookRestControllerApiFp(this.configuration).countVatBook(year, quarter, bookType, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatBookRestControllerApi
     */
    deleteOrDismissInBatchVatBook(ids, options) {
        return VatBookRestControllerApiFp(this.configuration).deleteOrDismissInBatchVatBook(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatBookRestControllerApi
     */
    deleteOrDismissVatBook(id, options) {
        return VatBookRestControllerApiFp(this.configuration).deleteOrDismissVatBook(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatBookRestControllerApi
     */
    getVatBook(id, options) {
        return VatBookRestControllerApiFp(this.configuration).getVatBook(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} quarter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatBookRestControllerApi
     */
    issuedRegisterVatBook(year, quarter, options) {
        return VatBookRestControllerApiFp(this.configuration).issuedRegisterVatBook(year, quarter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [year]
     * @param {number} [quarter]
     * @param {ListVatBookBookTypeEnum} [bookType]
     * @param {ListVatBookStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatBookRestControllerApi
     */
    listVatBook(year, quarter, bookType, status, term, showDismissed, options) {
        return VatBookRestControllerApiFp(this.configuration).listVatBook(year, quarter, bookType, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [year]
     * @param {number} [quarter]
     * @param {PageVatBookBookTypeEnum} [bookType]
     * @param {PageVatBookStatusEnum} [status]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatBookRestControllerApi
     */
    pageVatBook(page, size, sort, year, quarter, bookType, status, term, showDismissed, options) {
        return VatBookRestControllerApiFp(this.configuration).pageVatBook(page, size, sort, year, quarter, bookType, status, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} year
     * @param {number} quarter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatBookRestControllerApi
     */
    receivedRegisterVatBook(year, quarter, options) {
        return VatBookRestControllerApiFp(this.configuration).receivedRegisterVatBook(year, quarter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {VatBook} vatBook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatBookRestControllerApi
     */
    saveVatBook(vatBook, options) {
        return VatBookRestControllerApiFp(this.configuration).saveVatBook(vatBook, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CalculateVatBookTypeEnum = {
    EMITIDAS: 'EMITIDAS',
    RECIBIDAS: 'RECIBIDAS'
};
/**
 * @export
 */
export const CountVatBookBookTypeEnum = {
    EMITIDAS: 'EMITIDAS',
    RECIBIDAS: 'RECIBIDAS'
};
/**
 * @export
 */
export const CountVatBookStatusEnum = {
    PENDIENTE: 'PENDIENTE',
    PRESENTADO: 'PRESENTADO',
    ACEPTADO: 'ACEPTADO',
    RECHAZADO: 'RECHAZADO'
};
/**
 * @export
 */
export const ListVatBookBookTypeEnum = {
    EMITIDAS: 'EMITIDAS',
    RECIBIDAS: 'RECIBIDAS'
};
/**
 * @export
 */
export const ListVatBookStatusEnum = {
    PENDIENTE: 'PENDIENTE',
    PRESENTADO: 'PRESENTADO',
    ACEPTADO: 'ACEPTADO',
    RECHAZADO: 'RECHAZADO'
};
/**
 * @export
 */
export const PageVatBookBookTypeEnum = {
    EMITIDAS: 'EMITIDAS',
    RECIBIDAS: 'RECIBIDAS'
};
/**
 * @export
 */
export const PageVatBookStatusEnum = {
    PENDIENTE: 'PENDIENTE',
    PRESENTADO: 'PRESENTADO',
    ACEPTADO: 'ACEPTADO',
    RECHAZADO: 'RECHAZADO'
};
/**
 * VerifactuRestControllerApi - axios parameter creator
 * @export
 */
export const VerifactuRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificadoVerifactuRecord: async (options = {}) => {
            const localVarPath = `/api/admin/accounting/verifactu/certificado`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} ejercicio
         * @param {number} mes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conciliarVerifactuRecord: async (ejercicio, mes, options = {}) => {
            // verify required parameter 'ejercicio' is not null or undefined
            assertParamExists('conciliarVerifactuRecord', 'ejercicio', ejercicio);
            // verify required parameter 'mes' is not null or undefined
            assertParamExists('conciliarVerifactuRecord', 'mes', mes);
            const localVarPath = `/api/admin/accounting/verifactu/conciliar/{ejercicio}/{mes}`
                .replace(`{${"ejercicio"}}`, encodeURIComponent(String(ejercicio)))
                .replace(`{${"mes"}}`, encodeURIComponent(String(mes)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [billId]
         * @param {boolean} [cancelled]
         * @param {CountVerifactuRecordSubmissionStatusEnum} [submissionStatus]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countVerifactuRecord: async (billId, cancelled, submissionStatus, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/verifactu/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (billId !== undefined) {
                localVarQueryParameter['billId'] = billId;
            }
            if (cancelled !== undefined) {
                localVarQueryParameter['cancelled'] = cancelled;
            }
            if (submissionStatus !== undefined) {
                localVarQueryParameter['submissionStatus'] = submissionStatus;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declaracionVerifactuRecord: async (options = {}) => {
            const localVarPath = `/api/admin/accounting/verifactu/declaracion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchVerifactuRecord: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchVerifactuRecord', 'ids', ids);
            const localVarPath = `/api/admin/accounting/verifactu/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissVerifactuRecord: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissVerifactuRecord', 'id', id);
            const localVarPath = `/api/admin/accounting/verifactu/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByBillVerifactuRecord: async (billId, options = {}) => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('findByBillVerifactuRecord', 'billId', billId);
            const localVarPath = `/api/admin/accounting/verifactu/bill/{billId}`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerifactuRecord: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVerifactuRecord', 'id', id);
            const localVarPath = `/api/admin/accounting/verifactu/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicoDeclaracionesVerifactuRecord: async (options = {}) => {
            const localVarPath = `/api/admin/accounting/verifactu/declaracion/historico`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [billId]
         * @param {boolean} [cancelled]
         * @param {ListVerifactuRecordSubmissionStatusEnum} [submissionStatus]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVerifactuRecord: async (billId, cancelled, submissionStatus, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/verifactu/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (billId !== undefined) {
                localVarQueryParameter['billId'] = billId;
            }
            if (cancelled !== undefined) {
                localVarQueryParameter['cancelled'] = cancelled;
            }
            if (submissionStatus !== undefined) {
                localVarQueryParameter['submissionStatus'] = submissionStatus;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [billId]
         * @param {boolean} [cancelled]
         * @param {PageVerifactuRecordSubmissionStatusEnum} [submissionStatus]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageVerifactuRecord: async (page, size, sort, billId, cancelled, submissionStatus, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/accounting/verifactu/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (billId !== undefined) {
                localVarQueryParameter['billId'] = billId;
            }
            if (cancelled !== undefined) {
                localVarQueryParameter['cancelled'] = cancelled;
            }
            if (submissionStatus !== undefined) {
                localVarQueryParameter['submissionStatus'] = submissionStatus;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicarDeclaracionVerifactuRecord: async (options = {}) => {
            const localVarPath = `/api/admin/accounting/verifactu/declaracion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {VerifactuRecord} verifactuRecord
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveVerifactuRecord: async (verifactuRecord, options = {}) => {
            // verify required parameter 'verifactuRecord' is not null or undefined
            assertParamExists('saveVerifactuRecord', 'verifactuRecord', verifactuRecord);
            const localVarPath = `/api/admin/accounting/verifactu/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(verifactuRecord, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [max]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVerifactuRecord: async (max, options = {}) => {
            const localVarPath = `/api/admin/accounting/verifactu/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (max !== undefined) {
                localVarQueryParameter['max'] = max;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [max]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subsanarVerifactuRecord: async (max, options = {}) => {
            const localVarPath = `/api/admin/accounting/verifactu/subsanar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (max !== undefined) {
                localVarQueryParameter['max'] = max;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyChainVerifactuRecord: async (options = {}) => {
            const localVarPath = `/api/admin/accounting/verifactu/chain/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        xmlVerifactuRecord: async (billId, options = {}) => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('xmlVerifactuRecord', 'billId', billId);
            const localVarPath = `/api/admin/accounting/verifactu/bill/{billId}/xml`
                .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * VerifactuRestControllerApi - functional programming interface
 * @export
 */
export const VerifactuRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = VerifactuRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificadoVerifactuRecord(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificadoVerifactuRecord(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifactuRestControllerApi.certificadoVerifactuRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} ejercicio
         * @param {number} mes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async conciliarVerifactuRecord(ejercicio, mes, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.conciliarVerifactuRecord(ejercicio, mes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifactuRestControllerApi.conciliarVerifactuRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [billId]
         * @param {boolean} [cancelled]
         * @param {CountVerifactuRecordSubmissionStatusEnum} [submissionStatus]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countVerifactuRecord(billId, cancelled, submissionStatus, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countVerifactuRecord(billId, cancelled, submissionStatus, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifactuRestControllerApi.countVerifactuRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declaracionVerifactuRecord(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declaracionVerifactuRecord(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifactuRestControllerApi.declaracionVerifactuRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchVerifactuRecord(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchVerifactuRecord(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifactuRestControllerApi.deleteOrDismissInBatchVerifactuRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissVerifactuRecord(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissVerifactuRecord(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifactuRestControllerApi.deleteOrDismissVerifactuRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByBillVerifactuRecord(billId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByBillVerifactuRecord(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifactuRestControllerApi.findByBillVerifactuRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVerifactuRecord(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVerifactuRecord(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifactuRestControllerApi.getVerifactuRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicoDeclaracionesVerifactuRecord(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicoDeclaracionesVerifactuRecord(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifactuRestControllerApi.historicoDeclaracionesVerifactuRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [billId]
         * @param {boolean} [cancelled]
         * @param {ListVerifactuRecordSubmissionStatusEnum} [submissionStatus]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVerifactuRecord(billId, cancelled, submissionStatus, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVerifactuRecord(billId, cancelled, submissionStatus, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifactuRestControllerApi.listVerifactuRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [billId]
         * @param {boolean} [cancelled]
         * @param {PageVerifactuRecordSubmissionStatusEnum} [submissionStatus]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageVerifactuRecord(page, size, sort, billId, cancelled, submissionStatus, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageVerifactuRecord(page, size, sort, billId, cancelled, submissionStatus, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifactuRestControllerApi.pageVerifactuRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicarDeclaracionVerifactuRecord(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicarDeclaracionVerifactuRecord(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifactuRestControllerApi.publicarDeclaracionVerifactuRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {VerifactuRecord} verifactuRecord
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveVerifactuRecord(verifactuRecord, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveVerifactuRecord(verifactuRecord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifactuRestControllerApi.saveVerifactuRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [max]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendVerifactuRecord(max, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendVerifactuRecord(max, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifactuRestControllerApi.sendVerifactuRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [max]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subsanarVerifactuRecord(max, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subsanarVerifactuRecord(max, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifactuRestControllerApi.subsanarVerifactuRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyChainVerifactuRecord(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyChainVerifactuRecord(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifactuRestControllerApi.verifyChainVerifactuRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async xmlVerifactuRecord(billId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.xmlVerifactuRecord(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifactuRestControllerApi.xmlVerifactuRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * VerifactuRestControllerApi - factory interface
 * @export
 */
export const VerifactuRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VerifactuRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificadoVerifactuRecord(options) {
            return localVarFp.certificadoVerifactuRecord(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} ejercicio
         * @param {number} mes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conciliarVerifactuRecord(ejercicio, mes, options) {
            return localVarFp.conciliarVerifactuRecord(ejercicio, mes, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [billId]
         * @param {boolean} [cancelled]
         * @param {CountVerifactuRecordSubmissionStatusEnum} [submissionStatus]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countVerifactuRecord(billId, cancelled, submissionStatus, term, showDismissed, options) {
            return localVarFp.countVerifactuRecord(billId, cancelled, submissionStatus, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declaracionVerifactuRecord(options) {
            return localVarFp.declaracionVerifactuRecord(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchVerifactuRecord(ids, options) {
            return localVarFp.deleteOrDismissInBatchVerifactuRecord(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissVerifactuRecord(id, options) {
            return localVarFp.deleteOrDismissVerifactuRecord(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByBillVerifactuRecord(billId, options) {
            return localVarFp.findByBillVerifactuRecord(billId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerifactuRecord(id, options) {
            return localVarFp.getVerifactuRecord(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicoDeclaracionesVerifactuRecord(options) {
            return localVarFp.historicoDeclaracionesVerifactuRecord(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [billId]
         * @param {boolean} [cancelled]
         * @param {ListVerifactuRecordSubmissionStatusEnum} [submissionStatus]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVerifactuRecord(billId, cancelled, submissionStatus, term, showDismissed, options) {
            return localVarFp.listVerifactuRecord(billId, cancelled, submissionStatus, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [billId]
         * @param {boolean} [cancelled]
         * @param {PageVerifactuRecordSubmissionStatusEnum} [submissionStatus]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageVerifactuRecord(page, size, sort, billId, cancelled, submissionStatus, term, showDismissed, options) {
            return localVarFp.pageVerifactuRecord(page, size, sort, billId, cancelled, submissionStatus, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicarDeclaracionVerifactuRecord(options) {
            return localVarFp.publicarDeclaracionVerifactuRecord(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {VerifactuRecord} verifactuRecord
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveVerifactuRecord(verifactuRecord, options) {
            return localVarFp.saveVerifactuRecord(verifactuRecord, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [max]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVerifactuRecord(max, options) {
            return localVarFp.sendVerifactuRecord(max, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [max]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subsanarVerifactuRecord(max, options) {
            return localVarFp.subsanarVerifactuRecord(max, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyChainVerifactuRecord(options) {
            return localVarFp.verifyChainVerifactuRecord(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        xmlVerifactuRecord(billId, options) {
            return localVarFp.xmlVerifactuRecord(billId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VerifactuRestControllerApi - object-oriented interface
 * @export
 * @class VerifactuRestControllerApi
 * @extends {BaseAPI}
 */
export class VerifactuRestControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifactuRestControllerApi
     */
    certificadoVerifactuRecord(options) {
        return VerifactuRestControllerApiFp(this.configuration).certificadoVerifactuRecord(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} ejercicio
     * @param {number} mes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifactuRestControllerApi
     */
    conciliarVerifactuRecord(ejercicio, mes, options) {
        return VerifactuRestControllerApiFp(this.configuration).conciliarVerifactuRecord(ejercicio, mes, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [billId]
     * @param {boolean} [cancelled]
     * @param {CountVerifactuRecordSubmissionStatusEnum} [submissionStatus]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifactuRestControllerApi
     */
    countVerifactuRecord(billId, cancelled, submissionStatus, term, showDismissed, options) {
        return VerifactuRestControllerApiFp(this.configuration).countVerifactuRecord(billId, cancelled, submissionStatus, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifactuRestControllerApi
     */
    declaracionVerifactuRecord(options) {
        return VerifactuRestControllerApiFp(this.configuration).declaracionVerifactuRecord(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifactuRestControllerApi
     */
    deleteOrDismissInBatchVerifactuRecord(ids, options) {
        return VerifactuRestControllerApiFp(this.configuration).deleteOrDismissInBatchVerifactuRecord(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifactuRestControllerApi
     */
    deleteOrDismissVerifactuRecord(id, options) {
        return VerifactuRestControllerApiFp(this.configuration).deleteOrDismissVerifactuRecord(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} billId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifactuRestControllerApi
     */
    findByBillVerifactuRecord(billId, options) {
        return VerifactuRestControllerApiFp(this.configuration).findByBillVerifactuRecord(billId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifactuRestControllerApi
     */
    getVerifactuRecord(id, options) {
        return VerifactuRestControllerApiFp(this.configuration).getVerifactuRecord(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifactuRestControllerApi
     */
    historicoDeclaracionesVerifactuRecord(options) {
        return VerifactuRestControllerApiFp(this.configuration).historicoDeclaracionesVerifactuRecord(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [billId]
     * @param {boolean} [cancelled]
     * @param {ListVerifactuRecordSubmissionStatusEnum} [submissionStatus]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifactuRestControllerApi
     */
    listVerifactuRecord(billId, cancelled, submissionStatus, term, showDismissed, options) {
        return VerifactuRestControllerApiFp(this.configuration).listVerifactuRecord(billId, cancelled, submissionStatus, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [billId]
     * @param {boolean} [cancelled]
     * @param {PageVerifactuRecordSubmissionStatusEnum} [submissionStatus]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifactuRestControllerApi
     */
    pageVerifactuRecord(page, size, sort, billId, cancelled, submissionStatus, term, showDismissed, options) {
        return VerifactuRestControllerApiFp(this.configuration).pageVerifactuRecord(page, size, sort, billId, cancelled, submissionStatus, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifactuRestControllerApi
     */
    publicarDeclaracionVerifactuRecord(options) {
        return VerifactuRestControllerApiFp(this.configuration).publicarDeclaracionVerifactuRecord(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {VerifactuRecord} verifactuRecord
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifactuRestControllerApi
     */
    saveVerifactuRecord(verifactuRecord, options) {
        return VerifactuRestControllerApiFp(this.configuration).saveVerifactuRecord(verifactuRecord, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [max]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifactuRestControllerApi
     */
    sendVerifactuRecord(max, options) {
        return VerifactuRestControllerApiFp(this.configuration).sendVerifactuRecord(max, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [max]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifactuRestControllerApi
     */
    subsanarVerifactuRecord(max, options) {
        return VerifactuRestControllerApiFp(this.configuration).subsanarVerifactuRecord(max, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifactuRestControllerApi
     */
    verifyChainVerifactuRecord(options) {
        return VerifactuRestControllerApiFp(this.configuration).verifyChainVerifactuRecord(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} billId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifactuRestControllerApi
     */
    xmlVerifactuRecord(billId, options) {
        return VerifactuRestControllerApiFp(this.configuration).xmlVerifactuRecord(billId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CountVerifactuRecordSubmissionStatusEnum = {
    PENDIENTE: 'PENDIENTE',
    ACEPTADO: 'ACEPTADO',
    ACEPTADO_CON_ERRORES: 'ACEPTADO_CON_ERRORES',
    RECHAZADO: 'RECHAZADO'
};
/**
 * @export
 */
export const ListVerifactuRecordSubmissionStatusEnum = {
    PENDIENTE: 'PENDIENTE',
    ACEPTADO: 'ACEPTADO',
    ACEPTADO_CON_ERRORES: 'ACEPTADO_CON_ERRORES',
    RECHAZADO: 'RECHAZADO'
};
/**
 * @export
 */
export const PageVerifactuRecordSubmissionStatusEnum = {
    PENDIENTE: 'PENDIENTE',
    ACEPTADO: 'ACEPTADO',
    ACEPTADO_CON_ERRORES: 'ACEPTADO_CON_ERRORES',
    RECHAZADO: 'RECHAZADO'
};
/**
 * WikiPageRestControllerApi - axios parameter creator
 * @export
 */
export const WikiPageRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} section
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countWikiPage: async (section, term, showDismissed, options = {}) => {
            // verify required parameter 'section' is not null or undefined
            assertParamExists('countWikiPage', 'section', section);
            const localVarPath = `/api/admin/employee/wiki/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (section !== undefined) {
                localVarQueryParameter['section'] = section;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchWikiPage: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchWikiPage', 'ids', ids);
            const localVarPath = `/api/admin/employee/wiki/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissWikiPage: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissWikiPage', 'id', id);
            const localVarPath = `/api/admin/employee/wiki/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} wikiId
         * @param {number} num
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachmentWikiPage: async (wikiId, num, options = {}) => {
            // verify required parameter 'wikiId' is not null or undefined
            assertParamExists('downloadAttachmentWikiPage', 'wikiId', wikiId);
            // verify required parameter 'num' is not null or undefined
            assertParamExists('downloadAttachmentWikiPage', 'num', num);
            const localVarPath = `/api/admin/employee/wiki/{wikiId}/document/{num}`
                .replace(`{${"wikiId"}}`, encodeURIComponent(String(wikiId)))
                .replace(`{${"num"}}`, encodeURIComponent(String(num)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWikiPage: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWikiPage', 'id', id);
            const localVarPath = `/api/admin/employee/wiki/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} section
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWikiPage: async (section, term, showDismissed, options = {}) => {
            // verify required parameter 'section' is not null or undefined
            assertParamExists('listWikiPage', 'section', section);
            const localVarPath = `/api/admin/employee/wiki/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (section !== undefined) {
                localVarQueryParameter['section'] = section;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} section
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWikiPage: async (section, page, size, sort, term, showDismissed, options = {}) => {
            // verify required parameter 'section' is not null or undefined
            assertParamExists('pageWikiPage', 'section', section);
            const localVarPath = `/api/admin/employee/wiki/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (section !== undefined) {
                localVarQueryParameter['section'] = section;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {WikiPage} wikiPage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWikiPage: async (wikiPage, options = {}) => {
            // verify required parameter 'wikiPage' is not null or undefined
            assertParamExists('saveWikiPage', 'wikiPage', wikiPage);
            const localVarPath = `/api/admin/employee/wiki/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(wikiPage, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WikiPageRestControllerApi - functional programming interface
 * @export
 */
export const WikiPageRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = WikiPageRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} section
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countWikiPage(section, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countWikiPage(section, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WikiPageRestControllerApi.countWikiPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchWikiPage(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchWikiPage(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WikiPageRestControllerApi.deleteOrDismissInBatchWikiPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissWikiPage(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissWikiPage(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WikiPageRestControllerApi.deleteOrDismissWikiPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} wikiId
         * @param {number} num
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAttachmentWikiPage(wikiId, num, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAttachmentWikiPage(wikiId, num, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WikiPageRestControllerApi.downloadAttachmentWikiPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWikiPage(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWikiPage(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WikiPageRestControllerApi.getWikiPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} section
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWikiPage(section, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWikiPage(section, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WikiPageRestControllerApi.listWikiPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} section
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageWikiPage(section, page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageWikiPage(section, page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WikiPageRestControllerApi.pageWikiPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {WikiPage} wikiPage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveWikiPage(wikiPage, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveWikiPage(wikiPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WikiPageRestControllerApi.saveWikiPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * WikiPageRestControllerApi - factory interface
 * @export
 */
export const WikiPageRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WikiPageRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} section
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countWikiPage(section, term, showDismissed, options) {
            return localVarFp.countWikiPage(section, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchWikiPage(ids, options) {
            return localVarFp.deleteOrDismissInBatchWikiPage(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissWikiPage(id, options) {
            return localVarFp.deleteOrDismissWikiPage(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} wikiId
         * @param {number} num
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachmentWikiPage(wikiId, num, options) {
            return localVarFp.downloadAttachmentWikiPage(wikiId, num, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWikiPage(id, options) {
            return localVarFp.getWikiPage(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} section
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWikiPage(section, term, showDismissed, options) {
            return localVarFp.listWikiPage(section, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} section
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWikiPage(section, page, size, sort, term, showDismissed, options) {
            return localVarFp.pageWikiPage(section, page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WikiPage} wikiPage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWikiPage(wikiPage, options) {
            return localVarFp.saveWikiPage(wikiPage, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WikiPageRestControllerApi - object-oriented interface
 * @export
 * @class WikiPageRestControllerApi
 * @extends {BaseAPI}
 */
export class WikiPageRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} section
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WikiPageRestControllerApi
     */
    countWikiPage(section, term, showDismissed, options) {
        return WikiPageRestControllerApiFp(this.configuration).countWikiPage(section, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WikiPageRestControllerApi
     */
    deleteOrDismissInBatchWikiPage(ids, options) {
        return WikiPageRestControllerApiFp(this.configuration).deleteOrDismissInBatchWikiPage(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WikiPageRestControllerApi
     */
    deleteOrDismissWikiPage(id, options) {
        return WikiPageRestControllerApiFp(this.configuration).deleteOrDismissWikiPage(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} wikiId
     * @param {number} num
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WikiPageRestControllerApi
     */
    downloadAttachmentWikiPage(wikiId, num, options) {
        return WikiPageRestControllerApiFp(this.configuration).downloadAttachmentWikiPage(wikiId, num, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WikiPageRestControllerApi
     */
    getWikiPage(id, options) {
        return WikiPageRestControllerApiFp(this.configuration).getWikiPage(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} section
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WikiPageRestControllerApi
     */
    listWikiPage(section, term, showDismissed, options) {
        return WikiPageRestControllerApiFp(this.configuration).listWikiPage(section, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} section
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WikiPageRestControllerApi
     */
    pageWikiPage(section, page, size, sort, term, showDismissed, options) {
        return WikiPageRestControllerApiFp(this.configuration).pageWikiPage(section, page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WikiPage} wikiPage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WikiPageRestControllerApi
     */
    saveWikiPage(wikiPage, options) {
        return WikiPageRestControllerApiFp(this.configuration).saveWikiPage(wikiPage, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WorkAuditControllerApi - axios parameter creator
 * @export
 */
export const WorkAuditControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [start]
         * @param {string} [end]
         * @param {Array<number>} [person]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkAudits: async (start, end, person, options = {}) => {
            const localVarPath = `/api/admin/controlling/work-audit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (start !== undefined) {
                localVarQueryParameter['start'] = (start instanceof Date) ?
                    start.toISOString() :
                    start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = (end instanceof Date) ?
                    end.toISOString() :
                    end;
            }
            if (person) {
                localVarQueryParameter['person'] = person;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WorkAuditControllerApi - functional programming interface
 * @export
 */
export const WorkAuditControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkAuditControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [start]
         * @param {string} [end]
         * @param {Array<number>} [person]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkAudits(start, end, person, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkAudits(start, end, person, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkAuditControllerApi.getWorkAudits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * WorkAuditControllerApi - factory interface
 * @export
 */
export const WorkAuditControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkAuditControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [start]
         * @param {string} [end]
         * @param {Array<number>} [person]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkAudits(start, end, person, options) {
            return localVarFp.getWorkAudits(start, end, person, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WorkAuditControllerApi - object-oriented interface
 * @export
 * @class WorkAuditControllerApi
 * @extends {BaseAPI}
 */
export class WorkAuditControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [start]
     * @param {string} [end]
     * @param {Array<number>} [person]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkAuditControllerApi
     */
    getWorkAudits(start, end, person, options) {
        return WorkAuditControllerApiFp(this.configuration).getWorkAudits(start, end, person, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WorkBookingRestControllerApi - axios parameter creator
 * @export
 */
export const WorkBookingRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countWorkBooking: async (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/booking/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchWorkBooking: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchWorkBooking', 'ids', ids);
            const localVarPath = `/api/admin/employee/booking/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissWorkBooking: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissWorkBooking', 'id', id);
            const localVarPath = `/api/admin/employee/booking/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkBooking: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWorkBooking', 'id', id);
            const localVarPath = `/api/admin/employee/booking/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkBooking: async (personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/booking/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWorkBooking: async (page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/booking/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (personId !== undefined) {
                localVarQueryParameter['personId'] = personId;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }
            if (visibleByEmployee !== undefined) {
                localVarQueryParameter['visibleByEmployee'] = visibleByEmployee;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {WorkBooking} workBooking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWorkBooking: async (workBooking, options = {}) => {
            // verify required parameter 'workBooking' is not null or undefined
            assertParamExists('saveWorkBooking', 'workBooking', workBooking);
            const localVarPath = `/api/admin/employee/booking/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(workBooking, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WorkBookingRestControllerApi - functional programming interface
 * @export
 */
export const WorkBookingRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkBookingRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkBookingRestControllerApi.countWorkBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchWorkBooking(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchWorkBooking(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkBookingRestControllerApi.deleteOrDismissInBatchWorkBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissWorkBooking(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissWorkBooking(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkBookingRestControllerApi.deleteOrDismissWorkBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkBooking(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkBooking(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkBookingRestControllerApi.getWorkBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkBookingRestControllerApi.listWorkBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageWorkBooking(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageWorkBooking(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkBookingRestControllerApi.pageWorkBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {WorkBooking} workBooking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveWorkBooking(workBooking, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveWorkBooking(workBooking, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkBookingRestControllerApi.saveWorkBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * WorkBookingRestControllerApi - factory interface
 * @export
 */
export const WorkBookingRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkBookingRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.countWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchWorkBooking(ids, options) {
            return localVarFp.deleteOrDismissInBatchWorkBooking(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissWorkBooking(id, options) {
            return localVarFp.deleteOrDismissWorkBooking(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkBooking(id, options) {
            return localVarFp.getWorkBooking(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.listWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [personId]
         * @param {number} [year]
         * @param {number} [month]
         * @param {boolean} [visibleByEmployee]
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWorkBooking(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
            return localVarFp.pageWorkBooking(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WorkBooking} workBooking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWorkBooking(workBooking, options) {
            return localVarFp.saveWorkBooking(workBooking, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WorkBookingRestControllerApi - object-oriented interface
 * @export
 * @class WorkBookingRestControllerApi
 * @extends {BaseAPI}
 */
export class WorkBookingRestControllerApi extends BaseAPI {
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkBookingRestControllerApi
     */
    countWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return WorkBookingRestControllerApiFp(this.configuration).countWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkBookingRestControllerApi
     */
    deleteOrDismissInBatchWorkBooking(ids, options) {
        return WorkBookingRestControllerApiFp(this.configuration).deleteOrDismissInBatchWorkBooking(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkBookingRestControllerApi
     */
    deleteOrDismissWorkBooking(id, options) {
        return WorkBookingRestControllerApiFp(this.configuration).deleteOrDismissWorkBooking(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkBookingRestControllerApi
     */
    getWorkBooking(id, options) {
        return WorkBookingRestControllerApiFp(this.configuration).getWorkBooking(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkBookingRestControllerApi
     */
    listWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return WorkBookingRestControllerApiFp(this.configuration).listWorkBooking(personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [personId]
     * @param {number} [year]
     * @param {number} [month]
     * @param {boolean} [visibleByEmployee]
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkBookingRestControllerApi
     */
    pageWorkBooking(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options) {
        return WorkBookingRestControllerApiFp(this.configuration).pageWorkBooking(page, size, sort, personId, year, month, visibleByEmployee, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WorkBooking} workBooking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkBookingRestControllerApi
     */
    saveWorkBooking(workBooking, options) {
        return WorkBookingRestControllerApiFp(this.configuration).saveWorkBooking(workBooking, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WorkCenterRestControllerApi - axios parameter creator
 * @export
 */
export const WorkCenterRestControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countWorkCenter: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/center/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchWorkCenter: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteOrDismissInBatchWorkCenter', 'ids', ids);
            const localVarPath = `/api/admin/employee/center/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissWorkCenter: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrDismissWorkCenter', 'id', id);
            const localVarPath = `/api/admin/employee/center/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkCenter: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWorkCenter', 'id', id);
            const localVarPath = `/api/admin/employee/center/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkCenter: async (term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/center/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWorkCenter: async (page, size, sort, term, showDismissed, options = {}) => {
            const localVarPath = `/api/admin/employee/center/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (showDismissed !== undefined) {
                localVarQueryParameter['showDismissed'] = showDismissed;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {WorkCenter} workCenter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWorkCenter: async (workCenter, options = {}) => {
            // verify required parameter 'workCenter' is not null or undefined
            assertParamExists('saveWorkCenter', 'workCenter', workCenter);
            const localVarPath = `/api/admin/employee/center/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(workCenter, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WorkCenterRestControllerApi - functional programming interface
 * @export
 */
export const WorkCenterRestControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkCenterRestControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countWorkCenter(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countWorkCenter(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkCenterRestControllerApi.countWorkCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissInBatchWorkCenter(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissInBatchWorkCenter(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkCenterRestControllerApi.deleteOrDismissInBatchWorkCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrDismissWorkCenter(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrDismissWorkCenter(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkCenterRestControllerApi.deleteOrDismissWorkCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkCenter(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkCenter(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkCenterRestControllerApi.getWorkCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkCenter(term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkCenter(term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkCenterRestControllerApi.listWorkCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageWorkCenter(page, size, sort, term, showDismissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageWorkCenter(page, size, sort, term, showDismissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkCenterRestControllerApi.pageWorkCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {WorkCenter} workCenter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveWorkCenter(workCenter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveWorkCenter(workCenter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkCenterRestControllerApi.saveWorkCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * WorkCenterRestControllerApi - factory interface
 * @export
 */
export const WorkCenterRestControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkCenterRestControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countWorkCenter(term, showDismissed, options) {
            return localVarFp.countWorkCenter(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissInBatchWorkCenter(ids, options) {
            return localVarFp.deleteOrDismissInBatchWorkCenter(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrDismissWorkCenter(id, options) {
            return localVarFp.deleteOrDismissWorkCenter(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkCenter(id, options) {
            return localVarFp.getWorkCenter(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkCenter(term, showDismissed, options) {
            return localVarFp.listWorkCenter(term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [term]
         * @param {boolean} [showDismissed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWorkCenter(page, size, sort, term, showDismissed, options) {
            return localVarFp.pageWorkCenter(page, size, sort, term, showDismissed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WorkCenter} workCenter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWorkCenter(workCenter, options) {
            return localVarFp.saveWorkCenter(workCenter, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WorkCenterRestControllerApi - object-oriented interface
 * @export
 * @class WorkCenterRestControllerApi
 * @extends {BaseAPI}
 */
export class WorkCenterRestControllerApi extends BaseAPI {
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkCenterRestControllerApi
     */
    countWorkCenter(term, showDismissed, options) {
        return WorkCenterRestControllerApiFp(this.configuration).countWorkCenter(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkCenterRestControllerApi
     */
    deleteOrDismissInBatchWorkCenter(ids, options) {
        return WorkCenterRestControllerApiFp(this.configuration).deleteOrDismissInBatchWorkCenter(ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkCenterRestControllerApi
     */
    deleteOrDismissWorkCenter(id, options) {
        return WorkCenterRestControllerApiFp(this.configuration).deleteOrDismissWorkCenter(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkCenterRestControllerApi
     */
    getWorkCenter(id, options) {
        return WorkCenterRestControllerApiFp(this.configuration).getWorkCenter(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkCenterRestControllerApi
     */
    listWorkCenter(term, showDismissed, options) {
        return WorkCenterRestControllerApiFp(this.configuration).listWorkCenter(term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [term]
     * @param {boolean} [showDismissed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkCenterRestControllerApi
     */
    pageWorkCenter(page, size, sort, term, showDismissed, options) {
        return WorkCenterRestControllerApiFp(this.configuration).pageWorkCenter(page, size, sort, term, showDismissed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WorkCenter} workCenter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkCenterRestControllerApi
     */
    saveWorkCenter(workCenter, options) {
        return WorkCenterRestControllerApiFp(this.configuration).saveWorkCenter(workCenter, options).then((request) => request(this.axios, this.basePath));
    }
}
